(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Bundle = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clickAndDrag = function (selector, scroll_speed, classOnEvent) {
    if (scroll_speed === void 0) { scroll_speed = 3; }
    if (classOnEvent === void 0) { classOnEvent = 'dragging'; }
    var slider = document.querySelector(selector);
    var isDown = false;
    var startX;
    var scrollLeft;
    slider.addEventListener('mousedown', function (e) {
        if (e.clientX < slider.offsetLeft || e.clientX > slider.offsetLeft + slider.offsetWidth) {
            return;
        }
        e.preventDefault();
        isDown = true;
        slider.classList.add(classOnEvent);
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.addEventListener('click', function (event) {
            if (Math.abs(startX - event.pageX + slider.offsetLeft) > 3) {
                event.preventDefault();
            }
        });
    });
    slider.addEventListener('mouseleave', function () {
        isDown = false;
        slider.classList.remove(classOnEvent);
    });
    slider.addEventListener('mouseup', function () {
        isDown = false;
        slider.classList.remove(classOnEvent);
    });
    slider.addEventListener('mousemove', function (e) {
        if (!isDown)
            return;
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        var walk = (x - startX) * scroll_speed;
        slider.scrollLeft = scrollLeft - walk;
    });
};
exports.default = clickAndDrag;
},{}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setMaxDateValue = function () {
    var today = new Date();
    var eighteenYearsAgo = today;
    eighteenYearsAgo.setFullYear(today.getFullYear() - 18);
    var isLeapYear = function (year) { return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0); };
    if (today.getMonth() === 1 && today.getDate() === 29 && !isLeapYear(today.getFullYear())) {
        eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 1);
    }
    var maxDate = eighteenYearsAgo.toISOString().split('T')[0];
    return maxDate;
};
exports.default = setMaxDateValue;
},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var renderUpload = function () {
    var individualUploadActive = document.querySelector('.individual-upload__wrapper--active');
    individualUploadActive === null || individualUploadActive === void 0 ? void 0 : individualUploadActive.focus();
    if (individualUploadActive) {
        var individualUploadBackButtons = individualUploadActive.querySelectorAll('.individual-upload__back');
        var individualAuth_1 = document.querySelector('.individual-auth');
        var individualUploadSubmit_1 = individualUploadActive.querySelector('.individual-upload__submit');
        var individualUploadButtons_1 = individualUploadActive.querySelectorAll('.individual-upload__upload-input');
        var individualCaptureButtons_1 = individualUploadActive.querySelectorAll('.individual-upload__capture-input');
        var individualUploadItems_1 = individualUploadActive.querySelectorAll('.individual-upload__item');
        var individualUploadMains_1 = individualUploadActive.querySelectorAll('.individual-upload__upload-main');
        var previewContainers_1 = individualUploadActive.querySelectorAll('.individual-upload__preview');
        var previewImages_1 = individualUploadActive.querySelectorAll('.individual-upload__preview-image');
        var previewPdfs_1 = individualUploadActive.querySelectorAll('.individual-upload__preview-pdf');
        var previewFileNames_1 = individualUploadActive.querySelectorAll('.individual-upload__preview-name');
        var previewFileSizes_1 = individualUploadActive.querySelectorAll('.individual-upload__preview-size');
        var individualUploadAreas = individualUploadActive.querySelectorAll('.individual-upload__upload');
        var invalidUploadStatuses_1 = individualUploadActive.querySelectorAll('.individual-upload__status-invalid');
        var validUploadStatuses_1 = individualUploadActive.querySelectorAll('.individual-upload__status-valid');
        var individualUploadPreviewDeleteButton = individualUploadActive.querySelectorAll('.individual-upload__preview-delete');
        var fileValidations_1 = individualUploadActive
            .querySelector('.individual-upload__upload-input')
            .getAttribute('accept');
        var uploadedFiles_1 = [];
        var validateFile_1 = function (file) {
            var _a;
            var extension = (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            var maxSize = 8000000;
            return extension && fileValidations_1.includes('.' + extension) && file.size <= maxSize;
        };
        var kbToMb_1 = function (bytes) {
            var megabytes = bytes / (1024 * 1024);
            return megabytes.toFixed(1) + ' MB';
        };
        var handleFile_1 = function (event, i, isDropped) {
            if (isDropped === void 0) { isDropped = false; }
            if (isDropped) {
                var dt = event.dataTransfer;
                var files = dt.files;
                if (validateFile_1(files[0]) === true) {
                    var filePath = files[0].name;
                    var fileName = filePath.split('\\').pop().split('/').pop();
                    var fullFileName = filePath.split('\\').pop().split('/').pop();
                    var fileExtension = fileName.split('.').pop().toUpperCase();
                    var fileSize = kbToMb_1(files[0].size);
                    if (fileName.length > 12) {
                        fileName = fileName.substring(0, 10) + '..' + '.' + fileExtension;
                    }
                    previewFileNames_1[i].textContent = fileName;
                    previewFileNames_1[i].setAttribute('data-fileName', fullFileName);
                    previewFileSizes_1[i].textContent = fileSize;
                    uploadedFiles_1.push(files[0]);
                    if (individualUploadItems_1.length === uploadedFiles_1.length) {
                        individualUploadSubmit_1.removeAttribute('disabled');
                    }
                    return fileName;
                }
                return '';
            }
            else {
                var target = event.target;
                if (validateFile_1(target.files[0]) === true) {
                    var filePath = target.files[0].name;
                    var fileName = filePath.split('\\').pop().split('/').pop();
                    var fullFileName = filePath.split('\\').pop().split('/').pop();
                    var fileExtension = fileName.split('.').pop().toUpperCase();
                    var fileSize = kbToMb_1(target.files[0].size);
                    if (fileName.length > 12) {
                        fileName = fileName.substring(0, 10) + '..' + '.' + fileExtension;
                    }
                    if (previewFileNames_1[i] && previewFileSizes_1[i]) {
                        previewFileNames_1[i].textContent = fileName;
                        previewFileSizes_1[i].textContent = fileSize;
                        previewFileNames_1[i].setAttribute('data-fileName', fullFileName);
                        uploadedFiles_1.push(target.files[0]);
                        if (individualUploadItems_1.length === uploadedFiles_1.length) {
                            individualUploadSubmit_1.removeAttribute('disabled');
                        }
                    }
                    else {
                        console.error("Element at index ".concat(i, " not found."));
                    }
                    if (individualUploadItems_1.length === uploadedFiles_1.length) {
                        individualUploadSubmit_1.removeAttribute('disabled');
                    }
                    return fileName;
                }
                else {
                    return '';
                }
            }
        };
        var renderPreview_1 = function (event, index, droppedFile) {
            if (droppedFile === void 0) { droppedFile = null; }
            if (droppedFile) {
                if (validateFile_1(droppedFile) === true) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var _a;
                        var fileType = droppedFile.type;
                        var data = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                        var previewContainer = previewContainers_1[index];
                        var individualUploadMain = individualUploadMains_1[index];
                        var previewImage = previewImages_1[index];
                        var previewPdf = previewPdfs_1[index];
                        if (previewContainer) {
                            if (fileType.startsWith('image/')) {
                                showImgPreview_1(data, index, previewContainer, individualUploadMain);
                            }
                            else if (fileType.startsWith('application/pdf')) {
                                showPdfPreview_1(previewContainer, individualUploadMain, previewPdf, previewImage);
                            }
                        }
                    };
                    reader.readAsDataURL(droppedFile);
                }
            }
            else {
                var target = event.target;
                var file_1 = target.files ? target.files[0] : null;
                if (file_1 && validateFile_1(file_1) === true) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var _a;
                        var fileType = file_1.type;
                        var data = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                        var previewContainer = previewContainers_1[index];
                        var individualUploadMain = individualUploadMains_1[index];
                        var previewImage = previewImages_1[index];
                        var previewPdf = previewPdfs_1[index];
                        if (previewContainer) {
                            if (fileType.startsWith('image/')) {
                                showImgPreview_1(data, index, previewContainer, individualUploadMain);
                            }
                            else if (fileType.startsWith('application/pdf')) {
                                showPdfPreview_1(previewContainer, individualUploadMain, previewPdf, previewImage);
                            }
                        }
                    };
                    reader.readAsDataURL(file_1);
                }
            }
        };
        var showPdfPreview_1 = function (preview, main, previewPdf, previewImage) {
            previewPdf.classList.add('individual-upload__preview-pdf--active');
            previewImage.classList.remove('individual-upload__preview-image--active');
            main.classList.remove('individual-upload__upload-main--active');
            preview.classList.add('individual-upload__preview--active');
        };
        var showImgPreview_1 = function (data, i, preview, main) {
            main.classList.remove('individual-upload__upload-main--active');
            preview.classList.add('individual-upload__preview--active');
            previewImages_1[i].src = data;
            previewImages_1[i].classList.add('individual-upload__preview-image--active');
            previewPdfs_1[i].classList.remove('individual-upload__preview-pdf--active');
        };
        var handleProgress_1 = function (fileInput, index) {
            var progressBars = individualUploadActive.querySelectorAll('.individual-upload__progress-inner');
            var progress = progressBars[index];
            var file = fileInput.files[0] || null;
            if (file && file.size) {
                var fileSize_1 = file.size;
                var loaded_1 = 0;
                var reader = new FileReader();
                reader.onprogress = function (event) {
                    if (event.lengthComputable) {
                        loaded_1 = event.loaded;
                        var percent = (loaded_1 / fileSize_1) * 100;
                        progress.style.width = percent + '%';
                        if (percent === 100) {
                            progress.classList.add('individual-upload__progress-inner--complete');
                            invalidUploadStatuses_1[index].classList.remove('individual-upload__status-invalid--active');
                            validUploadStatuses_1[index].classList.add('individual-upload__status-valid--active');
                        }
                    }
                };
                reader.readAsDataURL(file);
                return reader;
            }
            else {
                var percent = 100;
                progress.style.width = percent + '%';
                progress.classList.add('individual-upload__progress-inner--complete');
                invalidUploadStatuses_1[index].classList.remove('individual-upload__status-invalid--active');
                validUploadStatuses_1[index].classList.add('individual-upload__status-valid--active');
                return percent;
            }
        };
        var handleDragOver_1 = function (e, area) {
            e.preventDefault();
            area.classList.add('individual-upload__upload--active');
        };
        var handleFileDrop_1 = function (e, index, area) {
            e.preventDefault();
            var button = individualCaptureButtons_1[index];
            handleFile_1(e, index, true);
            handleProgress_1(button, index);
            area.classList.remove('individual-upload__upload--active');
        };
        var handleDragLeave_1 = function (e, area) {
            e.preventDefault();
            area.classList.remove('individual-upload__upload--active');
        };
        var resetIndividualUpload_1 = function () {
            var individualUploadWrapper = document.querySelector('.individual-upload__wrapper--active');
            individualUploadWrapper === null || individualUploadWrapper === void 0 ? void 0 : individualUploadWrapper.classList.remove('individual-upload__wrapper--active');
            individualAuth_1.style.height = 'auto';
        };
        individualUploadBackButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                resetIndividualUpload_1();
            });
        });
        individualUploadButtons_1.forEach(function (button, i) {
            button.addEventListener('change', function (e) {
                handleFile_1(e, i);
                renderPreview_1(e, i);
                handleProgress_1(button, i);
            });
        });
        individualCaptureButtons_1.forEach(function (button, i) {
            button.addEventListener('change', function (e) {
                handleFile_1(e, i);
                var target = e.target;
                if (validateFile_1(target.files[0]) === true) {
                    handleProgress_1(button, i);
                    renderPreview_1(e, i);
                }
            });
        });
        individualUploadAreas.forEach(function (area, i) {
            area.addEventListener('dragover', function (e) {
                handleDragOver_1(e, area);
            });
            area.addEventListener('dragleave', function (e) {
                handleDragLeave_1(e, area);
            });
            area.addEventListener('drop', function (e) {
                var file = e.dataTransfer.files[0];
                handleFileDrop_1(e, i, area);
                renderPreview_1(e, i, file);
            });
        });
        individualUploadPreviewDeleteButton.forEach(function (button, i) {
            button.addEventListener('click', function () {
                var fileName = button.parentElement.previousElementSibling.children[0].getAttribute('data-fileName');
                var filteredArray = uploadedFiles_1.filter(function (obj) { return obj.name !== fileName; });
                uploadedFiles_1 = filteredArray;
                previewContainers_1[i].classList.remove('individual-upload__preview--active');
                individualUploadMains_1[i].classList.add('individual-upload__upload-main--active');
                individualUploadButtons_1[i].value = '';
                individualUploadSubmit_1.setAttribute('disabled', 'true');
            });
        });
    }
};
exports.default = renderUpload;
},{}],4:[function(require,module,exports){
var printButtons = document.querySelectorAll(".button--print");
printButtons.forEach(function (button) {
    button.addEventListener("click", function () {
        window.print();
    });
});
},{}],5:[function(require,module,exports){
document.addEventListener("DOMContentLoaded", function () {
    var rotatingElement = document.querySelector('.contact-form__image');
    var contactForm = document.querySelector('.contact-form');
    var lastScrollTop = 0;
    if (rotatingElement && contactForm) {
        contactForm.addEventListener('mouseover', function () {
            window.addEventListener('scroll', handleScroll);
        });
    }
    function handleScroll() {
        var scrollPos = window.scrollY;
        var rotation = (scrollPos - lastScrollTop) / 2;
        var translateZ = Math.max(0, scrollPos / 30);
        rotation = Math.min(Math.max(rotation, -20), 10);
        rotatingElement.style.transform = "rotateY(".concat(rotation, "deg) rotateX(").concat(rotation, "deg) translateZ(").concat(translateZ, "px)");
        lastScrollTop = scrollPos;
    }
});
},{}],6:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var createPayComponent = document.querySelector(".create-pay__wrapper");
var transferSummary = document.querySelector(".transfer-summary__wrapper");
var closeButtons = document.querySelector(".change-currency__close");
var overlay = document.querySelector(".change-currency__overlay");
var changeCurrencyButton = document.querySelector(".create-pay__change-currency");
var saveCurrencyButton = document.querySelector(".create-pay__currencies-save");
if (createPayComponent && transferSummary) {
    var thresholdErrorExceed_1 = createPayComponent.querySelector(".create-pay__error-exceeded");
    var thresholdErrorMin_1 = createPayComponent.querySelector(".create-pay__error-min");
    var minAmountParagraph_1 = createPayComponent.querySelector(".create-pay__min-amount");
    var amountInput_1 = createPayComponent.querySelector(".create-pay__amount");
    var currencySelect_1 = createPayComponent.querySelector(".create-pay__currencies");
    var currencySymbolElement_1 = createPayComponent.querySelector(".create-pay__currency-symbol");
    var nextButton_1 = createPayComponent.querySelector(".create-pay__button");
    var payBankButton_1 = document.querySelector(".create-pay__button--bank");
    var backButton_1 = transferSummary.querySelector(".transfer-summary__back");
    var transferSummariesRight_1 = transferSummary.querySelectorAll(".transfer-summary__right");
    var transferSummaryLeft_1 = transferSummary.querySelector(".transfer-summary__left");
    var transferPurposeSelect_1 = createPayComponent.querySelector("#create-pay__dropdown-select");
    var uid_1 = new URLSearchParams(window.location.search).get("_uid");
    var createPaymentDetailsContainer_1 = document.querySelector(".create-pay__details");
    var createPaymentError_1 = document.querySelector(".create-pay__error");
    var createPayAmount_1 = document.getElementById("create-pay__amount");
    var createPayRecievedAmount_1 = document.getElementById("create-pay__amount-received");
    var paymentMethodRadios_1 = document.querySelectorAll("input[name='payment-method']");
    var bankPaymentMethod_1 = Array.from(paymentMethodRadios_1).find(function (radio) { return radio.value === "BankTransfer"; }) || undefined;
    var paymentMethodRadio_1 = document.querySelector("input[name='payment-method']:checked");
    var ratesJson = createPayComponent.dataset.ratesJson;
    var feesJson = createPayComponent.dataset.feesJson;
    var receiveLabels_1 = document.querySelectorAll(".values--receive-value");
    var sendLabels_1 = document.querySelectorAll(".values--send-value");
    var exchangeRateLabels_1 = document.querySelectorAll(".values--exchange-rate");
    var transferPurposeLabels_1 = document.querySelectorAll(".values--transfer-purpose");
    var payValueLabels_1 = document.querySelectorAll(".values--pay-value");
    var transferFees_1 = document.querySelectorAll(".values--fees");
    var thresholdLabel_1 = document.querySelector("#thresholdAmount");
    var payoutCountryLabel_1 = document.querySelector(".values--payout-country");
    var youreSendingLabel_1 = document.querySelector(".value--youre-sending-value");
    var paymentMethodLabels_1 = document.querySelectorAll(".values--payment-method");
    var tooltipIcon_1 = document.querySelector('.create-pay__icon');
    var tooltipText_1 = tooltipIcon_1.nextElementSibling;
    var receiveCurrencyName_1 = createPayComponent.querySelector(".payload--receive-currency-name").innerText;
    var db_1 = JSON.parse(ratesJson);
    var feesDb_1 = JSON.parse(feesJson);
    var isLoading_1 = false;
    var sendCurrency_1 = db_1[0];
    var receiveCurrency_1 = sendCurrency_1.ToCurrencies.find(function (currency) { return currency.Name === receiveCurrencyName_1; });
    var session_1;
    var currentPayoutMethod_1 = paymentMethodRadio_1.value;
    var formatNumberWithCommas_1 = function (value) {
        var number = value.replace(/[^\d.]/g, '');
        var _a = number.split('.'), integerPart = _a[0], decimalPart = _a[1];
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (decimalPart !== undefined) {
            decimalPart = decimalPart.replace(/\./g, '');
            return integerPart + '.' + decimalPart;
        }
        return integerPart;
    };
    var closeOverlays_1 = function () {
        overlay.classList.remove("change-currency__overlay--active");
    };
    var showTransferSummary_1 = function () {
        var _a;
        createPayComponent.classList.remove("create-pay__wrapper--active");
        transferSummary.classList.add("transfer-summary__wrapper--active");
        if (window.innerWidth > 768) {
            (_a = document.querySelector(".transfer-summary__right[data-type='".concat(currentPayoutMethod_1, "']"))) === null || _a === void 0 ? void 0 : _a.classList.add("transfer-summary__right--active");
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    var hideTransferSummary_1 = function () {
        var anyContainsActive = Array.from(transferSummariesRight_1).some(function (div) { return div.classList.contains("transfer-summary__right--active"); });
        transferSummariesRight_1.forEach(function (div) {
            div.classList.remove("transfer-summary__right--active");
        });
        if (window.innerWidth < 768 && anyContainsActive) {
            transferSummaryLeft_1.classList.add("transfer-summary__left--active");
        }
        else {
            transferSummary.classList.remove("transfer-summary__wrapper--active");
            createPayComponent.classList.add("create-pay__wrapper--active");
        }
    };
    var resetErrors_1 = function () {
        nextButton_1.disabled = false;
        thresholdErrorExceed_1 === null || thresholdErrorExceed_1 === void 0 ? void 0 : thresholdErrorExceed_1.classList.remove("create-pay__error--active");
        thresholdErrorMin_1 === null || thresholdErrorMin_1 === void 0 ? void 0 : thresholdErrorMin_1.classList.remove("create-pay__error--active");
    };
    var saveCurrency_1 = function () {
        var selectedOption = currencySelect_1.options[currencySelect_1.selectedIndex];
        var customDataValue = selectedOption.getAttribute('data-cur-symbol');
        currencySymbolElement_1.textContent = customDataValue;
        resetErrors_1();
        handleValueChange_1();
        updateMinAmount_1();
        handleThreshold_1(amountInput_1);
    };
    var initiateBankTransfer_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading_1)
                        return [2];
                    isLoading_1 = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, axios_1.default.post("/api/payments/initiateBankTransfer", session_1)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    window.location.href = data.data.url;
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    alert("An error occurred while processing your request. Please try again later.");
                    console.error(error_1);
                    return [3, 5];
                case 4:
                    isLoading_1 = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var hookListeners_1 = function () {
        amountInput_1.addEventListener("input", function (e) {
            var target = e.target;
            amountInput_1.value = formatNumberWithCommas_1(target.value);
            resetErrors_1();
            handleThreshold_1(target);
            handleValueChange_1();
        });
        createPayRecievedAmount_1.addEventListener("input", function (e) {
            var target = e.target;
            createPayRecievedAmount_1.value = formatNumberWithCommas_1(target.value);
            resetErrors_1();
            handleThresholdRecieve_1(target);
            handleValueChange_1();
        });
        nextButton_1.addEventListener("click", function () {
            showTransferSummary_1();
        });
        backButton_1.addEventListener("click", function () {
            hideTransferSummary_1();
        });
        paymentMethodRadios_1.forEach(function (radio) {
            radio.addEventListener("change", function (e) {
                var target = e.target;
                currentPayoutMethod_1 = target.value;
                updatePaymentMethodElements_1();
                handleValueChange_1();
            });
        });
        payBankButton_1 === null || payBankButton_1 === void 0 ? void 0 : payBankButton_1.addEventListener("click", function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                initiateBankTransfer_1();
                return [2];
            });
        }); });
        transferPurposeSelect_1.addEventListener("change", handleValueChange_1);
    };
    var handleThreshold_1 = function (target) {
        if (thresholdLabel_1 && !isNaN(sendCurrency_1.Threshold)) {
            var text = formatNumberWithSymbol_1(sendCurrency_1.Threshold, 2, sendCurrency_1.Symbol);
            thresholdLabel_1.innerText = sendCurrency_1.Symbol + formatNumberWithCommas_1(text);
            if (target) {
                var originalSendAmountValue = parseFloat(target.value.replace(/[^\d.]/g, ''));
                if (originalSendAmountValue > sendCurrency_1.Threshold) {
                    amountInput_1.value = formatNumberWithCommas_1(sendCurrency_1.Threshold.toString());
                    thresholdErrorExceed_1 === null || thresholdErrorExceed_1 === void 0 ? void 0 : thresholdErrorExceed_1.classList.add("create-pay__error--active");
                    handleValueChange_1();
                }
            }
        }
    };
    var handleThresholdRecieve_1 = function (target) {
        if (thresholdLabel_1 && !isNaN(sendCurrency_1.Threshold)) {
            var text = formatNumberWithSymbol_1(sendCurrency_1.Threshold, 2, sendCurrency_1.Symbol);
            thresholdLabel_1.innerText = sendCurrency_1.Symbol + formatNumberWithCommas_1(text);
            if (target) {
                var originalRecieveAmountValue = parseFloat(target.value.replace(/[^\d.]/g, ''));
                var recieveAmountThreshold = sendCurrency_1.Threshold * receiveCurrency_1.ExchangeRate;
                if (originalRecieveAmountValue > recieveAmountThreshold) {
                    createPayRecievedAmount_1.value = formatNumberWithCommas_1(recieveAmountThreshold.toFixed(2));
                    thresholdErrorExceed_1 === null || thresholdErrorExceed_1 === void 0 ? void 0 : thresholdErrorExceed_1.classList.add("create-pay__error--active");
                    handleValueChange_1();
                }
            }
        }
    };
    var validateTotalToPay_1 = function () {
        var totalToPayValue = parseFloat(sendLabels_1[0].textContent.replace(/[^\d.]/g, ''));
        var transferFeesValue = parseFloat(transferFees_1[0].textContent.replace(/[^\d.]/g, ''));
        var difference = Math.abs(totalToPayValue - transferFeesValue);
        if (difference < sendCurrency_1.MinAmount) {
            nextButton_1.disabled = true;
        }
        else if (difference >= sendCurrency_1.MinAmount) {
            nextButton_1.disabled = false;
        }
    };
    var handleInvalidExchangeRate_1 = function () {
        amountInput_1.value = "";
        createPaymentDetailsContainer_1.classList.add("create-pay__details--disabled");
        createPaymentError_1.classList.add("create-pay__error--active");
        amountInput_1.disabled = true;
        nextButton_1.disabled = true;
        transferPurposeSelect_1.disabled = true;
        updateLabels_1("N/A", "N/A", "N/A", "N/A");
    };
    var handleValidExchangeRate_1 = function () {
        amountInput_1.placeholder = "";
        createPaymentDetailsContainer_1.classList.remove("create-pay__details--disabled");
        createPaymentError_1.classList.remove("create-pay__error--active");
        amountInput_1.disabled = false;
        nextButton_1.disabled = false;
        transferPurposeSelect_1.disabled = false;
        updateLabels_1("", "", "", "");
    };
    var handleInvalidAmount_1 = function () {
        nextButton_1.disabled = true;
        updateLabels_1("", "", transferPurposeSelect_1.value);
    };
    var handleValidAmount_1 = function () {
        nextButton_1.disabled = false;
        var minValue = sendCurrency_1.MinAmount;
        if (+amountInput_1.value < minValue) {
            nextButton_1.disabled = true;
            debouncedFunc_1(minValue);
        }
        else {
            updateSession_1();
        }
    };
    var debounce = function (func, wait) {
        var timeout;
        return function executedFunction() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var later = function () {
                clearTimeout(timeout);
                func.apply(void 0, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };
    var debouncedFunc_1 = debounce(function (min) {
        if (+amountInput_1.value < min) {
            thresholdErrorMin_1.classList.add("create-pay__error--active");
        }
        updateSession_1();
    }, 1000);
    var calculateSendAmount_1 = function (amount, exchangeRate, fixedPoints, symbol) {
        if (fixedPoints === void 0) { fixedPoints = 5; }
        var sendAmount = amount * exchangeRate;
        return formatNumberWithSymbol_1(sendAmount, fixedPoints, symbol);
    };
    var formatNumberWithSymbol_1 = function (value, fixedPoints, symbol) {
        if (fixedPoints === void 0) { fixedPoints = 5; }
        if (!symbol)
            return value.toFixed(fixedPoints);
        if (isNaN(value))
            return "";
        return "".concat(symbol).concat(value.toFixed(fixedPoints));
    };
    var calculateFees_1 = function (currentAmount) {
        return calculateFeeRate_1(currentAmount) + calculateFlatFee_1();
    };
    var calculateFeeRate_1 = function (currentAmount) {
        var _a, _b;
        var feeRate = (_b = (_a = feesDb_1 === null || feesDb_1 === void 0 ? void 0 : feesDb_1[currentPayoutMethod_1]) === null || _a === void 0 ? void 0 : _a.FeeRate) === null || _b === void 0 ? void 0 : _b.Value;
        if (feeRate) {
            var fee = currentAmount * feeRate;
            var roundedFee = Math.floor(fee * 100) / 100;
            return roundedFee;
        }
        return 0;
    };
    var calculateFlatFee_1 = function () {
        var _a, _b;
        var flatFee = (_b = (_a = feesDb_1 === null || feesDb_1 === void 0 ? void 0 : feesDb_1[currentPayoutMethod_1]) === null || _a === void 0 ? void 0 : _a.FlatFees[sendCurrency_1.Name]) === null || _b === void 0 ? void 0 : _b.Value;
        return flatFee !== null && flatFee !== void 0 ? flatFee : 0;
    };
    var updatePaymentMethodElements_1 = function () {
        var _a;
        paymentMethodRadio_1 = document.querySelector("input[name='payment-method']:checked");
        if (bankPaymentMethod_1) {
            var topParent = (_a = bankPaymentMethod_1.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (!sendCurrency_1.HasBankDetails) {
                topParent === null || topParent === void 0 ? void 0 : topParent.classList.add("hidden-element");
                if ((paymentMethodRadio_1 === null || paymentMethodRadio_1 === void 0 ? void 0 : paymentMethodRadio_1.value) === "BankTransfer") {
                    paymentMethodRadio_1 = Array.from(paymentMethodRadios_1).find(function (radio) { return radio.value !== "BankTransfer"; });
                    paymentMethodRadio_1.checked = true;
                }
            }
            else {
                topParent === null || topParent === void 0 ? void 0 : topParent.classList.remove("hidden-element");
            }
            currentPayoutMethod_1 = paymentMethodRadio_1.value;
        }
        var parent = (paymentMethodRadio_1 === null || paymentMethodRadio_1 === void 0 ? void 0 : paymentMethodRadio_1.parentElement) || undefined;
        paymentMethodLabels_1.forEach(function (label) { var _a, _b; return label.textContent = (_b = (_a = parent.querySelector(".create-pay__item-title")) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : ""; });
    };
    var updateLabels_1 = function (receiveAmount, sendAmount, tranferPurpose, exchangeText) {
        updatePaymentMethodElements_1();
        var originalSendAmountValue = parseFloat(sendAmount.replace(/[^\d.]/g, ''));
        paymentMethodRadio_1 = document.querySelector("input[name='payment-method']:checked");
        var fees = calculateFees_1(originalSendAmountValue);
        var sendAmountWithoutFees = formatNumberWithSymbol_1(originalSendAmountValue, 2, sendCurrency_1.Symbol);
        var sendAmountValue = originalSendAmountValue + fees;
        if (isNaN(sendAmountValue))
            return;
        sendAmount = formatNumberWithSymbol_1(sendAmountValue, 2, sendCurrency_1.Symbol);
        receiveLabels_1.forEach(function (label) { return label.textContent = receiveCurrency_1.Symbol + formatNumberWithCommas_1(receiveAmount); });
        sendLabels_1.forEach(function (label) { return label.textContent = sendCurrency_1.Symbol + formatNumberWithCommas_1(sendAmount); });
        payValueLabels_1.forEach(function (label) { return label.textContent = "Pay ".concat(sendCurrency_1.Symbol + formatNumberWithCommas_1(sendAmount)); });
        transferFees_1.forEach(function (label) { return label.textContent = sendCurrency_1.Symbol + formatNumberWithCommas_1(fees.toFixed(2).toString()); });
        if (tranferPurpose)
            transferPurposeLabels_1.forEach(function (label) { return label.textContent = tranferPurpose; });
        else
            updateTransferPurposeLabels_1();
        if (exchangeText)
            exchangeRateLabels_1.forEach(function (label) { return label.textContent = exchangeText; });
        else
            updateExchangeRateLabels_1();
        if (youreSendingLabel_1)
            youreSendingLabel_1.textContent = sendCurrency_1.Symbol + formatNumberWithCommas_1(sendAmountWithoutFees);
    };
    var updateExchangeRateLabels_1 = function () {
        if (sendCurrency_1 && receiveCurrency_1) {
            exchangeRateLabels_1.forEach(function (label) {
                label.textContent = "".concat(sendCurrency_1.Symbol, " 1 = ").concat(receiveCurrency_1.Symbol, " ").concat(receiveCurrency_1.ExchangeRate.toFixed(3));
            });
        }
    };
    var updateTransferPurposeLabels_1 = function () {
        transferPurposeLabels_1.forEach(function (label) {
            label.textContent = transferPurposeSelect_1.value;
        });
    };
    var handleValueChange_1 = function () {
        var originalSendValue = parseFloat(amountInput_1.value.replace(/[^\d.]/g, ''));
        sendCurrency_1 = db_1[currencySelect_1.selectedIndex];
        receiveCurrency_1 = sendCurrency_1.ToCurrencies.find(function (currency) { return currency.Name === receiveCurrencyName_1; });
        handleThreshold_1();
        var recieveAmount = parseFloat(createPayRecievedAmount_1.value.replace(/[^\d.]/g, ''));
        if (!receiveCurrency_1) {
            handleInvalidExchangeRate_1();
            return;
        }
        handleValidExchangeRate_1();
        if (isNaN(originalSendValue)) {
            handleInvalidAmount_1();
            return;
        }
        handleValidAmount_1();
        transferPurposeSelect_1 = createPayComponent.querySelector("#create-pay__dropdown-select");
        var toReceiveAmount = formatNumberWithSymbol_1(recieveAmount, 2, receiveCurrency_1.Symbol);
        var toSendAmount = calculateSendAmount_1(originalSendValue, (1), 2, sendCurrency_1.Symbol);
        var transferPurpose = transferPurposeSelect_1.value;
        var exchangeRate = "".concat(sendCurrency_1.Symbol, " 1 = ").concat(receiveCurrency_1.Symbol, " ").concat(receiveCurrency_1.ExchangeRate.toFixed(3));
        updateLabels_1(toReceiveAmount, toSendAmount, transferPurpose, exchangeRate);
        validateTotalToPay_1();
    };
    var populateDropdowns_1 = function () {
        currencySelect_1.innerHTML = "";
        db_1.forEach(function (currency) {
            var option = document.createElement("option");
            option.value = currency.Name;
            option.textContent = currency.Name;
            option.setAttribute("data-cur-symbol", currency.Symbol);
            option.classList.add("create-pay__currency");
            currencySelect_1.appendChild(option);
        });
        currencySelect_1.selectedIndex = 0;
        currencySymbolElement_1.textContent = db_1[0].Symbol;
    };
    var updateMinAmount_1 = function () {
        var amount = formatNumberWithSymbol_1(sendCurrency_1.MinAmount, 2, sendCurrency_1.Symbol);
        if (minAmountParagraph_1 != null) {
            minAmountParagraph_1.textContent = sendCurrency_1.Symbol + formatNumberWithCommas_1(amount);
        }
    };
    var isUserInput_1 = true;
    var updateSenderInput_1 = function () {
        var receivedAmountValue = parseFloat(createPayRecievedAmount_1.value.replace(/[^\d.]/g, ''));
        var senderAmount = (receivedAmountValue / receiveCurrency_1.ExchangeRate).toFixed(2);
        createPayAmount_1.value = formatNumberWithCommas_1(senderAmount);
        createPayAmount_1.dispatchEvent(new Event('input'));
    };
    var updateRecievesInput_1 = function () {
        var amountValue = parseFloat(createPayAmount_1.value.replace(/[^\d.]/g, ''));
        var sendAmount = (amountValue * receiveCurrency_1.ExchangeRate).toFixed(2);
        createPayRecievedAmount_1.value = formatNumberWithCommas_1(sendAmount);
        createPayRecievedAmount_1.dispatchEvent(new Event('input'));
    };
    createPayAmount_1.addEventListener('input', function () {
        if (isUserInput_1) {
            isUserInput_1 = false;
            updateRecievesInput_1();
            isUserInput_1 = true;
        }
    });
    createPayRecievedAmount_1.addEventListener('input', function () {
        if (isUserInput_1) {
            isUserInput_1 = false;
            updateSenderInput_1();
            isUserInput_1 = true;
        }
    });
    var updateSession_1 = function () {
        var _a;
        var amountValue = parseFloat(amountInput_1.value.replace(/[^\d.]/g, ''));
        var sendAmount = amountValue * receiveCurrency_1.ExchangeRate;
        session_1 = {
            Uid: parseInt(uid_1),
            ExchangeRate: receiveCurrency_1.ExchangeRate,
            FromValue: amountValue,
            FromCurrency: sendCurrency_1.Name,
            FromSymbol: sendCurrency_1.Symbol,
            ToCurrency: receiveCurrency_1.Name,
            ToSymbol: receiveCurrency_1.Symbol,
            ToValue: sendAmount,
            PayoutCountry: (_a = payoutCountryLabel_1 === null || payoutCountryLabel_1 === void 0 ? void 0 : payoutCountryLabel_1.textContent) !== null && _a !== void 0 ? _a : "",
            PayoutMethod: currentPayoutMethod_1,
            TransferPurpose: transferPurposeSelect_1.value
        };
        sessionStorage.setItem("createPaymentSession", JSON.stringify(session_1));
        dispatchSessionChangeEvent();
        function dispatchSessionChangeEvent() {
            var event = new Event('sessionChange');
            window.dispatchEvent(event);
        }
    };
    var showTooltip = function () {
        tooltipText_1.classList.add('create-pay__tooltip--active');
    };
    var hideTooltip_1 = function () {
        tooltipText_1.classList.remove('create-pay__tooltip--active');
    };
    tooltipIcon_1.addEventListener('mouseover', showTooltip);
    tooltipIcon_1.addEventListener('mouseout', hideTooltip_1);
    tooltipIcon_1.addEventListener('click', function () {
        if (tooltipText_1.classList.contains('create-pay__tooltip--active')) {
            tooltipText_1.classList.remove('create-pay__tooltip--active');
        }
        else {
            tooltipText_1.classList.add('create-pay__tooltip--active');
        }
    });
    tooltipIcon_1.addEventListener('touchstart', function (e) {
        e.preventDefault();
        if (tooltipText_1.classList.contains('create-pay__tooltip--active')) {
            tooltipText_1.classList.remove('create-pay__tooltip--active');
        }
        else {
            tooltipText_1.classList.add('create-pay__tooltip--active');
        }
    });
    document.addEventListener('touchstart', function (e) {
        if (e.target !== tooltipIcon_1 && e.target !== tooltipText_1) {
            hideTooltip_1();
        }
    });
    changeCurrencyButton.addEventListener("click", function () {
        changeCurrencyButton.nextElementSibling.classList.add("change-currency__overlay--active");
    });
    closeButtons.addEventListener("click", function () {
        closeOverlays_1();
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeOverlays_1();
        }
    });
    overlay.addEventListener("click", function (e) {
        var target = e.target;
        if (target.classList.contains("change-currency__overlay--active"))
            closeOverlays_1();
    });
    saveCurrencyButton.addEventListener("click", function () {
        saveCurrency_1();
        closeOverlays_1();
    });
    var init = function () {
        populateDropdowns_1();
        handleValueChange_1();
        hookListeners_1();
        handleThreshold_1();
        updateMinAmount_1();
        updatePaymentMethodElements_1();
    };
    init();
}
},{"axios":52}],7:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],8:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var ctaCardsCarousels = document.querySelectorAll(".cta-cards__carousel-inner");
var setRangeMax = function (arr, input) {
    var slidesLength = Array.from(arr).length;
    var rangeMax = '0';
    rangeMax = (slidesLength - 1).toString();
    input.max = rangeMax;
    setRangeThumbWidth(rangeMax, input);
};
var setRangeThumbWidth = function (max, input) {
    var width = 200 / +max;
    input.style.setProperty('--thumb-size', width.toString() + "px");
    if (max === "1") {
        input.style.setProperty('--thumb-size', "100px");
    }
};
if (ctaCardsCarousels) {
    var ctaCardsCarouselsArray = Array.from(ctaCardsCarousels) || [];
    ctaCardsCarouselsArray.forEach(function (item) {
        var glide = new glide_1.default(item, {
            type: 'slider',
            perView: 1.7,
            gap: 10,
            rewind: false,
            bound: true,
            breakpoints: {
                550: {
                    perView: 1.24,
                },
            }
        });
        glide.mount();
        var carouselRange = item.querySelector(".cta-cards__carousel-range");
        var slides = item.querySelectorAll(".cta-cards__card");
        carouselRange.addEventListener("input", function (e) {
            setTimeout(function () {
                glide.go("=".concat(carouselRange.value));
            }, 500);
        });
        glide.on('move.after', function () {
            var currentIndex = glide.index;
            carouselRange.value = currentIndex;
        });
        setRangeMax(slides, carouselRange);
    });
}
},{"@glidejs/glide":51}],9:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var recipientDetails = document.querySelectorAll(".recipient-detail");
if (recipientDetails.length > 0) {
    var setRangeMax_1 = function (arr, input) {
        var slidesLength = arr.length;
        var rangeMax = (slidesLength - 2).toString();
        input.max = rangeMax;
        setRangeThumbWidth_1(rangeMax, input);
    };
    var setRangeThumbWidth_1 = function (max, input) {
        var width = 94 / +max;
        input.style.setProperty('--thumb-size', width.toString() + "px");
        if (max === "1") {
            input.style.setProperty('--thumb-size', "47px");
        }
    };
    recipientDetails.forEach(function (item) {
        var glide = new glide_1.default(item, {
            type: 'slider',
            perView: 2.8,
            gap: 10,
            rewind: true,
            bound: true,
        });
        glide.mount();
        var carouselRange = item.querySelector(".recipient-detail__carousel-range");
        var slides = item.querySelectorAll(".recipient-detail__item");
        carouselRange.addEventListener("input", function (e) {
            setTimeout(function () {
                glide.go("=".concat(carouselRange.value));
            }, 500);
        });
        glide.on('move.after', function () {
            var currentIndex = glide.index;
            carouselRange.value = currentIndex.toString();
        });
        setRangeMax_1(slides, carouselRange);
    });
}
},{"@glidejs/glide":51}],10:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var clickDrag_1 = __importDefault(require("../../../helpers/clickDrag"));
var dashboardUnverified = document.querySelector('.dashboard-unverified');
if (dashboardUnverified) {
    var closeButtons = dashboardUnverified.querySelectorAll('.recipient-detail__close');
    var contactsCarousel = dashboardUnverified.querySelector('.dashboard-unverified__carousel');
    var contactsList = dashboardUnverified.querySelector('.dashboard-unverified__contacts-list');
    var handleOverlay_1 = function (card, index, overlays) {
        var activeIndex = index;
        card.addEventListener('click', function () {
            overlays[activeIndex].classList.add('recipient-detail__overlay--active');
        });
        card.addEventListener('keydown', function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === 'Enter') {
                overlays[activeIndex].classList.add('recipient-detail__overlay--active');
            }
        });
        if (overlays[activeIndex]) {
            overlays[activeIndex].addEventListener('click', function (e) {
                var targetElement = e.target;
                if (targetElement.classList.contains('recipient-detail__overlay')) {
                    overlays[activeIndex].classList.remove('recipient-detail__overlay--active');
                }
            });
        }
    };
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            button.parentElement.parentElement.parentElement.parentElement.classList.remove('recipient-detail__overlay--active');
        });
    });
    if (contactsCarousel) {
        var contactsCarouselCards = contactsCarousel.querySelectorAll('.dashboard-contact');
        var contactsCarouselOverlays_1 = contactsCarousel.querySelectorAll('.recipient-detail__overlay');
        var setRangeMax = function (arr, input) {
            var slidesLength = arr.length;
            var rangeMax = '0';
            rangeMax = (slidesLength - 1).toString();
            input.max = rangeMax;
            setRangeThumbWidth_1(rangeMax, input);
        };
        var setRangeThumbWidth_1 = function (max, input) {
            var width = 94 / +max;
            input.style.setProperty('--thumb-size', width.toString() + 'px');
            if (max === '1') {
                input.style.setProperty('--thumb-size', '47px');
            }
        };
        contactsCarouselCards.forEach(function (card, index) {
            handleOverlay_1(card, index, contactsCarouselOverlays_1);
        });
        var glide_2 = new glide_1.default(contactsCarousel, {
            type: 'slider',
            perView: 1.3,
            gap: 11,
            rewind: false,
            bound: true,
        });
        glide_2.mount();
        var carouselRange_1 = dashboardUnverified.querySelector('.dashboard-unverified__range');
        var slides = contactsCarousel.querySelectorAll('.dashboard-contact');
        carouselRange_1.addEventListener('input', function () {
            setTimeout(function () {
                glide_2.go("=".concat(carouselRange_1.value));
            }, 500);
        });
        glide_2.on('move.after', function () {
            var currentIndex = glide_2.index;
            carouselRange_1.value = currentIndex;
        });
        setRangeMax(slides, carouselRange_1);
    }
    if (contactsList) {
        var contactCards = contactsList.querySelectorAll('.dashboard-contact');
        var contactCardsOverlays_1 = contactsList.querySelectorAll('.recipient-detail__overlay');
        contactCards.forEach(function (card, index) {
            handleOverlay_1(card, index, contactCardsOverlays_1);
        });
    }
    (0, clickDrag_1.default)('.dashboard-unverified__links');
}
},{"../../../helpers/clickDrag":1,"@glidejs/glide":51}],11:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var clickDrag_1 = __importDefault(require("../../../helpers/clickDrag"));
var dashboard = document.querySelector('.dashboard');
if (dashboard) {
    var closeButtons = dashboard.querySelectorAll('.recipient-detail__close');
    var dashboardRight_1 = dashboard.querySelector(".dashboard__right");
    var footer_1 = document.querySelector(".footer");
    var dashboardPaymentCarousels = dashboard.querySelectorAll('.dashboard__carousel');
    var contactsCarousel_1 = dashboard.querySelector('.dashboard__carousel-contacts');
    var cardsCarousel = dashboard.querySelector('.dashboard__carousel-cards');
    var dashboardCardsCarousel = cardsCarousel.querySelectorAll('.dash-card');
    var dashboardCardsCarouselOverlays_1 = cardsCarousel.querySelectorAll('.recipient-detail__overlay');
    var contactsCarouselCards = contactsCarousel_1.querySelectorAll('.dashboard-contact');
    var contactsCarouselOverlays_1 = contactsCarousel_1.querySelectorAll('.recipient-detail__overlay');
    var contactsList = dashboard.querySelector('.dashboard__contacts-list');
    var cardsList = dashboard.querySelector('.dashboard__cards');
    var contactCards = contactsList.querySelectorAll('.dashboard-contact');
    var dashboardCards = cardsList.querySelectorAll('.dash-card');
    var contactCardsOverlays_1 = contactsList.querySelectorAll('.recipient-detail__overlay');
    var dashboardCardsOverlays_1 = cardsList.querySelectorAll('.recipient-detail__overlay');
    var setRangeMax_1 = function (arr, input) {
        var slidesLength = arr.length;
        var rangeMax = '0';
        rangeMax = (slidesLength - 1).toString();
        input.max = rangeMax;
        setRangeThumbWidth_1(rangeMax, input);
    };
    var setRangeThumbWidth_1 = function (max, input) {
        var width = 94 / +max;
        input.style.setProperty('--thumb-size', width.toString() + 'px');
        if (max === '1') {
            input.style.setProperty('--thumb-size', '47px');
        }
    };
    var handleOverlay_1 = function (card, index, overlays) {
        var activeIndex = index;
        card.addEventListener('click', function () {
            overlays[activeIndex].classList.add('recipient-detail__overlay--active');
            footer_1.classList.add("hidden");
        });
        card.addEventListener('keydown', function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === 'Enter') {
                overlays[activeIndex].classList.add('recipient-detail__overlay--active');
            }
        });
        if (overlays[activeIndex]) {
            overlays[activeIndex].addEventListener('click', function (e) {
                var targetElement = e.target;
                if (targetElement.classList.contains('recipient-detail__overlay')) {
                    overlays[activeIndex].classList.remove('recipient-detail__overlay--active');
                    setTimeout(function () {
                        dashboardRight_1.classList.remove("dashboard__right--hidden");
                        footer_1.classList.remove("hidden");
                    }, 200);
                }
            });
        }
    };
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            button.parentElement.parentElement.parentElement.parentElement.classList.remove('recipient-detail__overlay--active');
            setTimeout(function () {
                dashboardRight_1.classList.remove("dashboard__right--hidden");
                footer_1.classList.remove("hidden");
            }, 200);
        });
    });
    dashboardPaymentCarousels.forEach(function (carousel, i) {
        if (i === 0) {
            var glide = new glide_1.default(carousel, {
                type: 'slider',
                perView: 1,
                gap: 30,
                rewind: false,
                bound: false,
            });
            glide.mount();
            carousel.setAttribute("data-history-carousel", "true");
        }
        if (i === 1) {
            var glide = new glide_1.default(carousel, {
                type: 'slider',
                perView: 1.3,
                gap: 11,
                rewind: false,
                bound: true,
            });
            glide.mount();
            var carouselRange_1 = dashboard.querySelector('.dashboard__range');
            var slides = contactsCarousel_1.querySelectorAll('.dashboard-contact');
            carouselRange_1.addEventListener('input', function () {
                setTimeout(function () {
                    glide.go("=".concat(carouselRange_1.value));
                }, 500);
            });
            glide.on('move.after', function () {
                var currentIndex = glide.index;
                carouselRange_1.value = currentIndex;
            });
            setRangeMax_1(slides, carouselRange_1);
        }
    });
    dashboardCardsCarousel.forEach(function (card, index) {
        handleOverlay_1(card, index, dashboardCardsCarouselOverlays_1);
    });
    contactsCarouselCards.forEach(function (card, index) {
        handleOverlay_1(card, index, contactsCarouselOverlays_1);
    });
    contactCards.forEach(function (card, index) {
        handleOverlay_1(card, index, contactCardsOverlays_1);
    });
    dashboardCards.forEach(function (card, index) {
        handleOverlay_1(card, index, dashboardCardsOverlays_1);
    });
    (0, clickDrag_1.default)('.dashboard__links');
}
},{"../../../helpers/clickDrag":1,"@glidejs/glide":51}],12:[function(require,module,exports){
var featureDownloadButton = document.querySelector(".feature-with-media__button");
if (featureDownloadButton) {
    var featureDownloadMedia_1 = function (url, fileName) {
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };
    var onDownloadButtonClick = function () {
        var mediaUrl = featureDownloadButton.getAttribute("data-url");
        var mediaFileName = featureDownloadButton.getAttribute("data-label");
        featureDownloadMedia_1(mediaUrl, mediaFileName);
    };
    featureDownloadButton.addEventListener('click', onDownloadButtonClick);
}
},{}],13:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var individualUpload_1 = __importDefault(require("../../../helpers/individualUpload"));
var individualAuthProof = document.querySelectorAll(".individual-auth__proof");
var individualAuthDocumentTypes = document.querySelectorAll(".document-type");
if (individualAuthProof.length > 0 && individualAuthDocumentTypes.length > 0) {
    var individualAuth_1 = document.querySelector(".individual-auth");
    var individualAuthRight_1 = document.querySelector(".individual-auth__right");
    var individualAuthLeft_1 = document.querySelector(".individual-auth__left");
    var individualAuthButton = document.querySelector(".individual-auth__button");
    var individualAuthProofDocs_1 = document.querySelectorAll(".individual-auth__proof-docs");
    var individualAuthUploadButtons_1 = document.querySelectorAll(".individual-auth__upload-button");
    var individualAuthUploadWrappers_1 = document.querySelectorAll(".individual-upload__wrapper");
    if (window.innerWidth > 992) {
        individualAuthProof[0].classList.add("individual-auth__proof--active");
        individualAuthDocumentTypes[0].classList.add("document-type--active");
    }
    var resetIndividualAuthCards_1 = function () {
        individualAuthDocumentTypes.forEach(function (card) {
            card.classList.remove("document-type--active");
        });
        individualAuthProof.forEach(function (item) {
            item.classList.remove("individual-auth__proof--active");
        });
        individualAuthRight_1.classList.remove("individual-auth__right--active");
        individualAuthLeft_1.classList.remove("individual-auth__left--hidden");
    };
    var resetIndividualAuthDocs_1 = function () {
        individualAuthProofDocs_1.forEach(function (card) {
            card.classList.remove("individual-auth__proof-docs--active");
        });
    };
    var individualAuthRightScroll_1 = function () {
        var topOffset = 70;
        var elementTop = individualAuthRight_1.getBoundingClientRect().top + window.scrollY;
        var scrollPosition = elementTop - topOffset;
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    };
    var showActiveIndividualProof_1 = function (item, index) {
        resetIndividualAuthCards_1();
        item.classList.add("document-type--active");
        individualAuthProof[index].classList.add("individual-auth__proof--active");
        individualAuthRight_1.classList.add("individual-auth__right--active");
        individualAuthLeft_1.classList.add("individual-auth__left--hidden");
        if (window.innerWidth < 768) {
            individualAuthRightScroll_1();
        }
    };
    var handleProofDocClick_1 = function (doc) {
        var activeIndex = 0;
        individualAuthDocumentTypes.forEach(function (doc, i) {
            if (doc.classList.contains("document-type--active")) {
                activeIndex = i;
            }
        });
        individualAuthUploadButtons_1[activeIndex].removeAttribute("disabled");
        resetIndividualAuthDocs_1();
        doc.classList.add("individual-auth__proof-docs--active");
        individualAuthUploadButtons_1[activeIndex].addEventListener("click", function () {
            individualAuthUploadWrappers_1.forEach(function (item) {
                item.classList.remove("individual-upload__wrapper--active");
            });
            var individualAuthUploadWrapperActive = doc.nextElementSibling;
            individualAuthUploadWrapperActive.classList.add("individual-upload__wrapper--active");
            var individualUploadLeftActive = document.querySelector(".individual-upload__wrapper--active .individual-upload__left");
            individualAuth_1.style.height = "".concat(individualUploadLeftActive.scrollHeight, "px");
            (0, individualUpload_1.default)();
            var topOffset = 70;
            var upload = document.querySelector(".individual-upload__wrapper--active .individual-upload__left");
            var elementTop = upload.getBoundingClientRect().top + window.scrollY;
            var scrollPosition = elementTop - topOffset;
            window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        });
    };
    individualAuthButton.addEventListener("click", function () {
        resetIndividualAuthCards_1();
    });
    individualAuthDocumentTypes.forEach(function (card, i) {
        card.addEventListener("click", function () {
            showActiveIndividualProof_1(card, i);
        });
    });
    individualAuthDocumentTypes.forEach(function (card, i) {
        card.addEventListener("keydown", function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === "Enter") {
                showActiveIndividualProof_1(card, i);
            }
        });
    });
    individualAuthProofDocs_1.forEach(function (card, i) {
        card.addEventListener("click", function () {
            handleProofDocClick_1(card);
        });
        card.addEventListener("keydown", function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === "Enter") {
                handleProofDocClick_1(card);
            }
        });
    });
}
},{"../../../helpers/individualUpload":3}],14:[function(require,module,exports){
var loginCountry = document.querySelector(".login-country");
if (loginCountry) {
    var countryItems_1 = loginCountry.querySelectorAll(".login-country__item");
    var nextButton_1 = loginCountry.querySelector(".button");
    var activeCountry_1 = document.querySelector(".login-country__item.active");
    var countryInput_1 = document.getElementById('selectedCountry');
    var toggleCountry_1 = function (elm) {
        var _a;
        if (elm == activeCountry_1)
            return;
        activeCountry_1 === null || activeCountry_1 === void 0 ? void 0 : activeCountry_1.classList.remove("login-country__item--active");
        activeCountry_1 = elm;
        activeCountry_1.classList.add("login-country__item--active");
        var activeCountryName = ((_a = activeCountry_1.querySelector(".login-country__item-name")) === null || _a === void 0 ? void 0 : _a.textContent) || "";
        countryInput_1.value = activeCountryName.trim();
        nextButton_1.disabled = false;
    };
    var hookListeners = function () {
        countryItems_1.forEach(function (item) {
            item.addEventListener("click", function (e) {
                var target = e.target.closest(".login-country__item");
                toggleCountry_1(target);
            });
        });
    };
    document.addEventListener("DOMContentLoaded", hookListeners);
}
},{}],15:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var forgotPassForm = document.querySelector(".individual-forgot-pass__form");
if (forgotPassForm) {
    var forgotEmailInput_1 = document.querySelector(".individual-forgot-pass__email");
    var forgotEmailValidation_1 = document.querySelector(".individual-forgot-pass__validation-email");
    var resetForgotPasswordValidation_1 = function () {
        forgotEmailValidation_1.classList.remove("individual-forgot-pass__validation--active");
    };
    forgotEmailInput_1.addEventListener("input", function () {
        forgotEmailValidation_1.classList.remove("individual-forgot-pass__validation--active");
    });
    forgotPassForm.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            resetForgotPasswordValidation_1();
            formValues = {
                email: forgotEmailInput_1.value,
            };
            if (!forgotEmailInput_1.value) {
                forgotEmailValidation_1.classList.add("individual-forgot-pass__validation--active");
            }
            if (forgotEmailInput_1.value) {
                resetForgotPasswordValidation_1();
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{}],16:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dateMaxValue_1 = __importDefault(require("../../../helpers/dateMaxValue"));
var individualProfileForm = document.querySelector(".individual-profile__form");
if (individualProfileForm) {
    var firstNameInput_1 = document.querySelector(".individual-profile__first-name");
    var middleNameInput_1 = document.querySelector(".individual-profile__middle-name");
    var lastNameInput_1 = document.querySelector(".individual-profile__last-name");
    var dateInput_1 = document.querySelector(".individual-profile__dob");
    var dateInputOverlay_1 = document.querySelector(".individual-profile__dob-overlay");
    var dateInputIcon_1 = document.querySelector(".individual-profile__dob-icon-container");
    var countryInput_1 = document.querySelector(".individual-profile__country");
    var firstNameValidation_1 = document.querySelector(".individual-profile__validation-first-name");
    var middleNameValidation_1 = document.querySelector(".individual-profile__validation-middle-name");
    var lastNameValidation_1 = document.querySelector(".individual-profile__validation-last-name");
    var dateValidation_1 = document.querySelector(".individual-profile__validation-dob");
    var countryValidation_1 = document.querySelector(".individual-profile__validation-country");
    var isFormValid_1 = false;
    var resetIndividualProfileValidation_1 = function () {
        firstNameValidation_1.classList.remove("individual-profile__validation--active");
        middleNameValidation_1.classList.remove("individual-profile__validation--active");
        lastNameValidation_1.classList.remove("individual-profile__validation--active");
        dateValidation_1.classList.remove("individual-profile__validation--active");
        countryValidation_1.classList.remove("individual-profile__validation--active");
    };
    var resetForm = function () {
        firstNameInput_1.value = "";
        lastNameInput_1.value = "";
        middleNameInput_1.value = "";
        dateInput_1.value = "";
        countryInput_1.value = "";
        countryInput_1.classList.remove("individual-profile__country--active");
        dateInput_1.classList.remove("individual-profile__dob--active");
    };
    var nameValidation_1 = function (name) {
        var regex = /^[\u0600-\u06FFa-zA-Z\s'-]+$/;
        return regex.test(name);
    };
    var validateForm_1 = function () {
        isFormValid_1 = true;
        if (!firstNameInput_1.value || !nameValidation_1(firstNameInput_1.value)) {
            firstNameValidation_1.classList.add("individual-profile__validation--active");
            firstNameValidation_1.textContent = "First name is required and must contain only letters";
            isFormValid_1 = false;
        }
        if (middleNameInput_1.value && !nameValidation_1(middleNameInput_1.value)) {
            middleNameValidation_1.classList.add("individual-profile__validation--active");
            middleNameValidation_1.textContent = "Middle name must contain only letters";
            isFormValid_1 = false;
        }
        if (!lastNameInput_1.value || !nameValidation_1(lastNameInput_1.value)) {
            lastNameValidation_1.classList.add("individual-profile__validation--active");
            lastNameValidation_1.textContent = "Last name is required and must contain only letters";
            isFormValid_1 = false;
        }
        if (!dateInput_1.value) {
            dateValidation_1.classList.add("individual-profile__validation--active");
            isFormValid_1 = false;
        }
        if (!countryInput_1.value) {
            countryValidation_1.classList.add("individual-profile__validation--active");
            isFormValid_1 = false;
        }
        return isFormValid_1;
    };
    var handleDateClick_1 = function () {
        try {
            dateInput_1.showPicker();
        }
        catch (error) {
            console.log(error.message);
        }
    };
    var listenForInputChanges = function () {
        firstNameInput_1.addEventListener("input", function () {
            firstNameValidation_1.classList.remove("individual-profile__validation--active");
        });
        lastNameInput_1.addEventListener("input", function () {
            lastNameValidation_1.classList.remove("individual-profile__validation--active");
        });
        dateInput_1.addEventListener("click", function () {
            handleDateClick_1();
        });
        dateInputIcon_1.addEventListener("click", function () {
            handleDateClick_1();
        });
        dateInput_1.addEventListener("input", function () {
            dateInput_1.classList.add("individual-profile__dob--active");
            dateValidation_1.classList.remove("individual-profile__validation--active");
            dateInputOverlay_1.classList.add("individual-profile__dob-overlay--hidden");
        });
        countryInput_1.addEventListener("input", function () {
            countryValidation_1.classList.remove("individual-profile__validation--active");
            countryInput_1.classList.add("individual-profile__country--active");
        });
    };
    listenForInputChanges();
    dateInput_1.setAttribute("max", (0, dateMaxValue_1.default)());
    individualProfileForm.addEventListener("submit", function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            resetIndividualProfileValidation_1();
            formValues = {
                firstName: firstNameInput_1.value,
                middleName: middleNameInput_1.value,
                lastName: lastNameInput_1.value,
                dateOfBirth: dateInput_1.value,
                countryOfBirth: countryInput_1.value,
            };
            validateForm_1();
            if (isFormValid_1) {
                isFormValid_1 = false;
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{"../../../helpers/dateMaxValue":2}],17:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],18:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var individualResetPassword = document.querySelector(".individual-reset-pass__form");
if (individualResetPassword) {
    var passwordInput_1 = document.querySelector(".individual-reset-pass__password");
    var passwordAgainInput_1 = document.querySelector(".individual-reset-pass__password-again");
    var passwordAgainValidation_1 = document.querySelector(".individual-reset-pass__validation-password-again");
    var criteriaItems_1 = individualResetPassword.querySelectorAll(".individual-reset-pass__item");
    var showPasswordButtons = individualResetPassword.querySelectorAll(".zmdi-eye");
    var hidePasswordButtons = individualResetPassword.querySelectorAll(".zmdi-eye-off");
    var validations_1 = [false, false, false, false, false];
    var formValidation_1 = {
        password: false
    };
    var isSubmitClickedFirstTime_1 = false;
    var showValidationMessage_1 = function () {
        if (isSubmitClickedFirstTime_1) {
            passwordAgainValidation_1.classList.add("individual-reset-pass__validation--active");
        }
    };
    var removeValidationMessage_1 = function () {
        passwordAgainValidation_1.classList.remove("individual-reset-pass__validation--active");
    };
    var validatePassword_1 = function (password) {
        validations_1 = [false, false, false, false, false];
        if (password.length > 5) {
            validations_1[0] = true;
        }
        if (/(?=.*[a-z])/.test(password)) {
            validations_1[1] = true;
        }
        if (/(?=.*[A-Z])/.test(password)) {
            validations_1[2] = true;
        }
        if (/(?=.*\d)/.test(password)) {
            validations_1[3] = true;
        }
        if (/(?=.*[!@#$&*])/.test(password)) {
            validations_1[4] = true;
        }
        var isPasswordValid = false;
        if (passwordInput_1.value === passwordAgainInput_1.value && validations_1.every(function (val) { return val === true; })) {
            isPasswordValid = true;
            removeValidationMessage_1();
        }
        else {
            showValidationMessage_1();
        }
        if (!isPasswordValid) {
            formValidation_1.password = false;
        }
        else {
            formValidation_1.password = true;
        }
        return isPasswordValid ? "Password is valid." : validations_1;
    };
    var resetCriteriaItems_1 = function () {
        criteriaItems_1.forEach(function (item) {
            item.classList.remove("individual-reset-pass__item--active");
        });
    };
    showPasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.setAttribute("type", "text");
            button.classList.remove("zmdi-eye--active");
            button.nextElementSibling.classList.add("zmdi-eye-off--active");
        });
    });
    hidePasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.previousElementSibling.setAttribute("type", "password");
            button.classList.remove("zmdi-eye-off--active");
            button.previousElementSibling.classList.add("zmdi-eye--active");
        });
    });
    passwordInput_1.addEventListener("input", function () {
        validatePassword_1(passwordInput_1.value);
        for (var i = 0; i < criteriaItems_1.length; i++) {
            if (validations_1[i] === true) {
                criteriaItems_1[i].classList.add("individual-reset-pass__item--active");
            }
            else {
                criteriaItems_1[i].classList.remove("individual-reset-pass__item--active");
            }
        }
    });
    passwordAgainInput_1.addEventListener("input", function () {
        validatePassword_1(passwordAgainInput_1.value);
    });
    individualResetPassword.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            isSubmitClickedFirstTime_1 = true;
            if (passwordInput_1.value !== passwordAgainInput_1.value) {
                showValidationMessage_1();
            }
            formValues = {
                password: passwordInput_1.value,
            };
            if (formValidation_1.password === true) {
                console.log(formValues);
                validations_1 = [false, false, false, false, false];
                formValidation_1 = {
                    password: false
                };
                resetCriteriaItems_1();
            }
            else {
                console.log("Form is NOT valid");
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{}],19:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var signUpIndividual = document.querySelector('.sign-in-details__form');
if (signUpIndividual) {
    var emailInput_1 = document.querySelector('.sign-in-details__email');
    var passwordInput_1 = document.querySelector('.sign-in-details__password');
    var passwordAgainInput_1 = document.querySelector('.sign-in-details__password-again');
    var passwordAgainValidation_1 = document.querySelector('.sign-in-details__validation-password-again');
    var signUpIndividualEmailValidation_1 = document.querySelector('.sign-in-details__validation-email');
    var criteriaItems_1 = signUpIndividual.querySelectorAll('.sign-in-details__item');
    var showPasswordButtons = signUpIndividual.querySelectorAll('.zmdi-eye');
    var hidePasswordButtons = signUpIndividual.querySelectorAll('.zmdi-eye-off');
    var regexPattern_1 = signUpIndividual.getAttribute("pattern") || null;
    var conditions_1 = [];
    var validations_1 = [false];
    var formValidation_1 = {
        email: false,
        password: false,
    };
    var recaptcha = false;
    window.recaptcha = false;
    var isSubmitClickedFirstTime_1 = false;
    var extractConditions_1 = function (regexPattern) {
        validations_1 = [false];
        conditions_1 = [];
        conditions_1 = regexPattern.match(new RegExp("\\(\\?=(.*?)\\)|\\(\\?!(.*?)\\)|\\(\\?<=(.*?)\\)|\\(\\?<(.*?)\\)", "g"));
        conditions_1 = conditions_1.filter(function (condition) { return condition !== null; });
        conditions_1.map(function (condition) { return validations_1.push(false); });
    };
    var showValidationMessage_1 = function () {
        if (isSubmitClickedFirstTime_1) {
            passwordAgainValidation_1.classList.add("sign-in-details__validation--active");
        }
    };
    var removeValidationMessage_1 = function () {
        passwordAgainValidation_1.classList.remove("sign-in-details__validation--active");
    };
    var validateEmail_1 = function (email) {
        var trimmedEmail = email.trim().toLowerCase();
        if (String(trimmedEmail).match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9\-]*[a-zA-Z][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}))$/)) {
            signUpIndividualEmailValidation_1.classList.remove("sign-in-details__validation--active");
            formValidation_1.email = true;
        }
        else {
            signUpIndividualEmailValidation_1.classList.add("sign-in-details__validation--active");
            formValidation_1.email = false;
        }
    };
    function validateRecaptcha() {
        window.recaptcha = true;
    }
    window.validateRecaptcha = validateRecaptcha;
    var validatePassword_1 = function (password) {
        extractConditions_1(regexPattern_1);
        if (password.length > 5) {
            validations_1[0] = true;
        }
        conditions_1.forEach(function (cond, index) {
            if (new RegExp(cond).test(password)) {
                validations_1[index + 1] = true;
            }
        });
        var isPasswordValid = false;
        if (passwordInput_1.value && validations_1.every(function (val) { return val === true; })) {
            isPasswordValid = true;
            removeValidationMessage_1();
            resetCriteriaItems_1();
        }
        else {
            showValidationMessage_1();
        }
        if (isPasswordValid) {
            formValidation_1.password = true;
        }
        else {
            formValidation_1.password = false;
        }
        return isPasswordValid ? "Password is valid." : validations_1;
    };
    var resetCriteriaItems_1 = function () {
        criteriaItems_1.forEach(function (item) {
            item.classList.remove("sign-in-details__item--active");
        });
    };
    showPasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.setAttribute("type", "text");
            button.classList.remove("zmdi-eye--active");
            button.nextElementSibling.classList.add("zmdi-eye-off--active");
        });
    });
    hidePasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.previousElementSibling.setAttribute("type", "password");
            button.classList.remove("zmdi-eye-off--active");
            button.previousElementSibling.classList.add("zmdi-eye--active");
        });
    });
    emailInput_1.addEventListener("input", function () {
        if (isSubmitClickedFirstTime_1) {
            validateEmail_1(emailInput_1.value);
        }
    });
    passwordInput_1.addEventListener("input", function () {
        validatePassword_1(passwordInput_1.value);
        for (var i = 0; i < criteriaItems_1.length; i++) {
            if (validations_1[i] === true) {
                criteriaItems_1[i].classList.add("sign-in-details__item--active");
            }
            else {
                criteriaItems_1[i].classList.remove("sign-in-details__item--active");
            }
        }
    });
    passwordAgainInput_1.addEventListener("input", function () {
        removeValidationMessage_1();
    });
    signUpIndividual.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            isSubmitClickedFirstTime_1 = true;
            if (passwordInput_1.value !== passwordAgainInput_1.value) {
                showValidationMessage_1();
            }
            emailInput_1.value = emailInput_1.value.trim();
            validateEmail_1(emailInput_1.value);
            formValues = {
                email: emailInput_1.value,
                password: passwordInput_1.value,
            };
            if (formValidation_1.email === true
                && formValidation_1.password === true
                && passwordInput_1.value === passwordAgainInput_1.value
                && window.recaptcha === true) {
                formValidation_1 = {
                    email: false,
                    password: false
                };
                resetCriteriaItems_1();
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
    if (regexPattern_1) {
        extractConditions_1(regexPattern_1);
    }
}
},{}],20:[function(require,module,exports){
var keyFactCardTitles = document.querySelectorAll('.key-facts__card-title');
var numberRegex = /\d+\.?\d*/;
keyFactCardTitles.forEach(function (title) {
    var match = title.innerText.match(numberRegex);
    if (!match)
        return;
    var targetCount = parseFloat(match[0]);
    var currentCount = 0;
    var increment = targetCount < 10 ? 0.1 : 10;
    var isCountUpComplete = false;
    var isCountUpRunning = false;
    var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !isCountUpComplete && !isCountUpRunning) {
            isCountUpRunning = true;
            var interval_1 = setInterval(function () {
                if (targetCount === 0) {
                    currentCount = targetCount;
                }
                else {
                    currentCount = +(currentCount + increment).toFixed(1);
                }
                title.innerText = title.innerText.replace(numberRegex, currentCount.toString());
                if (currentCount >= targetCount) {
                    clearInterval(interval_1);
                    isCountUpComplete = true;
                    isCountUpRunning = false;
                }
            }, 100);
        }
    });
    observer.observe(title);
});
},{}],21:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var loginForm = document.querySelector(".login__form");
if (loginForm) {
    var resetLoginValidation_1 = function () {
        loginForm.querySelectorAll(".login__validation--active").forEach(function (node) {
            node.classList.remove("login__validation--active");
        });
    };
    var usernameInput_1 = document.querySelector(".login__username");
    var passwordInput_1 = document.querySelector(".login__password");
    var loginUsernameValidation_1 = document.querySelector(".login__validation-username");
    var loginPasswordValidation_1 = document.querySelector(".login__validation-password");
    usernameInput_1.addEventListener("input", function () {
        loginUsernameValidation_1.classList.remove("login__validation--active");
    });
    passwordInput_1.addEventListener("input", function () {
        loginPasswordValidation_1.classList.remove("login__validation--active");
    });
    loginForm.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            resetLoginValidation_1();
            if (!usernameInput_1.value) {
                loginUsernameValidation_1.classList.add("login__validation--active");
            }
            if (!passwordInput_1.value) {
                loginPasswordValidation_1.classList.add("login__validation--active");
            }
            if (!(usernameInput_1.value && passwordInput_1.value)) {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
(function () {
    var rotatingElementLogin = document.querySelector('.login__image');
    var lastScrollTop = 0;
    if (rotatingElementLogin) {
        rotatingElementLogin.addEventListener('mouseover', function () {
            window.addEventListener('scroll', handleLoginScroll);
        });
    }
    function handleLoginScroll() {
        var scrollPos = window.scrollY;
        var rotation = (scrollPos - lastScrollTop) / 2;
        var translateZ = Math.max(0, scrollPos / 30);
        rotation = Math.min(Math.max(rotation, -20), 10);
        rotatingElementLogin.style.transform = "rotateY(".concat(rotation, "deg) rotateX(").concat(rotation, "deg) translateZ(").concat(translateZ, "px)");
        lastScrollTop = scrollPos;
    }
})();
},{}],22:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var mediaCarousels = document.querySelectorAll(".media-carousel__carousel-inner");
if (mediaCarousels.length > 0) {
    var mediaCarouselsArray = Array.from(mediaCarousels) || [];
    mediaCarouselsArray.forEach(function (item) {
        var glide = new glide_1.default(item, {
            type: 'carousel',
            perView: 1.779,
            gap: 20,
            rewind: true,
            bound: true,
            focusAt: "center",
            breakpoints: {
                480: {
                    perView: 1.357,
                },
            }
        });
        glide.mount();
    });
}
},{"@glidejs/glide":51}],23:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var mobileMenuPlatform = document.querySelector('.menu-mobile-platform__container');
if (mobileMenuPlatform) {
    var mobileMenuOverlayPlatform_1 = document.querySelector('.menu-mobile-platform__overlay');
    var mobileMenuIconPlatform_1 = document.querySelector('.menu-mobile-platform__icon');
    var mobileMenuIconContainerPlatform = document.querySelector('.menu-mobile-platform__icon-container');
    var mobileMenuButtonPlatform = document.querySelector('.menu-mobile-platform__icon-container');
    var htmlPlatform_1 = document.querySelector('html');
    var carousel = mobileMenuPlatform.querySelector('.menu-mobile-platform__carousel');
    var cards = carousel.querySelectorAll('.dashboard-contact');
    var recipientDetailsOverlays_1 = mobileMenuPlatform.querySelectorAll('.recipient-detail__overlay');
    var closeButtons = mobileMenuPlatform.querySelectorAll('.recipient-detail__close');
    var handleOverlay_1 = function (card, index, overlays) {
        var activeIndex = index;
        card.addEventListener('click', function () {
            overlays[activeIndex].classList.add('recipient-detail__overlay--active');
        });
        card.addEventListener('keydown', function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === 'Enter') {
                overlays[activeIndex].classList.add('recipient-detail__overlay--active');
            }
        });
        if (overlays[activeIndex]) {
            overlays[activeIndex].addEventListener('click', function (e) {
                var targetElement = e.target;
                if (targetElement.classList.contains('recipient-detail__overlay')) {
                    overlays[activeIndex].classList.remove('recipient-detail__overlay--active');
                }
            });
        }
    };
    var handleMenuClose_1 = function () {
        mobileMenuIconPlatform_1.classList.remove('menu-mobile-platform__icon--open');
        mobileMenuOverlayPlatform_1.classList.remove('menu-mobile-platform__overlay--active');
        htmlPlatform_1.style.overflow = 'auto';
    };
    var handleShowMenu_1 = function () {
        mobileMenuIconPlatform_1.classList.add('menu-mobile-platform__icon--open');
        mobileMenuOverlayPlatform_1.classList.add('menu-mobile-platform__overlay--active');
        htmlPlatform_1.style.overflow = 'hidden';
    };
    mobileMenuOverlayPlatform_1.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            handleMenuClose_1();
        }
    });
    mobileMenuOverlayPlatform_1.addEventListener('click', function (e) {
        var targetElement = e.target;
        if (targetElement.className === 'menu-mobile-platform__overlay menu-mobile-platform__overlay--active') {
            handleMenuClose_1();
        }
    });
    if (carousel) {
        var glide = new glide_1.default(carousel, {
            type: 'slider',
            perView: 1.3,
            gap: 10,
            rewind: false,
            bound: false,
        });
        glide.mount();
        cards.forEach(function (card, index) {
            handleOverlay_1(card, index, recipientDetailsOverlays_1);
        });
        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                button.parentElement.parentElement.parentElement.parentElement.classList.remove('recipient-detail__overlay--active');
            });
        });
    }
    if (mobileMenuIconContainerPlatform) {
        mobileMenuIconContainerPlatform.addEventListener('click', function (e) {
            if (mobileMenuIconPlatform_1.classList.contains('menu-mobile-platform__icon--open')) {
                handleMenuClose_1();
            }
            else {
                handleShowMenu_1();
            }
        });
    }
    if (mobileMenuButtonPlatform) {
        mobileMenuButtonPlatform.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                if (mobileMenuIconPlatform_1.classList.contains('menu-mobile-platform__icon--open')) {
                    handleMenuClose_1();
                }
                else {
                    handleShowMenu_1();
                }
            }
        });
    }
}
},{"@glidejs/glide":51}],24:[function(require,module,exports){
var mobileMenuIcon = document.querySelector(".menu-mobile__icon");
var mobileMenuIconContainer = document.querySelector(".menu-mobile__icon-container");
var mobileMenuButton = document.querySelector(".menu-mobile__icon-container");
var mobileMenuBackButton = document.querySelector(".menu-mobile__back");
var getInTouchButton = document.querySelector(".menu-mobile__button");
var mobileMenuOverlay = document.querySelector(".menu-mobile__overlay");
var mobileMenuNested = document.querySelector(".menu-mobile__nested");
var html = document.querySelector("html");
if (mobileMenuIconContainer) {
    mobileMenuIconContainer.addEventListener("click", function (e) {
        if (mobileMenuIcon.classList.contains("menu-mobile__icon--open")) {
            mobileMenuIcon.classList.remove("menu-mobile__icon--open");
            mobileMenuOverlay.classList.remove("menu-mobile__overlay--active");
            setTimeout(function () {
                mobileMenuNested.classList.remove("menu-mobile__nested--active");
            }, 500);
            html.style.overflow = "auto";
        }
        else {
            mobileMenuIcon.classList.add("menu-mobile__icon--open");
            mobileMenuOverlay.classList.add("menu-mobile__overlay--active");
            html.style.overflow = "hidden";
        }
    });
}
if (mobileMenuButton) {
    mobileMenuButton.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            if (mobileMenuIcon.classList.contains("menu-mobile__icon--open")) {
                mobileMenuIcon.classList.remove("menu-mobile__icon--open");
                mobileMenuOverlay.classList.remove("menu-mobile__overlay--active");
                setTimeout(function () {
                    mobileMenuNested.classList.remove("menu-mobile__nested--active");
                }, 500);
                html.style.overflow = "auto";
            }
            else {
                mobileMenuIcon.classList.add("menu-mobile__icon--open");
                mobileMenuOverlay.classList.add("menu-mobile__overlay--active");
                html.style.overflow = "hidden";
            }
        }
    });
}
if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            mobileMenuIcon.classList.remove("menu-mobile__icon--open");
            mobileMenuOverlay.classList.remove("menu-mobile__overlay--active");
            setTimeout(function () {
                mobileMenuNested.classList.remove("menu-mobile__nested--active");
            }, 500);
            html.style.overflow = "auto";
        }
    });
    mobileMenuOverlay.addEventListener("click", function (e) {
        var targetElement = e.target;
        if (targetElement.className === "menu-mobile__overlay menu-mobile__overlay--active") {
            mobileMenuIcon.classList.remove("menu-mobile__icon--open");
            mobileMenuOverlay.classList.remove("menu-mobile__overlay--active");
            setTimeout(function () {
                mobileMenuNested.classList.remove("menu-mobile__nested--active");
            }, 500);
            html.style.overflow = "auto";
        }
    });
}
if (getInTouchButton) {
    getInTouchButton.addEventListener("click", function (e) {
        mobileMenuNested.classList.add("menu-mobile__nested--active");
    });
}
if (mobileMenuBackButton) {
    mobileMenuBackButton.addEventListener("click", function (e) {
        mobileMenuNested.classList.remove("menu-mobile__nested--active");
    });
}
},{}],25:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var account = document.querySelector(".account__wrapper");
if (account) {
    var type_1 = null;
    var conditions_1 = [];
    var validations_1 = [false];
    var validationMessages_1 = [
        "Must be at least 6 characters long. ",
        "Must have at least one lowercase letter. ",
        "Must have at least one uppercase letter. ",
        "Must include a number. ",
        "Must include any of the following symbols: !@#$&*."
    ];
    var changeButtons = account.querySelectorAll(".account__button");
    var closeButtons = account.querySelectorAll(".account-slider__close");
    var overlays_1 = account.querySelectorAll(".account-slider__overlay");
    var passwordInputs_1 = account.querySelectorAll(".account-slider__password");
    var passwordOldInput_1 = document.querySelector('.account-slider__password-old');
    var passwordOldValidation_1 = document.querySelector('.account-slider__validation-password-old');
    var passwordNewInput_1 = document.querySelector('.account-slider__password-new');
    var passwordNewValidation_1 = document.querySelector('.account-slider__validation-password-new');
    var passwordAgainInput_1 = document.querySelector('.account-slider__password-again');
    var passwordAgainValidation_1 = document.querySelector('.account-slider__validation-password-again');
    var photoValidation_1 = document.querySelector('.account-slider__validation-photo');
    var showPasswordButtons = account.querySelectorAll('.zmdi-eye');
    var hidePasswordButtons = account.querySelectorAll('.zmdi-eye-off');
    var countryDropdown_1 = document.querySelector('#account-slider__country');
    var countryOptions_1 = countryDropdown_1 === null || countryDropdown_1 === void 0 ? void 0 : countryDropdown_1.querySelectorAll('option');
    var currencyDropdown_1 = document.querySelector('.account-slider__currency');
    var currencyOptions_1 = currencyDropdown_1 === null || currencyDropdown_1 === void 0 ? void 0 : currencyDropdown_1.querySelectorAll('option');
    var uploadInput = document.querySelector('.account__upload-input');
    var forms = account.querySelectorAll(".account-slider__form");
    var passwordForm = account.querySelector(".account-slider__password-form");
    var regexPattern = passwordForm.getAttribute("pattern") || null;
    var notification_1 = account.querySelector(".account__notify");
    var submitButtons_1 = account.querySelectorAll(".button__label");
    var accountImages_1 = document.querySelectorAll(".account__image");
    var isLoading_1 = false;
    var successElm_1 = account.querySelector(".account__notify--success");
    var failElm_1 = account.querySelector(".account__notify--fail");
    var currentCountryElm_1 = account.querySelector("#currentResidenceCountry");
    var currentCurrencyElm_1 = account.querySelector("#currentCurrency");
    var closeOverlays_1 = function () {
        overlays_1.forEach(function (item) { return item.classList.remove("account-slider__overlay--active"); });
        setTimeout(function () {
            clearForm_1();
            resetValidations_1();
        }, 500);
    };
    var resetValidations_1 = function () {
        passwordOldValidation_1.classList.remove("account-slider__validation--active");
        passwordNewValidation_1.classList.remove("account-slider__validation--active");
        passwordAgainValidation_1.classList.remove("account-slider__validation--active");
        photoValidation_1.classList.remove("account-slider__validation--active");
    };
    var validatePasswords_1 = function () {
        if (!passwordOldInput_1.value) {
            passwordOldValidation_1.classList.add("account-slider__validation--active");
            passwordOldValidation_1.textContent = "This field cannot be empty";
            return false;
        }
        if (!passwordNewInput_1.value) {
            passwordNewValidation_1.classList.add("account-slider__validation--active");
            passwordNewValidation_1.textContent = "This field cannot be empty";
            return false;
        }
        if (!passwordAgainInput_1.value) {
            passwordAgainValidation_1.classList.add("account-slider__validation--active");
            passwordAgainValidation_1.textContent = "This field cannot be empty";
            return false;
        }
        if (passwordNewInput_1.value !== passwordAgainInput_1.value) {
            passwordNewValidation_1.classList.add("account-slider__validation--active");
            passwordNewValidation_1.textContent = "The passwords do not match.";
            passwordAgainValidation_1.classList.add("account-slider__validation--active");
            passwordAgainValidation_1.textContent = "The passwords do not match.";
            return false;
        }
        return true;
    };
    var showPhotoValidations_1 = function () {
        photoValidation_1.classList.add("account-slider__validation--active");
    };
    var validatePhoto_1 = function (file) {
        if (file && file.size <= 5000000) {
            return true;
        }
        showPhotoValidations_1();
        return false;
    };
    var clearForm_1 = function () {
        passwordInputs_1.forEach(function (input) { return input.value = ""; });
    };
    var updateButtons_1 = function () {
        submitButtons_1.forEach(function (button) { return button.disabled = isLoading_1; });
    };
    var updateMessages_1 = function (success) {
        if (success) {
            failElm_1.classList.remove("active");
            successElm_1.classList.add("active");
        }
        else if (success === false) {
            failElm_1.classList.add("active");
            successElm_1.classList.remove("active");
        }
        else if (isLoading_1) {
            failElm_1.classList.remove("active");
            successElm_1.classList.remove("active");
        }
    };
    var updateUI_1 = function (success) {
        updateButtons_1();
        updateMessages_1(success);
        if (success) {
            clearForm_1();
            closeOverlays_1();
        }
        else if (success === false) {
            closeOverlays_1();
        }
    };
    var enableOptions_1 = function (options, currentOptionIdx) {
        options.forEach(function (option) {
            option.disabled = false;
            option.style.color = "#000";
        });
        options[currentOptionIdx].disabled = true;
        options[currentOptionIdx].style.color = "rgba(0, 0, 0, 0.5)";
    };
    var updateCurrency_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, data, exception_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading_1 = true;
                    updateUI_1();
                    payload = {
                        currencyName: currencyDropdown_1.value
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post("/api/member/updatePreferredCurrency", payload)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    isLoading_1 = false;
                    updateUI_1(data.success);
                    if (data.success) {
                        enableOptions_1(currencyOptions_1, currencyDropdown_1.selectedIndex);
                        currentCurrencyElm_1.textContent = currencyDropdown_1.options[currencyDropdown_1.selectedIndex].text;
                    }
                    return [3, 4];
                case 3:
                    exception_1 = _a.sent();
                    updateUI_1(false);
                    console.log(exception_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var updateCountry_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, data, exception_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading_1 = true;
                    updateUI_1();
                    payload = {
                        country: countryDropdown_1.value
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post("/api/member/updateResidenceCountry", payload)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    isLoading_1 = false;
                    updateUI_1(data.success);
                    if (data.success) {
                        enableOptions_1(countryOptions_1, countryDropdown_1.selectedIndex);
                        currentCountryElm_1.textContent = countryDropdown_1.options[countryDropdown_1.selectedIndex].text;
                    }
                    return [3, 4];
                case 3:
                    exception_2 = _a.sent();
                    updateUI_1(false);
                    console.log(exception_2);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var updatePassword_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, data, exception_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading_1 = true;
                    updateUI_1();
                    payload = {
                        currentPassword: passwordOldInput_1.value,
                        newPassword: passwordNewInput_1.value
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post("/api/member/updatePassword", payload)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    isLoading_1 = false;
                    if (!data.success) {
                        passwordOldValidation_1.classList.add("account-slider__validation--active");
                        passwordOldValidation_1.textContent = data.message;
                        updateUI_1();
                    }
                    else {
                        updateUI_1(true);
                    }
                    return [3, 4];
                case 3:
                    exception_3 = _a.sent();
                    updateUI_1(false);
                    console.log(exception_3);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var updateProfilePicture_1 = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, data, exception_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading_1 = true;
                    updateUI_1();
                    payload = new FormData();
                    payload.append("profilePicture", file);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post("/api/member/updateProfilePicture", payload)];
                case 2:
                    response = _a.sent();
                    data = response.data;
                    isLoading_1 = false;
                    updateUI_1(data.success);
                    if (data.success) {
                        accountImages_1.forEach(function (img) {
                            img.src = URL.createObjectURL(file);
                            img.classList.remove("navbar-platform__avatar--default");
                            img.classList.remove("account__image--default");
                        });
                    }
                    return [3, 4];
                case 3:
                    exception_4 = _a.sent();
                    updateUI_1(false);
                    console.log(exception_4);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handlePasswordSubmit_1 = function (e) {
        e.preventDefault();
        resetValidations_1();
        if (validatePasswords_1() && validateRegexPassword_1(passwordNewInput_1.value)) {
            updatePassword_1();
        }
    };
    var handleCountrySubmit_1 = function (e) {
        e.preventDefault();
        updateCountry_1();
    };
    var handleCurrencySubmit_1 = function (e) {
        e.preventDefault();
        updateCurrency_1();
    };
    var handlePhotoSubmit_1 = function (e, file) {
        e.preventDefault();
        resetValidations_1();
        if (validatePhoto_1(file)) {
            updateProfilePicture_1(file);
        }
    };
    var validateRegexPassword_1 = function (password) {
        if (password && (password === null || password === void 0 ? void 0 : password.length) > 5) {
            validations_1[0] = true;
        }
        conditions_1.forEach(function (cond, index) {
            if (new RegExp(cond).test(password)) {
                validations_1[index + 1] = true;
            }
        });
        var isPasswordValid = false;
        if (validations_1.every(function (val) { return val === true; })) {
            isPasswordValid = true;
        }
        else {
            isPasswordValid = false;
            showRegexPasswordValidationMessage_1();
        }
        return isPasswordValid;
    };
    var showRegexPasswordValidationMessage_1 = function () {
        var validationMessage = validations_1
            .map(function (isValid, index) { return !isValid ? validationMessages_1[index] : ""; })
            .filter(function (msg) { return msg; })
            .join(" ");
        if (validations_1.every(function (val) { return val === true; })) {
            return;
        }
        else {
            passwordNewValidation_1.classList.add("account-slider__validation--active");
            passwordNewValidation_1.textContent = validationMessage;
            return;
        }
    };
    var extractConditions = function (regexPattern) {
        conditions_1 = regexPattern.match(/\(\?=(.*?)\)|\(\?!(.*?)\)|\(\?<=(.*?)\)|\(\?<(.*?)\)/g);
        conditions_1 = conditions_1.filter(function (condition) { return condition !== null; });
        conditions_1.map(function (condition) { return validations_1.push(false); });
    };
    var hideNotification = function () {
        var time = notification_1.getAttribute("data-timeout");
        if (time) {
            setTimeout(function () {
                notification_1.classList.remove("account__notify--fail");
                notification_1.classList.remove("account__notify--success");
            }, +time);
        }
    };
    uploadInput.addEventListener('change', function (e) {
        var target = e.target;
        var file = target.files[0];
        handlePhotoSubmit_1(e, file);
    });
    overlays_1.forEach(function (item) {
        item.addEventListener("click", function (e) {
            var target = e.target;
            if (target.classList.contains("account-slider__overlay--active"))
                closeOverlays_1();
        });
    });
    closeButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            closeOverlays_1();
        });
    });
    changeButtons.forEach(function (button, index) {
        button.addEventListener("click", function () {
            button.nextElementSibling.classList.add("account-slider__overlay--active");
            if (button.classList.contains("account__button-password")) {
                type_1 = "password";
            }
            else if (button.classList.contains("account__button-country")) {
                type_1 = "country";
            }
            else if (button.classList.contains("account__button-currency")) {
                type_1 = "currency";
            }
        });
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeOverlays_1();
        }
    });
    showPasswordButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            button.previousElementSibling.setAttribute('type', 'text');
            button.classList.remove('zmdi-eye--active');
            button.nextElementSibling.classList.add('zmdi-eye-off--active');
        });
    });
    hidePasswordButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            button.previousElementSibling.previousElementSibling.setAttribute('type', 'password');
            button.classList.remove('zmdi-eye-off--active');
            button.previousElementSibling.classList.add('zmdi-eye--active');
        });
    });
    passwordOldInput_1.addEventListener("input", function () {
        resetValidations_1();
    });
    passwordNewInput_1.addEventListener("input", function () {
        resetValidations_1();
    });
    passwordAgainInput_1.addEventListener("input", function () {
        resetValidations_1();
    });
    forms.forEach(function (form) {
        form.addEventListener("submit", function (e) {
            switch (type_1) {
                case "password":
                    handlePasswordSubmit_1(e);
                    break;
                case "country":
                    handleCountrySubmit_1(e);
                    break;
                case "currency":
                    handleCurrencySubmit_1(e);
                    break;
                default:
                    null;
            }
        });
    });
    if (regexPattern) {
        extractConditions(regexPattern);
    }
    if (notification_1.classList.contains("account__notify--fail") || notification_1.classList.contains("account__notify--success")) {
        hideNotification();
    }
}
},{"axios":52}],26:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],27:[function(require,module,exports){
var sendFundsButton = document.querySelector(".navbar__button-funds");
var sendFunds = document.querySelector(".send-funds__overlay");
var sendFundsMobileButton = document.querySelector(".navbar__sticky-button");
var htmlElement = document.documentElement;
var navbar = document.querySelector(".navbar");
var pageLinkCurrent = function (link) {
    var currentUrl = window.location.pathname.split("/")[1];
    if (currentUrl) {
        return link.includes(currentUrl);
    }
    return false;
};
if (sendFundsButton) {
    sendFundsButton.addEventListener("click", function (e) {
        if (sendFunds.classList.contains("send-funds__overlay--open")) {
            sendFunds.classList.remove("send-funds__overlay--active");
            htmlElement.style.overflow = "auto";
        }
        else {
            sendFunds.classList.add("send-funds__overlay--active");
            htmlElement.style.overflow = "hidden";
        }
    });
}
if (sendFundsMobileButton) {
    sendFundsMobileButton.addEventListener("click", function (e) {
        if (sendFunds.classList.contains("send-funds__overlay--open")) {
            sendFunds.classList.remove("send-funds__overlay--active");
            htmlElement.style.overflow = "auto";
        }
        else {
            sendFunds.classList.add("send-funds__overlay--active");
            htmlElement.style.overflow = "hidden";
        }
    });
}
if (navbar) {
    var links = navbar.querySelectorAll(".navbar__links-item .link");
    links.forEach(function (link) {
        var href = link.href;
        if (pageLinkCurrent(href)) {
            link.classList.add("link--active");
        }
    });
}
},{}],28:[function(require,module,exports){
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var axios_1 = __importDefault(require("axios"));
var newPaymentComponent = document.querySelector(".new-pay__wrapper");
if (newPaymentComponent) {
    var searchInput_1 = newPaymentComponent.querySelector(".new-pay__form-desktop .new-pay__search");
    var searchInputMobile_1 = newPaymentComponent.querySelector(".new-pay__form-mobile .new-pay__search");
    var newPaymentContacts_1 = newPaymentComponent.querySelector(".new-pay__contacts-list");
    var newPaymentRecipients_1 = newPaymentComponent.querySelector(".new-pay__recipients-list");
    var newPaymentCarousel = newPaymentComponent.querySelector(".new-pay__recipients-carousel");
    var newPayAmountText_1 = newPaymentComponent.querySelector(".new-pay__number");
    var recipientCards_1 = newPaymentRecipients_1.querySelectorAll(".dashboard-contact");
    var carouselCards_1 = newPaymentCarousel.querySelectorAll(".dashboard-contact");
    var loadMoreButton_1 = newPaymentComponent.querySelector(".new-pay__load");
    var loader_1 = newPaymentComponent.querySelector(".payments__loader");
    var contactDetails_1 = newPaymentComponent.querySelectorAll(".recipient-detail__overlay");
    var db_1 = {
        html: "",
        hasReachedEnd: false,
        lastId: 0
    };
    var isLoading_1 = false;
    var payload_1 = {
        keyword: "",
        lastId: 0,
        pageIncrement: 10
    };
    var handleOverlay_1 = function (card, index, overlays) {
        var activeIndex = index;
        card.addEventListener('click', function () {
            overlays[activeIndex].classList.add('recipient-detail__overlay--active');
        });
        card.addEventListener('keydown', function (e) {
            var keyboardEvent = e;
            if (keyboardEvent.key === 'Enter') {
                overlays[activeIndex].classList.add('recipient-detail__overlay--active');
            }
        });
        if (overlays[activeIndex]) {
            overlays[activeIndex].addEventListener('click', function (e) {
                var targetElement = e.target;
                if (targetElement.classList.contains('recipient-detail__overlay')) {
                    overlays[activeIndex].classList.remove('recipient-detail__overlay--active');
                }
            });
        }
    };
    var initGlide_1 = function (carousel, carouselRange, slides) {
        carouselRange.addEventListener("input", function () {
            setTimeout(function () {
                glide.go("=".concat(carouselRange.value));
            }, 500);
        });
        var setRangeMax = function (arr, input) {
            var slidesLength = arr.length;
            var rangeMax = '0';
            rangeMax = (slidesLength - 1).toString();
            input.max = rangeMax;
            setRangeThumbWidth(rangeMax, input);
        };
        var setRangeThumbWidth = function (max, input) {
            var width = 94 / +max;
            input.style.setProperty('--thumb-size', width.toString() + "px");
            if (max === "1") {
                input.style.setProperty('--thumb-size', "47px");
            }
        };
        var glide = new glide_1.default(carousel, {
            type: 'slider',
            perView: 1.37,
            gap: 11,
            rewind: false,
            bound: true,
        });
        glide.mount();
        glide.on('move.after', function () {
            var currentIndex = glide.index;
            carouselRange.value = currentIndex;
        });
        setRangeMax(slides, carouselRange);
        var carouselOverlays = carousel.querySelectorAll('.recipient-detail__overlay');
        carouselCards_1.forEach(function (card, i) {
            handleOverlay_1(card, i, carouselOverlays);
        });
    };
    var init = function () {
        var hookApiListeners = function () {
            var timeoutId;
            var handleSearch = function (e) {
                var target = e.target;
                var str = target.value;
                payload_1.keyword = str;
                payload_1.lastId = 0;
                db_1.html = "";
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function () {
                    fetchContacts_1();
                }, 1000);
            };
            loadMoreButton_1.addEventListener("click", function () {
                payload_1.lastId = db_1.lastId;
                fetchContacts_1();
            });
            searchInput_1.addEventListener("input", handleSearch);
            searchInputMobile_1.addEventListener("input", handleSearch);
        };
        var carousel = newPaymentComponent.querySelector(".new-pay__recipients-carousel");
        var carouselRange = newPaymentComponent.querySelector(".new-pay__range");
        var slides = carousel.querySelectorAll(".dashboard-contact");
        hookApiListeners();
        initGlide_1(carousel, carouselRange, slides);
    };
    var hookOverlays_1 = function () {
        var contactsCards = newPaymentContacts_1.querySelectorAll(".dashboard-contact");
        var closeButtons = newPaymentComponent.querySelectorAll(".recipient-detail__close");
        var contactsOverlays = newPaymentContacts_1.querySelectorAll('.recipient-detail__overlay');
        var recipientOverlays = newPaymentRecipients_1.querySelectorAll('.recipient-detail__overlay');
        contactsCards.forEach(function (card, i) {
            handleOverlay_1(card, i, contactsOverlays);
        });
        recipientCards_1.forEach(function (card, i) {
            handleOverlay_1(card, i, recipientOverlays);
        });
        closeButtons.forEach(function (button) {
            button.addEventListener("click", function () {
                contactDetails_1.forEach(function (item) { return item.classList.remove("recipient-detail__overlay--active"); });
                contactsCards.forEach(function (item) { return item.classList.remove("recipient-detail__overlay--active"); });
            });
        });
        contactDetails_1.forEach(function (item) {
            item.addEventListener("keydown", function (e) {
                var keyboardEvent = e;
                if (keyboardEvent.key === "Escape") {
                    item.classList.remove("recipient-detail__overlay--active");
                }
            });
        });
    };
    var clearData_1 = function () {
        var paymentsChildren = Array.from(newPaymentContacts_1.children);
        var itemsToKeep = [loadMoreButton_1.className, loader_1.className];
        paymentsChildren.forEach(function (child) {
            if (!itemsToKeep.includes(child.className)) {
                child.remove();
            }
        });
    };
    var refreshVariables_1 = function () {
        newPaymentContacts_1 = newPaymentComponent.querySelector(".new-pay__contacts-list");
        contactDetails_1 = newPaymentComponent.querySelectorAll(".recipient-detail__overlay");
    };
    var updateUI_1 = function () {
        var _a;
        refreshVariables_1();
        if (isLoading_1) {
            clearData_1();
            refreshVariables_1();
            loadMoreButton_1.classList.add("hidden");
            loader_1.classList.add("payments__loader--active");
            (_a = newPaymentContacts_1.querySelector(".payments__item-caption")) === null || _a === void 0 ? void 0 : _a.remove();
            newPayAmountText_1.textContent = "(0)";
        }
        else {
            loader_1.classList.remove("payments__loader--active");
            if (!db_1.hasReachedEnd) {
                loadMoreButton_1.classList.remove("hidden");
            }
            if (db_1.html) {
                newPaymentContacts_1.insertAdjacentHTML("afterbegin", db_1.html);
            }
            if (db_1.hasReachedEnd) {
                newPaymentContacts_1.insertAdjacentHTML("beforeend", '<li class="payments__item-caption flex flex--align-center flex--justify-center">End of results</li>');
            }
            else {
                loadMoreButton_1.classList.remove("hidden");
            }
            refreshVariables_1();
            newPayAmountText_1.textContent = "(".concat(newPaymentContacts_1.querySelectorAll(".dashboard-contact").length.toString(), ")");
        }
        hookOverlays_1();
    };
    var fetchContacts_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1, listElement, cardDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading_1)
                        return [2];
                    isLoading_1 = true;
                    updateUI_1();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, axios_1.default.get("/api/contacts/getAllContacts", {
                            params: __assign({}, payload_1),
                        })];
                case 2:
                    response = (_a.sent()).data;
                    isLoading_1 = false;
                    db_1.html += response.html;
                    db_1.hasReachedEnd = response.hasReachedEnd;
                    db_1.lastId = response.lastId;
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 5];
                case 4:
                    updateUI_1();
                    hookOverlays_1();
                    listElement = newPaymentComponent.querySelector(".new-pay__contacts-list");
                    cardDetails = listElement.querySelectorAll(".recipient-detail");
                    cardDetails.forEach(function (item) {
                        var carousel = item.querySelector(".recipient-detail__carousel");
                        var carouselRange = item.querySelector(".recipient-detail__carousel-range");
                        var slides = item.querySelectorAll(".recipient-detail__item");
                        initGlide_1(carousel, carouselRange, slides);
                    });
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    hookOverlays_1();
    init();
    fetchContacts_1();
}
},{"@glidejs/glide":51,"axios":52}],29:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],30:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var newRecipientComponent = document.querySelector('.new-recipient__wrapper');
if (newRecipientComponent) {
    var forms = newRecipientComponent.querySelectorAll('.new-recipient__form');
    var inputs_1 = newRecipientComponent.querySelectorAll('.new-recipient__input');
    var button_1 = newRecipientComponent.querySelector('.new-recipient__button');
    var loader_1 = newRecipientComponent.querySelector('.loader');
    var validStatus_1 = newRecipientComponent.querySelector('.new-recipient__status--valid');
    var invalidStatus_1 = newRecipientComponent.querySelector('.new-recipient__status--invalid');
    var isLoading_1 = false;
    var payload_1 = {
        CardNumber: "",
        Cvv: ""
    };
    var response_1;
    var reset_1 = function () {
        inputs_1.forEach(function (input) {
            input.classList.remove('new-recipient__input--active');
            input.classList.remove('new-recipient__input--error');
        });
        validStatus_1.classList.remove('new-recipient__status--active');
        invalidStatus_1.classList.remove('new-recipient__status--active');
        button_1.disabled = true;
    };
    var handleValid_1 = function () {
        inputs_1.forEach(function (input) { return input.classList.add('new-recipient__input--active'); });
        validStatus_1.classList.add('new-recipient__status--active');
        button_1.disabled = false;
        return true;
    };
    var handleInvalid_1 = function () {
        inputs_1.forEach(function (input) { return input.classList.add('new-recipient__input--error'); });
        invalidStatus_1.classList.add('new-recipient__status--active');
        button_1.disabled = true;
        return false;
    };
    var showLoader_1 = function () {
        inputs_1.forEach(function (input) { return (input.disabled = true); });
        loader_1.classList.add('loader--active');
    };
    var removeLoader_1 = function () {
        inputs_1.forEach(function (input) { return (input.disabled = false); });
        loader_1.classList.remove('loader--active');
    };
    var getCardPayload_1 = function () {
        var cardNumberInputs = newRecipientComponent.querySelectorAll('.new-recipient__input--card-number');
        var cvvInputs = newRecipientComponent.querySelectorAll('.new-recipient__input--card-cvv');
        var cardNumber = Array.from(cardNumberInputs).map(function (input) { return input.value; }).join('');
        var cvv = Array.from(cvvInputs).map(function (input) { return input.value; }).join('');
        return {
            CardNumber: cardNumber,
            Cvv: cvv
        };
    };
    var updateUI_1 = function () {
        if (isLoading_1) {
            showLoader_1();
        }
        else {
            removeLoader_1();
            if (response_1 === null || response_1 === void 0 ? void 0 : response_1.success) {
                handleValid_1();
                button_1.disabled = true;
                setTimeout(function () {
                    window.location.href = response_1.data.url;
                }, 2500);
            }
            else {
                handleInvalid_1();
            }
        }
    };
    var fetchCard_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading_1)
                        return [2];
                    isLoading_1 = true;
                    updateUI_1();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload_1 = getCardPayload_1();
                    return [4, axios_1.default.post('/api/recipients/getRecipient', payload_1)];
                case 2:
                    request = _a.sent();
                    response_1 = request.data;
                    isLoading_1 = false;
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 5];
                case 4:
                    updateUI_1();
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var checkInputs_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, _a, input;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reset_1();
                    for (_i = 0, _a = Array.from(inputs_1); _i < _a.length; _i++) {
                        input = _a[_i];
                        if (!input.value.trim()) {
                            button_1.disabled = true;
                            return [2, false];
                        }
                    }
                    return [4, fetchCard_1()];
                case 1:
                    _b.sent();
                    return [2];
            }
        });
    }); };
    forms.forEach(function (form) {
        var codeInputs = form.querySelectorAll('.new-recipient__input');
        codeInputs.forEach(function (input, index) {
            input.addEventListener('input', function (event) {
                var target = event.target;
                var value = target.value;
                value = value.replace(/\D/g, '');
                if (value.length > 1) {
                    value = value.slice(0, 1);
                }
                target.value = value;
                if (index < codeInputs.length - 1 && value) {
                    codeInputs[index + 1].focus();
                }
                checkInputs_1();
            });
            input.addEventListener('paste', function (event) { return __awaiter(void 0, void 0, void 0, function () {
                var clipboardText, digits;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            event.preventDefault();
                            return [4, navigator.clipboard.readText()];
                        case 1:
                            clipboardText = _a.sent();
                            digits = clipboardText.match(/\d/g);
                            if (digits) {
                                digits.forEach(function (digit, i) {
                                    if (i < codeInputs.length) {
                                        codeInputs[i].value = digit;
                                        checkInputs_1();
                                    }
                                });
                            }
                            return [2];
                    }
                });
            }); });
            input.addEventListener('keydown', function (event) {
                var target = event.target;
                var key = event.key;
                if (key === 'Backspace' && index > 0) {
                    if (!target.value && index > 0) {
                        codeInputs[index - 1].focus();
                    }
                }
            });
        });
    });
}
},{"axios":52}],31:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],32:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var newsGridCarousels = document.querySelectorAll(".news-grid__carousel-inner");
var setRangeMax = function (arr, input) {
    var slidesLength = Array.from(arr).length;
    var rangeMax = '0';
    rangeMax = (slidesLength - 1).toString();
    input.max = rangeMax;
    setRangeThumbWidth(rangeMax, input);
};
var setRangeThumbWidth = function (max, input) {
    var width = 200 / +max;
    input.style.setProperty('--thumb-size', width.toString() + "px");
    if (max === "1") {
        input.style.setProperty('--thumb-size', "100px");
    }
};
if (newsGridCarousels.length > 0) {
    var newsGridCarouselsArray = Array.from(newsGridCarousels) || [];
    newsGridCarouselsArray.forEach(function (item) {
        var glide = new glide_1.default(item, {
            type: 'slider',
            perView: 1.24,
            gap: 10,
            rewind: false,
            bound: true,
        });
        glide.mount();
        var carouselRange = item.querySelector(".news-grid__carousel-range");
        var slides = item.querySelectorAll(".news-grid__card");
        carouselRange.addEventListener("input", function (e) {
            setTimeout(function () {
                glide.go("=".concat(carouselRange.value));
            }, 500);
        });
        glide.on('move.after', function () {
            var currentIndex = glide.index;
            carouselRange.value = currentIndex;
        });
        setRangeMax(slides, carouselRange);
    });
}
},{"@glidejs/glide":51}],33:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var newsListing = document.querySelector('.news-listing') || null;
if (newsListing) {
    var nextButton_1 = document.querySelector('.news-listing__button--next');
    var prevButton_1 = document.querySelector('.news-listing__button--prev');
    var pageId_1 = +document.querySelector('#pageId').value;
    var newsCards_1 = [];
    var pageNumber_1 = 1;
    var pagesCount_1 = 0;
    var isLoading_1 = false;
    var fetchNews_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        pageNumber: pageNumber_1,
                        pageId: pageId_1,
                    };
                    isLoading_1 = true;
                    updateUI_1();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, axios_1.default.get('/api/newsListing/getNews', {
                            params: payload,
                        })];
                case 2:
                    response = _a.sent();
                    newsCards_1 = response.data.newsCards;
                    pagesCount_1 = response.data.pagesCount;
                    return [3, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3, 5];
                case 4:
                    isLoading_1 = false;
                    updateUI_1();
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var updateCards_1 = function () {
        var grid = document.querySelector('.news-listing__grid');
        grid.innerHTML = '';
        newsCards_1.forEach(function (card) {
            var cardDiv = document.createElement('div');
            cardDiv.classList.add('news-listing__card', 'flex', 'flex--column');
            if (card.imageUrl) {
                var image = document.createElement('img');
                image.classList.add('news-listing__card-image');
                image.src = card.imageUrl;
                image.alt = card.imageAlt;
                cardDiv.appendChild(image);
            }
            if (card.title) {
                var title = document.createElement('h5');
                title.classList.add('news-listing__card-title');
                title.innerText = card.title;
                cardDiv.appendChild(title);
            }
            var cardBottomDiv = document.createElement('div');
            cardBottomDiv.classList.add('news-listing__card-bottom', 'flex', 'flex--row', 'flex--justify-between', 'flex--align-center');
            if (card.readTime) {
                var readTime = document.createElement('p');
                readTime.classList.add('news-listing__card-read');
                readTime.innerText = card.readTime;
                cardBottomDiv.appendChild(readTime);
            }
            var cardButtonText = document.createElement('a');
            cardButtonText.classList.add('news-listing__button', 'flex', 'flex--row', 'flex--justify-center', 'flex--align-center');
            cardButtonText.href = card.url;
            cardButtonText.innerText = card.buttonText;
            var arrowSpan = document.createElement('span');
            arrowSpan.classList.add('zmdi', 'zmdi-long-arrow-right');
            cardButtonText.appendChild(arrowSpan);
            cardBottomDiv.appendChild(cardButtonText);
            cardDiv.appendChild(cardBottomDiv);
            grid.appendChild(cardDiv);
        });
    };
    var hookListeners_1 = function () {
        nextButton_1.addEventListener('click', function () {
            ++pageNumber_1;
            fetchNews_1();
        });
        prevButton_1.addEventListener('click', function () {
            --pageNumber_1;
            fetchNews_1();
        });
    };
    var updatePagination_1 = function () {
        if (isLoading_1) {
            nextButton_1.disabled = prevButton_1.disabled = true;
        }
        else {
            nextButton_1.disabled = pageNumber_1 >= pagesCount_1;
            prevButton_1.disabled = pageNumber_1 === 1;
        }
    };
    var updateUI_1 = function () {
        updateCards_1();
        updatePagination_1();
    };
    var init = function () {
        fetchNews_1();
        hookListeners_1();
    };
    document.addEventListener('DOMContentLoaded', init);
}
},{"axios":52}],34:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],35:[function(require,module,exports){

},{}],36:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var orgDirectorForm = document.querySelector(".org-director__form");
if (orgDirectorForm) {
    var resetValidation_1 = function () {
        validations_1.forEach(function (item) {
            item.classList.remove("org-director__validation--active");
        });
    };
    var inputs = orgDirectorForm.querySelectorAll(".org-director__input");
    var validations_1 = orgDirectorForm.querySelectorAll(".org-director__validation");
    var director1Input_1 = document.querySelector(".org-director__director-1");
    var director2Input_1 = document.querySelector(".org-director__director-2");
    var director3Input_1 = document.querySelector(".org-director__director-3");
    var director1Validation_1 = document.querySelector(".org-director__validation-director-1");
    inputs.forEach(function (input) {
        input.addEventListener("input", function () {
            input.nextElementSibling.classList.remove("org-director__validation--active");
        });
    });
    orgDirectorForm.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            resetValidation_1();
            formValues = {
                director1: director1Input_1.value,
                director2: director2Input_1.value,
                director3: director3Input_1.value,
            };
            if (!director1Input_1.value) {
                director1Validation_1.classList.add("org-director__validation--active");
            }
            if (director1Input_1.value) {
                resetValidation_1();
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{}],37:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var orgManualEntryForm = document.querySelector(".org-manual-entry__form");
if (orgManualEntryForm) {
    var nameInput_1 = document.querySelector(".org-manual-entry__name");
    var numberInput_1 = document.querySelector(".org-manual-entry__number");
    var address1Input_1 = document.querySelector(".org-manual-entry__address-1");
    var address2Input_1 = document.querySelector(".org-manual-entry__address-2");
    var address3Input_1 = document.querySelector(".org-manual-entry__address-3");
    var postcodeInput_1 = document.querySelector(".org-manual-entry__postcode");
    var countryInput_1 = document.querySelector(".org-manual-entry__country");
    var nameValidation_1 = document.querySelector(".org-manual-entry__validation-name");
    var numberValidation_1 = document.querySelector(".org-manual-entry__validation-number");
    var address1Validation_1 = document.querySelector(".org-manual-entry__validation-address-1");
    var postcodeValidation_1 = document.querySelector(".org-manual-entry__validation-postcode");
    var countryValidation_1 = document.querySelector(".org-manual-entry__validation-country");
    var isFormValid_1 = false;
    var resetValidation_1 = function () {
        nameValidation_1.classList.remove("org-manual-entry__validation--active");
        numberValidation_1.classList.remove("org-manual-entry__validation--active");
        address1Validation_1.classList.remove("org-manual-entry__validation--active");
        postcodeValidation_1.classList.remove("org-manual-entry__validation--active");
        countryValidation_1.classList.remove("org-manual-entry__validation--active");
    };
    var resetForm = function () {
        nameInput_1.value = "";
        numberInput_1.value = "";
        address1Input_1.value = "";
        address2Input_1.value = "";
        address3Input_1.value = "";
        postcodeInput_1.value = "";
        countryInput_1.value = "";
    };
    var validateForm_1 = function () {
        if (!nameInput_1.value) {
            nameValidation_1.classList.add("org-manual-entry__validation--active");
        }
        if (!numberInput_1.value) {
            numberValidation_1.classList.add("org-manual-entry__validation--active");
        }
        if (!address1Input_1.value) {
            address1Validation_1.classList.add("org-manual-entry__validation--active");
        }
        if (!postcodeInput_1.value) {
            postcodeValidation_1.classList.add("org-manual-entry__validation--active");
        }
        if (!countryInput_1.value) {
            countryValidation_1.classList.add("org-manual-entry__validation--active");
        }
        if (nameInput_1.value && numberInput_1.value && address1Input_1.value && postcodeInput_1.value && countryInput_1.value) {
            isFormValid_1 = true;
        }
    };
    var listenForInputChanges = function () {
        nameInput_1.addEventListener("input", function () {
            nameValidation_1.classList.remove("org-manual-entry__validation--active");
        });
        numberInput_1.addEventListener("input", function () {
            numberValidation_1.classList.remove("org-manual-entry__validation--active");
        });
        address1Input_1.addEventListener("input", function () {
            address1Validation_1.classList.remove("org-manual-entry__validation--active");
        });
        postcodeInput_1.addEventListener("input", function () {
            postcodeValidation_1.classList.remove("org-manual-entry__validation--active");
        });
        countryInput_1.addEventListener("input", function () {
            countryValidation_1.classList.remove("org-manual-entry__validation--active");
        });
    };
    listenForInputChanges();
    orgManualEntryForm.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            resetValidation_1();
            formValues = {
                name: nameInput_1.value,
                number: numberInput_1.value,
                address1: address1Input_1.value,
                address2: address2Input_1.value,
                address3: address3Input_1.value,
                postcode: postcodeInput_1.value,
                country: countryInput_1.value,
            };
            validateForm_1();
            if (isFormValid_1) {
                resetValidation_1();
                isFormValid_1 = false;
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{}],38:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dateMaxValue_1 = __importDefault(require("../../../helpers/dateMaxValue"));
var orgProfileMemberForm = document.querySelector(".org-member-profile__form");
if (orgProfileMemberForm) {
    var firstNameInput_1 = orgProfileMemberForm.querySelector(".org-member-profile__first-name");
    var middleNameInput_1 = orgProfileMemberForm.querySelector(".org-member-profile__middle-name");
    var lastNameInput_1 = orgProfileMemberForm.querySelector(".org-member-profile__last-name");
    var dateInput_1 = orgProfileMemberForm.querySelector(".org-member-profile__dob");
    var countryInput_1 = orgProfileMemberForm.querySelector(".org-member-profile__country");
    var validations_1 = orgProfileMemberForm.querySelectorAll(".org-member-profile__validation");
    var firstNameValidation_1 = orgProfileMemberForm.querySelector(".org-member-profile__validation-first-name");
    var middleNameValidation_1 = orgProfileMemberForm.querySelector(".org-member-profile__validation-middle-name");
    var lastNameValidation_1 = orgProfileMemberForm.querySelector(".org-member-profile__validation-last-name");
    var dateValidation_1 = orgProfileMemberForm.querySelector(".org-member-profile__validation-dob");
    var countryValidation_1 = orgProfileMemberForm.querySelector(".org-member-profile__validation-country");
    var isFormValid_1 = false;
    var resetValidation_1 = function () {
        validations_1.forEach(function (item) {
            item.classList.remove("org-member-profile__validation--active");
        });
    };
    var resetForm = function () {
        firstNameInput_1.value = "";
        lastNameInput_1.value = "";
        middleNameInput_1.value = "";
        dateInput_1.value = "";
        countryInput_1.value = "";
        countryInput_1.classList.remove("org-member-profile__country--active");
        dateInput_1.classList.remove("org-member-profile__dob--active");
    };
    var nameValidation_1 = function (name) {
        var regex = /^[\u0600-\u06FFa-zA-Z\s'-]+$/;
        return regex.test(name);
    };
    var validateForm_1 = function () {
        isFormValid_1 = true;
        if (!firstNameInput_1.value || !nameValidation_1(firstNameInput_1.value)) {
            firstNameValidation_1.classList.add("org-member-profile__validation--active");
            firstNameValidation_1.textContent = "First name is required and must contain only letters";
            isFormValid_1 = false;
        }
        if (middleNameInput_1.value && !nameValidation_1(middleNameInput_1.value)) {
            middleNameValidation_1.classList.add("org-member-profile__validation--active");
            middleNameValidation_1.textContent = "Middle name must contain only letters";
            isFormValid_1 = false;
        }
        if (!lastNameInput_1.value || !nameValidation_1(lastNameInput_1.value)) {
            lastNameValidation_1.classList.add("org-member-profile__validation--active");
            lastNameValidation_1.textContent = "Last name is required and must contain only letters";
            isFormValid_1 = false;
        }
        if (!dateInput_1.value) {
            dateValidation_1.classList.add("org-member-profile__validation--active");
            isFormValid_1 = false;
        }
        if (!countryInput_1.value) {
            countryValidation_1.classList.add("org-member-profile__validation--active");
            isFormValid_1 = false;
        }
        return isFormValid_1;
    };
    var listenForInputChanges = function () {
        firstNameInput_1.addEventListener("input", function () {
            firstNameValidation_1.classList.remove("org-member-profile__validation--active");
        });
        lastNameInput_1.addEventListener("input", function () {
            lastNameValidation_1.classList.remove("org-member-profile__validation--active");
        });
        dateInput_1.addEventListener("input", function () {
            dateInput_1.classList.add("org-member-profile__dob--active");
            dateValidation_1.classList.remove("org-member-profile__validation--active");
        });
        countryInput_1.addEventListener("input", function () {
            countryValidation_1.classList.remove("org-member-profile__validation--active");
            countryInput_1.classList.add("org-member-profile__country--active");
        });
    };
    listenForInputChanges();
    dateInput_1.setAttribute("max", (0, dateMaxValue_1.default)());
    orgProfileMemberForm.addEventListener("submit", function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            resetValidation_1();
            formValues = {
                firstName: firstNameInput_1.value,
                middleName: middleNameInput_1.value,
                lastName: lastNameInput_1.value,
                dateOfBirth: dateInput_1.value,
                countryOfBirth: countryInput_1.value,
            };
            validateForm_1();
            if (isFormValid_1) {
                isFormValid_1 = false;
            }
            else {
                e.preventDefault();
            }
            return [2];
        });
    }); });
}
},{"../../../helpers/dateMaxValue":2}],39:[function(require,module,exports){
var orgProfileConfirmComponent = document.querySelector(".org-profile-confirm__wrapper");
if (orgProfileConfirmComponent) {
    var directors_1 = orgProfileConfirmComponent.querySelectorAll(".org-profile-confirm__card");
    var continueButton_1 = orgProfileConfirmComponent.querySelector(".org-profile-confirm__next");
    var selectDirectors_1 = orgProfileConfirmComponent.querySelector(".org-profile-confirm__select");
    var selectedNumber_1 = orgProfileConfirmComponent.querySelector(".org-profile-confirm__number");
    var cardsContainer_1 = orgProfileConfirmComponent.querySelector(".org-profile-confirm__cards");
    var maxDirectors_1 = 3;
    var moreThanThree = directors_1.length > maxDirectors_1;
    var selectedItems_1 = [];
    var selectedNames_1 = [];
    var director0_1 = document.querySelector('input[name="Director0"]');
    var director1_1 = document.querySelector('input[name="Director1"]');
    var director2_1 = document.querySelector('input[name="Director2"]');
    var handleItems_1 = function (enableAll) {
        if (enableAll === void 0) { enableAll = false; }
        if (enableAll) {
            directors_1.forEach(function (item) {
                item.style.pointerEvents = "all";
                item.setAttribute("tabindex", "0");
            });
        }
        else if (!enableAll) {
            directors_1.forEach(function (item) {
                var radio = item.querySelector(".org-profile-confirm__card-radio");
                if (!radio.checked) {
                    item.style.pointerEvents = "none";
                    item.setAttribute("tabindex", "-1");
                }
            });
        }
    };
    var handleDirectorClick_1 = function (item, index) {
        var radio = item.querySelector(".org-profile-confirm__card-radio");
        var name = item.querySelector(".org-profile-confirm__card-title").textContent.trim();
        if (selectedItems_1.length < maxDirectors_1 && !radio.checked) {
            radio.checked = true;
            selectedItems_1.push(index);
            selectedNames_1.push(name);
            if (selectedNames_1.length > 0)
                director0_1.value = selectedNames_1[0];
            if (selectedNames_1.length > 1)
                director1_1.value = selectedNames_1[1];
            if (selectedNames_1.length > 2)
                director2_1.value = selectedNames_1[2];
        }
        else if (radio.checked) {
            radio.checked = false;
            selectedItems_1.splice(selectedItems_1.indexOf(index), 1);
            selectedNames_1.splice(selectedNames_1.indexOf(name), 1);
        }
        if (selectedItems_1.length > (maxDirectors_1 - 1)) {
            continueButton_1.disabled = false;
            handleItems_1();
        }
        else {
            continueButton_1.disabled = true;
            handleItems_1(true);
        }
        selectedNumber_1.textContent = selectedItems_1.length.toString() + "/" + maxDirectors_1.toString();
        if (selectedItems_1.length === maxDirectors_1) {
            continueButton_1.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    var showMoreThanThreeContent = function () {
        cardsContainer_1.classList.add("org-profile-confirm__cards-select");
        selectDirectors_1.classList.add("org-profile-confirm__select--active");
    };
    if (moreThanThree) {
        continueButton_1.disabled = true;
        showMoreThanThreeContent();
        directors_1.forEach(function (item, index) {
            item.classList.add("org-profile-confirm__card-alt");
            item.addEventListener("click", function () {
                handleDirectorClick_1(item, index);
            });
            item.addEventListener("keydown", function (event) {
                if (event.key === "Enter") {
                    handleDirectorClick_1(item, index);
                }
            });
        });
    }
}
},{}],40:[function(require,module,exports){
var orgProfile = document.querySelector(".org-profile__wrapper");
if (orgProfile) {
    var orgProfileCards_1 = document.querySelectorAll(".org-profile__card");
    var orgProfileForms_1 = document.querySelectorAll(".org-profile__form");
    var orgProfileButton_1 = document.querySelector(".org-profile__next");
    var resetRegisterCards_1 = function () {
        orgProfileCards_1.forEach(function (card) {
            card.classList.remove("org-profile__card--active");
        });
        orgProfileForms_1.forEach(function (card) {
            card.classList.remove("org-profile__form--active");
        });
    };
    var getCorrectInputs_1 = function () {
        var activeForm = orgProfile.querySelector(".org-profile__form--active");
        var inputName = activeForm.querySelector(".org-profile__name");
        var inputNumber = activeForm.querySelector(".org-profile__number");
        var isBusinessNameValid = false;
        var isBusinessNumberValid = false;
        var numberValidation = function (name) {
            var regex = /^\d+$/;
            return regex.test(name);
        };
        var validateBusinessName = function (input) {
            var parent = input.parentElement;
            var orgProfileNameValidation = parent.querySelector(".org-profile__validation-business-name");
            if (input.value.length > 0) {
                orgProfileNameValidation.classList.remove("org-profile__validation--active");
                isBusinessNameValid = true;
            }
            else {
                orgProfileNameValidation.classList.add("org-profile__validation--active");
                isBusinessNameValid = false;
            }
        };
        var validateBusinessNumber = function (input) {
            var parent = input.parentElement;
            var orgProfileNumberValidation = parent.querySelector(".org-profile__validation-business-number");
            if (input.value.length > 0 && numberValidation(input.value)) {
                orgProfileNumberValidation.classList.remove("org-profile__validation--active");
                isBusinessNumberValid = true;
            }
            else {
                orgProfileNumberValidation.classList.add("org-profile__validation--active");
                isBusinessNumberValid = false;
            }
        };
        var toggleSubmitButton = function () {
            if (isBusinessNameValid && isBusinessNumberValid) {
                orgProfileButton_1.disabled = false;
            }
            else {
                orgProfileButton_1.disabled = true;
            }
        };
        inputName.addEventListener("input", function (e) {
            var target = e.target;
            validateBusinessName(target);
            toggleSubmitButton();
        });
        inputNumber.addEventListener("input", function (e) {
            var target = e.target;
            validateBusinessNumber(target);
            toggleSubmitButton();
        });
    };
    var setActiveCard_1 = function (item, index) {
        resetRegisterCards_1();
        item.classList.add("org-profile__card--active");
        orgProfileForms_1[index].classList.add("org-profile__form--active");
        getCorrectInputs_1();
    };
    if (orgProfileCards_1.length > 0) {
        orgProfileCards_1[0].classList.add("org-profile__card--active");
        orgProfileForms_1[0].classList.add("org-profile__form--active");
        getCorrectInputs_1();
        orgProfileCards_1.forEach(function (card, i) {
            card.addEventListener("click", function () {
                setActiveCard_1(card, i);
            });
            card.addEventListener("keydown", function (e) {
                var keyboardEvent = e;
                if (keyboardEvent.key === "Enter") {
                    setActiveCard_1(card, i);
                }
            });
        });
        document.querySelector(".org-profile__next").addEventListener("click", function (e) {
            e.preventDefault();
            var activeForm = document.querySelector(".org-profile__form--active");
            activeForm.submit();
        });
    }
}
},{}],41:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var signUpOrganisation = document.querySelector(".sign-in-details__form-organisation");
if (signUpOrganisation) {
    var emailInput_1 = document.querySelector(".sign-in-details__email");
    var passwordInput_1 = document.querySelector(".sign-in-details__password");
    var passwordAgainInput_1 = document.querySelector(".sign-in-details__password-again");
    var passwordAgainValidation_1 = document.querySelector(".sign-in-details__validation-password-again");
    var signUpOrganisationEmailValidation_1 = document.querySelector(".sign-in-details__validation-email");
    var criteriaItems_1 = signUpOrganisation.querySelectorAll(".sign-in-details__item");
    var showPasswordButtons = signUpOrganisation.querySelectorAll(".zmdi-eye");
    var hidePasswordButtons = signUpOrganisation.querySelectorAll(".zmdi-eye-off");
    var regexPattern_1 = signUpOrganisation.getAttribute("pattern") || null;
    var conditions_1 = [];
    var validations_1 = [false];
    var formValidation_1 = {
        email: false,
        password: false
    };
    var recaptcha = false;
    window.recaptcha = false;
    var isSubmitClickedFirstTime_1 = false;
    var extractConditions_1 = function (regexPattern) {
        validations_1 = [false];
        conditions_1 = [];
        conditions_1 = regexPattern.match(/\(\?=(.*?)\)|\(\?!(.*?)\)|\(\?<=(.*?)\)|\(\?<(.*?)\)/g);
        conditions_1 = conditions_1.filter(function (condition) { return condition !== null; });
        conditions_1.map(function (condition) { return validations_1.push(false); });
    };
    var showValidationMessage_1 = function () {
        if (isSubmitClickedFirstTime_1) {
            passwordAgainValidation_1.classList.add("sign-in-details__validation--active");
        }
    };
    var removeValidationMessage_1 = function () {
        passwordAgainValidation_1.classList.remove("sign-in-details__validation--active");
    };
    var validateEmail_1 = function (email) {
        var trimmedEmail = email.trim().toLowerCase();
        if (String(trimmedEmail).match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            signUpOrganisationEmailValidation_1.classList.remove("sign-in-details__validation--active");
            formValidation_1.email = true;
        }
        else {
            signUpOrganisationEmailValidation_1.classList.add("sign-in-details__validation--active");
            formValidation_1.email = false;
        }
    };
    function validateRecaptcha() {
        window.recaptcha = true;
    }
    window.validateRecaptcha = validateRecaptcha;
    var validatePassword_1 = function (password) {
        extractConditions_1(regexPattern_1);
        if (password.length > 5) {
            validations_1[0] = true;
        }
        conditions_1.forEach(function (cond, index) {
            if (new RegExp(cond).test(password)) {
                validations_1[index + 1] = true;
            }
        });
        var isPasswordValid = false;
        if (passwordInput_1.value && validations_1.every(function (val) { return val === true; })) {
            isPasswordValid = true;
            removeValidationMessage_1();
            resetCriteriaItems_1();
        }
        else {
            showValidationMessage_1();
        }
        if (isPasswordValid) {
            formValidation_1.password = true;
        }
        else {
            formValidation_1.password = false;
        }
        return isPasswordValid ? "Password is valid." : validations_1;
    };
    var resetCriteriaItems_1 = function () {
        criteriaItems_1.forEach(function (item) {
            item.classList.remove("sign-in-details__item--active");
        });
    };
    showPasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.setAttribute("type", "text");
            button.classList.remove("zmdi-eye--active");
            button.nextElementSibling.classList.add("zmdi-eye-off--active");
        });
    });
    hidePasswordButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            button.previousElementSibling.previousElementSibling.setAttribute("type", "password");
            button.classList.remove("zmdi-eye-off--active");
            button.previousElementSibling.classList.add("zmdi-eye--active");
        });
    });
    emailInput_1.addEventListener("input", function () {
        if (isSubmitClickedFirstTime_1) {
            validateEmail_1(emailInput_1.value);
        }
    });
    passwordInput_1.addEventListener("input", function () {
        validatePassword_1(passwordInput_1.value);
        for (var i = 0; i < criteriaItems_1.length; i++) {
            if (validations_1[i] === true) {
                criteriaItems_1[i].classList.add("sign-in-details__item--active");
            }
            else {
                criteriaItems_1[i].classList.remove("sign-in-details__item--active");
            }
        }
    });
    passwordAgainInput_1.addEventListener("input", function () {
        removeValidationMessage_1();
    });
    signUpOrganisation.addEventListener("submit", function (e) { return __awaiter(_this, void 0, void 0, function () {
        var formValues;
        return __generator(this, function (_a) {
            isSubmitClickedFirstTime_1 = true;
            if (passwordInput_1.value !== passwordAgainInput_1.value) {
                showValidationMessage_1();
            }
            emailInput_1.value = emailInput_1.value.trim();
            validateEmail_1(emailInput_1.value);
            formValues = {
                email: emailInput_1.value,
                password: passwordInput_1.value,
            };
            if (formValidation_1.email === true
                && formValidation_1.password === true
                && passwordInput_1.value === passwordAgainInput_1.value
                && window.recaptcha === true) {
                formValidation_1 = {
                    email: false,
                    password: false
                };
                resetCriteriaItems_1();
            }
            else {
                e.preventDefault();
                window.recaptcha = false;
            }
            return [2];
        });
    }); });
    if (regexPattern_1) {
        extractConditions_1(regexPattern_1);
    }
}
},{}],42:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var paymentsComponent = document.querySelector('.payments__wrapper');
if (paymentsComponent) {
    var paymentsList_1 = paymentsComponent.querySelector('.payments__list');
    var paymentsRight_1 = paymentsComponent.querySelector('.payments__right');
    var searchInput_1 = paymentsComponent.querySelector('.payments__search');
    var paymentDates_1 = paymentsComponent.querySelector('.payments__dates');
    var dateInput1_1 = paymentDates_1.querySelector('.payments__date-1');
    var dateInput2_1 = paymentDates_1.querySelector('.payments__date-2');
    var paymentDateButton_1 = paymentsComponent.querySelector('.payments__button');
    var reachedEnd_1 = false;
    var lastTransactionId_1 = 0;
    var increment_1 = 12;
    var fetchingData_1 = false;
    var startDate_1 = null;
    var endDate_1 = null;
    var searchTerm_1 = null;
    var db_1 = [];
    var fetchData_1 = function (isScroll) { return __awaiter(void 0, void 0, void 0, function () {
        var response, newData, scrollThreshold, bottomScrollPosition, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (fetchingData_1 || reachedEnd_1) {
                        return [2];
                    }
                    fetchingData_1 = true;
                    showLoader_1();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.get("/api/payments/getAllPayments", {
                            params: {
                                pageIncrement: increment_1,
                                lastTransactionId: lastTransactionId_1,
                                startDate: startDate_1,
                                endDate: endDate_1,
                                searchTerm: searchTerm_1
                            },
                        })];
                case 2:
                    response = (_a.sent()).data;
                    lastTransactionId_1 = response.lastTransactionId;
                    reachedEnd_1 = response.reachedEnd;
                    newData = response.transactions;
                    db_1.push.apply(db_1, newData);
                    generateHtml_1(db_1);
                    if (reachedEnd_1) {
                        paymentsList_1.innerHTML +=
                            '<li class="payments__item-caption flex flex--align-center flex--justify-center">End of results</li>';
                    }
                    fetchingData_1 = false;
                    hideLoader_1();
                    afterData_1();
                    if (isScroll) {
                        scrollThreshold = 900;
                        bottomScrollPosition = paymentsList_1.scrollHeight - scrollThreshold;
                        paymentsList_1.scrollTo({ top: bottomScrollPosition, behavior: 'smooth' });
                    }
                    fetchingData_1 = false;
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var generateHtml_1 = function (data) {
        renderList_1(data);
        renderPayment_1(data);
    };
    var renderList_1 = function (data) {
        var container = paymentsList_1;
        if (!container)
            return;
        container.innerHTML =
            '<li class="payments__loader"> <img src="/assets/img/img/loader-icon.png" alt="loading icon" class="payments__loader-icon spin" /></li>';
        data.forEach(function (item) {
            var html = renderListItem_1(item);
            container.innerHTML += html;
        });
    };
    var formatAmount_1 = function (amount) {
        var numericAmount = parseFloat(amount.toString().replace(/[^0-9.-]+/g, ''));
        return numericAmount.toFixed(2);
    };
    var formatAmountWithCurrency_1 = function (item) {
        var formattedAmount = formatAmount_1(item.amount.value);
        var currencySymbol = item.amount.currencySymbol;
        return formattedAmount.includes(currencySymbol) ? formattedAmount : "".concat(currencySymbol).concat(formattedAmount);
    };
    var renderListItem_1 = function (item) {
        var status = item.status || "";
        item.amount.value = formatAmountWithCurrency_1(item);
        var html = "\n            <li class=\"payments__item fade-in-slow flex flex--align-center\" tabindex=\"0\">\n                <p class=\"payments__item-title\">".concat(item.title, "</p>\n                <div class=\"payments__item-info flex flex--align-center\">\n                    <p class=\"payments__item-amount\">").concat(item.amount.value, "</p>\n\n                    ").concat(status === "delivered" ? ("\n                        <div class=\"payments__item-status flex flex--align-center\">\n                            <i class=\"zmdi zmdi-check-circle\"></i>\n                        </div>\n                        ") : "", "\n\n                    ").concat(status === "rejected" ? ("\n                        <div class=\"payments__item-status flex flex--align-center\">\n                            <i class=\"zmdi zmdi-close-circle\"></i>\n                        </div>\n                        ") : "", "\n\n                    ").concat(status === "in progress" ? ("\n                        <div class=\"payments__item-status flex flex--align-center\">\n                            <div class=\"payments__item-dash\">\n                                <div class=\"payments__item-dash-inner\" style=\"--itemProgress: 20%;\"></div>\n                            </div>\n                        </div>\n                        ") : "", "\n\n                    ").concat(status === "pending" ? ("\n                        <div class=\"payments__item-status flex flex--align-center\">\n                            <div class=\"payments__item-dash\">\n                                <div class=\"payments__item-dash-inner\" style=\"--itemProgress: 50%;\"></div>\n                            </div>\n                        </div>\n                        ") : "", "\n\n                    <p class=\"payments__item-date\">").concat(item.dateValue, "</p>\n                </div>\n                <i class=\"zmdi zmdi-chevron-right\"></i>\n            </li>\n");
        return html;
    };
    var renderPayment_1 = function (data) {
        var container = paymentsRight_1;
        if (!container)
            return;
        container.innerHTML = '';
        data.forEach(function (item) {
            var html = renderPaymentItem_1(item);
            container.innerHTML += html;
        });
    };
    var renderPaymentItem_1 = function (item) {
        var payAgainText = paymentsRight_1.getAttribute('data-pay-again');
        var receiptText = paymentsRight_1.getAttribute('data-receipt');
        var paymentTitle = paymentsRight_1.getAttribute('data-pay-title');
        var paymentCaption = paymentsRight_1.getAttribute('data-pay-caption');
        var transferPurposeTitle = paymentsRight_1.getAttribute('data-purpose');
        var sentText = paymentsRight_1.getAttribute('data-sent');
        var exchangeRateText = paymentsRight_1.getAttribute('data-exchange');
        var totalPaidText = paymentsRight_1.getAttribute('data-total');
        var payoutCountryText = paymentsRight_1.getAttribute('data-country');
        var payoutMethodText = paymentsRight_1.getAttribute('data-method');
        var amanacardNumberText = paymentsRight_1.getAttribute('data-number');
        var paymentMethodText = paymentsRight_1.getAttribute('data-payment-method');
        var referenceNumberText = paymentsRight_1.getAttribute('data-reference-number');
        var status = item.status || "";
        var lastUpdated = item.lastUpdated || "";
        var paymentInProgressStatusTitle = paymentsRight_1.getAttribute('data-status-in-progress-title') || "";
        var paymentInProgressStatusSubtitle = paymentsRight_1.getAttribute('data-status-in-progress-subtitle') || "";
        var paymentPendingStatusTitle = paymentsRight_1.getAttribute('data-status-pending-title') || "";
        var paymentPendingStatusSubtitle = paymentsRight_1.getAttribute('data-status-pending-subtitle') || "";
        var paymentRejectedStatusTitle = paymentsRight_1.getAttribute('data-status-rejected-title') || "";
        var paymentRejectedStatusSubtitle = paymentsRight_1.getAttribute('data-status-rejected-subtitle') || "";
        var paymentDeliveredStatusTitle = paymentsRight_1.getAttribute('data-status-delivered-title') || "";
        var paymentDeliveredStatusSubtitle = paymentsRight_1.getAttribute('data-status-delivered-subtitle') || "";
        var lastUpdatedText = paymentsRight_1.getAttribute('data-last-updated') || "";
        var html = "\n        <div class=\"payments__details fade-in-slow flex flex--column flex--align-start\">\n            <div class=\"payments__header flex flex--wrap flex--justify-between flex--align-center\">\n                <p class=\"payments__date\">\n                    ".concat(item.dateValue, "\n                </p>\n                <div class=\"payments__buttons flex flex--wrap flex--justify-between\">\n                    ").concat(payAgainText && item.payAgainUrl && ("<a href=\"".concat(item.payAgainUrl, "\" class=\"link link--primary flex flex--justify-center flex--align-center\">\n                            <span class=\"link__label\">").concat(payAgainText, "</span>\n                        </a>")), "\n                    ").concat(receiptText && item.receiptUrl && ("<a href=\"".concat(item.receiptUrl, "\" class=\"link link--primary flex flex--justify-center flex--align-center\">\n                            <span class=\"link__label\">").concat(receiptText, "</span>\n                        </a>")), "\n                </div>\n            </div>\n            <div class=\"payments__transaction flex flex--column flex--align-center flex--justify-center\">\n                <div class=\"payments__amounts flex flex--wrap flex--align-center flex--justify-center\">\n                    <div class='payments__amount flex flex--column flex--align-center'>\n                        <span class='payments__value'>\n                        ").concat(item.amount.value, "\n                        </span>\n                        <span class='payments__currency'>\n                            ").concat(item.amount1.currency, "\n                        </span>\n                    </div>\n                    <i class='zmdi zmdi-long-arrow-right'></i>\n                    <div class='payments__amount flex flex--column flex--align-center'>\n                        <span class='payments__value'>\n                            ").concat(item.amount2.value, "\n                        </span>\n                        <span class='payments__currency'>\n                            ").concat(item.amount2.currency, "\n                        </span>\n                    </div>\n                </div>\n                <p class=\"payments__text flex flex--align-center flex--justify-center\">\n                    ").concat(paymentTitle, "\n                </p>\n                <div class=\"payments__item-dash\"></div>\n                <p class=\"payments__caption flex flex--align-center flex--justify-center\">\n                    ").concat(paymentCaption, "\n                </p>\n            </div>\n\n            ").concat(status === "in progress" ? ("\n                <div class=\"payments__step flex flex--column flex--align-center flex--justify-center\">\n                    <h5 class=\"payments__step-title\">".concat(paymentInProgressStatusTitle, "</h5>\n                    <div class=\"payments__step-progress-bar\">\n                        <div class=\"payments__step-progress\" style=\"--progress: 20%;\"></div>\n                    </div>\n                    <p class=\"payments__step-subtitle\">").concat(paymentInProgressStatusSubtitle, "</p>\n                    <p class=\"payments__step-text\">").concat(lastUpdatedText, " ").concat(lastUpdated, "</p>\n                </div>\n                ")) : "", "\n            \n            ").concat(status === "pending" ? ("\n                <div class=\"payments__step flex flex--column flex--align-center flex--justify-center\">\n                    <h5 class=\"payments__step-title\">".concat(paymentPendingStatusTitle, "</h5>\n                    <div class=\"payments__step-progress-bar\">\n                        <div class=\"payments__step-progress\" style=\"--progress: 50%;\"></div>\n                    </div>\n                    <p class=\"payments__step-subtitle\">").concat(paymentPendingStatusSubtitle, "</p>\n                    <p class=\"payments__step-text\">").concat(lastUpdatedText, " ").concat(lastUpdated, "</p>\n                </div>\n                ")) : "", "\n            \n            ").concat(status === "rejected" ? ("\n                <div class=\"payments__step flex flex--column flex--align-center flex--justify-center\">\n                    <h5 class=\"payments__step-title\">".concat(paymentRejectedStatusTitle, "</h5>\n                    <div class=\"payments__step-progress-bar\">\n                        <div class=\"payments__step-progress payments__step-progress--failed\" style=\"--progress: 100%;\"></div>\n                    </div>\n                    <p class=\"payments__step-subtitle\">").concat(paymentRejectedStatusSubtitle, "</p>\n                    <p class=\"payments__step-text\">").concat(lastUpdatedText, " ").concat(lastUpdated, "</p>\n                </div>\n                ")) : "", "\n            \n            ").concat(status === "delivered" ? ("\n                <div class=\"payments__step flex flex--column flex--align-center flex--justify-center\">\n                    <h5 class=\"payments__step-title\">".concat(paymentDeliveredStatusTitle, "</h5>\n                    <div class=\"payments__step-progress-bar\">\n                        <div class=\"payments__step-progress payments__step-progress--complete\" style=\"--progress: 100%;\"></div>\n                    </div>\n                    <p class=\"payments__step-subtitle\">").concat(paymentDeliveredStatusSubtitle, "</p>\n                    <p class=\"payments__step-text\">").concat(lastUpdatedText, " ").concat(lastUpdated, "</p>\n                </div>\n                ")) : "", "\n\n            <div class=\"payments__info flex flex--column flex--align-center flex--justify-center\">\n                <p class=\"payments__info-title\">").concat(transferPurposeTitle, "</p>\n                <p class=\"payments__info-text\">").concat(item.transferPurposeText, "</p>\n            </div>\n            <ul class=\"payments__content flex flex--column flex--align-start flex--justify-center\">\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(sentText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.amount.value, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(exchangeRateText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.exchangeRate, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(totalPaidText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.totalPaid, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(paymentMethodText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.paymentMethod, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(referenceNumberText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.referenceNumber, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(payoutCountryText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.payoutCountry, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(payoutMethodText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.payoutMethod, "</p>\n                </li>\n                <li class=\"payments__row flex flex--align-center flex--justify-between\">\n                    <p class=\"payments__row-title\">").concat(amanacardNumberText, "</p>\n                    <p class=\"payments__row-text\">").concat(item.amanacardNumber, "</p>\n                </li>\n            </ul>\n            <div class=\"payments__mobile-buttons flex flex--wrap flex--align-center flex--justify-center\">\n                <button class=\"button button--primary\">Receipt</button>\n                <button class=\"button button--primary\">").concat(payAgainText, "</button>\n            </div>\n        </div>\n    ");
        return html;
    };
    var isScrolledToBottom_1 = function () {
        var scrollThreshold = 100;
        return paymentsList_1.scrollTop + paymentsList_1.clientHeight >= paymentsList_1.scrollHeight - scrollThreshold;
    };
    paymentsList_1.addEventListener('scroll', function () {
        if (isScrolledToBottom_1()) {
            fetchData_1(true);
        }
    });
    var resetDb_1 = function () {
        db_1 = [];
        reachedEnd_1 = false;
        lastTransactionId_1 = null;
    };
    dateInput1_1.addEventListener('change', function (e) {
        var target = e.target;
        startDate_1 = formatDate_1(new Date(target.value));
        var today = formatDate_1(new Date());
        dateInput1_1.max = today;
        dateInput2_1.max = today;
        dateInput2_1.min = startDate_1;
        if (startDate_1 > endDate_1) {
            dateInput2_1.value = startDate_1;
        }
        else {
            dateInput1_1.max = endDate_1;
        }
        resetDb_1();
        fetchData_1(false);
    });
    dateInput2_1.addEventListener('change', function (e) {
        var target = e.target;
        endDate_1 = formatDate_1(new Date(target.value));
        dateInput1_1.max = endDate_1;
        if (startDate_1 > endDate_1) {
            dateInput1_1.value = endDate_1;
        }
        resetDb_1();
        fetchData_1(false);
    });
    paymentDateButton_1.addEventListener('click', function () {
        if (paymentDates_1.classList.contains('payments__dates--active')) {
            paymentDates_1.classList.remove('payments__dates--active');
            paymentDateButton_1.classList.remove("payments__button--active");
        }
        else {
            paymentDates_1.classList.add('payments__dates--active');
            paymentDateButton_1.classList.add("payments__button--active");
        }
    });
    var showLoader_1 = function () {
        var paymentsLoader = paymentsComponent.querySelector('.payments__loader');
        var items = paymentsComponent.querySelectorAll('.payments__item');
        items.forEach(function (item) {
            item.classList.add('payments__item--hidden');
        });
        paymentsLoader.classList.add('payments__loader--active');
    };
    var hideLoader_1 = function () {
        var paymentsLoader = paymentsComponent.querySelector('.payments__loader');
        var items = paymentsComponent.querySelectorAll('.payments__item');
        items.forEach(function (item) {
            item.classList.remove('payments__item--hidden');
        });
        paymentsLoader.classList.remove('payments__loader--active');
    };
    var formatDate_1 = function (date) {
        return date.toISOString().split('T')[0];
    };
    var afterData_1 = function () {
        var paymentsBack = paymentsComponent.querySelector('.payments__back');
        var paymentCards = paymentsComponent.querySelectorAll('.payments__item');
        var resetCards = function () {
            var newPaymentCards = paymentsComponent.querySelectorAll('.payments__item');
            newPaymentCards.forEach(function (card) {
                card.classList.remove('payments__item--active');
            });
        };
        var resetDetails = function () {
            var newPaymentDetails = paymentsComponent.querySelectorAll('.payments__details');
            newPaymentDetails.forEach(function (item) {
                paymentsRight_1.classList.remove('payments__right--active');
                item.classList.remove('payments__details--active');
            });
            paymentsBack.classList.remove('payments__back--active');
        };
        var handleCardSelect = function (card, index) {
            var newPaymentDetails = paymentsComponent.querySelectorAll('.payments__details');
            resetCards();
            resetDetails();
            card.classList.add('payments__item--active');
            paymentsRight_1.classList.add('payments__right--active');
            newPaymentDetails[index].classList.add('payments__details--active');
            paymentsBack.classList.add('payments__back--active');
            if (window.innerWidth < 768) {
                newPaymentDetails[index].focus();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                newPaymentDetails[index].addEventListener('keydown', function (e) {
                    var keyboardEvent = e;
                    if (keyboardEvent.key === 'Escape') {
                        resetCards();
                        resetDetails();
                    }
                });
            }
        };
        if (window.innerWidth > 768) {
            var newPaymentDetails = paymentsComponent.querySelectorAll('.payments__details');
            var newPaymentCards = paymentsComponent.querySelectorAll('.payments__item');
            if (newPaymentDetails.length > 0) {
                newPaymentDetails[0].classList.add('payments__details--active');
                newPaymentCards[0].classList.add('payments__item--active');
            }
        }
        var timeoutId;
        searchInput_1.addEventListener('input', function (e) {
            var target = e.target;
            searchTerm_1 = target.value.trim().toLowerCase();
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                resetDb_1();
                fetchData_1(false);
            }, 1000);
        });
        paymentCards.forEach(function (card, i) {
            card.addEventListener('click', function () {
                handleCardSelect(card, i);
            });
            card.addEventListener('keydown', function (e) {
                var keyboardEvent = e;
                if (keyboardEvent.key === 'Enter') {
                    handleCardSelect(card, i);
                }
            });
        });
        paymentsBack.addEventListener('click', function () {
            resetCards();
            resetDetails();
        });
    };
    var setDefaultDates = function () {
        var today = new Date();
        var oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        if (oneMonthAgo.getMonth() === 1 && oneMonthAgo.getDate() === 29) {
            oneMonthAgo.setDate(28);
        }
        endDate_1 = formatDate_1(today);
        startDate_1 = formatDate_1(oneMonthAgo);
        dateInput1_1.value = startDate_1;
        dateInput2_1.value = endDate_1;
        dateInput1_1.min = formatDate_1(new Date(2000, 0, 1));
        dateInput2_1.min = startDate_1;
        dateInput1_1.max = endDate_1;
        dateInput2_1.max = endDate_1;
    };
    setDefaultDates();
    fetchData_1(false);
}
},{"axios":52}],43:[function(require,module,exports){
module.exports=[
    {
        "Country Name": "Afghanistan",
        "ISO2": "AF",
        "ISO3": "AFG",
        "Top Level Domain": "af",
        "FIPS": "AF",
        "ISO Numeric": "004",
        "GeoNameID": 1149361,
        "E164": 93,
        "Phone Code": 93,
        "Continent": "Asia",
        "Capital": "Kabul",
        "Time Zone in Capital": "Asia/Kabul",
        "Currency": "Afghani",
        "Language Codes": "fa-AF,ps,uz-AF,tk",
        "Languages": "Afghan Persian or Dari (official) 50%, Pashto (official) 35%, Turkic languages (primarily Uzbek and Turkmen) 11%, 30 minor languages (primarily Balochi and Pashai) 4%, much bilingualism, but Dari functions as the lingua franca",
        "Area KM2": 647500,
        "Internet Hosts": 223,
        "Internet Users": 1000000,
        "Phones (Mobile)": 18000000,
        "Phones (Landline)": 13500,
        "GDP": 20650000000
    },
    {
        "Country Name": "Albania",
        "ISO2": "AL",
        "ISO3": "ALB",
        "Top Level Domain": "al",
        "FIPS": "AL",
        "ISO Numeric": "008",
        "GeoNameID": 783754,
        "E164": 355,
        "Phone Code": 355,
        "Continent": "Europe",
        "Capital": "Tirana",
        "Time Zone in Capital": "Europe/Tirane",
        "Currency": "Lek",
        "Language Codes": "sq,el",
        "Languages": "Albanian 98.8% (official - derived from Tosk dialect), Greek 0.5%, other 0.6% (including Macedonian, Roma, Vlach, Turkish, Italian, and Serbo-Croatian), unspecified 0.1% (2011 est.)",
        "Area KM2": 28748,
        "Internet Hosts": 15528,
        "Internet Users": 1300000,
        "Phones (Mobile)": 3500000,
        "Phones (Landline)": 312000,
        "GDP": 12800000000
    },
    {
        "Country Name": "Algeria",
        "ISO2": "DZ",
        "ISO3": "DZA",
        "Top Level Domain": "dz",
        "FIPS": "AG",
        "ISO Numeric": "012",
        "GeoNameID": 2589581,
        "E164": 213,
        "Phone Code": 213,
        "Continent": "Africa",
        "Capital": "Algiers",
        "Time Zone in Capital": "Africa/Algiers",
        "Currency": "Dinar",
        "Language Codes": "ar-DZ",
        "Languages": "Arabic (official), French (lingua franca), Berber dialects: Kabylie Berber (Tamazight), Chaouia Berber (Tachawit), Mzab Berber, Tuareg Berber (Tamahaq)",
        "Area KM2": 2381740,
        "Internet Hosts": 676,
        "Internet Users": 4700000,
        "Phones (Mobile)": 37692000,
        "Phones (Landline)": 3200000,
        "GDP": 215700000000
    },
    {
        "Country Name": "American Samoa",
        "ISO2": "AS",
        "ISO3": "ASM",
        "Top Level Domain": "as",
        "FIPS": "AQ",
        "ISO Numeric": "016",
        "GeoNameID": 5880801,
        "E164": 1,
        "Phone Code": "1-684",
        "Continent": "Oceania",
        "Capital": "Pago Pago",
        "Time Zone in Capital": "Pacific/Pago_Pago",
        "Currency": "Dollar",
        "Language Codes": "en-AS,sm,to",
        "Languages": "Samoan 90.6% (closely related to Hawaiian and other Polynesian languages), English 2.9%, Tongan 2.4%, other Pacific islander 2.1%, other 2%",
        "Area KM2": 199,
        "Internet Hosts": 2387,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": 10000,
        "GDP": 462200000
    },
    {
        "Country Name": "Andorra",
        "ISO2": "AD",
        "ISO3": "AND",
        "Top Level Domain": "ad",
        "FIPS": "AN",
        "ISO Numeric": "020",
        "GeoNameID": 3041565,
        "E164": 376,
        "Phone Code": 376,
        "Continent": "Europe",
        "Capital": "Andorra la Vella",
        "Time Zone in Capital": "Europe/Andorra",
        "Currency": "Euro",
        "Language Codes": "ca",
        "Languages": "Catalan (official), French, Castilian, Portuguese",
        "Area KM2": 468,
        "Internet Hosts": 28383,
        "Internet Users": 67100,
        "Phones (Mobile)": 65000,
        "Phones (Landline)": 39000,
        "GDP": 4800000000
    },
    {
        "Country Name": "Angola",
        "ISO2": "AO",
        "ISO3": "AGO",
        "Top Level Domain": "ao",
        "FIPS": "AO",
        "ISO Numeric": "024",
        "GeoNameID": 3351879,
        "E164": 244,
        "Phone Code": 244,
        "Continent": "Africa",
        "Capital": "Luanda",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Kwanza",
        "Language Codes": "pt-AO",
        "Languages": "Portuguese (official), Bantu and other African languages",
        "Area KM2": 1246700,
        "Internet Hosts": 20703,
        "Internet Users": 606700,
        "Phones (Mobile)": 9800000,
        "Phones (Landline)": 303000,
        "GDP": 124000000000
    },
    {
        "Country Name": "Anguilla",
        "ISO2": "AI",
        "ISO3": "AIA",
        "Top Level Domain": "ai",
        "FIPS": "AV",
        "ISO Numeric": 660,
        "GeoNameID": 3573511,
        "E164": 1,
        "Phone Code": "1-264",
        "Continent": "North America",
        "Capital": "The Valley",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-AI",
        "Languages": "English (official)",
        "Area KM2": 102,
        "Internet Hosts": 269,
        "Internet Users": 3700,
        "Phones (Mobile)": 26000,
        "Phones (Landline)": 6000,
        "GDP": 175400000
    },
    {
        "Country Name": "Antarctica",
        "ISO2": "AQ",
        "ISO3": "ATA",
        "Top Level Domain": "aq",
        "FIPS": "AY",
        "ISO Numeric": "010",
        "GeoNameID": 6697173,
        "E164": 672,
        "Phone Code": 672,
        "Continent": "Antarctica",
        "Capital": "",
        "Time Zone in Capital": "Antarctica/Troll",
        "Currency": "",
        "Language Codes": "",
        "Languages": "",
        "Area KM2": 14000000,
        "Internet Hosts": 7764,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Antigua and Barbuda",
        "ISO2": "AG",
        "ISO3": "ATG",
        "Top Level Domain": "ag",
        "FIPS": "AC",
        "ISO Numeric": "028",
        "GeoNameID": 3576396,
        "E164": 1,
        "Phone Code": "1-268",
        "Continent": "North America",
        "Capital": "St. John's",
        "Time Zone in Capital": "America/Antigua",
        "Currency": "Dollar",
        "Language Codes": "en-AG",
        "Languages": "English (official), local dialects",
        "Area KM2": 443,
        "Internet Hosts": 11532,
        "Internet Users": 65000,
        "Phones (Mobile)": 179800,
        "Phones (Landline)": 35000,
        "GDP": 1220000000
    },
    {
        "Country Name": "Argentina",
        "ISO2": "AR",
        "ISO3": "ARG",
        "Top Level Domain": "ar",
        "FIPS": "AR",
        "ISO Numeric": "032",
        "GeoNameID": 3865483,
        "E164": 54,
        "Phone Code": 54,
        "Continent": "South America",
        "Capital": "Buenos Aires",
        "Time Zone in Capital": "America/Argentina/Buenos_Aires",
        "Currency": "Peso",
        "Language Codes": "es-AR,en,it,de,fr,gn",
        "Languages": "Spanish (official), Italian, English, German, French, indigenous (Mapudungun, Quechua)",
        "Area KM2": 2766890,
        "Internet Hosts": 11232000,
        "Internet Users": 13694000,
        "Phones (Mobile)": 58600000,
        "Phones (Landline)": 1,
        "GDP": 484600000000
    },
    {
        "Country Name": "Armenia",
        "ISO2": "AM",
        "ISO3": "ARM",
        "Top Level Domain": "am",
        "FIPS": "AM",
        "ISO Numeric": "051",
        "GeoNameID": 174982,
        "E164": 374,
        "Phone Code": 374,
        "Continent": "Asia",
        "Capital": "Yerevan",
        "Time Zone in Capital": "Asia/Yerevan",
        "Currency": "Dram",
        "Language Codes": "hy",
        "Languages": "Armenian (official) 97.9%, Kurdish (spoken by Yezidi minority) 1%, other 1% (2011 est.)",
        "Area KM2": 29800,
        "Internet Hosts": 194142,
        "Internet Users": 208200,
        "Phones (Mobile)": 3223000,
        "Phones (Landline)": 584000,
        "GDP": 10440000000
    },
    {
        "Country Name": "Aruba",
        "ISO2": "AW",
        "ISO3": "ABW",
        "Top Level Domain": "aw",
        "FIPS": "AA",
        "ISO Numeric": 533,
        "GeoNameID": 3577279,
        "E164": 297,
        "Phone Code": 297,
        "Continent": "North America",
        "Capital": "Oranjestad",
        "Time Zone in Capital": "America/Curacao",
        "Currency": "Guilder",
        "Language Codes": "nl-AW,es,en",
        "Languages": "Papiamento (a Spanish-Portuguese-Dutch-English dialect) 69.4%, Spanish 13.7%, English (widely spoken) 7.1%, Dutch (official) 6.1%, Chinese 1.5%, other 1.7%, unspecified 0.4% (2010 est.)",
        "Area KM2": 193,
        "Internet Hosts": 40560,
        "Internet Users": 24000,
        "Phones (Mobile)": 135000,
        "Phones (Landline)": 43000,
        "GDP": 2516000000
    },
    {
        "Country Name": "Australia",
        "ISO2": "AU",
        "ISO3": "AUS",
        "Top Level Domain": "au",
        "FIPS": "AS",
        "ISO Numeric": "036",
        "GeoNameID": 2077456,
        "E164": 61,
        "Phone Code": 61,
        "Continent": "Oceania",
        "Capital": "Canberra",
        "Time Zone in Capital": "Australia/Sydney",
        "Currency": "Dollar",
        "Language Codes": "en-AU",
        "Languages": "English 76.8%, Mandarin 1.6%, Italian 1.4%, Arabic 1.3%, Greek 1.2%, Cantonese 1.2%, Vietnamese 1.1%, other 10.4%, unspecified 5% (2011 est.)",
        "Area KM2": 7686850,
        "Internet Hosts": 17081000,
        "Internet Users": 15810000,
        "Phones (Mobile)": 24400000,
        "Phones (Landline)": 10470000,
        "GDP": 1488000000000
    },
    {
        "Country Name": "Austria",
        "ISO2": "AT",
        "ISO3": "AUT",
        "Top Level Domain": "at",
        "FIPS": "AU",
        "ISO Numeric": "040",
        "GeoNameID": 2782113,
        "E164": 43,
        "Phone Code": 43,
        "Continent": "Europe",
        "Capital": "Vienna",
        "Time Zone in Capital": "Europe/Vienna",
        "Currency": "Euro",
        "Language Codes": "de-AT,hr,hu,sl",
        "Languages": "German (official nationwide) 88.6%, Turkish 2.3%, Serbian 2.2%, Croatian (official in Burgenland) 1.6%, other (includes Slovene, official in Carinthia, and Hungarian, official in Burgenland) 5.3% (2001 census)",
        "Area KM2": 83858,
        "Internet Hosts": 3512000,
        "Internet Users": 6143000,
        "Phones (Mobile)": 13590000,
        "Phones (Landline)": 3342000,
        "GDP": 417900000000
    },
    {
        "Country Name": "Azerbaijan",
        "ISO2": "AZ",
        "ISO3": "AZE",
        "Top Level Domain": "az",
        "FIPS": "AJ",
        "ISO Numeric": "031",
        "GeoNameID": 587116,
        "E164": 994,
        "Phone Code": 994,
        "Continent": "Asia",
        "Capital": "Baku",
        "Time Zone in Capital": "Asia/Baku",
        "Currency": "Manat",
        "Language Codes": "az,ru,hy",
        "Languages": "Azerbaijani (Azeri) (official) 92.5%, Russian 1.4%, Armenian 1.4%, other 4.7% (2009 est.)",
        "Area KM2": 86600,
        "Internet Hosts": 46856,
        "Internet Users": 2420000,
        "Phones (Mobile)": 10125000,
        "Phones (Landline)": 1734000,
        "GDP": 76010000000
    },
    {
        "Country Name": "Bahamas",
        "ISO2": "BS",
        "ISO3": "BHS",
        "Top Level Domain": "bs",
        "FIPS": "BF",
        "ISO Numeric": "044",
        "GeoNameID": 3572887,
        "E164": 1,
        "Phone Code": "1-242",
        "Continent": "North America",
        "Capital": "Nassau",
        "Time Zone in Capital": "America/Nassau",
        "Currency": "Dollar",
        "Language Codes": "en-BS",
        "Languages": "English (official), Creole (among Haitian immigrants)",
        "Area KM2": 13940,
        "Internet Hosts": 20661,
        "Internet Users": 115800,
        "Phones (Mobile)": 254000,
        "Phones (Landline)": 137000,
        "GDP": 8373000000
    },
    {
        "Country Name": "Bahrain",
        "ISO2": "BH",
        "ISO3": "BHR",
        "Top Level Domain": "bh",
        "FIPS": "BA",
        "ISO Numeric": "048",
        "GeoNameID": 290291,
        "E164": 973,
        "Phone Code": 973,
        "Continent": "Asia",
        "Capital": "Manama",
        "Time Zone in Capital": "Asia/Bahrain",
        "Currency": "Dinar",
        "Language Codes": "ar-BH,en,fa,ur",
        "Languages": "Arabic (official), English, Farsi, Urdu",
        "Area KM2": 665,
        "Internet Hosts": 47727,
        "Internet Users": 419500,
        "Phones (Mobile)": 2125000,
        "Phones (Landline)": 290000,
        "GDP": 28360000000
    },
    {
        "Country Name": "Bangladesh",
        "ISO2": "BD",
        "ISO3": "BGD",
        "Top Level Domain": "bd",
        "FIPS": "BG",
        "ISO Numeric": "050",
        "GeoNameID": 1210997,
        "E164": 880,
        "Phone Code": 880,
        "Continent": "Asia",
        "Capital": "Dhaka",
        "Time Zone in Capital": "Asia/Dhaka",
        "Currency": "Taka",
        "Language Codes": "bn-BD,en",
        "Languages": "Bangla (official, also known as Bengali), English",
        "Area KM2": 144000,
        "Internet Hosts": 71164,
        "Internet Users": 617300,
        "Phones (Mobile)": 97180000,
        "Phones (Landline)": 962000,
        "GDP": 140200000000
    },
    {
        "Country Name": "Barbados",
        "ISO2": "BB",
        "ISO3": "BRB",
        "Top Level Domain": "bb",
        "FIPS": "BB",
        "ISO Numeric": "052",
        "GeoNameID": 3374084,
        "E164": 1,
        "Phone Code": "1-246",
        "Continent": "North America",
        "Capital": "Bridgetown",
        "Time Zone in Capital": "America/Barbados",
        "Currency": "Dollar",
        "Language Codes": "en-BB",
        "Languages": "English (official), Bajan (English-based creole language, widely spoken in informal settings)",
        "Area KM2": 431,
        "Internet Hosts": 1524,
        "Internet Users": 188000,
        "Phones (Mobile)": 347000,
        "Phones (Landline)": 144000,
        "GDP": 4262000000
    },
    {
        "Country Name": "Belarus",
        "ISO2": "BY",
        "ISO3": "BLR",
        "Top Level Domain": "by",
        "FIPS": "BO",
        "ISO Numeric": 112,
        "GeoNameID": 630336,
        "E164": 375,
        "Phone Code": 375,
        "Continent": "Europe",
        "Capital": "Minsk",
        "Time Zone in Capital": "Europe/Minsk",
        "Currency": "Ruble",
        "Language Codes": "be,ru",
        "Languages": "Belarusian (official) 23.4%, Russian (official) 70.2%, other 3.1% (includes small Polish- and Ukrainian-speaking minorities), unspecified 3.3% (2009 est.)",
        "Area KM2": 207600,
        "Internet Hosts": 295217,
        "Internet Users": 2643000,
        "Phones (Mobile)": 10675000,
        "Phones (Landline)": 4407000,
        "GDP": 69240000000
    },
    {
        "Country Name": "Belgium",
        "ISO2": "BE",
        "ISO3": "BEL",
        "Top Level Domain": "be",
        "FIPS": "BE",
        "ISO Numeric": "056",
        "GeoNameID": 2802361,
        "E164": 32,
        "Phone Code": 32,
        "Continent": "Europe",
        "Capital": "Brussels",
        "Time Zone in Capital": "Europe/Brussels",
        "Currency": "Euro",
        "Language Codes": "nl-BE,fr-BE,de-BE",
        "Languages": "Dutch (official) 60%, French (official) 40%, German (official) less than 1%, legally bilingual (Dutch and French)",
        "Area KM2": 30510,
        "Internet Hosts": 5192000,
        "Internet Users": 8113000,
        "Phones (Mobile)": 12880000,
        "Phones (Landline)": 4631000,
        "GDP": 507400000000
    },
    {
        "Country Name": "Belize",
        "ISO2": "BZ",
        "ISO3": "BLZ",
        "Top Level Domain": "bz",
        "FIPS": "BH",
        "ISO Numeric": "084",
        "GeoNameID": 3582678,
        "E164": 501,
        "Phone Code": 501,
        "Continent": "North America",
        "Capital": "Belmopan",
        "Time Zone in Capital": "America/Belize",
        "Currency": "Dollar",
        "Language Codes": "en-BZ,es",
        "Languages": "Spanish 46%, Creole 32.9%, Mayan dialects 8.9%, English 3.9% (official), Garifuna 3.4% (Carib), German 3.3%, other 1.4%, unknown 0.2% (2000 census)",
        "Area KM2": 22966,
        "Internet Hosts": 3392,
        "Internet Users": 36000,
        "Phones (Mobile)": 164200,
        "Phones (Landline)": 25400,
        "GDP": 1637000000
    },
    {
        "Country Name": "Benin",
        "ISO2": "BJ",
        "ISO3": "BEN",
        "Top Level Domain": "bj",
        "FIPS": "BN",
        "ISO Numeric": 204,
        "GeoNameID": 2395170,
        "E164": 229,
        "Phone Code": 229,
        "Continent": "Africa",
        "Capital": "Porto-Novo",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-BJ",
        "Languages": "French (official), Fon and Yoruba (most common vernaculars in south), tribal languages (at least six major ones in north)",
        "Area KM2": 112620,
        "Internet Hosts": 491,
        "Internet Users": 200100,
        "Phones (Mobile)": 8408000,
        "Phones (Landline)": 156700,
        "GDP": 8359000000
    },
    {
        "Country Name": "Bermuda",
        "ISO2": "BM",
        "ISO3": "BMU",
        "Top Level Domain": "bm",
        "FIPS": "BD",
        "ISO Numeric": "060",
        "GeoNameID": 3573345,
        "E164": 1,
        "Phone Code": "1-441",
        "Continent": "North America",
        "Capital": "Hamilton",
        "Time Zone in Capital": "Atlantic/Bermuda",
        "Currency": "Dollar",
        "Language Codes": "en-BM,pt",
        "Languages": "English (official), Portuguese",
        "Area KM2": 53,
        "Internet Hosts": 20040,
        "Internet Users": 54000,
        "Phones (Mobile)": 91000,
        "Phones (Landline)": 69000,
        "GDP": 5600000000
    },
    {
        "Country Name": "Bhutan",
        "ISO2": "BT",
        "ISO3": "BTN",
        "Top Level Domain": "bt",
        "FIPS": "BT",
        "ISO Numeric": "064",
        "GeoNameID": 1252634,
        "E164": 975,
        "Phone Code": 975,
        "Continent": "Asia",
        "Capital": "Thimphu",
        "Time Zone in Capital": "Asia/Thimphu",
        "Currency": "Ngultrum",
        "Language Codes": "dz",
        "Languages": "Sharchhopka 28%, Dzongkha (official) 24%, Lhotshamkha 22%, other 26% (includes foreign languages) (2005 est.)",
        "Area KM2": 47000,
        "Internet Hosts": 14590,
        "Internet Users": 50000,
        "Phones (Mobile)": 560000,
        "Phones (Landline)": 27000,
        "GDP": 2133000000
    },
    {
        "Country Name": "Bolivia",
        "ISO2": "BO",
        "ISO3": "BOL",
        "Top Level Domain": "bo",
        "FIPS": "BL",
        "ISO Numeric": "068",
        "GeoNameID": 3923057,
        "E164": 591,
        "Phone Code": 591,
        "Continent": "South America",
        "Capital": "Sucre",
        "Time Zone in Capital": "America/La_Paz",
        "Currency": "Boliviano",
        "Language Codes": "es-BO,qu,ay",
        "Languages": "Spanish (official) 60.7%, Quechua (official) 21.2%, Aymara (official) 14.6%, Guarani (official), foreign languages 2.4%, other 1.2%",
        "Area KM2": 1098580,
        "Internet Hosts": 180988,
        "Internet Users": 1103000,
        "Phones (Mobile)": 9494000,
        "Phones (Landline)": 880600,
        "GDP": 30790000000
    },
    {
        "Country Name": "Bosnia and Herzegovina",
        "ISO2": "BA",
        "ISO3": "BIH",
        "Top Level Domain": "ba",
        "FIPS": "BK",
        "ISO Numeric": "070",
        "GeoNameID": 3277605,
        "E164": 387,
        "Phone Code": 387,
        "Continent": "Europe",
        "Capital": "Sarajevo",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Marka",
        "Language Codes": "bs,hr-BA,sr-BA",
        "Languages": "Bosnian (official), Croatian (official), Serbian (official)",
        "Area KM2": 51129,
        "Internet Hosts": 155252,
        "Internet Users": 1422000,
        "Phones (Mobile)": 3350000,
        "Phones (Landline)": 878000,
        "GDP": 18870000000
    },
    {
        "Country Name": "Botswana",
        "ISO2": "BW",
        "ISO3": "BWA",
        "Top Level Domain": "bw",
        "FIPS": "BC",
        "ISO Numeric": "072",
        "GeoNameID": 933860,
        "E164": 267,
        "Phone Code": 267,
        "Continent": "Africa",
        "Capital": "Gaborone",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Pula",
        "Language Codes": "en-BW,tn-BW",
        "Languages": "Setswana 78.2%, Kalanga 7.9%, Sekgalagadi 2.8%, English (official) 2.1%, other 8.6%, unspecified 0.4% (2001 census)",
        "Area KM2": 600370,
        "Internet Hosts": 1806,
        "Internet Users": 120000,
        "Phones (Mobile)": 3082000,
        "Phones (Landline)": 160500,
        "GDP": 15530000000
    },
    {
        "Country Name": "Brazil",
        "ISO2": "BR",
        "ISO3": "BRA",
        "Top Level Domain": "br",
        "FIPS": "BR",
        "ISO Numeric": "076",
        "GeoNameID": 3469034,
        "E164": 55,
        "Phone Code": 55,
        "Continent": "South America",
        "Capital": "Brasilia",
        "Time Zone in Capital": "America/Sao_Paulo",
        "Currency": "Real",
        "Language Codes": "pt-BR,es,en,fr",
        "Languages": "Portuguese (official and most widely spoken language)",
        "Area KM2": 8511965,
        "Internet Hosts": 26577000,
        "Internet Users": 75982000,
        "Phones (Mobile)": 248324000,
        "Phones (Landline)": 44300000,
        "GDP": 2190000000000
    },
    {
        "Country Name": "British Indian Ocean Territory",
        "ISO2": "IO",
        "ISO3": "IOT",
        "Top Level Domain": "io",
        "FIPS": "IO",
        "ISO Numeric": "086",
        "GeoNameID": 1282588,
        "E164": 246,
        "Phone Code": 246,
        "Continent": "Asia",
        "Capital": "Diego Garcia",
        "Time Zone in Capital": "Indian/Chagos",
        "Currency": "Dollar",
        "Language Codes": "en-IO",
        "Languages": "English",
        "Area KM2": 60,
        "Internet Hosts": 75006,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "British Virgin Islands",
        "ISO2": "VG",
        "ISO3": "VGB",
        "Top Level Domain": "vg",
        "FIPS": "VI",
        "ISO Numeric": "092",
        "GeoNameID": 3577718,
        "E164": 1,
        "Phone Code": "1-284",
        "Continent": "North America",
        "Capital": "Road Town",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-VG",
        "Languages": "English (official)",
        "Area KM2": 153,
        "Internet Hosts": 505,
        "Internet Users": 4000,
        "Phones (Mobile)": 48700,
        "Phones (Landline)": 12268,
        "GDP": 1095000000
    },
    {
        "Country Name": "Brunei",
        "ISO2": "BN",
        "ISO3": "BRN",
        "Top Level Domain": "bn",
        "FIPS": "BX",
        "ISO Numeric": "096",
        "GeoNameID": 1820814,
        "E164": 673,
        "Phone Code": 673,
        "Continent": "Asia",
        "Capital": "Bandar Seri Begawan",
        "Time Zone in Capital": "Asia/Brunei",
        "Currency": "Dollar",
        "Language Codes": "ms-BN,en-BN",
        "Languages": "Malay (official), English, Chinese",
        "Area KM2": 5770,
        "Internet Hosts": 49457,
        "Internet Users": 314900,
        "Phones (Mobile)": 469700,
        "Phones (Landline)": 70933,
        "GDP": 16560000000
    },
    {
        "Country Name": "Bulgaria",
        "ISO2": "BG",
        "ISO3": "BGR",
        "Top Level Domain": "bg",
        "FIPS": "BU",
        "ISO Numeric": 100,
        "GeoNameID": 732800,
        "E164": 359,
        "Phone Code": 359,
        "Continent": "Europe",
        "Capital": "Sofia",
        "Time Zone in Capital": "Europe/Sofia",
        "Currency": "Lev",
        "Language Codes": "bg,tr-BG",
        "Languages": "Bulgarian (official) 76.8%, Turkish 8.2%, Roma 3.8%, other 0.7%, unspecified 10.5% (2011 est.)",
        "Area KM2": 110910,
        "Internet Hosts": 976277,
        "Internet Users": 3395000,
        "Phones (Mobile)": 10780000,
        "Phones (Landline)": 2253000,
        "GDP": 53700000000
    },
    {
        "Country Name": "Burkina Faso",
        "ISO2": "BF",
        "ISO3": "BFA",
        "Top Level Domain": "bf",
        "FIPS": "UV",
        "ISO Numeric": 854,
        "GeoNameID": 2361809,
        "E164": 226,
        "Phone Code": 226,
        "Continent": "Africa",
        "Capital": "Ouagadougou",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-BF",
        "Languages": "French (official), native African languages belonging to Sudanic family spoken by 90% of the population",
        "Area KM2": 274200,
        "Internet Hosts": 1795,
        "Internet Users": 178100,
        "Phones (Mobile)": 9980000,
        "Phones (Landline)": 141400,
        "GDP": 12130000000
    },
    {
        "Country Name": "Burundi",
        "ISO2": "BI",
        "ISO3": "BDI",
        "Top Level Domain": "bi",
        "FIPS": "BY",
        "ISO Numeric": 108,
        "GeoNameID": 433561,
        "E164": 257,
        "Phone Code": 257,
        "Continent": "Africa",
        "Capital": "Bujumbura",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Franc",
        "Language Codes": "fr-BI,rn",
        "Languages": "Kirundi 29.7% (official), Kirundi and other language 9.1%, French (official) and French and other language 0.3%, Swahili and Swahili and other language 0.2% (along Lake Tanganyika and in the Bujumbura area), English and English and other language 0.06%, more than 2 languages 3.7%, unspecified 56.9% (2008 est.)",
        "Area KM2": 27830,
        "Internet Hosts": 229,
        "Internet Users": 157800,
        "Phones (Mobile)": 2247000,
        "Phones (Landline)": 17400,
        "GDP": 2676000000
    },
    {
        "Country Name": "Cambodia",
        "ISO2": "KH",
        "ISO3": "KHM",
        "Top Level Domain": "kh",
        "FIPS": "CB",
        "ISO Numeric": 116,
        "GeoNameID": 1831722,
        "E164": 855,
        "Phone Code": 855,
        "Continent": "Asia",
        "Capital": "Phnom Penh",
        "Time Zone in Capital": "Asia/Phnom_Penh",
        "Currency": "Riels",
        "Language Codes": "km,fr,en",
        "Languages": "Khmer (official) 96.3%, other 3.7% (2008 est.)",
        "Area KM2": 181040,
        "Internet Hosts": 13784,
        "Internet Users": 78500,
        "Phones (Mobile)": 19100000,
        "Phones (Landline)": 584000,
        "GDP": 15640000000
    },
    {
        "Country Name": "Cameroon",
        "ISO2": "CM",
        "ISO3": "CMR",
        "Top Level Domain": "cm",
        "FIPS": "CM",
        "ISO Numeric": 120,
        "GeoNameID": 2233387,
        "E164": 237,
        "Phone Code": 237,
        "Continent": "Africa",
        "Capital": "Yaounde",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "en-CM,fr-CM",
        "Languages": "24 major African language groups, English (official), French (official)",
        "Area KM2": 475440,
        "Internet Hosts": 10207,
        "Internet Users": 749600,
        "Phones (Mobile)": 13100000,
        "Phones (Landline)": 737400,
        "GDP": 27880000000
    },
    {
        "Country Name": "Canada",
        "ISO2": "CA",
        "ISO3": "CAN",
        "Top Level Domain": "ca",
        "FIPS": "CA",
        "ISO Numeric": 124,
        "GeoNameID": 6251999,
        "E164": 1,
        "Phone Code": 1,
        "Continent": "North America",
        "Capital": "Ottawa",
        "Time Zone in Capital": "America/Toronto",
        "Currency": "Dollar",
        "Language Codes": "en-CA,fr-CA,iu",
        "Languages": "English (official) 58.7%, French (official) 22%, Punjabi 1.4%, Italian 1.3%, Spanish 1.3%, German 1.3%, Cantonese 1.2%, Tagalog 1.2%, Arabic 1.1%, other 10.5% (2011 est.)",
        "Area KM2": 9984670,
        "Internet Hosts": 8743000,
        "Internet Users": 26960000,
        "Phones (Mobile)": 26263000,
        "Phones (Landline)": 18010000,
        "GDP": 1825000000000
    },
    {
        "Country Name": "Cape Verde",
        "ISO2": "CV",
        "ISO3": "CPV",
        "Top Level Domain": "cv",
        "FIPS": "CV",
        "ISO Numeric": 132,
        "GeoNameID": 3374766,
        "E164": 238,
        "Phone Code": 238,
        "Continent": "Africa",
        "Capital": "Praia",
        "Time Zone in Capital": "Atlantic/Cape_Verde",
        "Currency": "Escudo",
        "Language Codes": "pt-CV",
        "Languages": "Portuguese (official), Crioulo (a blend of Portuguese and West African words)",
        "Area KM2": 4033,
        "Internet Hosts": 38,
        "Internet Users": 150000,
        "Phones (Mobile)": 425300,
        "Phones (Landline)": 70200,
        "GDP": 1955000000
    },
    {
        "Country Name": "Cayman Islands",
        "ISO2": "KY",
        "ISO3": "CYM",
        "Top Level Domain": "ky",
        "FIPS": "CJ",
        "ISO Numeric": 136,
        "GeoNameID": 3580718,
        "E164": 1,
        "Phone Code": "1-345",
        "Continent": "North America",
        "Capital": "George Town",
        "Time Zone in Capital": "America/Cayman",
        "Currency": "Dollar",
        "Language Codes": "en-KY",
        "Languages": "English (official) 90.9%, Spanish 4%, Filipino 3.3%, other 1.7%, unspecified 0.1% (2010 est.)",
        "Area KM2": 262,
        "Internet Hosts": 23472,
        "Internet Users": 23000,
        "Phones (Mobile)": 96300,
        "Phones (Landline)": 37400,
        "GDP": 2250000000
    },
    {
        "Country Name": "Central African Republic",
        "ISO2": "CF",
        "ISO3": "CAF",
        "Top Level Domain": "cf",
        "FIPS": "CT",
        "ISO Numeric": 140,
        "GeoNameID": 239880,
        "E164": 236,
        "Phone Code": 236,
        "Continent": "Africa",
        "Capital": "Bangui",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-CF,sg,ln,kg",
        "Languages": "French (official), Sangho (lingua franca and national language), tribal languages",
        "Area KM2": 622984,
        "Internet Hosts": 20,
        "Internet Users": 22600,
        "Phones (Mobile)": 1070000,
        "Phones (Landline)": 5600,
        "GDP": 2050000000
    },
    {
        "Country Name": "Chad",
        "ISO2": "TD",
        "ISO3": "TCD",
        "Top Level Domain": "td",
        "FIPS": "CD",
        "ISO Numeric": 148,
        "GeoNameID": 2434508,
        "E164": 235,
        "Phone Code": 235,
        "Continent": "Africa",
        "Capital": "N'Djamena",
        "Time Zone in Capital": "Africa/Ndjamena",
        "Currency": "Franc",
        "Language Codes": "fr-TD,ar-TD,sre",
        "Languages": "French (official), Arabic (official), Sara (in south), more than 120 different languages and dialects",
        "Area KM2": 1284000,
        "Internet Hosts": 6,
        "Internet Users": 168100,
        "Phones (Mobile)": 4200000,
        "Phones (Landline)": 29900,
        "GDP": 13590000000
    },
    {
        "Country Name": "Chile",
        "ISO2": "CL",
        "ISO3": "CHL",
        "Top Level Domain": "cl",
        "FIPS": "CI",
        "ISO Numeric": 152,
        "GeoNameID": 3895114,
        "E164": 56,
        "Phone Code": 56,
        "Continent": "South America",
        "Capital": "Santiago",
        "Time Zone in Capital": "America/Santiago",
        "Currency": "Peso",
        "Language Codes": "es-CL",
        "Languages": "Spanish 99.5% (official), English 10.2%, indigenous 1% (includes Mapudungun, Aymara, Quechua, Rapa Nui), other 2.3%, unspecified 0.2%",
        "Area KM2": 756950,
        "Internet Hosts": 2152000,
        "Internet Users": 7009000,
        "Phones (Mobile)": 24130000,
        "Phones (Landline)": 3276000,
        "GDP": 281700000000
    },
    {
        "Country Name": "China",
        "ISO2": "CN",
        "ISO3": "CHN",
        "Top Level Domain": "cn",
        "FIPS": "CH",
        "ISO Numeric": 156,
        "GeoNameID": 1814991,
        "E164": 86,
        "Phone Code": 86,
        "Continent": "Asia",
        "Capital": "Beijing",
        "Time Zone in Capital": "Asia/Shanghai",
        "Currency": "Yuan Renminbi",
        "Language Codes": "zh-CN,yue,wuu,dta,ug,za",
        "Languages": "Standard Chinese or Mandarin (official; Putonghua, based on the Beijing dialect), Yue (Cantonese), Wu (Shanghainese), Minbei (Fuzhou), Minnan (Hokkien-Taiwanese), Xiang, Gan, Hakka dialects, minority languages",
        "Area KM2": 9596960,
        "Internet Hosts": 20602000,
        "Internet Users": 389000000,
        "Phones (Mobile)": 1100000000,
        "Phones (Landline)": 278860000,
        "GDP": 9330000000000
    },
    {
        "Country Name": "Christmas Island",
        "ISO2": "CX",
        "ISO3": "CXR",
        "Top Level Domain": "cx",
        "FIPS": "KT",
        "ISO Numeric": 162,
        "GeoNameID": 2078138,
        "E164": 61,
        "Phone Code": 61,
        "Continent": "Asia",
        "Capital": "Flying Fish Cove",
        "Time Zone in Capital": "Indian/Christmas",
        "Currency": "Dollar",
        "Language Codes": "en,zh,ms-CC",
        "Languages": "English (official), Chinese, Malay",
        "Area KM2": 135,
        "Internet Hosts": 3028,
        "Internet Users": 464,
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Cocos Islands",
        "ISO2": "CC",
        "ISO3": "CCK",
        "Top Level Domain": "cc",
        "FIPS": "CK",
        "ISO Numeric": 166,
        "GeoNameID": 1547376,
        "E164": 61,
        "Phone Code": 61,
        "Continent": "Asia",
        "Capital": "West Island",
        "Time Zone in Capital": "Indian/Cocos",
        "Currency": "Dollar",
        "Language Codes": "ms-CC,en",
        "Languages": "Malay (Cocos dialect), English",
        "Area KM2": 14,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Colombia",
        "ISO2": "CO",
        "ISO3": "COL",
        "Top Level Domain": "co",
        "FIPS": "CO",
        "ISO Numeric": 170,
        "GeoNameID": 3686110,
        "E164": 57,
        "Phone Code": 57,
        "Continent": "South America",
        "Capital": "Bogota",
        "Time Zone in Capital": "America/Bogota",
        "Currency": "Peso",
        "Language Codes": "es-CO",
        "Languages": "Spanish (official)",
        "Area KM2": 1138910,
        "Internet Hosts": 4410000,
        "Internet Users": 22538000,
        "Phones (Mobile)": 49066000,
        "Phones (Landline)": 6291000,
        "GDP": 369200000000
    },
    {
        "Country Name": "Comoros",
        "ISO2": "KM",
        "ISO3": "COM",
        "Top Level Domain": "km",
        "FIPS": "CN",
        "ISO Numeric": 174,
        "GeoNameID": 921929,
        "E164": 269,
        "Phone Code": 269,
        "Continent": "Africa",
        "Capital": "Moroni",
        "Time Zone in Capital": "Indian/Comoro",
        "Currency": "Franc",
        "Language Codes": "ar,fr-KM",
        "Languages": "Arabic (official), French (official), Shikomoro (a blend of Swahili and Arabic)",
        "Area KM2": 2170,
        "Internet Hosts": 14,
        "Internet Users": 24300,
        "Phones (Mobile)": 250000,
        "Phones (Landline)": 24000,
        "GDP": 658000000
    },
    {
        "Country Name": "Cook Islands",
        "ISO2": "CK",
        "ISO3": "COK",
        "Top Level Domain": "ck",
        "FIPS": "CW",
        "ISO Numeric": 184,
        "GeoNameID": 1899402,
        "E164": 682,
        "Phone Code": 682,
        "Continent": "Oceania",
        "Capital": "Avarua",
        "Time Zone in Capital": "Pacific/Rarotonga",
        "Currency": "Dollar",
        "Language Codes": "en-CK,mi",
        "Languages": "English (official) 86.4%, Cook Islands Maori (Rarotongan) (official) 76.2%, other 8.3%",
        "Area KM2": 240,
        "Internet Hosts": 3562,
        "Internet Users": 6000,
        "Phones (Mobile)": 7800,
        "Phones (Landline)": 7200,
        "GDP": 183200000
    },
    {
        "Country Name": "Costa Rica",
        "ISO2": "CR",
        "ISO3": "CRI",
        "Top Level Domain": "cr",
        "FIPS": "CS",
        "ISO Numeric": 188,
        "GeoNameID": 3624060,
        "E164": 506,
        "Phone Code": 506,
        "Continent": "North America",
        "Capital": "San Jose",
        "Time Zone in Capital": "America/Costa_Rica",
        "Currency": "Colon",
        "Language Codes": "es-CR,en",
        "Languages": "Spanish (official), English",
        "Area KM2": 51100,
        "Internet Hosts": 147258,
        "Internet Users": 1485000,
        "Phones (Mobile)": 6151000,
        "Phones (Landline)": 1018000,
        "GDP": 48510000000
    },
    {
        "Country Name": "Croatia",
        "ISO2": "HR",
        "ISO3": "HRV",
        "Top Level Domain": "hr",
        "FIPS": "HR",
        "ISO Numeric": 191,
        "GeoNameID": 3202326,
        "E164": 385,
        "Phone Code": 385,
        "Continent": "Europe",
        "Capital": "Zagreb",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Kuna",
        "Language Codes": "hr-HR,sr",
        "Languages": "Croatian (official) 95.6%, Serbian 1.2%, other 3% (including Hungarian, Czech, Slovak, and Albanian), unspecified 0.2% (2011 est.)",
        "Area KM2": 56542,
        "Internet Hosts": 729420,
        "Internet Users": 2234000,
        "Phones (Mobile)": 4970000,
        "Phones (Landline)": 1640000,
        "GDP": 59140000000
    },
    {
        "Country Name": "Cuba",
        "ISO2": "CU",
        "ISO3": "CUB",
        "Top Level Domain": "cu",
        "FIPS": "CU",
        "ISO Numeric": 192,
        "GeoNameID": 3562981,
        "E164": 53,
        "Phone Code": 53,
        "Continent": "North America",
        "Capital": "Havana",
        "Time Zone in Capital": "America/Havana",
        "Currency": "Peso",
        "Language Codes": "es-CU",
        "Languages": "Spanish (official)",
        "Area KM2": 110860,
        "Internet Hosts": 3244,
        "Internet Users": 1606000,
        "Phones (Mobile)": 1682000,
        "Phones (Landline)": 1217000,
        "GDP": 72300000000
    },
    {
        "Country Name": "Curacao",
        "ISO2": "CW",
        "ISO3": "CUW",
        "Top Level Domain": "cw",
        "FIPS": "UC",
        "ISO Numeric": 531,
        "GeoNameID": 7626836,
        "E164": 599,
        "Phone Code": 599,
        "Continent": "North America",
        "Capital": "Willemstad",
        "Time Zone in Capital": "America/Curacao",
        "Currency": "Guilder",
        "Language Codes": "nl,pap",
        "Languages": "Papiamentu (a Spanish-Portuguese-Dutch-English dialect) 81.2%, Dutch (official) 8%, Spanish 4%, English 2.9%, other 3.9% (2001 census)",
        "Area KM2": 444,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 5600000000
    },
    {
        "Country Name": "Cyprus",
        "ISO2": "CY",
        "ISO3": "CYP",
        "Top Level Domain": "cy",
        "FIPS": "CY",
        "ISO Numeric": 196,
        "GeoNameID": 146669,
        "E164": 357,
        "Phone Code": 357,
        "Continent": "Europe",
        "Capital": "Nicosia",
        "Time Zone in Capital": "Asia/Nicosia",
        "Currency": "Euro",
        "Language Codes": "el-CY,tr-CY,en",
        "Languages": "Greek (official) 80.9%, Turkish (official) 0.2%, English 4.1%, Romanian 2.9%, Russian 2.5%, Bulgarian 2.2%, Arabic 1.2%, Filippino 1.1%, other 4.3%, unspecified 0.6% (2011 est.)",
        "Area KM2": 9250,
        "Internet Hosts": 252013,
        "Internet Users": 433900,
        "Phones (Mobile)": 1110000,
        "Phones (Landline)": 373200,
        "GDP": 21780000000
    },
    {
        "Country Name": "Czech Republic",
        "ISO2": "CZ",
        "ISO3": "CZE",
        "Top Level Domain": "cz",
        "FIPS": "EZ",
        "ISO Numeric": 203,
        "GeoNameID": 3077311,
        "E164": 420,
        "Phone Code": 420,
        "Continent": "Europe",
        "Capital": "Prague",
        "Time Zone in Capital": "Europe/Prague",
        "Currency": "Koruna",
        "Language Codes": "cs,sk",
        "Languages": "Czech 95.4%, Slovak 1.6%, other 3% (2011 census)",
        "Area KM2": 78866,
        "Internet Hosts": 4148000,
        "Internet Users": 6681000,
        "Phones (Mobile)": 12973000,
        "Phones (Landline)": 2100000,
        "GDP": 194800000000
    },
    {
        "Country Name": "Democratic Republic of the Congo",
        "ISO2": "CD",
        "ISO3": "COD",
        "Top Level Domain": "cd",
        "FIPS": "CG",
        "ISO Numeric": 180,
        "GeoNameID": 203312,
        "E164": 243,
        "Phone Code": 243,
        "Continent": "Africa",
        "Capital": "Kinshasa",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-CD,ln,kg",
        "Languages": "French (official), Lingala (a lingua franca trade language), Kingwana (a dialect of Kiswahili or Swahili), Kikongo, Tshiluba",
        "Area KM2": 2345410,
        "Internet Hosts": 2515,
        "Internet Users": 290000,
        "Phones (Mobile)": 19487000,
        "Phones (Landline)": 58200,
        "GDP": 18560000000
    },
    {
        "Country Name": "Denmark",
        "ISO2": "DK",
        "ISO3": "DNK",
        "Top Level Domain": "dk",
        "FIPS": "DA",
        "ISO Numeric": 208,
        "GeoNameID": 2623032,
        "E164": 45,
        "Phone Code": 45,
        "Continent": "Europe",
        "Capital": "Copenhagen",
        "Time Zone in Capital": "Europe/Copenhagen",
        "Currency": "Krone",
        "Language Codes": "da-DK,en,fo,de-DK",
        "Languages": "Danish, Faroese, Greenlandic (an Inuit dialect), German (small minority)",
        "Area KM2": 43094,
        "Internet Hosts": 4297000,
        "Internet Users": 4750000,
        "Phones (Mobile)": 6600000,
        "Phones (Landline)": 2431000,
        "GDP": 324300000000
    },
    {
        "Country Name": "Djibouti",
        "ISO2": "DJ",
        "ISO3": "DJI",
        "Top Level Domain": "dj",
        "FIPS": "DJ",
        "ISO Numeric": 262,
        "GeoNameID": 223816,
        "E164": 253,
        "Phone Code": 253,
        "Continent": "Africa",
        "Capital": "Djibouti",
        "Time Zone in Capital": "Africa/Djibouti",
        "Currency": "Franc",
        "Language Codes": "fr-DJ,ar,so-DJ,aa",
        "Languages": "French (official), Arabic (official), Somali, Afar",
        "Area KM2": 23000,
        "Internet Hosts": 215,
        "Internet Users": 25900,
        "Phones (Mobile)": 209000,
        "Phones (Landline)": 18000,
        "GDP": 1459000000
    },
    {
        "Country Name": "Dominica",
        "ISO2": "DM",
        "ISO3": "DMA",
        "Top Level Domain": "dm",
        "FIPS": "DO",
        "ISO Numeric": 212,
        "GeoNameID": 3575830,
        "E164": 1,
        "Phone Code": "1-767",
        "Continent": "North America",
        "Capital": "Roseau",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-DM",
        "Languages": "English (official), French patois",
        "Area KM2": 754,
        "Internet Hosts": 723,
        "Internet Users": 28000,
        "Phones (Mobile)": 109300,
        "Phones (Landline)": 14600,
        "GDP": 495000000
    },
    {
        "Country Name": "Dominican Republic",
        "ISO2": "DO",
        "ISO3": "DOM",
        "Top Level Domain": "do",
        "FIPS": "DR",
        "ISO Numeric": 214,
        "GeoNameID": 3508796,
        "E164": 1,
        "Phone Code": "1-809, 1-829, 1-849",
        "Continent": "North America",
        "Capital": "Santo Domingo",
        "Time Zone in Capital": "America/Santo_Domingo",
        "Currency": "Peso",
        "Language Codes": "es-DO",
        "Languages": "Spanish (official)",
        "Area KM2": 48730,
        "Internet Hosts": 404500,
        "Internet Users": 2701000,
        "Phones (Mobile)": 9038000,
        "Phones (Landline)": 1065000,
        "GDP": 59270000000
    },
    {
        "Country Name": "East Timor",
        "ISO2": "TL",
        "ISO3": "TLS",
        "Top Level Domain": "tl",
        "FIPS": "TT",
        "ISO Numeric": 626,
        "GeoNameID": 1966436,
        "E164": 670,
        "Phone Code": 670,
        "Continent": "Oceania",
        "Capital": "Dili",
        "Time Zone in Capital": "Asia/Dili",
        "Currency": "Dollar",
        "Language Codes": "tet,pt-TL,id,en",
        "Languages": "Tetum (official), Portuguese (official), Indonesian, English",
        "Area KM2": 15007,
        "Internet Hosts": 252,
        "Internet Users": 2100,
        "Phones (Mobile)": 621000,
        "Phones (Landline)": 3000,
        "GDP": 6129000000
    },
    {
        "Country Name": "Ecuador",
        "ISO2": "EC",
        "ISO3": "ECU",
        "Top Level Domain": "ec",
        "FIPS": "EC",
        "ISO Numeric": 218,
        "GeoNameID": 3658394,
        "E164": 593,
        "Phone Code": 593,
        "Continent": "South America",
        "Capital": "Quito",
        "Time Zone in Capital": "America/Guayaquil",
        "Currency": "Dollar",
        "Language Codes": "es-EC",
        "Languages": "Spanish (Castillian) 93% (official), Quechua 4.1%, other indigenous 0.7%, foreign 2.2%",
        "Area KM2": 283560,
        "Internet Hosts": 170538,
        "Internet Users": 3352000,
        "Phones (Mobile)": 16457000,
        "Phones (Landline)": 2310000,
        "GDP": 91410000000
    },
    {
        "Country Name": "Egypt",
        "ISO2": "EG",
        "ISO3": "EGY",
        "Top Level Domain": "eg",
        "FIPS": "EG",
        "ISO Numeric": 818,
        "GeoNameID": 357994,
        "E164": 20,
        "Phone Code": 20,
        "Continent": "Africa",
        "Capital": "Cairo",
        "Time Zone in Capital": "Africa/Cairo",
        "Currency": "Pound",
        "Language Codes": "ar-EG,en,fr",
        "Languages": "Arabic (official), English and French widely understood by educated classes",
        "Area KM2": 1001450,
        "Internet Hosts": 200430,
        "Internet Users": 20136000,
        "Phones (Mobile)": 96800000,
        "Phones (Landline)": 8557000,
        "GDP": 262000000000
    },
    {
        "Country Name": "El Salvador",
        "ISO2": "SV",
        "ISO3": "SLV",
        "Top Level Domain": "sv",
        "FIPS": "ES",
        "ISO Numeric": 222,
        "GeoNameID": 3585968,
        "E164": 503,
        "Phone Code": 503,
        "Continent": "North America",
        "Capital": "San Salvador",
        "Time Zone in Capital": "America/El_Salvador",
        "Currency": "Dollar",
        "Language Codes": "es-SV",
        "Languages": "Spanish (official), Nahua (among some Amerindians)",
        "Area KM2": 21040,
        "Internet Hosts": 24070,
        "Internet Users": 746000,
        "Phones (Mobile)": 8650000,
        "Phones (Landline)": 1060000,
        "GDP": 24670000000
    },
    {
        "Country Name": "Equatorial Guinea",
        "ISO2": "GQ",
        "ISO3": "GNQ",
        "Top Level Domain": "gq",
        "FIPS": "EK",
        "ISO Numeric": 226,
        "GeoNameID": 2309096,
        "E164": 240,
        "Phone Code": 240,
        "Continent": "Africa",
        "Capital": "Malabo",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "es-GQ,fr",
        "Languages": "Spanish (official) 67.6%, other (includes French (official), Fang, Bubi) 32.4% (1994 census)",
        "Area KM2": 28051,
        "Internet Hosts": 7,
        "Internet Users": 14400,
        "Phones (Mobile)": 501000,
        "Phones (Landline)": 14900,
        "GDP": 17080000000
    },
    {
        "Country Name": "Eritrea",
        "ISO2": "ER",
        "ISO3": "ERI",
        "Top Level Domain": "er",
        "FIPS": "ER",
        "ISO Numeric": 232,
        "GeoNameID": 338010,
        "E164": 291,
        "Phone Code": 291,
        "Continent": "Africa",
        "Capital": "Asmara",
        "Time Zone in Capital": "Africa/Asmara",
        "Currency": "Nakfa",
        "Language Codes": "aa-ER,ar,tig,kun,ti-ER",
        "Languages": "Tigrinya (official), Arabic (official), English (official), Tigre, Kunama, Afar, other Cushitic languages",
        "Area KM2": 121320,
        "Internet Hosts": 701,
        "Internet Users": 200000,
        "Phones (Mobile)": 305300,
        "Phones (Landline)": 60000,
        "GDP": 3438000000
    },
    {
        "Country Name": "Estonia",
        "ISO2": "EE",
        "ISO3": "EST",
        "Top Level Domain": "ee",
        "FIPS": "EN",
        "ISO Numeric": 233,
        "GeoNameID": 453733,
        "E164": 372,
        "Phone Code": 372,
        "Continent": "Europe",
        "Capital": "Tallinn",
        "Time Zone in Capital": "Europe/Tallinn",
        "Currency": "Euro",
        "Language Codes": "et,ru",
        "Languages": "Estonian (official) 68.5%, Russian 29.6%, Ukrainian 0.6%, other 1.2%, unspecified 0.1% (2011 est.)",
        "Area KM2": 45226,
        "Internet Hosts": 865494,
        "Internet Users": 971700,
        "Phones (Mobile)": 2070000,
        "Phones (Landline)": 448200,
        "GDP": 24280000000
    },
    {
        "Country Name": "Ethiopia",
        "ISO2": "ET",
        "ISO3": "ETH",
        "Top Level Domain": "et",
        "FIPS": "ET",
        "ISO Numeric": 231,
        "GeoNameID": 337996,
        "E164": 251,
        "Phone Code": 251,
        "Continent": "Africa",
        "Capital": "Addis Ababa",
        "Time Zone in Capital": "Africa/Addis_Ababa",
        "Currency": "Birr",
        "Language Codes": "am,en-ET,om-ET,ti-ET,so-ET,sid",
        "Languages": "Oromo (official working language in the State of Oromiya) 33.8%, Amharic (official national language) 29.3%, Somali (official working language of the State of Sumale) 6.2%, Tigrigna (Tigrinya) (official working language of the State of Tigray) 5.9%, Sidamo 4%, Wolaytta 2.2%, Gurage 2%, Afar (official working language of the State of Afar) 1.7%, Hadiyya 1.7%, Gamo 1.5%, Gedeo 1.3%, Opuuo 1.2%, Kafa 1.1%, other 8.1%, English (major foreign language taught in schools), Arabic (2007 est.)",
        "Area KM2": 1127127,
        "Internet Hosts": 179,
        "Internet Users": 447300,
        "Phones (Mobile)": 20524000,
        "Phones (Landline)": 797500,
        "GDP": 47340000000
    },
    {
        "Country Name": "Falkland Islands",
        "ISO2": "FK",
        "ISO3": "FLK",
        "Top Level Domain": "fk",
        "FIPS": "FK",
        "ISO Numeric": 238,
        "GeoNameID": 3474414,
        "E164": 500,
        "Phone Code": 500,
        "Continent": "South America",
        "Capital": "Stanley",
        "Time Zone in Capital": "Atlantic/Stanley",
        "Currency": "Pound",
        "Language Codes": "en-FK",
        "Languages": "English 89%, Spanish 7.7%, other 3.3% (2006 est.)",
        "Area KM2": 12173,
        "Internet Hosts": 110,
        "Internet Users": 2900,
        "Phones (Mobile)": 3450,
        "Phones (Landline)": 1980,
        "GDP": 164500000
    },
    {
        "Country Name": "Faroe Islands",
        "ISO2": "FO",
        "ISO3": "FRO",
        "Top Level Domain": "fo",
        "FIPS": "FO",
        "ISO Numeric": 234,
        "GeoNameID": 2622320,
        "E164": 298,
        "Phone Code": 298,
        "Continent": "Europe",
        "Capital": "Torshavn",
        "Time Zone in Capital": "Atlantic/Faroe",
        "Currency": "Krone",
        "Language Codes": "fo,da-FO",
        "Languages": "Faroese (derived from Old Norse), Danish",
        "Area KM2": 1399,
        "Internet Hosts": 7575,
        "Internet Users": 37500,
        "Phones (Mobile)": 61000,
        "Phones (Landline)": 24000,
        "GDP": 2320000000
    },
    {
        "Country Name": "Fiji",
        "ISO2": "FJ",
        "ISO3": "FJI",
        "Top Level Domain": "fj",
        "FIPS": "FJ",
        "ISO Numeric": 242,
        "GeoNameID": 2205218,
        "E164": 679,
        "Phone Code": 679,
        "Continent": "Oceania",
        "Capital": "Suva",
        "Time Zone in Capital": "Pacific/Fiji",
        "Currency": "Dollar",
        "Language Codes": "en-FJ,fj",
        "Languages": "English (official), Fijian (official), Hindustani",
        "Area KM2": 18270,
        "Internet Hosts": 21739,
        "Internet Users": 114200,
        "Phones (Mobile)": 858800,
        "Phones (Landline)": 88400,
        "GDP": 4218000000
    },
    {
        "Country Name": "Finland",
        "ISO2": "FI",
        "ISO3": "FIN",
        "Top Level Domain": "fi",
        "FIPS": "FI",
        "ISO Numeric": 246,
        "GeoNameID": 660013,
        "E164": 358,
        "Phone Code": 358,
        "Continent": "Europe",
        "Capital": "Helsinki",
        "Time Zone in Capital": "Europe/Helsinki",
        "Currency": "Euro",
        "Language Codes": "fi-FI,sv-FI,smn",
        "Languages": "Finnish (official) 94.2%, Swedish (official) 5.5%, other (small Sami- and Russian-speaking minorities) 0.2% (2012 est.)",
        "Area KM2": 337030,
        "Internet Hosts": 4763000,
        "Internet Users": 4393000,
        "Phones (Mobile)": 9320000,
        "Phones (Landline)": 890000,
        "GDP": 259600000000
    },
    {
        "Country Name": "France",
        "ISO2": "FR",
        "ISO3": "FRA",
        "Top Level Domain": "fr",
        "FIPS": "FR",
        "ISO Numeric": 250,
        "GeoNameID": 3017382,
        "E164": 33,
        "Phone Code": 33,
        "Continent": "Europe",
        "Capital": "Paris",
        "Time Zone in Capital": "Europe/Paris",
        "Currency": "Euro",
        "Language Codes": "fr-FR,frp,br,co,ca,eu,oc",
        "Languages": "French (official) 100%, rapidly declining regional dialects and languages (Provencal, Breton, Alsatian, Corsican, Catalan, Basque, Flemish)",
        "Area KM2": 547030,
        "Internet Hosts": 17266000,
        "Internet Users": 45262000,
        "Phones (Mobile)": 62280000,
        "Phones (Landline)": 39290000,
        "GDP": 2739000000000
    },
    {
        "Country Name": "French Polynesia",
        "ISO2": "PF",
        "ISO3": "PYF",
        "Top Level Domain": "pf",
        "FIPS": "FP",
        "ISO Numeric": 258,
        "GeoNameID": 4030656,
        "E164": 689,
        "Phone Code": 689,
        "Continent": "Oceania",
        "Capital": "Papeete",
        "Time Zone in Capital": "Pacific/Tahiti",
        "Currency": "Franc",
        "Language Codes": "fr-PF,ty",
        "Languages": "French (official) 61.1%, Polynesian (official) 31.4%, Asian languages 1.2%, other 0.3%, unspecified 6% (2002 census)",
        "Area KM2": 4167,
        "Internet Hosts": 37949,
        "Internet Users": 120000,
        "Phones (Mobile)": 226000,
        "Phones (Landline)": 55000,
        "GDP": 5650000000
    },
    {
        "Country Name": "Gabon",
        "ISO2": "GA",
        "ISO3": "GAB",
        "Top Level Domain": "ga",
        "FIPS": "GB",
        "ISO Numeric": 266,
        "GeoNameID": 2400553,
        "E164": 241,
        "Phone Code": 241,
        "Continent": "Africa",
        "Capital": "Libreville",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-GA",
        "Languages": "French (official), Fang, Myene, Nzebi, Bapounou/Eschira, Bandjabi",
        "Area KM2": 267667,
        "Internet Hosts": 127,
        "Internet Users": 98800,
        "Phones (Mobile)": 2930000,
        "Phones (Landline)": 17000,
        "GDP": 19970000000
    },
    {
        "Country Name": "Gambia",
        "ISO2": "GM",
        "ISO3": "GMB",
        "Top Level Domain": "gm",
        "FIPS": "GA",
        "ISO Numeric": 270,
        "GeoNameID": 2413451,
        "E164": 220,
        "Phone Code": 220,
        "Continent": "Africa",
        "Capital": "Banjul",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Dalasi",
        "Language Codes": "en-GM,mnk,wof,wo,ff",
        "Languages": "English (official), Mandinka, Wolof, Fula, other indigenous vernaculars",
        "Area KM2": 11300,
        "Internet Hosts": 656,
        "Internet Users": 130100,
        "Phones (Mobile)": 1526000,
        "Phones (Landline)": 64200,
        "GDP": 896000000
    },
    {
        "Country Name": "Georgia",
        "ISO2": "GE",
        "ISO3": "GEO",
        "Top Level Domain": "ge",
        "FIPS": "GG",
        "ISO Numeric": 268,
        "GeoNameID": 614540,
        "E164": 995,
        "Phone Code": 995,
        "Continent": "Asia",
        "Capital": "Tbilisi",
        "Time Zone in Capital": "Asia/Tbilisi",
        "Currency": "Lari",
        "Language Codes": "ka,ru,hy,az",
        "Languages": "Georgian (official) 71%, Russian 9%, Armenian 7%, Azeri 6%, other 7%",
        "Area KM2": 69700,
        "Internet Hosts": 357864,
        "Internet Users": 1300000,
        "Phones (Mobile)": 4699000,
        "Phones (Landline)": 1276000,
        "GDP": 15950000000
    },
    {
        "Country Name": "Germany",
        "ISO2": "DE",
        "ISO3": "DEU",
        "Top Level Domain": "de",
        "FIPS": "GM",
        "ISO Numeric": 276,
        "GeoNameID": 2921044,
        "E164": 49,
        "Phone Code": 49,
        "Continent": "Europe",
        "Capital": "Berlin",
        "Time Zone in Capital": "Europe/Berlin",
        "Currency": "Euro",
        "Language Codes": "de",
        "Languages": "German (official)",
        "Area KM2": 357021,
        "Internet Hosts": 20043000,
        "Internet Users": 65125000,
        "Phones (Mobile)": 107700000,
        "Phones (Landline)": 50700000,
        "GDP": 3593000000000
    },
    {
        "Country Name": "Ghana",
        "ISO2": "GH",
        "ISO3": "GHA",
        "Top Level Domain": "gh",
        "FIPS": "GH",
        "ISO Numeric": 288,
        "GeoNameID": 2300660,
        "E164": 233,
        "Phone Code": 233,
        "Continent": "Africa",
        "Capital": "Accra",
        "Time Zone in Capital": "Africa/Accra",
        "Currency": "Cedi",
        "Language Codes": "en-GH,ak,ee,tw",
        "Languages": "Asante 14.8%, Ewe 12.7%, Fante 9.9%, Boron (Brong) 4.6%, Dagomba 4.3%, Dangme 4.3%, Dagarte (Dagaba) 3.7%, Akyem 3.4%, Ga 3.4%, Akuapem 2.9%, other (includes English (official)) 36.1% (2000 census)",
        "Area KM2": 239460,
        "Internet Hosts": 59086,
        "Internet Users": 1297000,
        "Phones (Mobile)": 25618000,
        "Phones (Landline)": 285000,
        "GDP": 45550000000
    },
    {
        "Country Name": "Gibraltar",
        "ISO2": "GI",
        "ISO3": "GIB",
        "Top Level Domain": "gi",
        "FIPS": "GI",
        "ISO Numeric": 292,
        "GeoNameID": 2411586,
        "E164": 350,
        "Phone Code": 350,
        "Continent": "Europe",
        "Capital": "Gibraltar",
        "Time Zone in Capital": "Europe/Gibraltar",
        "Currency": "Pound",
        "Language Codes": "en-GI,es,it,pt",
        "Languages": "English (used in schools and for official purposes), Spanish, Italian, Portuguese",
        "Area KM2": 7,
        "Internet Hosts": 3509,
        "Internet Users": 20200,
        "Phones (Mobile)": 34750,
        "Phones (Landline)": 23100,
        "GDP": 1106000000
    },
    {
        "Country Name": "Greece",
        "ISO2": "GR",
        "ISO3": "GRC",
        "Top Level Domain": "gr",
        "FIPS": "GR",
        "ISO Numeric": 300,
        "GeoNameID": 390903,
        "E164": 30,
        "Phone Code": 30,
        "Continent": "Europe",
        "Capital": "Athens",
        "Time Zone in Capital": "Europe/Athens",
        "Currency": "Euro",
        "Language Codes": "el-GR,en,fr",
        "Languages": "Greek (official) 99%, other (includes English and French) 1%",
        "Area KM2": 131940,
        "Internet Hosts": 3201000,
        "Internet Users": 4971000,
        "Phones (Mobile)": 13354000,
        "Phones (Landline)": 5461000,
        "GDP": 243300000000
    },
    {
        "Country Name": "Greenland",
        "ISO2": "GL",
        "ISO3": "GRL",
        "Top Level Domain": "gl",
        "FIPS": "GL",
        "ISO Numeric": 304,
        "GeoNameID": 3425505,
        "E164": 299,
        "Phone Code": 299,
        "Continent": "North America",
        "Capital": "Nuuk",
        "Time Zone in Capital": "America/Godthab",
        "Currency": "Krone",
        "Language Codes": "kl,da-GL,en",
        "Languages": "Greenlandic (East Inuit) (official), Danish (official), English",
        "Area KM2": 2166086,
        "Internet Hosts": 15645,
        "Internet Users": 36000,
        "Phones (Mobile)": 59455,
        "Phones (Landline)": 18900,
        "GDP": 2160000000
    },
    {
        "Country Name": "Grenada",
        "ISO2": "GD",
        "ISO3": "GRD",
        "Top Level Domain": "gd",
        "FIPS": "GJ",
        "ISO Numeric": 308,
        "GeoNameID": 3580239,
        "E164": 1,
        "Phone Code": "1-473",
        "Continent": "North America",
        "Capital": "St. George's",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-GD",
        "Languages": "English (official), French patois",
        "Area KM2": 344,
        "Internet Hosts": 80,
        "Internet Users": 25000,
        "Phones (Mobile)": 128000,
        "Phones (Landline)": 28500,
        "GDP": 811000000
    },
    {
        "Country Name": "Guam",
        "ISO2": "GU",
        "ISO3": "GUM",
        "Top Level Domain": "gu",
        "FIPS": "GQ",
        "ISO Numeric": 316,
        "GeoNameID": 4043988,
        "E164": 1,
        "Phone Code": "1-671",
        "Continent": "Oceania",
        "Capital": "Hagatna",
        "Time Zone in Capital": "Pacific/Guam",
        "Currency": "Dollar",
        "Language Codes": "en-GU,ch-GU",
        "Languages": "English 43.6%, Filipino 21.2%, Chamorro 17.8%, other Pacific island languages 10%, Asian languages 6.3%, other 1.1% (2010 est.)",
        "Area KM2": 549,
        "Internet Hosts": 23,
        "Internet Users": 90000,
        "Phones (Mobile)": 98000,
        "Phones (Landline)": 67000,
        "GDP": 4600000000
    },
    {
        "Country Name": "Guatemala",
        "ISO2": "GT",
        "ISO3": "GTM",
        "Top Level Domain": "gt",
        "FIPS": "GT",
        "ISO Numeric": 320,
        "GeoNameID": 3595528,
        "E164": 502,
        "Phone Code": 502,
        "Continent": "North America",
        "Capital": "Guatemala City",
        "Time Zone in Capital": "America/Guatemala",
        "Currency": "Quetzal",
        "Language Codes": "es-GT",
        "Languages": "Spanish (official) 60%, Amerindian languages 40%",
        "Area KM2": 108890,
        "Internet Hosts": 357552,
        "Internet Users": 2279000,
        "Phones (Mobile)": 20787000,
        "Phones (Landline)": 1744000,
        "GDP": 53900000000
    },
    {
        "Country Name": "Guernsey",
        "ISO2": "GG",
        "ISO3": "GGY",
        "Top Level Domain": "gg",
        "FIPS": "GK",
        "ISO Numeric": 831,
        "GeoNameID": 3042362,
        "E164": 44,
        "Phone Code": "44-1481",
        "Continent": "Europe",
        "Capital": "St Peter Port",
        "Time Zone in Capital": "Europe/London",
        "Currency": "Pound",
        "Language Codes": "en,fr",
        "Languages": "English, French, Norman-French dialect spoken in country districts",
        "Area KM2": 78,
        "Internet Hosts": 239,
        "Internet Users": 48300,
        "Phones (Mobile)": 43800,
        "Phones (Landline)": 45100,
        "GDP": 2742000000
    },
    {
        "Country Name": "Guinea",
        "ISO2": "GN",
        "ISO3": "GIN",
        "Top Level Domain": "gn",
        "FIPS": "GV",
        "ISO Numeric": 324,
        "GeoNameID": 2420477,
        "E164": 224,
        "Phone Code": 224,
        "Continent": "Africa",
        "Capital": "Conakry",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-GN",
        "Languages": "French (official)",
        "Area KM2": 245857,
        "Internet Hosts": 15,
        "Internet Users": 95000,
        "Phones (Mobile)": 4781000,
        "Phones (Landline)": 18000,
        "GDP": 6544000000
    },
    {
        "Country Name": "Guinea-Bissau",
        "ISO2": "GW",
        "ISO3": "GNB",
        "Top Level Domain": "gw",
        "FIPS": "PU",
        "ISO Numeric": 624,
        "GeoNameID": 2372248,
        "E164": 245,
        "Phone Code": 245,
        "Continent": "Africa",
        "Capital": "Bissau",
        "Time Zone in Capital": "Africa/Bissau",
        "Currency": "Franc",
        "Language Codes": "pt-GW,pov",
        "Languages": "Portuguese (official), Crioulo, African languages",
        "Area KM2": 36120,
        "Internet Hosts": 90,
        "Internet Users": 37100,
        "Phones (Mobile)": 1100000,
        "Phones (Landline)": 5000,
        "GDP": 880000000
    },
    {
        "Country Name": "Guyana",
        "ISO2": "GY",
        "ISO3": "GUY",
        "Top Level Domain": "gy",
        "FIPS": "GY",
        "ISO Numeric": 328,
        "GeoNameID": 3378535,
        "E164": 592,
        "Phone Code": 592,
        "Continent": "South America",
        "Capital": "Georgetown",
        "Time Zone in Capital": "America/Guyana",
        "Currency": "Dollar",
        "Language Codes": "en-GY",
        "Languages": "English, Amerindian dialects, Creole, Caribbean Hindustani (a dialect of Hindi), Urdu",
        "Area KM2": 214970,
        "Internet Hosts": 24936,
        "Internet Users": 189600,
        "Phones (Mobile)": 547000,
        "Phones (Landline)": 154200,
        "GDP": 3020000000
    },
    {
        "Country Name": "Haiti",
        "ISO2": "HT",
        "ISO3": "HTI",
        "Top Level Domain": "ht",
        "FIPS": "HA",
        "ISO Numeric": 332,
        "GeoNameID": 3723988,
        "E164": 509,
        "Phone Code": 509,
        "Continent": "North America",
        "Capital": "Port-au-Prince",
        "Time Zone in Capital": "America/Port-au-Prince",
        "Currency": "Gourde",
        "Language Codes": "ht,fr-HT",
        "Languages": "French (official), Creole (official)",
        "Area KM2": 27750,
        "Internet Hosts": 555,
        "Internet Users": 1000000,
        "Phones (Mobile)": 6095000,
        "Phones (Landline)": 50000,
        "GDP": 8287000000
    },
    {
        "Country Name": "Honduras",
        "ISO2": "HN",
        "ISO3": "HND",
        "Top Level Domain": "hn",
        "FIPS": "HO",
        "ISO Numeric": 340,
        "GeoNameID": 3608932,
        "E164": 504,
        "Phone Code": 504,
        "Continent": "North America",
        "Capital": "Tegucigalpa",
        "Time Zone in Capital": "America/Tegucigalpa",
        "Currency": "Lempira",
        "Language Codes": "es-HN",
        "Languages": "Spanish (official), Amerindian dialects",
        "Area KM2": 112090,
        "Internet Hosts": 30955,
        "Internet Users": 731700,
        "Phones (Mobile)": 7370000,
        "Phones (Landline)": 610000,
        "GDP": 18880000000
    },
    {
        "Country Name": "Hong Kong",
        "ISO2": "HK",
        "ISO3": "HKG",
        "Top Level Domain": "hk",
        "FIPS": "HK",
        "ISO Numeric": 344,
        "GeoNameID": 1819730,
        "E164": 852,
        "Phone Code": 852,
        "Continent": "Asia",
        "Capital": "Hong Kong",
        "Time Zone in Capital": "Asia/Hong_Kong",
        "Currency": "Dollar",
        "Language Codes": "zh-HK,yue,zh,en",
        "Languages": "Cantonese (official) 89.5%, English (official) 3.5%, Putonghua (Mandarin) 1.4%, other Chinese dialects 4%, other 1.6% (2011 est.)",
        "Area KM2": 1092,
        "Internet Hosts": 870041,
        "Internet Users": 4873000,
        "Phones (Mobile)": 16403000,
        "Phones (Landline)": 4362000,
        "GDP": 272100000000
    },
    {
        "Country Name": "Hungary",
        "ISO2": "HU",
        "ISO3": "HUN",
        "Top Level Domain": "hu",
        "FIPS": "HU",
        "ISO Numeric": 348,
        "GeoNameID": 719819,
        "E164": 36,
        "Phone Code": 36,
        "Continent": "Europe",
        "Capital": "Budapest",
        "Time Zone in Capital": "Europe/Budapest",
        "Currency": "Forint",
        "Language Codes": "hu-HU",
        "Languages": "Hungarian (official) 99.6%, English 16%, German 11.2%, Russian 1.6%, Romanian 1.3%, French 1.2%, other 4.2%",
        "Area KM2": 93030,
        "Internet Hosts": 3145000,
        "Internet Users": 6176000,
        "Phones (Mobile)": 11580000,
        "Phones (Landline)": 2960000,
        "GDP": 130600000000
    },
    {
        "Country Name": "Iceland",
        "ISO2": "IS",
        "ISO3": "ISL",
        "Top Level Domain": "is",
        "FIPS": "IC",
        "ISO Numeric": 352,
        "GeoNameID": 2629691,
        "E164": 354,
        "Phone Code": 354,
        "Continent": "Europe",
        "Capital": "Reykjavik",
        "Time Zone in Capital": "Atlantic/Reykjavik",
        "Currency": "Krona",
        "Language Codes": "is,en,de,da,sv,no",
        "Languages": "Icelandic, English, Nordic languages, German widely spoken",
        "Area KM2": 103000,
        "Internet Hosts": 369969,
        "Internet Users": 301600,
        "Phones (Mobile)": 346000,
        "Phones (Landline)": 189000,
        "GDP": 14590000000
    },
    {
        "Country Name": "India",
        "ISO2": "IN",
        "ISO3": "IND",
        "Top Level Domain": "in",
        "FIPS": "IN",
        "ISO Numeric": 356,
        "GeoNameID": 1269750,
        "E164": 91,
        "Phone Code": 91,
        "Continent": "Asia",
        "Capital": "New Delhi",
        "Time Zone in Capital": "Asia/Kolkata",
        "Currency": "Rupee",
        "Language Codes": "en-IN,hi,bn,te,mr,ta,ur,gu,kn,ml,or,pa,as,bh,sat,ks,ne,sd,kok,doi,mni,sit,sa,fr,lus,inc",
        "Languages": "Hindi 41%, Bengali 8.1%, Telugu 7.2%, Marathi 7%, Tamil 5.9%, Urdu 5%, Gujarati 4.5%, Kannada 3.7%, Malayalam 3.2%, Oriya 3.2%, Punjabi 2.8%, Assamese 1.3%, Maithili 1.2%, other 5.9%",
        "Area KM2": 3287590,
        "Internet Hosts": 6746000,
        "Internet Users": 61338000,
        "Phones (Mobile)": 893862000,
        "Phones (Landline)": 31080000,
        "GDP": 1670000000000
    },
    {
        "Country Name": "Indonesia",
        "ISO2": "ID",
        "ISO3": "IDN",
        "Top Level Domain": "id",
        "FIPS": "ID",
        "ISO Numeric": 360,
        "GeoNameID": 1643084,
        "E164": 62,
        "Phone Code": 62,
        "Continent": "Asia",
        "Capital": "Jakarta",
        "Time Zone in Capital": "Asia/Jakarta",
        "Currency": "Rupiah",
        "Language Codes": "id,en,nl,jv",
        "Languages": "Bahasa Indonesia (official, modified form of Malay), English, Dutch, local dialects (of which the most widely spoken is Javanese)",
        "Area KM2": 1919440,
        "Internet Hosts": 1344000,
        "Internet Users": 20000000,
        "Phones (Mobile)": 281960000,
        "Phones (Landline)": 37983000,
        "GDP": 867500000000
    },
    {
        "Country Name": "Iran",
        "ISO2": "IR",
        "ISO3": "IRN",
        "Top Level Domain": "ir",
        "FIPS": "IR",
        "ISO Numeric": 364,
        "GeoNameID": 130758,
        "E164": 98,
        "Phone Code": 98,
        "Continent": "Asia",
        "Capital": "Tehran",
        "Time Zone in Capital": "Asia/Tehran",
        "Currency": "Rial",
        "Language Codes": "fa-IR,ku",
        "Languages": "Persian (official) 53%, Azeri Turkic and Turkic dialects 18%, Kurdish 10%, Gilaki and Mazandarani 7%, Luri 6%, Balochi 2%, Arabic 2%, other 2%",
        "Area KM2": 1648000,
        "Internet Hosts": 197804,
        "Internet Users": 8214000,
        "Phones (Mobile)": 58160000,
        "Phones (Landline)": 28760000,
        "GDP": 411900000000
    },
    {
        "Country Name": "Iraq",
        "ISO2": "IQ",
        "ISO3": "IRQ",
        "Top Level Domain": "iq",
        "FIPS": "IZ",
        "ISO Numeric": 368,
        "GeoNameID": 99237,
        "E164": 964,
        "Phone Code": 964,
        "Continent": "Asia",
        "Capital": "Baghdad",
        "Time Zone in Capital": "Asia/Baghdad",
        "Currency": "Dinar",
        "Language Codes": "ar-IQ,ku,hy",
        "Languages": "Arabic (official), Kurdish (official), Turkmen (a Turkish dialect) and Assyrian (Neo-Aramaic) are official in areas where they constitute a majority of the population), Armenian",
        "Area KM2": 437072,
        "Internet Hosts": 26,
        "Internet Users": 325900,
        "Phones (Mobile)": 26760000,
        "Phones (Landline)": 1870000,
        "GDP": 221800000000
    },
    {
        "Country Name": "Ireland",
        "ISO2": "IE",
        "ISO3": "IRL",
        "Top Level Domain": "ie",
        "FIPS": "EI",
        "ISO Numeric": 372,
        "GeoNameID": 2963597,
        "E164": 353,
        "Phone Code": 353,
        "Continent": "Europe",
        "Capital": "Dublin",
        "Time Zone in Capital": "Europe/Dublin",
        "Currency": "Euro",
        "Language Codes": "en-IE,ga-IE",
        "Languages": "English (official, the language generally used), Irish (Gaelic or Gaeilge) (official, spoken mainly in areas along the western coast)",
        "Area KM2": 70280,
        "Internet Hosts": 1387000,
        "Internet Users": 3042000,
        "Phones (Mobile)": 4906000,
        "Phones (Landline)": 2007000,
        "GDP": 220900000000
    },
    {
        "Country Name": "Isle of Man",
        "ISO2": "IM",
        "ISO3": "IMN",
        "Top Level Domain": "im",
        "FIPS": "IM",
        "ISO Numeric": 833,
        "GeoNameID": 3042225,
        "E164": 44,
        "Phone Code": "44-1624",
        "Continent": "Europe",
        "Capital": "Douglas, Isle of Man",
        "Time Zone in Capital": "Europe/London",
        "Currency": "Pound",
        "Language Codes": "en,gv",
        "Languages": "English, Manx Gaelic (about 2% of the population has some knowledge)",
        "Area KM2": 572,
        "Internet Hosts": 895,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 4076000000
    },
    {
        "Country Name": "Israel",
        "ISO2": "IL",
        "ISO3": "ISR",
        "Top Level Domain": "il",
        "FIPS": "IS",
        "ISO Numeric": 376,
        "GeoNameID": 294640,
        "E164": 972,
        "Phone Code": 972,
        "Continent": "Asia",
        "Capital": "Jerusalem",
        "Time Zone in Capital": "Asia/Jerusalem",
        "Currency": "Shekel",
        "Language Codes": "he,ar-IL,en-IL,",
        "Languages": "Hebrew (official), Arabic (used officially for Arab minority), English (most commonly used foreign language)",
        "Area KM2": 20770,
        "Internet Hosts": 2483000,
        "Internet Users": 4525000,
        "Phones (Mobile)": 9225000,
        "Phones (Landline)": 3594000,
        "GDP": 272700000000
    },
    {
        "Country Name": "Italy",
        "ISO2": "IT",
        "ISO3": "ITA",
        "Top Level Domain": "it",
        "FIPS": "IT",
        "ISO Numeric": 380,
        "GeoNameID": 3175395,
        "E164": 39,
        "Phone Code": 39,
        "Continent": "Europe",
        "Capital": "Rome",
        "Time Zone in Capital": "Europe/Rome",
        "Currency": "Euro",
        "Language Codes": "it-IT,de-IT,fr-IT,sc,ca,co,sl",
        "Languages": "Italian (official), German (parts of Trentino-Alto Adige region are predominantly German-speaking), French (small French-speaking minority in Valle d'Aosta region), Slovene (Slovene-speaking minority in the Trieste-Gorizia area)",
        "Area KM2": 301230,
        "Internet Hosts": 25662000,
        "Internet Users": 29235000,
        "Phones (Mobile)": 97225000,
        "Phones (Landline)": 21656000,
        "GDP": 2068000000000
    },
    {
        "Country Name": "Ivory Coast",
        "ISO2": "CI",
        "ISO3": "CIV",
        "Top Level Domain": "ci",
        "FIPS": "IV",
        "ISO Numeric": 384,
        "GeoNameID": 2287781,
        "E164": 225,
        "Phone Code": 225,
        "Continent": "Africa",
        "Capital": "Yamoussoukro",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-CI",
        "Languages": "French (official), 60 native dialects of which Dioula is the most widely spoken",
        "Area KM2": 322460,
        "Internet Hosts": 9115,
        "Internet Users": 967300,
        "Phones (Mobile)": 19827000,
        "Phones (Landline)": 268000,
        "GDP": 28280000000
    },
    {
        "Country Name": "Jamaica",
        "ISO2": "JM",
        "ISO3": "JAM",
        "Top Level Domain": "jm",
        "FIPS": "JM",
        "ISO Numeric": 388,
        "GeoNameID": 3489940,
        "E164": 1,
        "Phone Code": "1-876",
        "Continent": "North America",
        "Capital": "Kingston",
        "Time Zone in Capital": "America/Jamaica",
        "Currency": "Dollar",
        "Language Codes": "en-JM",
        "Languages": "English, English patois",
        "Area KM2": 10991,
        "Internet Hosts": 3906,
        "Internet Users": 1581000,
        "Phones (Mobile)": 2665000,
        "Phones (Landline)": 265000,
        "GDP": 14390000000
    },
    {
        "Country Name": "Japan",
        "ISO2": "JP",
        "ISO3": "JPN",
        "Top Level Domain": "jp",
        "FIPS": "JA",
        "ISO Numeric": 392,
        "GeoNameID": 1861060,
        "E164": 81,
        "Phone Code": 81,
        "Continent": "Asia",
        "Capital": "Tokyo",
        "Time Zone in Capital": "Asia/Tokyo",
        "Currency": "Yen",
        "Language Codes": "ja",
        "Languages": "Japanese",
        "Area KM2": 377835,
        "Internet Hosts": 64453000,
        "Internet Users": 99182000,
        "Phones (Mobile)": 138363000,
        "Phones (Landline)": 64273000,
        "GDP": 5007000000000
    },
    {
        "Country Name": "Jersey",
        "ISO2": "JE",
        "ISO3": "JEY",
        "Top Level Domain": "je",
        "FIPS": "JE",
        "ISO Numeric": 832,
        "GeoNameID": 3042142,
        "E164": 44,
        "Phone Code": "44-1534",
        "Continent": "Europe",
        "Capital": "Saint Helier",
        "Time Zone in Capital": "Europe/London",
        "Currency": "Pound",
        "Language Codes": "en,pt",
        "Languages": "English 94.5% (official), Portuguese 4.6%, other 0.9% (2001 census)",
        "Area KM2": 116,
        "Internet Hosts": 264,
        "Internet Users": 29500,
        "Phones (Mobile)": 108000,
        "Phones (Landline)": 73800,
        "GDP": 5100000000
    },
    {
        "Country Name": "Jordan",
        "ISO2": "JO",
        "ISO3": "JOR",
        "Top Level Domain": "jo",
        "FIPS": "JO",
        "ISO Numeric": 400,
        "GeoNameID": 248816,
        "E164": 962,
        "Phone Code": 962,
        "Continent": "Asia",
        "Capital": "Amman",
        "Time Zone in Capital": "Asia/Amman",
        "Currency": "Dinar",
        "Language Codes": "ar-JO,en",
        "Languages": "Arabic (official), English (widely understood among upper and middle classes)",
        "Area KM2": 92300,
        "Internet Hosts": 69473,
        "Internet Users": 1642000,
        "Phones (Mobile)": 8984000,
        "Phones (Landline)": 435000,
        "GDP": 34080000000
    },
    {
        "Country Name": "Kazakhstan",
        "ISO2": "KZ",
        "ISO3": "KAZ",
        "Top Level Domain": "kz",
        "FIPS": "KZ",
        "ISO Numeric": 398,
        "GeoNameID": 1522867,
        "E164": 7,
        "Phone Code": 7,
        "Continent": "Asia",
        "Capital": "Astana",
        "Time Zone in Capital": "Asia/Almaty",
        "Currency": "Tenge",
        "Language Codes": "kk,ru",
        "Languages": "Kazakh (official, Qazaq) 64.4%, Russian (official, used in everyday business, designated the \"language of interethnic communication\") 95% (2001 est.)",
        "Area KM2": 2717300,
        "Internet Hosts": 67464,
        "Internet Users": 5299000,
        "Phones (Mobile)": 28731000,
        "Phones (Landline)": 4340000,
        "GDP": 224900000000
    },
    {
        "Country Name": "Kenya",
        "ISO2": "KE",
        "ISO3": "KEN",
        "Top Level Domain": "ke",
        "FIPS": "KE",
        "ISO Numeric": 404,
        "GeoNameID": 192950,
        "E164": 254,
        "Phone Code": 254,
        "Continent": "Africa",
        "Capital": "Nairobi",
        "Time Zone in Capital": "Africa/Nairobi",
        "Currency": "Shilling",
        "Language Codes": "en-KE,sw-KE",
        "Languages": "English (official), Kiswahili (official), numerous indigenous languages",
        "Area KM2": 582650,
        "Internet Hosts": 71018,
        "Internet Users": 3996000,
        "Phones (Mobile)": 30732000,
        "Phones (Landline)": 251600,
        "GDP": 45310000000
    },
    {
        "Country Name": "Kiribati",
        "ISO2": "KI",
        "ISO3": "KIR",
        "Top Level Domain": "ki",
        "FIPS": "KR",
        "ISO Numeric": 296,
        "GeoNameID": 4030945,
        "E164": 686,
        "Phone Code": 686,
        "Continent": "Oceania",
        "Capital": "Tarawa",
        "Time Zone in Capital": "Pacific/Tarawa",
        "Currency": "Dollar",
        "Language Codes": "en-KI,gil",
        "Languages": "I-Kiribati, English (official)",
        "Area KM2": 811,
        "Internet Hosts": 327,
        "Internet Users": 7800,
        "Phones (Mobile)": 16000,
        "Phones (Landline)": 9000,
        "GDP": 173000000
    },
    {
        "Country Name": "Kosovo",
        "ISO2": "XK",
        "ISO3": "XKX",
        "Top Level Domain": "",
        "FIPS": "KV",
        "ISO Numeric": 0,
        "GeoNameID": 831053,
        "E164": 383,
        "Phone Code": 383,
        "Continent": "Europe",
        "Capital": "Pristina",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Euro",
        "Language Codes": "sq,sr",
        "Languages": "Albanian (official), Serbian (official), Bosnian, Turkish, Roma",
        "Area KM2": 10887,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": 562000,
        "Phones (Landline)": 106300,
        "GDP": 7150000000
    },
    {
        "Country Name": "Kuwait",
        "ISO2": "KW",
        "ISO3": "KWT",
        "Top Level Domain": "kw",
        "FIPS": "KU",
        "ISO Numeric": 414,
        "GeoNameID": 285570,
        "E164": 965,
        "Phone Code": 965,
        "Continent": "Asia",
        "Capital": "Kuwait City",
        "Time Zone in Capital": "Asia/Kuwait",
        "Currency": "Dinar",
        "Language Codes": "ar-KW,en",
        "Languages": "Arabic (official), English widely spoken",
        "Area KM2": 17820,
        "Internet Hosts": 2771,
        "Internet Users": 1100000,
        "Phones (Mobile)": 5526000,
        "Phones (Landline)": 510000,
        "GDP": 179500000000
    },
    {
        "Country Name": "Kyrgyzstan",
        "ISO2": "KG",
        "ISO3": "KGZ",
        "Top Level Domain": "kg",
        "FIPS": "KG",
        "ISO Numeric": 417,
        "GeoNameID": 1527747,
        "E164": 996,
        "Phone Code": 996,
        "Continent": "Asia",
        "Capital": "Bishkek",
        "Time Zone in Capital": "Asia/Bishkek",
        "Currency": "Som",
        "Language Codes": "ky,uz,ru",
        "Languages": "Kyrgyz (official) 64.7%, Uzbek 13.6%, Russian (official) 12.5%, Dungun 1%, other 8.2% (1999 census)",
        "Area KM2": 198500,
        "Internet Hosts": 115573,
        "Internet Users": 2195000,
        "Phones (Mobile)": 6800000,
        "Phones (Landline)": 489000,
        "GDP": 7234000000
    },
    {
        "Country Name": "Laos",
        "ISO2": "LA",
        "ISO3": "LAO",
        "Top Level Domain": "la",
        "FIPS": "LA",
        "ISO Numeric": 418,
        "GeoNameID": 1655842,
        "E164": 856,
        "Phone Code": 856,
        "Continent": "Asia",
        "Capital": "Vientiane",
        "Time Zone in Capital": "Asia/Vientiane",
        "Currency": "Kip",
        "Language Codes": "lo,fr,en",
        "Languages": "Lao (official), French, English, various ethnic languages",
        "Area KM2": 236800,
        "Internet Hosts": 1532,
        "Internet Users": 300000,
        "Phones (Mobile)": 6492000,
        "Phones (Landline)": 112000,
        "GDP": 10100000000
    },
    {
        "Country Name": "Latvia",
        "ISO2": "LV",
        "ISO3": "LVA",
        "Top Level Domain": "lv",
        "FIPS": "LG",
        "ISO Numeric": 428,
        "GeoNameID": 458258,
        "E164": 371,
        "Phone Code": 371,
        "Continent": "Europe",
        "Capital": "Riga",
        "Time Zone in Capital": "Europe/Riga",
        "Currency": "Euro",
        "Language Codes": "lv,ru,lt",
        "Languages": "Latvian (official) 56.3%, Russian 33.8%, other 0.6% (includes Polish, Ukrainian, and Belarusian), unspecified 9.4% (2011 est.)",
        "Area KM2": 64589,
        "Internet Hosts": 359604,
        "Internet Users": 1504000,
        "Phones (Mobile)": 2310000,
        "Phones (Landline)": 501000,
        "GDP": 30380000000
    },
    {
        "Country Name": "Lebanon",
        "ISO2": "LB",
        "ISO3": "LBN",
        "Top Level Domain": "lb",
        "FIPS": "LE",
        "ISO Numeric": 422,
        "GeoNameID": 272103,
        "E164": 961,
        "Phone Code": 961,
        "Continent": "Asia",
        "Capital": "Beirut",
        "Time Zone in Capital": "Asia/Beirut",
        "Currency": "Pound",
        "Language Codes": "ar-LB,fr-LB,en,hy",
        "Languages": "Arabic (official), French, English, Armenian",
        "Area KM2": 10400,
        "Internet Hosts": 64926,
        "Internet Users": 1000000,
        "Phones (Mobile)": 4000000,
        "Phones (Landline)": 878000,
        "GDP": 43490000000
    },
    {
        "Country Name": "Lesotho",
        "ISO2": "LS",
        "ISO3": "LSO",
        "Top Level Domain": "ls",
        "FIPS": "LT",
        "ISO Numeric": 426,
        "GeoNameID": 932692,
        "E164": 266,
        "Phone Code": 266,
        "Continent": "Africa",
        "Capital": "Maseru",
        "Time Zone in Capital": "Africa/Johannesburg",
        "Currency": "Loti",
        "Language Codes": "en-LS,st,zu,xh",
        "Languages": "Sesotho (official) (southern Sotho), English (official), Zulu, Xhosa",
        "Area KM2": 30355,
        "Internet Hosts": 11030,
        "Internet Users": 76800,
        "Phones (Mobile)": 1312000,
        "Phones (Landline)": 43100,
        "GDP": 2457000000
    },
    {
        "Country Name": "Liberia",
        "ISO2": "LR",
        "ISO3": "LBR",
        "Top Level Domain": "lr",
        "FIPS": "LI",
        "ISO Numeric": 430,
        "GeoNameID": 2275384,
        "E164": 231,
        "Phone Code": 231,
        "Continent": "Africa",
        "Capital": "Monrovia",
        "Time Zone in Capital": "Africa/Monrovia",
        "Currency": "Dollar",
        "Language Codes": "en-LR",
        "Languages": "English 20% (official), some 20 ethnic group languages few of which can be written or used in correspondence",
        "Area KM2": 111370,
        "Internet Hosts": 7,
        "Internet Users": 20000,
        "Phones (Mobile)": 2394000,
        "Phones (Landline)": 3200,
        "GDP": 1977000000
    },
    {
        "Country Name": "Libya",
        "ISO2": "LY",
        "ISO3": "LBY",
        "Top Level Domain": "ly",
        "FIPS": "LY",
        "ISO Numeric": 434,
        "GeoNameID": 2215636,
        "E164": 218,
        "Phone Code": 218,
        "Continent": "Africa",
        "Capital": "Tripolis",
        "Time Zone in Capital": "Africa/Tripoli",
        "Currency": "Dinar",
        "Language Codes": "ar-LY,it,en",
        "Languages": "Arabic (official), Italian, English (all widely understood in the major cities); Berber (Nafusi, Ghadamis, Suknah, Awjilah, Tamasheq)",
        "Area KM2": 1759540,
        "Internet Hosts": 17926,
        "Internet Users": 353900,
        "Phones (Mobile)": 9590000,
        "Phones (Landline)": 814000,
        "GDP": 70920000000
    },
    {
        "Country Name": "Liechtenstein",
        "ISO2": "LI",
        "ISO3": "LIE",
        "Top Level Domain": "li",
        "FIPS": "LS",
        "ISO Numeric": 438,
        "GeoNameID": 3042058,
        "E164": 423,
        "Phone Code": 423,
        "Continent": "Europe",
        "Capital": "Vaduz",
        "Time Zone in Capital": "Europe/Zurich",
        "Currency": "Franc",
        "Language Codes": "de-LI",
        "Languages": "German 94.5% (official) (Alemannic is the main dialect), Italian 1.1%, other 4.3% (2010 est.)",
        "Area KM2": 160,
        "Internet Hosts": 14278,
        "Internet Users": 23000,
        "Phones (Mobile)": 38000,
        "Phones (Landline)": 20000,
        "GDP": 5113000000
    },
    {
        "Country Name": "Lithuania",
        "ISO2": "LT",
        "ISO3": "LTU",
        "Top Level Domain": "lt",
        "FIPS": "LH",
        "ISO Numeric": 440,
        "GeoNameID": 597427,
        "E164": 370,
        "Phone Code": 370,
        "Continent": "Europe",
        "Capital": "Vilnius",
        "Time Zone in Capital": "Europe/Vilnius",
        "Currency": "Euro",
        "Language Codes": "lt,ru,pl",
        "Languages": "Lithuanian (official) 82%, Russian 8%, Polish 5.6%, other 0.9%, unspecified 3.5% (2011 est.)",
        "Area KM2": 65200,
        "Internet Hosts": 1205000,
        "Internet Users": 1964000,
        "Phones (Mobile)": 5000000,
        "Phones (Landline)": 667300,
        "GDP": 46710000000
    },
    {
        "Country Name": "Luxembourg",
        "ISO2": "LU",
        "ISO3": "LUX",
        "Top Level Domain": "lu",
        "FIPS": "LU",
        "ISO Numeric": 442,
        "GeoNameID": 2960313,
        "E164": 352,
        "Phone Code": 352,
        "Continent": "Europe",
        "Capital": "Luxembourg",
        "Time Zone in Capital": "Europe/Luxembourg",
        "Currency": "Euro",
        "Language Codes": "lb,de-LU,fr-LU",
        "Languages": "Luxembourgish (official administrative language and national language (spoken vernacular)), French (official administrative language), German (official administrative language)",
        "Area KM2": 2586,
        "Internet Hosts": 250900,
        "Internet Users": 424500,
        "Phones (Mobile)": 761300,
        "Phones (Landline)": 266700,
        "GDP": 60540000000
    },
    {
        "Country Name": "Macau",
        "ISO2": "MO",
        "ISO3": "MAC",
        "Top Level Domain": "mo",
        "FIPS": "MC",
        "ISO Numeric": 446,
        "GeoNameID": 1821275,
        "E164": 853,
        "Phone Code": 853,
        "Continent": "Asia",
        "Capital": "Macao",
        "Time Zone in Capital": "Asia/Macau",
        "Currency": "Pataca",
        "Language Codes": "zh,zh-MO,pt",
        "Languages": "Cantonese 83.3%, Mandarin 5%, Hokkien 3.7%, English 2.3%, other Chinese dialects 2%, Tagalog 1.7%, Portuguese 0.7%, other 1.3%",
        "Area KM2": 254,
        "Internet Hosts": 327,
        "Internet Users": 270200,
        "Phones (Mobile)": 1613000,
        "Phones (Landline)": 162500,
        "GDP": 51680000000
    },
    {
        "Country Name": "Macedonia",
        "ISO2": "MK",
        "ISO3": "MKD",
        "Top Level Domain": "mk",
        "FIPS": "MK",
        "ISO Numeric": 807,
        "GeoNameID": 718075,
        "E164": 389,
        "Phone Code": 389,
        "Continent": "Europe",
        "Capital": "Skopje",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Denar",
        "Language Codes": "mk,sq,tr,rmm,sr",
        "Languages": "Macedonian (official) 66.5%, Albanian (official) 25.1%, Turkish 3.5%, Roma 1.9%, Serbian 1.2%, other 1.8% (2002 census)",
        "Area KM2": 25333,
        "Internet Hosts": 62826,
        "Internet Users": 1057000,
        "Phones (Mobile)": 2235000,
        "Phones (Landline)": 407900,
        "GDP": 10650000000
    },
    {
        "Country Name": "Madagascar",
        "ISO2": "MG",
        "ISO3": "MDG",
        "Top Level Domain": "mg",
        "FIPS": "MA",
        "ISO Numeric": 450,
        "GeoNameID": 1062947,
        "E164": 261,
        "Phone Code": 261,
        "Continent": "Africa",
        "Capital": "Antananarivo",
        "Time Zone in Capital": "Indian/Antananarivo",
        "Currency": "Ariary",
        "Language Codes": "fr-MG,mg",
        "Languages": "French (official), Malagasy (official), English",
        "Area KM2": 587040,
        "Internet Hosts": 38392,
        "Internet Users": 319900,
        "Phones (Mobile)": 8564000,
        "Phones (Landline)": 143700,
        "GDP": 10530000000
    },
    {
        "Country Name": "Malawi",
        "ISO2": "MW",
        "ISO3": "MWI",
        "Top Level Domain": "mw",
        "FIPS": "MI",
        "ISO Numeric": 454,
        "GeoNameID": 927384,
        "E164": 265,
        "Phone Code": 265,
        "Continent": "Africa",
        "Capital": "Lilongwe",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Kwacha",
        "Language Codes": "ny,yao,tum,swk",
        "Languages": "English (official), Chichewa (common), Chinyanja, Chiyao, Chitumbuka, Chilomwe, Chinkhonde, Chingoni, Chisena, Chitonga, Chinyakyusa, Chilambya",
        "Area KM2": 118480,
        "Internet Hosts": 1099,
        "Internet Users": 716400,
        "Phones (Mobile)": 4420000,
        "Phones (Landline)": 227300,
        "GDP": 3683000000
    },
    {
        "Country Name": "Malaysia",
        "ISO2": "MY",
        "ISO3": "MYS",
        "Top Level Domain": "my",
        "FIPS": "MY",
        "ISO Numeric": 458,
        "GeoNameID": 1733045,
        "E164": 60,
        "Phone Code": 60,
        "Continent": "Asia",
        "Capital": "Kuala Lumpur",
        "Time Zone in Capital": "Asia/Kuala_Lumpur",
        "Currency": "Ringgit",
        "Language Codes": "ms-MY,en,zh,ta,te,ml,pa,th",
        "Languages": "Bahasa Malaysia (official), English, Chinese (Cantonese, Mandarin, Hokkien, Hakka, Hainan, Foochow), Tamil, Telugu, Malayalam, Panjabi, Thai",
        "Area KM2": 329750,
        "Internet Hosts": 422470,
        "Internet Users": 15355000,
        "Phones (Mobile)": 41325000,
        "Phones (Landline)": 4589000,
        "GDP": 312400000000
    },
    {
        "Country Name": "Maldives",
        "ISO2": "MV",
        "ISO3": "MDV",
        "Top Level Domain": "mv",
        "FIPS": "MV",
        "ISO Numeric": 462,
        "GeoNameID": 1282028,
        "E164": 960,
        "Phone Code": 960,
        "Continent": "Asia",
        "Capital": "Male",
        "Time Zone in Capital": "Indian/Maldives",
        "Currency": "Rufiyaa",
        "Language Codes": "dv,en",
        "Languages": "Dhivehi (official, dialect of Sinhala, script derived from Arabic), English (spoken by most government officials)",
        "Area KM2": 300,
        "Internet Hosts": 3296,
        "Internet Users": 86400,
        "Phones (Mobile)": 560000,
        "Phones (Landline)": 23140,
        "GDP": 2270000000
    },
    {
        "Country Name": "Mali",
        "ISO2": "ML",
        "ISO3": "MLI",
        "Top Level Domain": "ml",
        "FIPS": "ML",
        "ISO Numeric": 466,
        "GeoNameID": 2453866,
        "E164": 223,
        "Phone Code": 223,
        "Continent": "Africa",
        "Capital": "Bamako",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-ML,bm",
        "Languages": "French (official), Bambara 46.3%, Peul/foulfoulbe 9.4%, Dogon 7.2%, Maraka/soninke 6.4%, Malinke 5.6%, Sonrhai/djerma 5.6%, Minianka 4.3%, Tamacheq 3.5%, Senoufo 2.6%, unspecified 0.6%, other 8.5%",
        "Area KM2": 1240000,
        "Internet Hosts": 437,
        "Internet Users": 249800,
        "Phones (Mobile)": 14613000,
        "Phones (Landline)": 112000,
        "GDP": 11370000000
    },
    {
        "Country Name": "Malta",
        "ISO2": "MT",
        "ISO3": "MLT",
        "Top Level Domain": "mt",
        "FIPS": "MT",
        "ISO Numeric": 470,
        "GeoNameID": 2562770,
        "E164": 356,
        "Phone Code": 356,
        "Continent": "Europe",
        "Capital": "Valletta",
        "Time Zone in Capital": "Europe/Malta",
        "Currency": "Euro",
        "Language Codes": "mt,en-MT",
        "Languages": "Maltese (official) 90.1%, English (official) 6%, multilingual 3%, other 0.9% (2005 est.)",
        "Area KM2": 316,
        "Internet Hosts": 14754,
        "Internet Users": 240600,
        "Phones (Mobile)": 539500,
        "Phones (Landline)": 229700,
        "GDP": 9541000000
    },
    {
        "Country Name": "Marshall Islands",
        "ISO2": "MH",
        "ISO3": "MHL",
        "Top Level Domain": "mh",
        "FIPS": "RM",
        "ISO Numeric": 584,
        "GeoNameID": 2080185,
        "E164": 692,
        "Phone Code": 692,
        "Continent": "Oceania",
        "Capital": "Majuro",
        "Time Zone in Capital": "Pacific/Majuro",
        "Currency": "Dollar",
        "Language Codes": "mh,en-MH",
        "Languages": "Marshallese (official) 98.2%, other languages 1.8% (1999 census)",
        "Area KM2": 181,
        "Internet Hosts": 3,
        "Internet Users": 2200,
        "Phones (Mobile)": 3800,
        "Phones (Landline)": 4400,
        "GDP": 193000000
    },
    {
        "Country Name": "Mauritania",
        "ISO2": "MR",
        "ISO3": "MRT",
        "Top Level Domain": "mr",
        "FIPS": "MR",
        "ISO Numeric": 478,
        "GeoNameID": 2378080,
        "E164": 222,
        "Phone Code": 222,
        "Continent": "Africa",
        "Capital": "Nouakchott",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Ouguiya",
        "Language Codes": "ar-MR,fuc,snk,fr,mey,wo",
        "Languages": "Arabic (official and national), Pulaar, Soninke, Wolof (all national languages), French, Hassaniya (a variety of Arabic)",
        "Area KM2": 1030700,
        "Internet Hosts": 22,
        "Internet Users": 75000,
        "Phones (Mobile)": 4024000,
        "Phones (Landline)": 65100,
        "GDP": 4183000000
    },
    {
        "Country Name": "Mauritius",
        "ISO2": "MU",
        "ISO3": "MUS",
        "Top Level Domain": "mu",
        "FIPS": "MP",
        "ISO Numeric": 480,
        "GeoNameID": 934292,
        "E164": 230,
        "Phone Code": 230,
        "Continent": "Africa",
        "Capital": "Port Louis",
        "Time Zone in Capital": "Indian/Mauritius",
        "Currency": "Rupee",
        "Language Codes": "en-MU,bho,fr",
        "Languages": "Creole 86.5%, Bhojpuri 5.3%, French 4.1%, two languages 1.4%, other 2.6% (includes English, the official language, which is spoken by less than 1% of the population), unspecified 0.1% (2011 est.)",
        "Area KM2": 2040,
        "Internet Hosts": 51139,
        "Internet Users": 290000,
        "Phones (Mobile)": 1485000,
        "Phones (Landline)": 349100,
        "GDP": 11900000000
    },
    {
        "Country Name": "Mayotte",
        "ISO2": "YT",
        "ISO3": "MYT",
        "Top Level Domain": "yt",
        "FIPS": "MF",
        "ISO Numeric": 175,
        "GeoNameID": 1024031,
        "E164": 262,
        "Phone Code": 262,
        "Continent": "Africa",
        "Capital": "Mamoudzou",
        "Time Zone in Capital": "Indian/Mayotte",
        "Currency": "Euro",
        "Language Codes": "fr-YT",
        "Languages": "French",
        "Area KM2": 374,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Mexico",
        "ISO2": "MX",
        "ISO3": "MEX",
        "Top Level Domain": "mx",
        "FIPS": "MX",
        "ISO Numeric": 484,
        "GeoNameID": 3996063,
        "E164": 52,
        "Phone Code": 52,
        "Continent": "North America",
        "Capital": "Mexico City",
        "Time Zone in Capital": "America/Mexico_City",
        "Currency": "Peso",
        "Language Codes": "es-MX",
        "Languages": "Spanish only 92.7%, Spanish and indigenous languages 5.7%, indigenous only 0.8%, unspecified 0.8%",
        "Area KM2": 1972550,
        "Internet Hosts": 16233000,
        "Internet Users": 31020000,
        "Phones (Mobile)": 100786000,
        "Phones (Landline)": 20220000,
        "GDP": 1327000000000
    },
    {
        "Country Name": "Micronesia",
        "ISO2": "FM",
        "ISO3": "FSM",
        "Top Level Domain": "fm",
        "FIPS": "FM",
        "ISO Numeric": 583,
        "GeoNameID": 2081918,
        "E164": 691,
        "Phone Code": 691,
        "Continent": "Oceania",
        "Capital": "Palikir",
        "Time Zone in Capital": "Pacific/Pohnpei",
        "Currency": "Dollar",
        "Language Codes": "en-FM,chk,pon,yap,kos,uli,woe,nkr,kpg",
        "Languages": "English (official and common language), Chuukese, Kosrean, Pohnpeian, Yapese, Ulithian, Woleaian, Nukuoro, Kapingamarangi",
        "Area KM2": 702,
        "Internet Hosts": 4668,
        "Internet Users": 17000,
        "Phones (Mobile)": 27600,
        "Phones (Landline)": 8400,
        "GDP": 339000000
    },
    {
        "Country Name": "Moldova",
        "ISO2": "MD",
        "ISO3": "MDA",
        "Top Level Domain": "md",
        "FIPS": "MD",
        "ISO Numeric": 498,
        "GeoNameID": 617790,
        "E164": 373,
        "Phone Code": 373,
        "Continent": "Europe",
        "Capital": "Chisinau",
        "Time Zone in Capital": "Europe/Chisinau",
        "Currency": "Leu",
        "Language Codes": "ro,ru,gag,tr",
        "Languages": "Moldovan 58.8% (official; virtually the same as the Romanian language), Romanian 16.4%, Russian 16%, Ukrainian 3.8%, Gagauz 3.1% (a Turkish language), Bulgarian 1.1%, other 0.3%, unspecified 0.4%",
        "Area KM2": 33843,
        "Internet Hosts": 711564,
        "Internet Users": 1333000,
        "Phones (Mobile)": 4080000,
        "Phones (Landline)": 1206000,
        "GDP": 7932000000
    },
    {
        "Country Name": "Monaco",
        "ISO2": "MC",
        "ISO3": "MCO",
        "Top Level Domain": "mc",
        "FIPS": "MN",
        "ISO Numeric": 492,
        "GeoNameID": 2993457,
        "E164": 377,
        "Phone Code": 377,
        "Continent": "Europe",
        "Capital": "Monaco",
        "Time Zone in Capital": "Europe/Monaco",
        "Currency": "Euro",
        "Language Codes": "fr-MC,en,it",
        "Languages": "French (official), English, Italian, Monegasque",
        "Area KM2": 2,
        "Internet Hosts": 26009,
        "Internet Users": 23000,
        "Phones (Mobile)": 33200,
        "Phones (Landline)": 44500,
        "GDP": 5748000000
    },
    {
        "Country Name": "Mongolia",
        "ISO2": "MN",
        "ISO3": "MNG",
        "Top Level Domain": "mn",
        "FIPS": "MG",
        "ISO Numeric": 496,
        "GeoNameID": 2029969,
        "E164": 976,
        "Phone Code": 976,
        "Continent": "Asia",
        "Capital": "Ulan Bator",
        "Time Zone in Capital": "Asia/Ulaanbaatar",
        "Currency": "Tugrik",
        "Language Codes": "mn,ru",
        "Languages": "Khalkha Mongol 90% (official), Turkic, Russian (1999)",
        "Area KM2": 1565000,
        "Internet Hosts": 20084,
        "Internet Users": 330000,
        "Phones (Mobile)": 3375000,
        "Phones (Landline)": 176700,
        "GDP": 11140000000
    },
    {
        "Country Name": "Montenegro",
        "ISO2": "ME",
        "ISO3": "MNE",
        "Top Level Domain": "me",
        "FIPS": "MJ",
        "ISO Numeric": 499,
        "GeoNameID": 3194884,
        "E164": 382,
        "Phone Code": 382,
        "Continent": "Europe",
        "Capital": "Podgorica",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Euro",
        "Language Codes": "sr,hu,bs,sq,hr,rom",
        "Languages": "Serbian 42.9%, Montenegrin (official) 37%, Bosnian 5.3%, Albanian 5.3%, Serbo-Croat 2%, other 3.5%, unspecified 4% (2011 est.)",
        "Area KM2": 14026,
        "Internet Hosts": 10088,
        "Internet Users": 280000,
        "Phones (Mobile)": 1126000,
        "Phones (Landline)": 163000,
        "GDP": 4518000000
    },
    {
        "Country Name": "Montserrat",
        "ISO2": "MS",
        "ISO3": "MSR",
        "Top Level Domain": "ms",
        "FIPS": "MH",
        "ISO Numeric": 500,
        "GeoNameID": 3578097,
        "E164": 1,
        "Phone Code": "1-664",
        "Continent": "North America",
        "Capital": "Plymouth",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-MS",
        "Languages": "English",
        "Area KM2": 102,
        "Internet Hosts": 2431,
        "Internet Users": 1200,
        "Phones (Mobile)": 4000,
        "Phones (Landline)": 3000,
        "GDP": ""
    },
    {
        "Country Name": "Morocco",
        "ISO2": "MA",
        "ISO3": "MAR",
        "Top Level Domain": "ma",
        "FIPS": "MO",
        "ISO Numeric": 504,
        "GeoNameID": 2542007,
        "E164": 212,
        "Phone Code": 212,
        "Continent": "Africa",
        "Capital": "Rabat",
        "Time Zone in Capital": "Africa/Casablanca",
        "Currency": "Dirham",
        "Language Codes": "ar-MA,fr",
        "Languages": "Arabic (official), Berber languages (Tamazight (official), Tachelhit, Tarifit), French (often the language of business, government, and diplomacy)",
        "Area KM2": 446550,
        "Internet Hosts": 277338,
        "Internet Users": 13213000,
        "Phones (Mobile)": 39016000,
        "Phones (Landline)": 3280000,
        "GDP": 104800000000
    },
    {
        "Country Name": "Mozambique",
        "ISO2": "MZ",
        "ISO3": "MOZ",
        "Top Level Domain": "mz",
        "FIPS": "MZ",
        "ISO Numeric": 508,
        "GeoNameID": 1036973,
        "E164": 258,
        "Phone Code": 258,
        "Continent": "Africa",
        "Capital": "Maputo",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Metical",
        "Language Codes": "pt-MZ,vmw",
        "Languages": "Emakhuwa 25.3%, Portuguese (official) 10.7%, Xichangana 10.3%, Cisena 7.5%, Elomwe 7%, Echuwabo 5.1%, other Mozambican languages 30.1%, other 4% (1997 census)",
        "Area KM2": 801590,
        "Internet Hosts": 89737,
        "Internet Users": 613600,
        "Phones (Mobile)": 8108000,
        "Phones (Landline)": 88100,
        "GDP": 14670000000
    },
    {
        "Country Name": "Myanmar",
        "ISO2": "MM",
        "ISO3": "MMR",
        "Top Level Domain": "mm",
        "FIPS": "BM",
        "ISO Numeric": 104,
        "GeoNameID": 1327865,
        "E164": 95,
        "Phone Code": 95,
        "Continent": "Asia",
        "Capital": "Nay Pyi Taw",
        "Time Zone in Capital": "Asia/Rangoon",
        "Currency": "Kyat",
        "Language Codes": "my",
        "Languages": "Burmese (official)",
        "Area KM2": 678500,
        "Internet Hosts": 1055,
        "Internet Users": 110000,
        "Phones (Mobile)": 5440000,
        "Phones (Landline)": 556000,
        "GDP": 59430000000
    },
    {
        "Country Name": "Namibia",
        "ISO2": "NA",
        "ISO3": "NAM",
        "Top Level Domain": "na",
        "FIPS": "WA",
        "ISO Numeric": 516,
        "GeoNameID": 3355338,
        "E164": 264,
        "Phone Code": 264,
        "Continent": "Africa",
        "Capital": "Windhoek",
        "Time Zone in Capital": "Africa/Windhoek",
        "Currency": "Dollar",
        "Language Codes": "en-NA,af,de,hz,naq",
        "Languages": "Oshiwambo languages 48.9%, Nama/Damara 11.3%, Afrikaans 10.4% (common language of most of the population and about 60% of the white population), Otjiherero languages 8.6%, Kavango languages 8.5%, Caprivi languages 4.8%, English (official) 3.4%, other African languages 2.3%, other 1.7%",
        "Area KM2": 825418,
        "Internet Hosts": 78280,
        "Internet Users": 127500,
        "Phones (Mobile)": 2435000,
        "Phones (Landline)": 171000,
        "GDP": 12300000000
    },
    {
        "Country Name": "Nauru",
        "ISO2": "NR",
        "ISO3": "NRU",
        "Top Level Domain": "nr",
        "FIPS": "NR",
        "ISO Numeric": 520,
        "GeoNameID": 2110425,
        "E164": 674,
        "Phone Code": 674,
        "Continent": "Oceania",
        "Capital": "Yaren",
        "Time Zone in Capital": "Pacific/Nauru",
        "Currency": "Dollar",
        "Language Codes": "na,en-NR",
        "Languages": "Nauruan 93% (official, a distinct Pacific Island language), English 2% (widely understood, spoken, and used for most government and commercial purposes), other 5% (includes I-Kiribati 2% and Chinese 2%)",
        "Area KM2": 21,
        "Internet Hosts": 8162,
        "Internet Users": "",
        "Phones (Mobile)": 6800,
        "Phones (Landline)": 1900,
        "GDP": ""
    },
    {
        "Country Name": "Nepal",
        "ISO2": "NP",
        "ISO3": "NPL",
        "Top Level Domain": "np",
        "FIPS": "NP",
        "ISO Numeric": 524,
        "GeoNameID": 1282988,
        "E164": 977,
        "Phone Code": 977,
        "Continent": "Asia",
        "Capital": "Kathmandu",
        "Time Zone in Capital": "Asia/Kathmandu",
        "Currency": "Rupee",
        "Language Codes": "ne,en",
        "Languages": "Nepali (official) 44.6%, Maithali 11.7%, Bhojpuri 6%, Tharu 5.8%, Tamang 5.1%, Newar 3.2%, Magar 3%, Bajjika 3%, Urdu 2.6%, Avadhi 1.9%, Limbu 1.3%, Gurung 1.2%, other 10.4%, unspecified 0.2%",
        "Area KM2": 140800,
        "Internet Hosts": 41256,
        "Internet Users": 577800,
        "Phones (Mobile)": 18138000,
        "Phones (Landline)": 834000,
        "GDP": 19340000000
    },
    {
        "Country Name": "Netherlands",
        "ISO2": "NL",
        "ISO3": "NLD",
        "Top Level Domain": "nl",
        "FIPS": "NL",
        "ISO Numeric": 528,
        "GeoNameID": 2750405,
        "E164": 31,
        "Phone Code": 31,
        "Continent": "Europe",
        "Capital": "Amsterdam",
        "Time Zone in Capital": "Europe/Amsterdam",
        "Currency": "Euro",
        "Language Codes": "nl-NL,fy-NL",
        "Languages": "Dutch (official)",
        "Area KM2": 41526,
        "Internet Hosts": 13699000,
        "Internet Users": 14872000,
        "Phones (Mobile)": 19643000,
        "Phones (Landline)": 7086000,
        "GDP": 722300000000
    },
    {
        "Country Name": "Netherlands Antilles",
        "ISO2": "AN",
        "ISO3": "ANT",
        "Top Level Domain": "an",
        "FIPS": "NT",
        "ISO Numeric": 530,
        "GeoNameID": "",
        "E164": 599,
        "Phone Code": 599,
        "Continent": "North America",
        "Capital": "Willemstad",
        "Time Zone in Capital": "America/Curacao",
        "Currency": "Guilder",
        "Language Codes": "nl-AN,en,es",
        "Languages": "Dutch, English, Spanish",
        "Area KM2": 960,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "New Caledonia",
        "ISO2": "NC",
        "ISO3": "NCL",
        "Top Level Domain": "nc",
        "FIPS": "NC",
        "ISO Numeric": 540,
        "GeoNameID": 2139685,
        "E164": 687,
        "Phone Code": 687,
        "Continent": "Oceania",
        "Capital": "Noumea",
        "Time Zone in Capital": "Pacific/Noumea",
        "Currency": "Franc",
        "Language Codes": "fr-NC",
        "Languages": "French (official), 33 Melanesian-Polynesian dialects",
        "Area KM2": 19060,
        "Internet Hosts": 34231,
        "Internet Users": 85000,
        "Phones (Mobile)": 231000,
        "Phones (Landline)": 80000,
        "GDP": 9280000000
    },
    {
        "Country Name": "New Zealand",
        "ISO2": "NZ",
        "ISO3": "NZL",
        "Top Level Domain": "nz",
        "FIPS": "NZ",
        "ISO Numeric": 554,
        "GeoNameID": 2186224,
        "E164": 64,
        "Phone Code": 64,
        "Continent": "Oceania",
        "Capital": "Wellington",
        "Time Zone in Capital": "Pacific/Auckland",
        "Currency": "Dollar",
        "Language Codes": "en-NZ,mi",
        "Languages": "English (de facto official) 89.8%, Maori (de jure official) 3.5%, Samoan 2%, Hindi 1.6%, French 1.2%, Northern Chinese 1.2%, Yue 1%, Other or not stated 20.5%, New Zealand Sign Language (de jure official)",
        "Area KM2": 268680,
        "Internet Hosts": 3026000,
        "Internet Users": 3400000,
        "Phones (Mobile)": 4922000,
        "Phones (Landline)": 1880000,
        "GDP": 181100000000
    },
    {
        "Country Name": "Nicaragua",
        "ISO2": "NI",
        "ISO3": "NIC",
        "Top Level Domain": "ni",
        "FIPS": "NU",
        "ISO Numeric": 558,
        "GeoNameID": 3617476,
        "E164": 505,
        "Phone Code": 505,
        "Continent": "North America",
        "Capital": "Managua",
        "Time Zone in Capital": "America/Managua",
        "Currency": "Cordoba",
        "Language Codes": "es-NI,en",
        "Languages": "Spanish (official) 95.3%, Miskito 2.2%, Mestizo of the Caribbean coast 2%, other 0.5%",
        "Area KM2": 129494,
        "Internet Hosts": 296068,
        "Internet Users": 199800,
        "Phones (Mobile)": 5346000,
        "Phones (Landline)": 320000,
        "GDP": 11260000000
    },
    {
        "Country Name": "Niger",
        "ISO2": "NE",
        "ISO3": "NER",
        "Top Level Domain": "ne",
        "FIPS": "NG",
        "ISO Numeric": 562,
        "GeoNameID": 2440476,
        "E164": 227,
        "Phone Code": 227,
        "Continent": "Africa",
        "Capital": "Niamey",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-NE,ha,kr,dje",
        "Languages": "French (official), Hausa, Djerma",
        "Area KM2": 1267000,
        "Internet Hosts": 454,
        "Internet Users": 115900,
        "Phones (Mobile)": 5400000,
        "Phones (Landline)": 100500,
        "GDP": 7304000000
    },
    {
        "Country Name": "Nigeria",
        "ISO2": "NG",
        "ISO3": "NGA",
        "Top Level Domain": "ng",
        "FIPS": "NI",
        "ISO Numeric": 566,
        "GeoNameID": 2328926,
        "E164": 234,
        "Phone Code": 234,
        "Continent": "Africa",
        "Capital": "Abuja",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Naira",
        "Language Codes": "en-NG,ha,yo,ig,ff",
        "Languages": "English (official), Hausa, Yoruba, Igbo (Ibo), Fulani, over 500 additional indigenous languages",
        "Area KM2": 923768,
        "Internet Hosts": 1234,
        "Internet Users": 43989000,
        "Phones (Mobile)": 112780000,
        "Phones (Landline)": 418200,
        "GDP": 502000000000
    },
    {
        "Country Name": "Niue",
        "ISO2": "NU",
        "ISO3": "NIU",
        "Top Level Domain": "nu",
        "FIPS": "NE",
        "ISO Numeric": 570,
        "GeoNameID": 4036232,
        "E164": 683,
        "Phone Code": 683,
        "Continent": "Oceania",
        "Capital": "Alofi",
        "Time Zone in Capital": "Pacific/Niue",
        "Currency": "Dollar",
        "Language Codes": "niu,en-NU",
        "Languages": "Niuean (official) 46% (a Polynesian language closely related to Tongan and Samoan), Niuean and English 32%, English (official) 11%, Niuean and others 5%, other 6% (2011 est.)",
        "Area KM2": 260,
        "Internet Hosts": 79508,
        "Internet Users": 1100,
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 10010000
    },
    {
        "Country Name": "North Korea",
        "ISO2": "KP",
        "ISO3": "PRK",
        "Top Level Domain": "kp",
        "FIPS": "KN",
        "ISO Numeric": 408,
        "GeoNameID": 1873107,
        "E164": 850,
        "Phone Code": 850,
        "Continent": "Asia",
        "Capital": "Pyongyang",
        "Time Zone in Capital": "Asia/Pyongyang",
        "Currency": "Won",
        "Language Codes": "ko-KP",
        "Languages": "Korean",
        "Area KM2": 120540,
        "Internet Hosts": 8,
        "Internet Users": "",
        "Phones (Mobile)": 1700000,
        "Phones (Landline)": 1180000,
        "GDP": 28000000000
    },
    {
        "Country Name": "Northern Mariana Islands",
        "ISO2": "MP",
        "ISO3": "MNP",
        "Top Level Domain": "mp",
        "FIPS": "CQ",
        "ISO Numeric": 580,
        "GeoNameID": 4041468,
        "E164": 1,
        "Phone Code": "1-670",
        "Continent": "Oceania",
        "Capital": "Saipan",
        "Time Zone in Capital": "Pacific/Saipan",
        "Currency": "Dollar",
        "Language Codes": "fil,tl,zh,ch-MP,en-MP",
        "Languages": "Philippine languages 32.8%, Chamorro (official) 24.1%, English (official) 17%, other Pacific island languages 10.1%, Chinese 6.8%, other Asian languages 7.3%, other 1.9% (2010 est.)",
        "Area KM2": 477,
        "Internet Hosts": 17,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 733000000
    },
    {
        "Country Name": "Norway",
        "ISO2": "NO",
        "ISO3": "NOR",
        "Top Level Domain": "no",
        "FIPS": "NO",
        "ISO Numeric": 578,
        "GeoNameID": 3144096,
        "E164": 47,
        "Phone Code": 47,
        "Continent": "Europe",
        "Capital": "Oslo",
        "Time Zone in Capital": "Europe/Oslo",
        "Currency": "Krone",
        "Language Codes": "no,nb,nn,se,fi",
        "Languages": "Bokmal Norwegian (official), Nynorsk Norwegian (official), small Sami- and Finnish-speaking minorities",
        "Area KM2": 324220,
        "Internet Hosts": 3588000,
        "Internet Users": 4431000,
        "Phones (Mobile)": 5732000,
        "Phones (Landline)": 1465000,
        "GDP": 515800000000
    },
    {
        "Country Name": "Oman",
        "ISO2": "OM",
        "ISO3": "OMN",
        "Top Level Domain": "om",
        "FIPS": "MU",
        "ISO Numeric": 512,
        "GeoNameID": 286963,
        "E164": 968,
        "Phone Code": 968,
        "Continent": "Asia",
        "Capital": "Muscat",
        "Time Zone in Capital": "Asia/Muscat",
        "Currency": "Rial",
        "Language Codes": "ar-OM,en,bal,ur",
        "Languages": "Arabic (official), English, Baluchi, Urdu, Indian dialects",
        "Area KM2": 212460,
        "Internet Hosts": 14531,
        "Internet Users": 1465000,
        "Phones (Mobile)": 5278000,
        "Phones (Landline)": 305000,
        "GDP": 81950000000
    },
    {
        "Country Name": "Pakistan",
        "ISO2": "PK",
        "ISO3": "PAK",
        "Top Level Domain": "pk",
        "FIPS": "PK",
        "ISO Numeric": 586,
        "GeoNameID": 1168579,
        "E164": 92,
        "Phone Code": 92,
        "Continent": "Asia",
        "Capital": "Islamabad",
        "Time Zone in Capital": "Asia/Karachi",
        "Currency": "Rupee",
        "Language Codes": "ur-PK,en-PK,pa,sd,ps,brh",
        "Languages": "Punjabi 48%, Sindhi 12%, Saraiki (a Punjabi variant) 10%, Pashto (alternate name, Pashtu) 8%, Urdu (official) 8%, Balochi 3%, Hindko 2%, Brahui 1%, English (official; lingua franca of Pakistani elite and most government ministries), Burushaski, and other 8%",
        "Area KM2": 803940,
        "Internet Hosts": 365813,
        "Internet Users": 20431000,
        "Phones (Mobile)": 125000000,
        "Phones (Landline)": 5803000,
        "GDP": 236500000000
    },
    {
        "Country Name": "Palau",
        "ISO2": "PW",
        "ISO3": "PLW",
        "Top Level Domain": "pw",
        "FIPS": "PS",
        "ISO Numeric": 585,
        "GeoNameID": 1559582,
        "E164": 680,
        "Phone Code": 680,
        "Continent": "Oceania",
        "Capital": "Melekeok",
        "Time Zone in Capital": "Pacific/Palau",
        "Currency": "Dollar",
        "Language Codes": "pau,sov,en-PW,tox,ja,fil,zh",
        "Languages": "Palauan (official on most islands) 66.6%, Carolinian 0.7%, other Micronesian 0.7%, English (official) 15.5%, Filipino 10.8%, Chinese 1.8%, other Asian 2.6%, other 1.3%",
        "Area KM2": 458,
        "Internet Hosts": 4,
        "Internet Users": "",
        "Phones (Mobile)": 17150,
        "Phones (Landline)": 7300,
        "GDP": 221000000
    },
    {
        "Country Name": "Palestine",
        "ISO2": "PS",
        "ISO3": "PSE",
        "Top Level Domain": "ps",
        "FIPS": "WE",
        "ISO Numeric": 275,
        "GeoNameID": 6254930,
        "E164": 970,
        "Phone Code": 970,
        "Continent": "Asia",
        "Capital": "East Jerusalem",
        "Time Zone in Capital": "Asia/Hebron",
        "Currency": "Shekel",
        "Language Codes": "ar-PS",
        "Languages": "Arabic, Hebrew, English",
        "Area KM2": 5970,
        "Internet Hosts": "",
        "Internet Users": 1379000,
        "Phones (Mobile)": 3041000,
        "Phones (Landline)": 406000,
        "GDP": 6641000000
    },
    {
        "Country Name": "Panama",
        "ISO2": "PA",
        "ISO3": "PAN",
        "Top Level Domain": "pa",
        "FIPS": "PM",
        "ISO Numeric": 591,
        "GeoNameID": 3703430,
        "E164": 507,
        "Phone Code": 507,
        "Continent": "North America",
        "Capital": "Panama City",
        "Time Zone in Capital": "America/Panama",
        "Currency": "Balboa",
        "Language Codes": "es-PA,en",
        "Languages": "Spanish (official), English 14%",
        "Area KM2": 78200,
        "Internet Hosts": 11022,
        "Internet Users": 959800,
        "Phones (Mobile)": 6770000,
        "Phones (Landline)": 640000,
        "GDP": 40620000000
    },
    {
        "Country Name": "Papua New Guinea",
        "ISO2": "PG",
        "ISO3": "PNG",
        "Top Level Domain": "pg",
        "FIPS": "PP",
        "ISO Numeric": 598,
        "GeoNameID": 2088628,
        "E164": 675,
        "Phone Code": 675,
        "Continent": "Oceania",
        "Capital": "Port Moresby",
        "Time Zone in Capital": "Pacific/Port_Moresby",
        "Currency": "Kina",
        "Language Codes": "en-PG,ho,meu,tpi",
        "Languages": "Tok Pisin (official), English (official), Hiri Motu (official), some 836 indigenous languages spoken (about 12% of the world's total); most languages have fewer than 1,000 speakers",
        "Area KM2": 462840,
        "Internet Hosts": 5006,
        "Internet Users": 125000,
        "Phones (Mobile)": 2709000,
        "Phones (Landline)": 139000,
        "GDP": 16100000000
    },
    {
        "Country Name": "Paraguay",
        "ISO2": "PY",
        "ISO3": "PRY",
        "Top Level Domain": "py",
        "FIPS": "PA",
        "ISO Numeric": 600,
        "GeoNameID": 3437598,
        "E164": 595,
        "Phone Code": 595,
        "Continent": "South America",
        "Capital": "Asuncion",
        "Time Zone in Capital": "America/Asuncion",
        "Currency": "Guarani",
        "Language Codes": "es-PY,gn",
        "Languages": "Spanish (official), Guarani (official)",
        "Area KM2": 406750,
        "Internet Hosts": 280658,
        "Internet Users": 1105000,
        "Phones (Mobile)": 6790000,
        "Phones (Landline)": 376000,
        "GDP": 30560000000
    },
    {
        "Country Name": "Peru",
        "ISO2": "PE",
        "ISO3": "PER",
        "Top Level Domain": "pe",
        "FIPS": "PE",
        "ISO Numeric": 604,
        "GeoNameID": 3932488,
        "E164": 51,
        "Phone Code": 51,
        "Continent": "South America",
        "Capital": "Lima",
        "Time Zone in Capital": "America/Lima",
        "Currency": "Sol",
        "Language Codes": "es-PE,qu,ay",
        "Languages": "Spanish (official) 84.1%, Quechua (official) 13%, Aymara (official) 1.7%, Ashaninka 0.3%, other native languages (includes a large number of minor Amazonian languages) 0.7%, other (includes foreign languages and sign language) 0.2% (2007 est.)",
        "Area KM2": 1285220,
        "Internet Hosts": 234102,
        "Internet Users": 9158000,
        "Phones (Mobile)": 29400000,
        "Phones (Landline)": 3420000,
        "GDP": 210300000000
    },
    {
        "Country Name": "Philippines",
        "ISO2": "PH",
        "ISO3": "PHL",
        "Top Level Domain": "ph",
        "FIPS": "RP",
        "ISO Numeric": 608,
        "GeoNameID": 1694008,
        "E164": 63,
        "Phone Code": 63,
        "Continent": "Asia",
        "Capital": "Manila",
        "Time Zone in Capital": "Asia/Manila",
        "Currency": "Peso",
        "Language Codes": "tl,en-PH,fil",
        "Languages": "Filipino (official; based on Tagalog) and English (official); eight major dialects - Tagalog, Cebuano, Ilocano, Hiligaynon or Ilonggo, Bicol, Waray, Pampango, and Pangasinan",
        "Area KM2": 300000,
        "Internet Hosts": 425812,
        "Internet Users": 8278000,
        "Phones (Mobile)": 103000000,
        "Phones (Landline)": 3939000,
        "GDP": 272200000000
    },
    {
        "Country Name": "Pitcairn",
        "ISO2": "PN",
        "ISO3": "PCN",
        "Top Level Domain": "pn",
        "FIPS": "PC",
        "ISO Numeric": 612,
        "GeoNameID": 4030699,
        "E164": 64,
        "Phone Code": 64,
        "Continent": "Oceania",
        "Capital": "Adamstown",
        "Time Zone in Capital": "Pacific/Pitcairn",
        "Currency": "Dollar",
        "Language Codes": "en-PN",
        "Languages": "English",
        "Area KM2": 47,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Poland",
        "ISO2": "PL",
        "ISO3": "POL",
        "Top Level Domain": "pl",
        "FIPS": "PL",
        "ISO Numeric": 616,
        "GeoNameID": 798544,
        "E164": 48,
        "Phone Code": 48,
        "Continent": "Europe",
        "Capital": "Warsaw",
        "Time Zone in Capital": "Europe/Warsaw",
        "Currency": "Zloty",
        "Language Codes": "pl",
        "Languages": "Polish (official) 96.2%, Polish and non-Polish 2%, non-Polish 0.5%, unspecified 1.3%",
        "Area KM2": 312685,
        "Internet Hosts": 13265000,
        "Internet Users": 22452000,
        "Phones (Mobile)": 50840000,
        "Phones (Landline)": 6125000,
        "GDP": 513900000000
    },
    {
        "Country Name": "Portugal",
        "ISO2": "PT",
        "ISO3": "PRT",
        "Top Level Domain": "pt",
        "FIPS": "PO",
        "ISO Numeric": 620,
        "GeoNameID": 2264397,
        "E164": 351,
        "Phone Code": 351,
        "Continent": "Europe",
        "Capital": "Lisbon",
        "Time Zone in Capital": "Europe/Lisbon",
        "Currency": "Euro",
        "Language Codes": "pt-PT,mwl",
        "Languages": "Portuguese (official), Mirandese (official, but locally used)",
        "Area KM2": 92391,
        "Internet Hosts": 3748000,
        "Internet Users": 5168000,
        "Phones (Mobile)": 12312000,
        "Phones (Landline)": 4558000,
        "GDP": 219300000000
    },
    {
        "Country Name": "Puerto Rico",
        "ISO2": "PR",
        "ISO3": "PRI",
        "Top Level Domain": "pr",
        "FIPS": "RQ",
        "ISO Numeric": 630,
        "GeoNameID": 4566966,
        "E164": 1,
        "Phone Code": "1-787, 1-939",
        "Continent": "North America",
        "Capital": "San Juan",
        "Time Zone in Capital": "America/Puerto_Rico",
        "Currency": "Dollar",
        "Language Codes": "en-PR,es-PR",
        "Languages": "Spanish, English",
        "Area KM2": 9104,
        "Internet Hosts": 469,
        "Internet Users": 1000000,
        "Phones (Mobile)": 3060000,
        "Phones (Landline)": 780200,
        "GDP": 93520000000
    },
    {
        "Country Name": "Qatar",
        "ISO2": "QA",
        "ISO3": "QAT",
        "Top Level Domain": "qa",
        "FIPS": "QA",
        "ISO Numeric": 634,
        "GeoNameID": 289688,
        "E164": 974,
        "Phone Code": 974,
        "Continent": "Asia",
        "Capital": "Doha",
        "Time Zone in Capital": "Asia/Qatar",
        "Currency": "Rial",
        "Language Codes": "ar-QA,es",
        "Languages": "Arabic (official), English commonly used as a second language",
        "Area KM2": 11437,
        "Internet Hosts": 897,
        "Internet Users": 563800,
        "Phones (Mobile)": 2600000,
        "Phones (Landline)": 327000,
        "GDP": 213100000000
    },
    {
        "Country Name": "Republic of the Congo",
        "ISO2": "CG",
        "ISO3": "COG",
        "Top Level Domain": "cg",
        "FIPS": "CF",
        "ISO Numeric": 178,
        "GeoNameID": 2260494,
        "E164": 242,
        "Phone Code": 242,
        "Continent": "Africa",
        "Capital": "Brazzaville",
        "Time Zone in Capital": "Africa/Lagos",
        "Currency": "Franc",
        "Language Codes": "fr-CG,kg,ln-CG",
        "Languages": "French (official), Lingala and Monokutuba (lingua franca trade languages), many local languages and dialects (of which Kikongo is the most widespread)",
        "Area KM2": 342000,
        "Internet Hosts": 45,
        "Internet Users": 245200,
        "Phones (Mobile)": 4283000,
        "Phones (Landline)": 14900,
        "GDP": 14250000000
    },
    {
        "Country Name": "Reunion",
        "ISO2": "RE",
        "ISO3": "REU",
        "Top Level Domain": "re",
        "FIPS": "RE",
        "ISO Numeric": 638,
        "GeoNameID": 935317,
        "E164": 262,
        "Phone Code": 262,
        "Continent": "Africa",
        "Capital": "Saint-Denis",
        "Time Zone in Capital": "Indian/Reunion",
        "Currency": "Euro",
        "Language Codes": "fr-RE",
        "Languages": "French",
        "Area KM2": 2517,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Romania",
        "ISO2": "RO",
        "ISO3": "ROU",
        "Top Level Domain": "ro",
        "FIPS": "RO",
        "ISO Numeric": 642,
        "GeoNameID": 798549,
        "E164": 40,
        "Phone Code": 40,
        "Continent": "Europe",
        "Capital": "Bucharest",
        "Time Zone in Capital": "Europe/Bucharest",
        "Currency": "Leu",
        "Language Codes": "ro,hu,rom",
        "Languages": "Romanian (official) 85.4%, Hungarian 6.3%, Romany (Gypsy) 1.2%, other 1%, unspecified 6.1% (2011 est.)",
        "Area KM2": 237500,
        "Internet Hosts": 2667000,
        "Internet Users": 7787000,
        "Phones (Mobile)": 22700000,
        "Phones (Landline)": 4680000,
        "GDP": 188900000000
    },
    {
        "Country Name": "Russia",
        "ISO2": "RU",
        "ISO3": "RUS",
        "Top Level Domain": "ru",
        "FIPS": "RS",
        "ISO Numeric": 643,
        "GeoNameID": 2017370,
        "E164": 7,
        "Phone Code": 7,
        "Continent": "Europe",
        "Capital": "Moscow",
        "Time Zone in Capital": "Europe/Moscow",
        "Currency": "Ruble",
        "Language Codes": "ru,tt,xal,cau,ady,kv,ce,tyv,cv,udm,tut,mns,bua,myv,mdf,chm,ba,inh,tut,kbd,krc,ava,sah,nog",
        "Languages": "Russian (official) 96.3%, Dolgang 5.3%, German 1.5%, Chechen 1%, Tatar 3%, other 10.3%",
        "Area KM2": 17100000,
        "Internet Hosts": 14865000,
        "Internet Users": 40853000,
        "Phones (Mobile)": 261900000,
        "Phones (Landline)": 42900000,
        "GDP": 2113000000000
    },
    {
        "Country Name": "Rwanda",
        "ISO2": "RW",
        "ISO3": "RWA",
        "Top Level Domain": "rw",
        "FIPS": "RW",
        "ISO Numeric": 646,
        "GeoNameID": 49518,
        "E164": 250,
        "Phone Code": 250,
        "Continent": "Africa",
        "Capital": "Kigali",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Franc",
        "Language Codes": "rw,en-RW,fr-RW,sw",
        "Languages": "Kinyarwanda only (official, universal Bantu vernacular) 93.2%, Kinyarwanda and other language(s) 6.2%, French (official) and other language(s) 0.1%, English (official) and other language(s) 0.1%, Swahili (or Kiswahili, used in commercial centers) 0.02%, other 0.03%, unspecified 0.3% (2002 est.)",
        "Area KM2": 26338,
        "Internet Hosts": 1447,
        "Internet Users": 450000,
        "Phones (Mobile)": 5690000,
        "Phones (Landline)": 44400,
        "GDP": 7700000000
    },
    {
        "Country Name": "Saint Barthelemy",
        "ISO2": "BL",
        "ISO3": "BLM",
        "Top Level Domain": "gp",
        "FIPS": "TB",
        "ISO Numeric": 652,
        "GeoNameID": 3578476,
        "E164": 590,
        "Phone Code": 590,
        "Continent": "North America",
        "Capital": "Gustavia",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Euro",
        "Language Codes": "fr",
        "Languages": "French (primary), English",
        "Area KM2": 21,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Saint Helena",
        "ISO2": "SH",
        "ISO3": "SHN",
        "Top Level Domain": "sh",
        "FIPS": "SH",
        "ISO Numeric": 654,
        "GeoNameID": 3370751,
        "E164": 290,
        "Phone Code": 290,
        "Continent": "Africa",
        "Capital": "Jamestown",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Pound",
        "Language Codes": "en-SH",
        "Languages": "English",
        "Area KM2": 410,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Saint Kitts and Nevis",
        "ISO2": "KN",
        "ISO3": "KNA",
        "Top Level Domain": "kn",
        "FIPS": "SC",
        "ISO Numeric": 659,
        "GeoNameID": 3575174,
        "E164": 1,
        "Phone Code": "1-869",
        "Continent": "North America",
        "Capital": "Basseterre",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-KN",
        "Languages": "English (official)",
        "Area KM2": 261,
        "Internet Hosts": 54,
        "Internet Users": 17000,
        "Phones (Mobile)": 84000,
        "Phones (Landline)": 20000,
        "GDP": 767000000
    },
    {
        "Country Name": "Saint Lucia",
        "ISO2": "LC",
        "ISO3": "LCA",
        "Top Level Domain": "lc",
        "FIPS": "ST",
        "ISO Numeric": 662,
        "GeoNameID": 3576468,
        "E164": 1,
        "Phone Code": "1-758",
        "Continent": "North America",
        "Capital": "Castries",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-LC",
        "Languages": "English (official), French patois",
        "Area KM2": 616,
        "Internet Hosts": 100,
        "Internet Users": 142900,
        "Phones (Mobile)": 227000,
        "Phones (Landline)": 36800,
        "GDP": 1377000000
    },
    {
        "Country Name": "Saint Martin",
        "ISO2": "MF",
        "ISO3": "MAF",
        "Top Level Domain": "gp",
        "FIPS": "RN",
        "ISO Numeric": 663,
        "GeoNameID": 3578421,
        "E164": 1,
        "Phone Code": 590,
        "Continent": "North America",
        "Capital": "Marigot",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Euro",
        "Language Codes": "fr",
        "Languages": "French (official), English, Dutch, French Patois, Spanish, Papiamento (dialect of Netherlands Antilles)",
        "Area KM2": 53,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 561500000
    },
    {
        "Country Name": "Saint Pierre and Miquelon",
        "ISO2": "PM",
        "ISO3": "SPM",
        "Top Level Domain": "pm",
        "FIPS": "SB",
        "ISO Numeric": 666,
        "GeoNameID": 3424932,
        "E164": 508,
        "Phone Code": 508,
        "Continent": "North America",
        "Capital": "Saint-Pierre",
        "Time Zone in Capital": "America/Miquelon",
        "Currency": "Euro",
        "Language Codes": "fr-PM",
        "Languages": "French (official)",
        "Area KM2": 242,
        "Internet Hosts": 15,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": 4800,
        "GDP": 215300000
    },
    {
        "Country Name": "Saint Vincent and the Grenadines",
        "ISO2": "VC",
        "ISO3": "VCT",
        "Top Level Domain": "vc",
        "FIPS": "VC",
        "ISO Numeric": 670,
        "GeoNameID": 3577815,
        "E164": 1,
        "Phone Code": "1-784",
        "Continent": "North America",
        "Capital": "Kingstown",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-VC,fr",
        "Languages": "English, French patois",
        "Area KM2": 389,
        "Internet Hosts": 305,
        "Internet Users": 76000,
        "Phones (Mobile)": 135500,
        "Phones (Landline)": 19400,
        "GDP": 742000000
    },
    {
        "Country Name": "Samoa",
        "ISO2": "WS",
        "ISO3": "WSM",
        "Top Level Domain": "ws",
        "FIPS": "WS",
        "ISO Numeric": 882,
        "GeoNameID": 4034894,
        "E164": 685,
        "Phone Code": 685,
        "Continent": "Oceania",
        "Capital": "Apia",
        "Time Zone in Capital": "Pacific/Apia",
        "Currency": "Tala",
        "Language Codes": "sm,en-WS",
        "Languages": "Samoan (Polynesian) (official), English",
        "Area KM2": 2944,
        "Internet Hosts": 18013,
        "Internet Users": 9000,
        "Phones (Mobile)": 167400,
        "Phones (Landline)": 35300,
        "GDP": 705000000
    },
    {
        "Country Name": "San Marino",
        "ISO2": "SM",
        "ISO3": "SMR",
        "Top Level Domain": "sm",
        "FIPS": "SM",
        "ISO Numeric": 674,
        "GeoNameID": 3168068,
        "E164": 378,
        "Phone Code": 378,
        "Continent": "Europe",
        "Capital": "San Marino",
        "Time Zone in Capital": "Europe/Rome",
        "Currency": "Euro",
        "Language Codes": "it-SM",
        "Languages": "Italian",
        "Area KM2": 61,
        "Internet Hosts": 11015,
        "Internet Users": 17000,
        "Phones (Mobile)": 36000,
        "Phones (Landline)": 18700,
        "GDP": 1866000000
    },
    {
        "Country Name": "Sao Tome and Principe",
        "ISO2": "ST",
        "ISO3": "STP",
        "Top Level Domain": "st",
        "FIPS": "TP",
        "ISO Numeric": 678,
        "GeoNameID": 2410758,
        "E164": 239,
        "Phone Code": 239,
        "Continent": "Africa",
        "Capital": "Sao Tome",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Dobra",
        "Language Codes": "pt-ST",
        "Languages": "Portuguese 98.4% (official), Forro 36.2%, Cabo Verdian 8.5%, French 6.8%, Angolar 6.6%, English 4.9%, Lunguie 1%, other (including sign language) 2.4%",
        "Area KM2": 1001,
        "Internet Hosts": 1678,
        "Internet Users": 26700,
        "Phones (Mobile)": 122000,
        "Phones (Landline)": 8000,
        "GDP": 311000000
    },
    {
        "Country Name": "Saudi Arabia",
        "ISO2": "SA",
        "ISO3": "SAU",
        "Top Level Domain": "sa",
        "FIPS": "SA",
        "ISO Numeric": 682,
        "GeoNameID": 102358,
        "E164": 966,
        "Phone Code": 966,
        "Continent": "Asia",
        "Capital": "Riyadh",
        "Time Zone in Capital": "Asia/Riyadh",
        "Currency": "Rial",
        "Language Codes": "ar-SA",
        "Languages": "Arabic (official)",
        "Area KM2": 1960582,
        "Internet Hosts": 145941,
        "Internet Users": 9774000,
        "Phones (Mobile)": 53000000,
        "Phones (Landline)": 4800000,
        "GDP": 718500000000
    },
    {
        "Country Name": "Senegal",
        "ISO2": "SN",
        "ISO3": "SEN",
        "Top Level Domain": "sn",
        "FIPS": "SG",
        "ISO Numeric": 686,
        "GeoNameID": 2245662,
        "E164": 221,
        "Phone Code": 221,
        "Continent": "Africa",
        "Capital": "Dakar",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-SN,wo,fuc,mnk",
        "Languages": "French (official), Wolof, Pulaar, Jola, Mandinka",
        "Area KM2": 196190,
        "Internet Hosts": 237,
        "Internet Users": 1818000,
        "Phones (Mobile)": 11470000,
        "Phones (Landline)": 338200,
        "GDP": 15360000000
    },
    {
        "Country Name": "Serbia",
        "ISO2": "RS",
        "ISO3": "SRB",
        "Top Level Domain": "rs",
        "FIPS": "RI",
        "ISO Numeric": 688,
        "GeoNameID": 6290252,
        "E164": 381,
        "Phone Code": 381,
        "Continent": "Europe",
        "Capital": "Belgrade",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Dinar",
        "Language Codes": "sr,hu,bs,rom",
        "Languages": "Serbian (official) 88.1%, Hungarian 3.4%, Bosnian 1.9%, Romany 1.4%, other 3.4%, undeclared or unknown 1.8%",
        "Area KM2": 88361,
        "Internet Hosts": 1102000,
        "Internet Users": 4107000,
        "Phones (Mobile)": 9138000,
        "Phones (Landline)": 2977000,
        "GDP": 43680000000
    },
    {
        "Country Name": "Seychelles",
        "ISO2": "SC",
        "ISO3": "SYC",
        "Top Level Domain": "sc",
        "FIPS": "SE",
        "ISO Numeric": 690,
        "GeoNameID": 241170,
        "E164": 248,
        "Phone Code": 248,
        "Continent": "Africa",
        "Capital": "Victoria",
        "Time Zone in Capital": "Indian/Mahe",
        "Currency": "Rupee",
        "Language Codes": "en-SC,fr-SC",
        "Languages": "Seychellois Creole (official) 89.1%, English (official) 5.1%, French (official) 0.7%, other 3.8%, unspecified 1.4% (2010 est.)",
        "Area KM2": 455,
        "Internet Hosts": 247,
        "Internet Users": 32000,
        "Phones (Mobile)": 138300,
        "Phones (Landline)": 28900,
        "GDP": 1271000000
    },
    {
        "Country Name": "Sierra Leone",
        "ISO2": "SL",
        "ISO3": "SLE",
        "Top Level Domain": "sl",
        "FIPS": "SL",
        "ISO Numeric": 694,
        "GeoNameID": 2403846,
        "E164": 232,
        "Phone Code": 232,
        "Continent": "Africa",
        "Capital": "Freetown",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Leone",
        "Language Codes": "en-SL,men,tem",
        "Languages": "English (official, regular use limited to literate minority), Mende (principal vernacular in the south), Temne (principal vernacular in the north), Krio (English-based Creole, spoken by the descendants of freed Jamaican slaves who were settled in the Freetown area, a lingua franca and a first language for 10% of the population but understood by 95%)",
        "Area KM2": 71740,
        "Internet Hosts": 282,
        "Internet Users": 14900,
        "Phones (Mobile)": 2210000,
        "Phones (Landline)": 18000,
        "GDP": 4607000000
    },
    {
        "Country Name": "Singapore",
        "ISO2": "SG",
        "ISO3": "SGP",
        "Top Level Domain": "sg",
        "FIPS": "SN",
        "ISO Numeric": 702,
        "GeoNameID": 1880251,
        "E164": 65,
        "Phone Code": 65,
        "Continent": "Asia",
        "Capital": "Singapore",
        "Time Zone in Capital": "Asia/Singapore",
        "Currency": "Dollar",
        "Language Codes": "cmn,en-SG,ms-SG,ta-SG,zh-SG",
        "Languages": "Mandarin (official) 36.3%, English (official) 29.8%, Malay (official) 11.9%, Hokkien 8.1%, Tamil (official) 4.4%, Cantonese 4.1%, Teochew 3.2%, other Indian languages 1.2%, other Chinese dialects 1.1%, other 1.1% (2010 est.)",
        "Area KM2": 693,
        "Internet Hosts": 1960000,
        "Internet Users": 3235000,
        "Phones (Mobile)": 8063000,
        "Phones (Landline)": 1990000,
        "GDP": 295700000000
    },
    {
        "Country Name": "Sint Maarten",
        "ISO2": "SX",
        "ISO3": "SXM",
        "Top Level Domain": "sx",
        "FIPS": "NN",
        "ISO Numeric": 534,
        "GeoNameID": 7609695,
        "E164": 1,
        "Phone Code": "1-721",
        "Continent": "North America",
        "Capital": "Philipsburg",
        "Time Zone in Capital": "America/Curacao",
        "Currency": "Guilder",
        "Language Codes": "nl,en",
        "Languages": "English (official) 67.5%, Spanish 12.9%, Creole 8.2%, Dutch (official) 4.2%, Papiamento (a Spanish-Portuguese-Dutch-English dialect) 2.2%, French 1.5%, other 3.5% (2001 census)",
        "Area KM2": 34,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": 794700000
    },
    {
        "Country Name": "Slovakia",
        "ISO2": "SK",
        "ISO3": "SVK",
        "Top Level Domain": "sk",
        "FIPS": "LO",
        "ISO Numeric": 703,
        "GeoNameID": 3057568,
        "E164": 421,
        "Phone Code": 421,
        "Continent": "Europe",
        "Capital": "Bratislava",
        "Time Zone in Capital": "Europe/Prague",
        "Currency": "Euro",
        "Language Codes": "sk,hu",
        "Languages": "Slovak (official) 78.6%, Hungarian 9.4%, Roma 2.3%, Ruthenian 1%, other or unspecified 8.8% (2011 est.)",
        "Area KM2": 48845,
        "Internet Hosts": 1384000,
        "Internet Users": 4063000,
        "Phones (Mobile)": 6095000,
        "Phones (Landline)": 975000,
        "GDP": 96960000000
    },
    {
        "Country Name": "Slovenia",
        "ISO2": "SI",
        "ISO3": "SVN",
        "Top Level Domain": "si",
        "FIPS": "SI",
        "ISO Numeric": 705,
        "GeoNameID": 3190538,
        "E164": 386,
        "Phone Code": 386,
        "Continent": "Europe",
        "Capital": "Ljubljana",
        "Time Zone in Capital": "Europe/Belgrade",
        "Currency": "Euro",
        "Language Codes": "sl,sh",
        "Languages": "Slovenian (official) 91.1%, Serbo-Croatian 4.5%, other or unspecified 4.4%, Italian (official, only in municipalities where Italian national communities reside), Hungarian (official, only in municipalities where Hungarian national communities reside) (2002 census)",
        "Area KM2": 20273,
        "Internet Hosts": 415581,
        "Internet Users": 1298000,
        "Phones (Mobile)": 2246000,
        "Phones (Landline)": 825000,
        "GDP": 46820000000
    },
    {
        "Country Name": "Solomon Islands",
        "ISO2": "SB",
        "ISO3": "SLB",
        "Top Level Domain": "sb",
        "FIPS": "BP",
        "ISO Numeric": "090",
        "GeoNameID": 2103350,
        "E164": 677,
        "Phone Code": 677,
        "Continent": "Oceania",
        "Capital": "Honiara",
        "Time Zone in Capital": "Pacific/Guadalcanal",
        "Currency": "Dollar",
        "Language Codes": "en-SB,tpi",
        "Languages": "Melanesian pidgin (in much of the country is lingua franca), English (official but spoken by only 1%-2% of the population), 120 indigenous languages",
        "Area KM2": 28450,
        "Internet Hosts": 4370,
        "Internet Users": 10000,
        "Phones (Mobile)": 302100,
        "Phones (Landline)": 8060,
        "GDP": 1099000000
    },
    {
        "Country Name": "Somalia",
        "ISO2": "SO",
        "ISO3": "SOM",
        "Top Level Domain": "so",
        "FIPS": "SO",
        "ISO Numeric": 706,
        "GeoNameID": 51537,
        "E164": 252,
        "Phone Code": 252,
        "Continent": "Africa",
        "Capital": "Mogadishu",
        "Time Zone in Capital": "Africa/Mogadishu",
        "Currency": "Shilling",
        "Language Codes": "so-SO,ar-SO,it,en-SO",
        "Languages": "Somali (official), Arabic (official, according to the Transitional Federal Charter), Italian, English",
        "Area KM2": 637657,
        "Internet Hosts": 186,
        "Internet Users": 106000,
        "Phones (Mobile)": 658000,
        "Phones (Landline)": 100000,
        "GDP": 2372000000
    },
    {
        "Country Name": "South Africa",
        "ISO2": "ZA",
        "ISO3": "ZAF",
        "Top Level Domain": "za",
        "FIPS": "SF",
        "ISO Numeric": 710,
        "GeoNameID": 953987,
        "E164": 27,
        "Phone Code": 27,
        "Continent": "Africa",
        "Capital": "Pretoria",
        "Time Zone in Capital": "Africa/Johannesburg",
        "Currency": "Rand",
        "Language Codes": "zu,xh,af,nso,en-ZA,tn,st,ts,ss,ve,nr",
        "Languages": "IsiZulu (official) 22.7%, IsiXhosa (official) 16%, Afrikaans (official) 13.5%, English (official) 9.6%, Sepedi (official) 9.1%, Setswana (official) 8%, Sesotho (official) 7.6%, Xitsonga (official) 4.5%, siSwati (official) 2.5%, Tshivenda (official) 2.4%, isiNdebele (official) 2.1%, sign language 0.5%, other 1.6% (2011 est.)",
        "Area KM2": 1219912,
        "Internet Hosts": 4761000,
        "Internet Users": 4420000,
        "Phones (Mobile)": 68400000,
        "Phones (Landline)": 4030000,
        "GDP": 353900000000
    },
    {
        "Country Name": "South Korea",
        "ISO2": "KR",
        "ISO3": "KOR",
        "Top Level Domain": "kr",
        "FIPS": "KS",
        "ISO Numeric": 410,
        "GeoNameID": 1835841,
        "E164": 82,
        "Phone Code": 82,
        "Continent": "Asia",
        "Capital": "Seoul",
        "Time Zone in Capital": "Asia/Seoul",
        "Currency": "Won",
        "Language Codes": "ko-KR,en",
        "Languages": "Korean, English (widely taught in junior high and high school)",
        "Area KM2": 98480,
        "Internet Hosts": 315697,
        "Internet Users": 39400000,
        "Phones (Mobile)": 53625000,
        "Phones (Landline)": 30100000,
        "GDP": 1198000000000
    },
    {
        "Country Name": "South Sudan",
        "ISO2": "SS",
        "ISO3": "SSD",
        "Top Level Domain": "ss",
        "FIPS": "OD",
        "ISO Numeric": 728,
        "GeoNameID": 7909807,
        "E164": 211,
        "Phone Code": 211,
        "Continent": "Africa",
        "Capital": "Juba",
        "Time Zone in Capital": "Africa/Khartoum",
        "Currency": "Pound",
        "Language Codes": "en",
        "Languages": "English (official), Arabic (includes Juba and Sudanese variants), regional languages include Dinka, Nuer, Bari, Zande, Shilluk",
        "Area KM2": 644329,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": 2000000,
        "Phones (Landline)": 2200,
        "GDP": 11770000000
    },
    {
        "Country Name": "Spain",
        "ISO2": "ES",
        "ISO3": "ESP",
        "Top Level Domain": "es",
        "FIPS": "SP",
        "ISO Numeric": 724,
        "GeoNameID": 2510769,
        "E164": 34,
        "Phone Code": 34,
        "Continent": "Europe",
        "Capital": "Madrid",
        "Time Zone in Capital": "Europe/Madrid",
        "Currency": "Euro",
        "Language Codes": "es-ES,ca,gl,eu,oc",
        "Languages": "Castilian Spanish (official) 74%, Catalan 17%, Galician 7%, and Basque 2%",
        "Area KM2": 504782,
        "Internet Hosts": 4228000,
        "Internet Users": 28119000,
        "Phones (Mobile)": 50663000,
        "Phones (Landline)": 19220000,
        "GDP": 1356000000000
    },
    {
        "Country Name": "Sri Lanka",
        "ISO2": "LK",
        "ISO3": "LKA",
        "Top Level Domain": "lk",
        "FIPS": "CE",
        "ISO Numeric": 144,
        "GeoNameID": 1227603,
        "E164": 94,
        "Phone Code": 94,
        "Continent": "Asia",
        "Capital": "Colombo",
        "Time Zone in Capital": "Asia/Colombo",
        "Currency": "Rupee",
        "Language Codes": "si,ta,en",
        "Languages": "Sinhala (official and national language) 74%, Tamil (national language) 18%, other 8%",
        "Area KM2": 65610,
        "Internet Hosts": 9552,
        "Internet Users": 1777000,
        "Phones (Mobile)": 19533000,
        "Phones (Landline)": 2796000,
        "GDP": 65120000000
    },
    {
        "Country Name": "Sudan",
        "ISO2": "SD",
        "ISO3": "SDN",
        "Top Level Domain": "sd",
        "FIPS": "SU",
        "ISO Numeric": 729,
        "GeoNameID": 366755,
        "E164": 249,
        "Phone Code": 249,
        "Continent": "Africa",
        "Capital": "Khartoum",
        "Time Zone in Capital": "Africa/Khartoum",
        "Currency": "Pound",
        "Language Codes": "ar-SD,en,fia",
        "Languages": "Arabic (official), English (official), Nubian, Ta Bedawie, Fur",
        "Area KM2": 1861484,
        "Internet Hosts": 99,
        "Internet Users": 4200000,
        "Phones (Mobile)": 27659000,
        "Phones (Landline)": 425000,
        "GDP": 52500000000
    },
    {
        "Country Name": "Suriname",
        "ISO2": "SR",
        "ISO3": "SUR",
        "Top Level Domain": "sr",
        "FIPS": "NS",
        "ISO Numeric": 740,
        "GeoNameID": 3382998,
        "E164": 597,
        "Phone Code": 597,
        "Continent": "South America",
        "Capital": "Paramaribo",
        "Time Zone in Capital": "America/Paramaribo",
        "Currency": "Dollar",
        "Language Codes": "nl-SR,en,srn,hns,jv",
        "Languages": "Dutch (official), English (widely spoken), Sranang Tongo (Surinamese, sometimes called Taki-Taki, is native language of Creoles and much of the younger population and is lingua franca among others), Caribbean Hindustani (a dialect of Hindi), Javanese",
        "Area KM2": 163270,
        "Internet Hosts": 188,
        "Internet Users": 163000,
        "Phones (Mobile)": 977000,
        "Phones (Landline)": 83000,
        "GDP": 5009000000
    },
    {
        "Country Name": "Svalbard and Jan Mayen",
        "ISO2": "SJ",
        "ISO3": "SJM",
        "Top Level Domain": "sj",
        "FIPS": "SV",
        "ISO Numeric": 744,
        "GeoNameID": 607072,
        "E164": 47,
        "Phone Code": 47,
        "Continent": "Europe",
        "Capital": "Longyearbyen",
        "Time Zone in Capital": "Europe/Oslo",
        "Currency": "Krone",
        "Language Codes": "no,ru",
        "Languages": "Norwegian, Russian",
        "Area KM2": 62049,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Swaziland",
        "ISO2": "SZ",
        "ISO3": "SWZ",
        "Top Level Domain": "sz",
        "FIPS": "WZ",
        "ISO Numeric": 748,
        "GeoNameID": 934841,
        "E164": 268,
        "Phone Code": 268,
        "Continent": "Africa",
        "Capital": "Mbabane",
        "Time Zone in Capital": "Africa/Johannesburg",
        "Currency": "Lilangeni",
        "Language Codes": "en-SZ,ss-SZ",
        "Languages": "English (official, used for government business), siSwati (official)",
        "Area KM2": 17363,
        "Internet Hosts": 2744,
        "Internet Users": 90100,
        "Phones (Mobile)": 805000,
        "Phones (Landline)": 48600,
        "GDP": 3807000000
    },
    {
        "Country Name": "Sweden",
        "ISO2": "SE",
        "ISO3": "SWE",
        "Top Level Domain": "se",
        "FIPS": "SW",
        "ISO Numeric": 752,
        "GeoNameID": 2661886,
        "E164": 46,
        "Phone Code": 46,
        "Continent": "Europe",
        "Capital": "Stockholm",
        "Time Zone in Capital": "Europe/Stockholm",
        "Currency": "Krona",
        "Language Codes": "sv-SE,se,sma,fi-SE",
        "Languages": "Swedish (official), small Sami- and Finnish-speaking minorities",
        "Area KM2": 449964,
        "Internet Hosts": 5978000,
        "Internet Users": 8398000,
        "Phones (Mobile)": 11643000,
        "Phones (Landline)": 4321000,
        "GDP": 552000000000
    },
    {
        "Country Name": "Switzerland",
        "ISO2": "CH",
        "ISO3": "CHE",
        "Top Level Domain": "ch",
        "FIPS": "SZ",
        "ISO Numeric": 756,
        "GeoNameID": 2658434,
        "E164": 41,
        "Phone Code": 41,
        "Continent": "Europe",
        "Capital": "Berne",
        "Time Zone in Capital": "Europe/Zurich",
        "Currency": "Franc",
        "Language Codes": "de-CH,fr-CH,it-CH,rm",
        "Languages": "German (official) 64.9%, French (official) 22.6%, Italian (official) 8.3%, Serbo-Croatian 2.5%, Albanian 2.6%, Portuguese 3.4%, Spanish 2.2%, English 4.6%, Romansch (official) 0.5%, other 5.1%",
        "Area KM2": 41290,
        "Internet Hosts": 5301000,
        "Internet Users": 6152000,
        "Phones (Mobile)": 10460000,
        "Phones (Landline)": 4382000,
        "GDP": 646200000000
    },
    {
        "Country Name": "Syria",
        "ISO2": "SY",
        "ISO3": "SYR",
        "Top Level Domain": "sy",
        "FIPS": "SY",
        "ISO Numeric": 760,
        "GeoNameID": 163843,
        "E164": 963,
        "Phone Code": 963,
        "Continent": "Asia",
        "Capital": "Damascus",
        "Time Zone in Capital": "Asia/Damascus",
        "Currency": "Pound",
        "Language Codes": "ar-SY,ku,hy,arc,fr,en",
        "Languages": "Arabic (official), Kurdish, Armenian, Aramaic, Circassian (widely understood); French, English (somewhat understood)",
        "Area KM2": 185180,
        "Internet Hosts": 416,
        "Internet Users": 4469000,
        "Phones (Mobile)": 12928000,
        "Phones (Landline)": 4425000,
        "GDP": 64700000000
    },
    {
        "Country Name": "Taiwan",
        "ISO2": "TW",
        "ISO3": "TWN",
        "Top Level Domain": "tw",
        "FIPS": "TW",
        "ISO Numeric": 158,
        "GeoNameID": 1668284,
        "E164": 886,
        "Phone Code": 886,
        "Continent": "Asia",
        "Capital": "Taipei",
        "Time Zone in Capital": "Asia/Taipei",
        "Currency": "Dollar",
        "Language Codes": "zh-TW,zh,nan,hak",
        "Languages": "Mandarin Chinese (official), Taiwanese (Min), Hakka dialects",
        "Area KM2": 35980,
        "Internet Hosts": 6272000,
        "Internet Users": 16147000,
        "Phones (Mobile)": 29455000,
        "Phones (Landline)": 15998000,
        "GDP": 484700000000
    },
    {
        "Country Name": "Tajikistan",
        "ISO2": "TJ",
        "ISO3": "TJK",
        "Top Level Domain": "tj",
        "FIPS": "TI",
        "ISO Numeric": 762,
        "GeoNameID": 1220409,
        "E164": 992,
        "Phone Code": 992,
        "Continent": "Asia",
        "Capital": "Dushanbe",
        "Time Zone in Capital": "Asia/Dushanbe",
        "Currency": "Somoni",
        "Language Codes": "tg,ru",
        "Languages": "Tajik (official), Russian widely used in government and business",
        "Area KM2": 143100,
        "Internet Hosts": 6258,
        "Internet Users": 700000,
        "Phones (Mobile)": 6528000,
        "Phones (Landline)": 393000,
        "GDP": 8513000000
    },
    {
        "Country Name": "Tanzania",
        "ISO2": "TZ",
        "ISO3": "TZA",
        "Top Level Domain": "tz",
        "FIPS": "TZ",
        "ISO Numeric": 834,
        "GeoNameID": 149590,
        "E164": 255,
        "Phone Code": 255,
        "Continent": "Africa",
        "Capital": "Dodoma",
        "Time Zone in Capital": "Africa/Dar_es_Salaam",
        "Currency": "Shilling",
        "Language Codes": "sw-TZ,en,ar",
        "Languages": "Kiswahili or Swahili (official), Kiunguja (name for Swahili in Zanzibar), English (official, primary language of commerce, administration, and higher education), Arabic (widely spoken in Zanzibar), many local languages",
        "Area KM2": 945087,
        "Internet Hosts": 26074,
        "Internet Users": 678000,
        "Phones (Mobile)": 27220000,
        "Phones (Landline)": 161100,
        "GDP": 31940000000
    },
    {
        "Country Name": "Thailand",
        "ISO2": "TH",
        "ISO3": "THA",
        "Top Level Domain": "th",
        "FIPS": "TH",
        "ISO Numeric": 764,
        "GeoNameID": 1605651,
        "E164": 66,
        "Phone Code": 66,
        "Continent": "Asia",
        "Capital": "Bangkok",
        "Time Zone in Capital": "Asia/Bangkok",
        "Currency": "Baht",
        "Language Codes": "th,en",
        "Languages": "Thai (official) 90.7%, Burmese 1.3%, other 8%",
        "Area KM2": 514000,
        "Internet Hosts": 3399000,
        "Internet Users": 17483000,
        "Phones (Mobile)": 84075000,
        "Phones (Landline)": 6391000,
        "GDP": 400900000000
    },
    {
        "Country Name": "Togo",
        "ISO2": "TG",
        "ISO3": "TGO",
        "Top Level Domain": "tg",
        "FIPS": "TO",
        "ISO Numeric": 768,
        "GeoNameID": 2363686,
        "E164": 228,
        "Phone Code": 228,
        "Continent": "Africa",
        "Capital": "Lome",
        "Time Zone in Capital": "Africa/Abidjan",
        "Currency": "Franc",
        "Language Codes": "fr-TG,ee,hna,kbp,dag,ha",
        "Languages": "French (official, the language of commerce), Ewe and Mina (the two major African languages in the south), Kabye (sometimes spelled Kabiye) and Dagomba (the two major African languages in the north)",
        "Area KM2": 56785,
        "Internet Hosts": 1168,
        "Internet Users": 356300,
        "Phones (Mobile)": 3518000,
        "Phones (Landline)": 225000,
        "GDP": 4299000000
    },
    {
        "Country Name": "Tokelau",
        "ISO2": "TK",
        "ISO3": "TKL",
        "Top Level Domain": "tk",
        "FIPS": "TL",
        "ISO Numeric": 772,
        "GeoNameID": 4031074,
        "E164": 690,
        "Phone Code": 690,
        "Continent": "Oceania",
        "Capital": "",
        "Time Zone in Capital": "Pacific/Fakaofo",
        "Currency": "Dollar",
        "Language Codes": "tkl,en-TK",
        "Languages": "Tokelauan 93.5% (a Polynesian language), English 58.9%, Samoan 45.5%, Tuvaluan 11.6%, Kiribati 2.7%, other 2.5%, none 4.1%, unspecified 0.6%",
        "Area KM2": 10,
        "Internet Hosts": 2069,
        "Internet Users": 800,
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Tonga",
        "ISO2": "TO",
        "ISO3": "TON",
        "Top Level Domain": "to",
        "FIPS": "TN",
        "ISO Numeric": 776,
        "GeoNameID": 4032283,
        "E164": 676,
        "Phone Code": 676,
        "Continent": "Oceania",
        "Capital": "Nuku'alofa",
        "Time Zone in Capital": "Pacific/Tongatapu",
        "Currency": "Pa'anga",
        "Language Codes": "to,en-TO",
        "Languages": "English and Tongan 87%, Tongan (official) 10.7%, English (official) 1.2%, other 1.1%, uspecified 0.03% (2006 est.)",
        "Area KM2": 748,
        "Internet Hosts": 5367,
        "Internet Users": 8400,
        "Phones (Mobile)": 56000,
        "Phones (Landline)": 30000,
        "GDP": 477000000
    },
    {
        "Country Name": "Trinidad and Tobago",
        "ISO2": "TT",
        "ISO3": "TTO",
        "Top Level Domain": "tt",
        "FIPS": "TD",
        "ISO Numeric": 780,
        "GeoNameID": 3573591,
        "E164": 1,
        "Phone Code": "1-868",
        "Continent": "North America",
        "Capital": "Port of Spain",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-TT,hns,fr,es,zh",
        "Languages": "English (official), Caribbean Hindustani (a dialect of Hindi), French, Spanish, Chinese",
        "Area KM2": 5128,
        "Internet Hosts": 241690,
        "Internet Users": 593000,
        "Phones (Mobile)": 1884000,
        "Phones (Landline)": 287000,
        "GDP": 27130000000
    },
    {
        "Country Name": "Tunisia",
        "ISO2": "TN",
        "ISO3": "TUN",
        "Top Level Domain": "tn",
        "FIPS": "TS",
        "ISO Numeric": 788,
        "GeoNameID": 2464461,
        "E164": 216,
        "Phone Code": 216,
        "Continent": "Africa",
        "Capital": "Tunis",
        "Time Zone in Capital": "Africa/Tunis",
        "Currency": "Dinar",
        "Language Codes": "ar-TN,fr",
        "Languages": "Arabic (official, one of the languages of commerce), French (commerce), Berber (Tamazight)",
        "Area KM2": 163610,
        "Internet Hosts": 576,
        "Internet Users": 3500000,
        "Phones (Mobile)": 12840000,
        "Phones (Landline)": 1105000,
        "GDP": 48380000000
    },
    {
        "Country Name": "Turkey",
        "ISO2": "TR",
        "ISO3": "TUR",
        "Top Level Domain": "tr",
        "FIPS": "TU",
        "ISO Numeric": 792,
        "GeoNameID": 298795,
        "E164": 90,
        "Phone Code": 90,
        "Continent": "Asia",
        "Capital": "Ankara",
        "Time Zone in Capital": "Europe/Istanbul",
        "Currency": "Lira",
        "Language Codes": "tr-TR,ku,diq,az,av",
        "Languages": "Turkish (official), Kurdish, other minority languages",
        "Area KM2": 780580,
        "Internet Hosts": 7093000,
        "Internet Users": 27233000,
        "Phones (Mobile)": 67680000,
        "Phones (Landline)": 13860000,
        "GDP": 821800000000
    },
    {
        "Country Name": "Turkmenistan",
        "ISO2": "TM",
        "ISO3": "TKM",
        "Top Level Domain": "tm",
        "FIPS": "TX",
        "ISO Numeric": 795,
        "GeoNameID": 1218197,
        "E164": 993,
        "Phone Code": 993,
        "Continent": "Asia",
        "Capital": "Ashgabat",
        "Time Zone in Capital": "Asia/Ashgabat",
        "Currency": "Manat",
        "Language Codes": "tk,ru,uz",
        "Languages": "Turkmen (official) 72%, Russian 12%, Uzbek 9%, other 7%",
        "Area KM2": 488100,
        "Internet Hosts": 714,
        "Internet Users": 80400,
        "Phones (Mobile)": 3953000,
        "Phones (Landline)": 575000,
        "GDP": 40560000000
    },
    {
        "Country Name": "Turks and Caicos Islands",
        "ISO2": "TC",
        "ISO3": "TCA",
        "Top Level Domain": "tc",
        "FIPS": "TK",
        "ISO Numeric": 796,
        "GeoNameID": 3576916,
        "E164": 1,
        "Phone Code": "1-649",
        "Continent": "North America",
        "Capital": "Cockburn Town",
        "Time Zone in Capital": "America/Grand_Turk",
        "Currency": "Dollar",
        "Language Codes": "en-TC",
        "Languages": "English (official)",
        "Area KM2": 430,
        "Internet Hosts": 73217,
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Tuvalu",
        "ISO2": "TV",
        "ISO3": "TUV",
        "Top Level Domain": "tv",
        "FIPS": "TV",
        "ISO Numeric": 798,
        "GeoNameID": 2110297,
        "E164": 688,
        "Phone Code": 688,
        "Continent": "Oceania",
        "Capital": "Funafuti",
        "Time Zone in Capital": "Pacific/Funafuti",
        "Currency": "Dollar",
        "Language Codes": "tvl,en,sm,gil",
        "Languages": "Tuvaluan (official), English (official), Samoan, Kiribati (on the island of Nui)",
        "Area KM2": 26,
        "Internet Hosts": 145158,
        "Internet Users": 4200,
        "Phones (Mobile)": 2800,
        "Phones (Landline)": 1450,
        "GDP": 38000000
    },
    {
        "Country Name": "U.S. Virgin Islands",
        "ISO2": "VI",
        "ISO3": "VIR",
        "Top Level Domain": "vi",
        "FIPS": "VQ",
        "ISO Numeric": 850,
        "GeoNameID": 4796775,
        "E164": 1,
        "Phone Code": "1-340",
        "Continent": "North America",
        "Capital": "Charlotte Amalie",
        "Time Zone in Capital": "America/Port_of_Spain",
        "Currency": "Dollar",
        "Language Codes": "en-VI",
        "Languages": "English 74.7%, Spanish or Spanish Creole 16.8%, French or French Creole 6.6%, other 1.9% (2000 census)",
        "Area KM2": 352,
        "Internet Hosts": 4790,
        "Internet Users": 30000,
        "Phones (Mobile)": 80300,
        "Phones (Landline)": 75800,
        "GDP": ""
    },
    {
        "Country Name": "Uganda",
        "ISO2": "UG",
        "ISO3": "UGA",
        "Top Level Domain": "ug",
        "FIPS": "UG",
        "ISO Numeric": 800,
        "GeoNameID": 226074,
        "E164": 256,
        "Phone Code": 256,
        "Continent": "Africa",
        "Capital": "Kampala",
        "Time Zone in Capital": "Africa/Kampala",
        "Currency": "Shilling",
        "Language Codes": "en-UG,lg,sw,ar",
        "Languages": "English (official national language, taught in grade schools, used in courts of law and by most newspapers and some radio broadcasts), Ganda or Luganda (most widely used of the Niger-Congo languages, preferred for native language publications in the capital and may be taught in school), other Niger-Congo languages, Nilo-Saharan languages, Swahili, Arabic",
        "Area KM2": 236040,
        "Internet Hosts": 32683,
        "Internet Users": 3200000,
        "Phones (Mobile)": 16355000,
        "Phones (Landline)": 315000,
        "GDP": 22600000000
    },
    {
        "Country Name": "Ukraine",
        "ISO2": "UA",
        "ISO3": "UKR",
        "Top Level Domain": "ua",
        "FIPS": "UP",
        "ISO Numeric": 804,
        "GeoNameID": 690791,
        "E164": 380,
        "Phone Code": 380,
        "Continent": "Europe",
        "Capital": "Kiev",
        "Time Zone in Capital": "Europe/Kiev",
        "Currency": "Hryvnia",
        "Language Codes": "uk,ru-UA,rom,pl,hu",
        "Languages": "Ukrainian (official) 67%, Russian (regional language) 24%, other (includes small Romanian-, Polish-, and Hungarian-speaking minorities) 9%",
        "Area KM2": 603700,
        "Internet Hosts": 2173000,
        "Internet Users": 7770000,
        "Phones (Mobile)": 59344000,
        "Phones (Landline)": 12182000,
        "GDP": 175500000000
    },
    {
        "Country Name": "United Arab Emirates",
        "ISO2": "AE",
        "ISO3": "ARE",
        "Top Level Domain": "ae",
        "FIPS": "AE",
        "ISO Numeric": 784,
        "GeoNameID": 290557,
        "E164": 971,
        "Phone Code": 971,
        "Continent": "Asia",
        "Capital": "Abu Dhabi",
        "Time Zone in Capital": "Asia/Dubai",
        "Currency": "Dirham",
        "Language Codes": "ar-AE,fa,en,hi,ur",
        "Languages": "Arabic (official), Persian, English, Hindi, Urdu",
        "Area KM2": 82880,
        "Internet Hosts": 337804,
        "Internet Users": 3449000,
        "Phones (Mobile)": 13775000,
        "Phones (Landline)": 1967000,
        "GDP": 390000000000
    },
    {
        "Country Name": "United Kingdom",
        "ISO2": "GB",
        "ISO3": "GBR",
        "Top Level Domain": "uk",
        "FIPS": "UK",
        "ISO Numeric": 826,
        "GeoNameID": 2635167,
        "E164": 44,
        "Phone Code": 44,
        "Continent": "Europe",
        "Capital": "London",
        "Time Zone in Capital": "Europe/London",
        "Currency": "Pound",
        "Language Codes": "en-GB,cy-GB,gd",
        "Languages": "English",
        "Area KM2": 244820,
        "Internet Hosts": 8107000,
        "Internet Users": 51444000,
        "Phones (Mobile)": 82109000,
        "Phones (Landline)": 33010000,
        "GDP": 2490000000000
    },
    {
        "Country Name": "United States",
        "ISO2": "US",
        "ISO3": "USA",
        "Top Level Domain": "us",
        "FIPS": "US",
        "ISO Numeric": 840,
        "GeoNameID": 6252001,
        "E164": 1,
        "Phone Code": 1,
        "Continent": "North America",
        "Capital": "Washington",
        "Time Zone in Capital": "America/New_York",
        "Currency": "Dollar",
        "Language Codes": "en-US,es-US,haw,fr",
        "Languages": "English 82.1%, Spanish 10.7%, other Indo-European 3.8%, Asian and Pacific island 2.7%, other 0.7% (2000 census)",
        "Area KM2": 9629091,
        "Internet Hosts": 505000000,
        "Internet Users": 245000000,
        "Phones (Mobile)": 310000000,
        "Phones (Landline)": 139000000,
        "GDP": 16720000000000
    },
    {
        "Country Name": "Uruguay",
        "ISO2": "UY",
        "ISO3": "URY",
        "Top Level Domain": "uy",
        "FIPS": "UY",
        "ISO Numeric": 858,
        "GeoNameID": 3439705,
        "E164": 598,
        "Phone Code": 598,
        "Continent": "South America",
        "Capital": "Montevideo",
        "Time Zone in Capital": "America/Montevideo",
        "Currency": "Peso",
        "Language Codes": "es-UY",
        "Languages": "Spanish (official), Portunol, Brazilero (Portuguese-Spanish mix on the Brazilian frontier)",
        "Area KM2": 176220,
        "Internet Hosts": 1036000,
        "Internet Users": 1405000,
        "Phones (Mobile)": 5000000,
        "Phones (Landline)": 1010000,
        "GDP": 57110000000
    },
    {
        "Country Name": "Uzbekistan",
        "ISO2": "UZ",
        "ISO3": "UZB",
        "Top Level Domain": "uz",
        "FIPS": "UZ",
        "ISO Numeric": 860,
        "GeoNameID": 1512440,
        "E164": 998,
        "Phone Code": 998,
        "Continent": "Asia",
        "Capital": "Tashkent",
        "Time Zone in Capital": "Asia/Tashkent",
        "Currency": "Som",
        "Language Codes": "uz,ru,tg",
        "Languages": "Uzbek (official) 74.3%, Russian 14.2%, Tajik 4.4%, other 7.1%",
        "Area KM2": 447400,
        "Internet Hosts": 56075,
        "Internet Users": 4689000,
        "Phones (Mobile)": 20274000,
        "Phones (Landline)": 1963000,
        "GDP": 55180000000
    },
    {
        "Country Name": "Vanuatu",
        "ISO2": "VU",
        "ISO3": "VUT",
        "Top Level Domain": "vu",
        "FIPS": "NH",
        "ISO Numeric": 548,
        "GeoNameID": 2134431,
        "E164": 678,
        "Phone Code": 678,
        "Continent": "Oceania",
        "Capital": "Port Vila",
        "Time Zone in Capital": "Pacific/Efate",
        "Currency": "Vatu",
        "Language Codes": "bi,en-VU,fr-VU",
        "Languages": "local languages (more than 100) 63.2%, Bislama (official; creole) 33.7%, English (official) 2%, French (official) 0.6%, other 0.5% (2009 est.)",
        "Area KM2": 12200,
        "Internet Hosts": 5655,
        "Internet Users": 17000,
        "Phones (Mobile)": 137000,
        "Phones (Landline)": 5800,
        "GDP": 828000000
    },
    {
        "Country Name": "Vatican",
        "ISO2": "VA",
        "ISO3": "VAT",
        "Top Level Domain": "va",
        "FIPS": "VT",
        "ISO Numeric": 336,
        "GeoNameID": 3164670,
        "E164": 39,
        "Phone Code": 379,
        "Continent": "Europe",
        "Capital": "Vatican City",
        "Time Zone in Capital": "Europe/Rome",
        "Currency": "Euro",
        "Language Codes": "la,it,fr",
        "Languages": "Latin, Italian, French",
        "Area KM2": 0,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Venezuela",
        "ISO2": "VE",
        "ISO3": "VEN",
        "Top Level Domain": "ve",
        "FIPS": "VE",
        "ISO Numeric": 862,
        "GeoNameID": 3625428,
        "E164": 58,
        "Phone Code": 58,
        "Continent": "South America",
        "Capital": "Caracas",
        "Time Zone in Capital": "America/Caracas",
        "Currency": "Bolivar",
        "Language Codes": "es-VE",
        "Languages": "Spanish (official), numerous indigenous dialects",
        "Area KM2": 912050,
        "Internet Hosts": 1016000,
        "Internet Users": 8918000,
        "Phones (Mobile)": 30520000,
        "Phones (Landline)": 7650000,
        "GDP": 367500000000
    },
    {
        "Country Name": "Vietnam",
        "ISO2": "VN",
        "ISO3": "VNM",
        "Top Level Domain": "vn",
        "FIPS": "VM",
        "ISO Numeric": 704,
        "GeoNameID": 1562822,
        "E164": 84,
        "Phone Code": 84,
        "Continent": "Asia",
        "Capital": "Hanoi",
        "Time Zone in Capital": "Asia/Ho_Chi_Minh",
        "Currency": "Dong",
        "Language Codes": "vi,en,fr,zh,km",
        "Languages": "Vietnamese (official), English (increasingly favored as a second language), some French, Chinese, and Khmer, mountain area languages (Mon-Khmer and Malayo-Polynesian)",
        "Area KM2": 329560,
        "Internet Hosts": 189553,
        "Internet Users": 23382000,
        "Phones (Mobile)": 134066000,
        "Phones (Landline)": 10191000,
        "GDP": 170000000000
    },
    {
        "Country Name": "Wallis and Futuna",
        "ISO2": "WF",
        "ISO3": "WLF",
        "Top Level Domain": "wf",
        "FIPS": "WF",
        "ISO Numeric": 876,
        "GeoNameID": 4034749,
        "E164": 681,
        "Phone Code": 681,
        "Continent": "Oceania",
        "Capital": "Mata Utu",
        "Time Zone in Capital": "Pacific/Wallis",
        "Currency": "Franc",
        "Language Codes": "wls,fud,fr-WF",
        "Languages": "Wallisian (indigenous Polynesian language) 58.9%, Futunian 30.1%, French (official) 10.8%, other 0.2% (2003 census)",
        "Area KM2": 274,
        "Internet Hosts": 2760,
        "Internet Users": 1300,
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Western Sahara",
        "ISO2": "EH",
        "ISO3": "ESH",
        "Top Level Domain": "eh",
        "FIPS": "WI",
        "ISO Numeric": 732,
        "GeoNameID": 2461445,
        "E164": 212,
        "Phone Code": 212,
        "Continent": "Africa",
        "Capital": "El-Aaiun",
        "Time Zone in Capital": "Africa/El_Aaiun",
        "Currency": "Dirham",
        "Language Codes": "ar,mey",
        "Languages": "Standard Arabic (national), Hassaniya Arabic, Moroccan Arabic",
        "Area KM2": 266000,
        "Internet Hosts": "",
        "Internet Users": "",
        "Phones (Mobile)": "",
        "Phones (Landline)": "",
        "GDP": ""
    },
    {
        "Country Name": "Yemen",
        "ISO2": "YE",
        "ISO3": "YEM",
        "Top Level Domain": "ye",
        "FIPS": "YM",
        "ISO Numeric": 887,
        "GeoNameID": 69543,
        "E164": 967,
        "Phone Code": 967,
        "Continent": "Asia",
        "Capital": "Sanaa",
        "Time Zone in Capital": "Asia/Aden",
        "Currency": "Rial",
        "Language Codes": "ar-YE",
        "Languages": "Arabic (official)",
        "Area KM2": 527970,
        "Internet Hosts": 33206,
        "Internet Users": 2349000,
        "Phones (Mobile)": 13900000,
        "Phones (Landline)": 1100000,
        "GDP": 43890000000
    },
    {
        "Country Name": "Zambia",
        "ISO2": "ZM",
        "ISO3": "ZMB",
        "Top Level Domain": "zm",
        "FIPS": "ZA",
        "ISO Numeric": 894,
        "GeoNameID": 895949,
        "E164": 260,
        "Phone Code": 260,
        "Continent": "Africa",
        "Capital": "Lusaka",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Kwacha",
        "Language Codes": "en-ZM,bem,loz,lun,lue,ny,toi",
        "Languages": "Bembe 33.4%, Nyanja 14.7%, Tonga 11.4%, Lozi 5.5%, Chewa 4.5%, Nsenga 2.9%, Tumbuka 2.5%, Lunda (North Western) 1.9%, Kaonde 1.8%, Lala 1.8%, Lamba 1.8%, English (official) 1.7%, Luvale 1.5%, Mambwe 1.3%, Namwanga 1.2%, Lenje 1.1%, Bisa 1%, other 9.2%, unspecified 0.4%",
        "Area KM2": 752614,
        "Internet Hosts": 16571,
        "Internet Users": 816200,
        "Phones (Mobile)": 10525000,
        "Phones (Landline)": 82500,
        "GDP": 22240000000
    },
    {
        "Country Name": "Zimbabwe",
        "ISO2": "ZW",
        "ISO3": "ZWE",
        "Top Level Domain": "zw",
        "FIPS": "ZI",
        "ISO Numeric": 716,
        "GeoNameID": 878675,
        "E164": 263,
        "Phone Code": 263,
        "Continent": "Africa",
        "Capital": "Harare",
        "Time Zone in Capital": "Africa/Maputo",
        "Currency": "Dollar",
        "Language Codes": "en-ZW,sn,nr,nd",
        "Languages": "English (official), Shona, Sindebele (the language of the Ndebele, sometimes called Ndebele), numerous but minor tribal dialects",
        "Area KM2": 390580,
        "Internet Hosts": 30615,
        "Internet Users": 1423000,
        "Phones (Mobile)": 12614000,
        "Phones (Landline)": 301600,
        "GDP": 10480000000
    }
]
},{}],44:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var countries_json_1 = __importDefault(require("./countries.json"));
var axios_1 = __importDefault(require("axios"));
var phoneButtons = document.querySelectorAll(".modal--phone-button");
var phoneModals = document.querySelectorAll(".modal--phone");
var phoneLabels = document.querySelectorAll(".values--phone");
var readOnlyPhoneInput = document.querySelector(".phone-input.readonly");
var amanacardNumber = document.getElementById("cardNumber");
var phoneNumberHiddenInput = document.querySelector('input[name="newPhoneNumber"]');
var getCountryCode = function (countryName) {
    var country = countries_json_1.default.find(function (country) { return country["Country Name"].toLowerCase() === countryName.toLowerCase(); });
    return country ? country["ISO2"] : "";
};
var updatePhoneNumber = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, exception_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                if (!(phoneNumberHiddenInput && payload.newNumber !== null && payload.newNumber !== undefined)) return [3, 1];
                phoneNumberHiddenInput.value = payload.newNumber;
                return [2, {
                        success: true,
                        message: "Phone number updated successfully."
                    }];
            case 1: return [4, axios_1.default.post("/api/recipients/updateRecipientPhoneNumber", payload)];
            case 2:
                response = _a.sent();
                return [2, response.data];
            case 3: return [3, 5];
            case 4:
                exception_1 = _a.sent();
                console.error(exception_1);
                return [2, {
                        success: false,
                        message: "An error occurred while updating the phone number."
                    }];
            case 5: return [2];
        }
    });
}); };
if (phoneButtons.length > 0 && phoneModals.length > 0 && phoneButtons.length === phoneModals.length) {
    phoneButtons.forEach(function (button, index) {
        button.addEventListener("click", function (e) {
            phoneModals[index].classList.add("active");
            readOnlyPhoneInput.dispatchEvent(new Event('input'));
        });
    });
    phoneModals.forEach(function (modal) {
        var _a = modal.dataset, allowedCountry = _a.allowedCountry, currentNumber = _a.currentNumber, successMessage = _a.successMessage, errorMessage = _a.errorMessage, loadingMessage = _a.loadingMessage, uid = _a.uid;
        var modalButton = modal.querySelector(".modal-button");
        var oldButtonHtml = modalButton.innerHTML;
        var closeButton = modal.querySelector(".close");
        var isLoading = false;
        var newNumber = null;
        var resetButton = function () {
            modalButton.innerHTML = oldButtonHtml;
            modalButton.disabled = false;
        };
        modal.addEventListener("click", function (event) {
            if (event.target === modal) {
                modal.classList.remove("active");
            }
        });
        if (closeButton) {
            closeButton.addEventListener("click", function () {
                modal.classList.remove("active");
            });
        }
        var phoneInputs = modal.querySelectorAll(".phone-input");
        phoneInputs.forEach(function (input) {
            var iti = window.intlTelInput(input, {
                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.4/build/js/utils.js",
                autoHideDialCode: false,
                nationalMode: false
            });
            iti.setCountry(getCountryCode(allowedCountry));
            if (input.classList.contains('readonly')) {
                input.disabled = true;
                input.value = currentNumber;
                input.dispatchEvent(new Event('input'));
            }
            input.addEventListener('input', function () {
                newNumber = iti.getNumber();
                modalButton.disabled = !iti.isValidNumber();
            });
            var updateUI = function (success) {
                if (success === void 0) { success = null; }
                input.disabled = isLoading;
                if (isLoading) {
                    modalButton.disabled = true;
                    modalButton.textContent = loadingMessage;
                    input.classList.add("readonly");
                }
                else if (success === true) {
                    modalButton.textContent = successMessage;
                    input.disabled = true;
                    input.classList.add("readonly");
                    phoneLabels.forEach(function (label) {
                        label.textContent = newNumber;
                    });
                    setTimeout(function () {
                        modal.classList.remove("active");
                        phoneInputs.forEach(function (input) {
                            input.value = newNumber;
                        });
                        resetButton();
                    }, 2500);
                }
                else if (success === false) {
                    modalButton.textContent = errorMessage;
                    input.disabled = true;
                    input.classList.add("readonly");
                    setTimeout(function () {
                        modal.classList.remove("active");
                        resetButton();
                    }, 2500);
                }
            };
            modalButton.addEventListener("click", function () { return __awaiter(void 0, void 0, void 0, function () {
                var payload, response;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (isLoading)
                                return [2];
                            isLoading = true;
                            updateUI();
                            payload = {
                                uid: parseInt(uid),
                                newNumber: newNumber,
                                amanacardNumber: (_a = amanacardNumber === null || amanacardNumber === void 0 ? void 0 : amanacardNumber.textContent.trim()) !== null && _a !== void 0 ? _a : ""
                            };
                            return [4, updatePhoneNumber(payload)];
                        case 1:
                            response = _b.sent();
                            isLoading = false;
                            updateUI(response.success);
                            return [2];
                    }
                });
            }); });
        });
    });
}
},{"./countries.json":43,"axios":52}],45:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
},{}],46:[function(require,module,exports){
var video = document.querySelector(".quote__video");
var alreadyActive = false;
if (video) {
    var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && !alreadyActive) {
                video.play();
                alreadyActive = true;
            }
        });
    }, { threshold: 0.5 });
    observer.observe(video);
}
},{}],47:[function(require,module,exports){
var registerAccountType = document.querySelector(".register__wrapper");
var registerAccountTypeLink = document.querySelector(".register__link");
if (registerAccountType) {
    var registerAccountTypeCards_1 = document.querySelectorAll(".register__card");
    var resetRegisterCards_1 = function () {
        registerAccountTypeCards_1.forEach(function (card) {
            card.classList.remove("register__card--active");
        });
    };
    var setActiveCard_1 = function (item) {
        resetRegisterCards_1();
        item.classList.add("register__card--active");
        registerAccountTypeLink.href = item.getAttribute("data-link");
    };
    if (registerAccountTypeCards_1.length > 0) {
        var firstCardLink = registerAccountTypeCards_1[0].getAttribute("data-link");
        registerAccountTypeCards_1[0].classList.add("register__card--active");
        registerAccountTypeLink.href = firstCardLink;
        registerAccountTypeCards_1.forEach(function (card) {
            card.addEventListener("click", function () {
                setActiveCard_1(card);
            });
            card.addEventListener("keydown", function (e) {
                var keyboardEvent = e;
                if (keyboardEvent.key === "Enter") {
                    setActiveCard_1(card);
                }
            });
        });
    }
}
},{}],48:[function(require,module,exports){
var sendFundsOverlay = document.querySelector(".send-funds__overlay");
if (sendFundsOverlay) {
    var sendFundsCards = document.querySelectorAll(".send-funds__card");
    var sendFundsNested_1 = document.querySelectorAll(".send-funds__nested");
    var sendFundsMain_1 = document.querySelector(".send-funds__main");
    var sendFundsBack = document.querySelector(".send-funds__back");
    var sendFundsCloseButton = document.querySelector(".send-funds__close");
    var sendFundsCloseButtonMobile = document.querySelector(".send-funds__close-mobile");
    var sendFundsShareButton_1 = document.querySelector(".send-funds__share");
    var sendFundsBackButton_1 = document.querySelector(".send-funds__back");
    var sendFundsButtons_1 = document.querySelector(".send-funds__buttons");
    var mobileMenu_1 = document.querySelector(".menu-mobile__overlay");
    var menuMobileIcon_1 = document.querySelector(".menu-mobile__icon");
    var htmlEl_1 = document.documentElement;
    var closeSendFunds_1 = function () {
        sendFundsOverlay.classList.remove("send-funds__overlay--active");
        htmlEl_1.style.overflow = "auto";
        setTimeout(function () {
            sendFundsNested_1.forEach(function (item) {
                item.classList.remove("send-funds__nested--active");
            });
            sendFundsMain_1.classList.remove("send-funds__main--hidden");
            sendFundsButtons_1.classList.remove("send-funds__buttons--border");
            sendFundsBackButton_1.classList.remove("send-funds__back--active");
            sendFundsShareButton_1.classList.remove("send-funds__share--active");
        }, 500);
    };
    var openSendFunds_1 = function (index) {
        if (mobileMenu_1 === null || mobileMenu_1 === void 0 ? void 0 : mobileMenu_1.classList.contains("menu-mobile__overlay--active")) {
            mobileMenu_1.classList.remove("menu-mobile__overlay--active");
            menuMobileIcon_1.classList.remove("menu-mobile__icon--open");
        }
        sendFundsMain_1.classList.add("send-funds__main--hidden");
        sendFundsNested_1[index].classList.add("send-funds__nested--active");
        sendFundsButtons_1.classList.add("send-funds__buttons--border");
        sendFundsBackButton_1.classList.add("send-funds__back--active");
        sendFundsShareButton_1.classList.add("send-funds__share--active");
    };
    var goBackFunds_1 = function () {
        sendFundsNested_1.forEach(function (item) {
            item.classList.remove("send-funds__nested--active");
        });
        sendFundsMain_1.classList.remove("send-funds__main--hidden");
        sendFundsButtons_1.classList.remove("send-funds__buttons--border");
        sendFundsBackButton_1.classList.remove("send-funds__back--active");
        sendFundsShareButton_1.classList.remove("send-funds__share--active");
    };
    if (sendFundsCards.length > 0) {
        sendFundsCards.forEach(function (card, i) {
            card.addEventListener("click", function () { return openSendFunds_1(i); });
        });
        sendFundsCards.forEach(function (card, i) {
            card.addEventListener("keydown", function (e) {
                var keyboardEvent = e;
                if (keyboardEvent.key === "Enter") {
                    openSendFunds_1(i);
                }
            });
        });
    }
    if (sendFundsBack) {
        sendFundsBack.addEventListener("click", function () { return goBackFunds_1(); });
    }
    if (sendFundsCloseButton) {
        sendFundsCloseButton.addEventListener("click", closeSendFunds_1);
    }
    if (sendFundsCloseButtonMobile) {
        sendFundsCloseButtonMobile.addEventListener("click", closeSendFunds_1);
    }
    if (sendFundsOverlay) {
        sendFundsOverlay.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                closeSendFunds_1();
            }
        });
        sendFundsOverlay.addEventListener("click", function (e) {
            var targetElement = e.target;
            if (targetElement.classList.contains("send-funds__overlay--active")) {
                closeSendFunds_1();
            }
        });
    }
}
},{}],49:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = __importDefault(require("@glidejs/glide"));
var teamGridCarousels = document.querySelectorAll(".team-grid__carousel-inner");
var teamGridComponents;
if (window.innerWidth > 480) {
    teamGridComponents = document.querySelectorAll(".team-grid__grid");
}
else {
    teamGridComponents = document.querySelectorAll(".team-grid__carousel");
}
if (teamGridCarousels.length > 0) {
    var setRangeMax_1 = function (arr, input) {
        var slidesLength = arr.length;
        var rangeMax = (slidesLength - 2).toString();
        input.max = rangeMax;
        setRangeThumbWidth_1(rangeMax, input);
    };
    var setRangeThumbWidth_1 = function (max, input) {
        var width = 200 / +max;
        input.style.setProperty('--thumb-size', width.toString() + "px");
        if (max === "1") {
            input.style.setProperty('--thumb-size', "100px");
        }
    };
    teamGridCarousels.forEach(function (item) {
        var glide = new glide_1.default(item, {
            type: 'slider',
            perView: 1.7,
            gap: 10,
            rewind: true,
            bound: true,
            breakpoints: {
                480: {
                    perView: 2.065,
                },
            }
        });
        glide.mount();
        var carouselRange = item.querySelector(".team-grid__carousel-range");
        var slides = item.querySelectorAll(".team-grid__card");
        carouselRange.addEventListener("input", function (e) {
            setTimeout(function () {
                glide.go("=".concat(carouselRange.value));
            }, 500);
        });
        glide.on('move.after', function () {
            var currentIndex = glide.index;
            carouselRange.value = currentIndex.toString();
        });
        setRangeMax_1(slides, carouselRange);
    });
}
if (teamGridComponents.length > 0) {
    teamGridComponents.forEach(function (item) {
        var teamGridCards = item.querySelectorAll(".team-grid__card");
        var teamGridModals = item.querySelectorAll(".team-grid__modal");
        teamGridCards.forEach(function (card, i) {
            card.addEventListener("click", function () {
                modalIndex = i;
                var modal = teamGridModals[modalIndex];
                modal.showModal();
                setActiveModal(modal);
                attachModalEventListeners();
            });
            var activeModal = null;
            var modalIndex = 0;
            var handlePrev = function (modals, index) {
                closeAllModals();
                if (index === 0) {
                    modalIndex = modals.length - 1;
                }
                else {
                    modalIndex--;
                }
                var newModal = modals[modalIndex];
                setActiveModal(newModal);
                newModal === null || newModal === void 0 ? void 0 : newModal.showModal();
            };
            var handleNext = function (modals, index) {
                closeAllModals();
                if (index === modals.length - 1) {
                    modalIndex = 0;
                }
                else {
                    modalIndex++;
                }
                var newModal = modals[modalIndex];
                setActiveModal(newModal);
                newModal === null || newModal === void 0 ? void 0 : newModal.showModal();
            };
            var attachModalEventListeners = function () {
                var modalPrevButton = activeModal === null || activeModal === void 0 ? void 0 : activeModal.querySelector(".team-grid__modal-prev");
                var modalNextButton = activeModal === null || activeModal === void 0 ? void 0 : activeModal.querySelector(".team-grid__modal-next");
                var modalCloseButton = activeModal === null || activeModal === void 0 ? void 0 : activeModal.querySelector(".team-grid__modal-close");
                modalCloseButton.blur();
                activeModal.focus();
                modalCloseButton.addEventListener("click", function () { return activeModal === null || activeModal === void 0 ? void 0 : activeModal.close(); });
                activeModal.addEventListener("click", function (e) {
                    var target = e.target;
                    if (target.classList.contains("team-grid__modal")) {
                        activeModal.close();
                    }
                });
                modalPrevButton === null || modalPrevButton === void 0 ? void 0 : modalPrevButton.removeEventListener("click", handlePrevEvent);
                modalNextButton === null || modalNextButton === void 0 ? void 0 : modalNextButton.removeEventListener("click", handleNextEvent);
                modalPrevButton === null || modalPrevButton === void 0 ? void 0 : modalPrevButton.addEventListener("click", handlePrevEvent);
                modalNextButton === null || modalNextButton === void 0 ? void 0 : modalNextButton.addEventListener("click", handleNextEvent);
            };
            var handlePrevEvent = function () {
                handlePrev(teamGridModals, modalIndex);
                var prevButton = activeModal === null || activeModal === void 0 ? void 0 : activeModal.querySelector(".team-grid__modal-prev");
                prevButton.focus();
            };
            var handleNextEvent = function () {
                handleNext(teamGridModals, modalIndex);
                var nextButton = activeModal === null || activeModal === void 0 ? void 0 : activeModal.querySelector(".team-grid__modal-next");
                nextButton.focus();
            };
            var onActiveModalChange = function () {
                attachModalEventListeners();
            };
            var setActiveModal = function (modal) {
                activeModal = modal;
                onActiveModalChange();
            };
            var closeAllModals = function () {
                teamGridModals.forEach(function (modal) {
                    modal.close();
                });
            };
        });
    });
}
},{"@glidejs/glide":51}],50:[function(require,module,exports){
var transferSummaryComponent = document.querySelector(".transfer-summary__wrapper");
if (transferSummaryComponent) {
    var transferSummaryLeft_1 = transferSummaryComponent.querySelector(".transfer-summary__left");
    var transferSummaryNextButton = transferSummaryComponent.querySelector(".transfer-summary__button");
    var showTransferSummary_1 = function () {
        var _a;
        transferSummaryLeft_1.classList.remove("transfer-summary__left--active");
        var currentPayoutMethod = document.querySelector("input[name='payment-method']:checked").value;
        (_a = document.querySelector(".transfer-summary__right[data-type='".concat(currentPayoutMethod, "']"))) === null || _a === void 0 ? void 0 : _a.classList.add("transfer-summary__right--active");
        document.querySelector;
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    transferSummaryNextButton.addEventListener("click", function () {
        showTransferSummary_1();
    });
}
},{}],51:[function(require,module,exports){
/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Glide = factory());
})(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  var defaults = {
    /**
     * Type of the movement.
     *
     * Available types:
     * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
     * `carousel` - Changes slides without starting over when it reaches the first or last slide.
     *
     * @type {String}
     */
    type: 'slider',

    /**
     * Start at specific slide number defined with zero-based index.
     *
     * @type {Number}
     */
    startAt: 0,

    /**
     * A number of slides visible on the single viewport.
     *
     * @type {Number}
     */
    perView: 1,

    /**
     * Focus currently active slide at a specified position in the track.
     *
     * Available inputs:
     * `center` - Current slide will be always focused at the center of a track.
     * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
     *
     * @type {String|Number}
     */
    focusAt: 0,

    /**
     * A size of the gap added between slides.
     *
     * @type {Number}
     */
    gap: 10,

    /**
     * Change slides after a specified interval. Use `false` for turning off autoplay.
     *
     * @type {Number|Boolean}
     */
    autoplay: false,

    /**
     * Stop autoplay on mouseover event.
     *
     * @type {Boolean}
     */
    hoverpause: true,

    /**
     * Allow for changing slides with left and right keyboard arrows.
     *
     * @type {Boolean}
     */
    keyboard: true,

    /**
     * Stop running `perView` number of slides from the end. Use this
     * option if you don't want to have an empty space after
     * a slider. Works only with `slider` type and a
     * non-centered `focusAt` setting.
     *
     * @type {Boolean}
     */
    bound: false,

    /**
     * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
     *
     * @type {Number|Boolean}
     */
    swipeThreshold: 80,

    /**
     * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
     *
     * @type {Number|Boolean}
     */
    dragThreshold: 120,

    /**
     * A number of slides moved on single swipe.
     *
     * Available types:
     * `` - Moves slider by one slide per swipe
     * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
     *
     * @type {String}
     */
    perSwipe: '',

    /**
     * Moving distance ratio of the slides on a swiping and dragging.
     *
     * @type {Number}
     */
    touchRatio: 0.5,

    /**
     * Angle required to activate slides moving on swiping or dragging.
     *
     * @type {Number}
     */
    touchAngle: 45,

    /**
     * Duration of the animation in milliseconds.
     *
     * @type {Number}
     */
    animationDuration: 400,

    /**
     * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
     *
     * @type {Boolean}
     */
    rewind: true,

    /**
     * Duration of the rewinding animation of the `slider` type in milliseconds.
     *
     * @type {Number}
     */
    rewindDuration: 800,

    /**
     * Easing function for the animation.
     *
     * @type {String}
     */
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

    /**
     * Wait for the animation to finish until the next user input can be processed
     *
     * @type {boolean}
     */
    waitForTransition: true,

    /**
     * Throttle costly events at most once per every wait milliseconds.
     *
     * @type {Number}
     */
    throttle: 10,

    /**
     * Moving direction mode.
     *
     * Available inputs:
     * - 'ltr' - left to right movement,
     * - 'rtl' - right to left movement.
     *
     * @type {String}
     */
    direction: 'ltr',

    /**
     * The distance value of the next and previous viewports which
     * have to peek in the current view. Accepts number and
     * pixels as a string. Left and right peeking can be
     * set up separately with a directions object.
     *
     * For example:
     * `100` - Peek 100px on the both sides.
     * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
     *
     * @type {Number|String|Object}
     */
    peek: 0,

    /**
     * Defines how many clones of current viewport will be generated.
     *
     * @type {Number}
     */
    cloningRatio: 1,

    /**
     * Collection of options applied at specified media breakpoints.
     * For example: display two slides per view under 800px.
     * `{
     *   '800px': {
     *     perView: 2
     *   }
     * }`
     */
    breakpoints: {},

    /**
     * Collection of internally used HTML classes.
     *
     * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
     * @type {Object}
     */
    classes: {
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
      },
      type: {
        slider: 'glide--slider',
        carousel: 'glide--carousel'
      },
      slide: {
        clone: 'glide__slide--clone',
        active: 'glide__slide--active'
      },
      arrow: {
        disabled: 'glide__arrow--disabled'
      },
      nav: {
        active: 'glide__bullet--active'
      }
    }
  };

  /**
   * Outputs warning message to the bowser console.
   *
   * @param  {String} msg
   * @return {Void}
   */
  function warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
  }

  /**
   * Converts value entered as number
   * or string to integer value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toInt(value) {
    return parseInt(value);
  }
  /**
   * Converts value entered as number
   * or string to flat value.
   *
   * @param {String} value
   * @returns {Number}
   */

  function toFloat(value) {
    return parseFloat(value);
  }
  /**
   * Indicates whether the specified value is a string.
   *
   * @param  {*}   value
   * @return {Boolean}
   */

  function isString(value) {
    return typeof value === 'string';
  }
  /**
   * Indicates whether the specified value is an object.
   *
   * @param  {*} value
   * @return {Boolean}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function isObject(value) {
    var type = _typeof(value);

    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
  }
  /**
   * Indicates whether the specified value is a function.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  /**
   * Indicates whether the specified value is undefined.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Indicates whether the specified value is an array.
   *
   * @param  {*} value
   * @return {Boolean}
   */

  function isArray(value) {
    return value.constructor === Array;
  }

  /**
   * Creates and initializes specified collection of extensions.
   * Each extension receives access to instance of glide and rest of components.
   *
   * @param {Object} glide
   * @param {Object} extensions
   *
   * @returns {Object}
   */

  function mount(glide, extensions, events) {
    var components = {};

    for (var name in extensions) {
      if (isFunction(extensions[name])) {
        components[name] = extensions[name](glide, components, events);
      } else {
        warn('Extension must be a function');
      }
    }

    for (var _name in components) {
      if (isFunction(components[_name].mount)) {
        components[_name].mount();
      }
    }

    return components;
  }

  /**
   * Defines getter and setter property on the specified object.
   *
   * @param  {Object} obj         Object where property has to be defined.
   * @param  {String} prop        Name of the defined property.
   * @param  {Object} definition  Get and set definitions for the property.
   * @return {Void}
   */
  function define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
  }
  /**
   * Sorts aphabetically object keys.
   *
   * @param  {Object} obj
   * @return {Object}
   */

  function sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function (r, k) {
      r[k] = obj[k];
      return r[k], r;
    }, {});
  }
  /**
   * Merges passed settings object with default options.
   *
   * @param  {Object} defaults
   * @param  {Object} settings
   * @return {Object}
   */

  function mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.

    if (settings.hasOwnProperty('classes')) {
      options.classes = Object.assign({}, defaults.classes, settings.classes);
      var properties = ['direction', 'type', 'slide', 'arrow', 'nav'];
      properties.forEach(function (property) {
        if (settings.classes.hasOwnProperty(property)) {
          options.classes[property] = _objectSpread2(_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
        }
      });
    }

    if (settings.hasOwnProperty('breakpoints')) {
      options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    }

    return options;
  }

  var EventsBus = /*#__PURE__*/function () {
    /**
     * Construct a EventBus instance.
     *
     * @param {Object} events
     */
    function EventsBus() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBus);

      this.events = events;
      this.hop = events.hasOwnProperty;
    }
    /**
     * Adds listener to the specifed event.
     *
     * @param {String|Array} event
     * @param {Function} handler
     */


    _createClass(EventsBus, [{
      key: "on",
      value: function on(event, handler) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.on(event[i], handler);
          }

          return;
        } // Create the event's object if not yet created


        if (!this.hop.call(this.events, event)) {
          this.events[event] = [];
        } // Add the handler to queue


        var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event

        return {
          remove: function remove() {
            delete this.events[event][index];
          }
        };
      }
      /**
       * Runs registered handlers for specified event.
       *
       * @param {String|Array} event
       * @param {Object=} context
       */

    }, {
      key: "emit",
      value: function emit(event, context) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.emit(event[i], context);
          }

          return;
        } // If the event doesn't exist, or there's no handlers in queue, just leave


        if (!this.hop.call(this.events, event)) {
          return;
        } // Cycle through events queue, fire!


        this.events[event].forEach(function (item) {
          item(context || {});
        });
      }
    }]);

    return EventsBus;
  }();

  var Glide$1 = /*#__PURE__*/function () {
    /**
     * Construct glide.
     *
     * @param  {String} selector
     * @param  {Object} options
     */
    function Glide(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Glide);

      this._c = {};
      this._t = [];
      this._e = new EventsBus();
      this.disabled = false;
      this.selector = selector;
      this.settings = mergeOptions(defaults, options);
      this.index = this.settings.startAt;
    }
    /**
     * Initializes glide.
     *
     * @param {Object} extensions Collection of extensions to initialize.
     * @return {Glide}
     */


    _createClass(Glide, [{
      key: "mount",
      value: function mount$1() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._e.emit('mount.before');

        if (isObject(extensions)) {
          this._c = mount(this, extensions, this._e);
        } else {
          warn('You need to provide a object on `mount()`');
        }

        this._e.emit('mount.after');

        return this;
      }
      /**
       * Collects an instance `translate` transformers.
       *
       * @param  {Array} transformers Collection of transformers.
       * @return {Void}
       */

    }, {
      key: "mutate",
      value: function mutate() {
        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (isArray(transformers)) {
          this._t = transformers;
        } else {
          warn('You need to provide a array on `mutate()`');
        }

        return this;
      }
      /**
       * Updates glide with specified settings.
       *
       * @param {Object} settings
       * @return {Glide}
       */

    }, {
      key: "update",
      value: function update() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.settings = mergeOptions(this.settings, settings);

        if (settings.hasOwnProperty('startAt')) {
          this.index = settings.startAt;
        }

        this._e.emit('update');

        return this;
      }
      /**
       * Change slide with specified pattern. A pattern must be in the special format:
       * `>` - Move one forward
       * `<` - Move one backward
       * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
       * `>>` - Rewinds to end (last slide)
       * `<<` - Rewinds to start (first slide)
       * `|>` - Move one viewport forward
       * `|<` - Move one viewport backward
       *
       * @param {String} pattern
       * @return {Glide}
       */

    }, {
      key: "go",
      value: function go(pattern) {
        this._c.Run.make(pattern);

        return this;
      }
      /**
       * Move track by specified distance.
       *
       * @param {String} distance
       * @return {Glide}
       */

    }, {
      key: "move",
      value: function move(distance) {
        this._c.Transition.disable();

        this._c.Move.make(distance);

        return this;
      }
      /**
       * Destroy instance and revert all changes done by this._c.
       *
       * @return {Glide}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._e.emit('destroy');

        return this;
      }
      /**
       * Start instance autoplaying.
       *
       * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Glide}
       */

    }, {
      key: "play",
      value: function play() {
        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (interval) {
          this.settings.autoplay = interval;
        }

        this._e.emit('play');

        return this;
      }
      /**
       * Stop instance autoplaying.
       *
       * @return {Glide}
       */

    }, {
      key: "pause",
      value: function pause() {
        this._e.emit('pause');

        return this;
      }
      /**
       * Sets glide into a idle status.
       *
       * @return {Glide}
       */

    }, {
      key: "disable",
      value: function disable() {
        this.disabled = true;
        return this;
      }
      /**
       * Sets glide into a active status.
       *
       * @return {Glide}
       */

    }, {
      key: "enable",
      value: function enable() {
        this.disabled = false;
        return this;
      }
      /**
       * Adds cuutom event listener with handler.
       *
       * @param  {String|Array} event
       * @param  {Function} handler
       * @return {Glide}
       */

    }, {
      key: "on",
      value: function on(event, handler) {
        this._e.on(event, handler);

        return this;
      }
      /**
       * Checks if glide is a precised type.
       *
       * @param  {String} name
       * @return {Boolean}
       */

    }, {
      key: "isType",
      value: function isType(name) {
        return this.settings.type === name;
      }
      /**
       * Gets value of the core options.
       *
       * @return {Object}
       */

    }, {
      key: "settings",
      get: function get() {
        return this._o;
      }
      /**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */
      ,
      set: function set(o) {
        if (isObject(o)) {
          this._o = o;
        } else {
          warn('Options must be an `object` instance.');
        }
      }
      /**
       * Gets current index of the slider.
       *
       * @return {Object}
       */

    }, {
      key: "index",
      get: function get() {
        return this._i;
      }
      /**
       * Sets current index a slider.
       *
       * @return {Object}
       */
      ,
      set: function set(i) {
        this._i = toInt(i);
      }
      /**
       * Gets type name of the slider.
       *
       * @return {String}
       */

    }, {
      key: "type",
      get: function get() {
        return this.settings.type;
      }
      /**
       * Gets value of the idle status.
       *
       * @return {Boolean}
       */

    }, {
      key: "disabled",
      get: function get() {
        return this._d;
      }
      /**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */
      ,
      set: function set(status) {
        this._d = !!status;
      }
    }]);

    return Glide;
  }();

  function Run (Glide, Components, Events) {
    var Run = {
      /**
       * Initializes autorunning of the glide.
       *
       * @return {Void}
       */
      mount: function mount() {
        this._o = false;
      },

      /**
       * Makes glides running based on the passed moving schema.
       *
       * @param {String} move
       */
      make: function make(move) {
        var _this = this;

        if (!Glide.disabled) {
          !Glide.settings.waitForTransition || Glide.disable();
          this.move = move;
          Events.emit('run.before', this.move);
          this.calculate();
          Events.emit('run', this.move);
          Components.Transition.after(function () {
            if (_this.isStart()) {
              Events.emit('run.start', _this.move);
            }

            if (_this.isEnd()) {
              Events.emit('run.end', _this.move);
            }

            if (_this.isOffset()) {
              _this._o = false;
              Events.emit('run.offset', _this.move);
            }

            Events.emit('run.after', _this.move);
            Glide.enable();
          });
        }
      },

      /**
       * Calculates current index based on defined move.
       *
       * @return {Number|Undefined}
       */
      calculate: function calculate() {
        var move = this.move,
            length = this.length;
        var steps = move.steps,
            direction = move.direction; // By default assume that size of view is equal to one slide

        var viewSize = 1; // While direction is `=` we want jump to
        // a specified index described in steps.

        if (direction === '=') {
          // Check if bound is true, 
          // as we want to avoid whitespaces.
          if (Glide.settings.bound && toInt(steps) > length) {
            Glide.index = length;
            return;
          }

          Glide.index = steps;
          return;
        } // When pattern is equal to `>>` we want
        // fast forward to the last slide.


        if (direction === '>' && steps === '>') {
          Glide.index = length;
          return;
        } // When pattern is equal to `<<` we want
        // fast forward to the first slide.


        if (direction === '<' && steps === '<') {
          Glide.index = 0;
          return;
        } // pagination movement


        if (direction === '|') {
          viewSize = Glide.settings.perView || 1;
        } // we are moving forward


        if (direction === '>' || direction === '|' && steps === '>') {
          var index = calculateForwardIndex(viewSize);

          if (index > length) {
            this._o = true;
          }

          Glide.index = normalizeForwardIndex(index, viewSize);
          return;
        } // we are moving backward


        if (direction === '<' || direction === '|' && steps === '<') {
          var _index = calculateBackwardIndex(viewSize);

          if (_index < 0) {
            this._o = true;
          }

          Glide.index = normalizeBackwardIndex(_index, viewSize);
          return;
        }

        warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
      },

      /**
       * Checks if we are on the first slide.
       *
       * @return {Boolean}
       */
      isStart: function isStart() {
        return Glide.index <= 0;
      },

      /**
       * Checks if we are on the last slide.
       *
       * @return {Boolean}
       */
      isEnd: function isEnd() {
        return Glide.index >= this.length;
      },

      /**
       * Checks if we are making a offset run.
       *
       * @param {String} direction
       * @return {Boolean}
       */
      isOffset: function isOffset() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        if (!direction) {
          return this._o;
        }

        if (!this._o) {
          return false;
        } // did we view to the right?


        if (direction === '|>') {
          return this.move.direction === '|' && this.move.steps === '>';
        } // did we view to the left?


        if (direction === '|<') {
          return this.move.direction === '|' && this.move.steps === '<';
        }

        return this.move.direction === direction;
      },

      /**
       * Checks if bound mode is active
       *
       * @return {Boolean}
       */
      isBound: function isBound() {
        return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
      }
    };
    /**
     * Returns index value to move forward/to the right
     *
     * @param viewSize
     * @returns {Number}
     */

    function calculateForwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index + viewSize;
      }

      return index + (viewSize - index % viewSize);
    }
    /**
     * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {Number}
     */


    function normalizeForwardIndex(index, viewSize) {
      var length = Run.length;

      if (index <= length) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index - (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on the last possible index value given by bound
        if (Run.isBound() && !Run.isEnd()) {
          return length;
        }

        return 0;
      }

      if (Run.isBound()) {
        return length;
      }

      return Math.floor(length / viewSize) * viewSize;
    }
    /**
     * Calculates index value to move backward/to the left
     *
     * @param viewSize
     * @returns {Number}
     */


    function calculateBackwardIndex(viewSize) {
      var index = Glide.index;

      if (Glide.isType('carousel')) {
        return index - viewSize;
      } // ensure our back navigation results in the same index as a forward navigation
      // to experience a homogeneous paging


      var view = Math.ceil(index / viewSize);
      return (view - 1) * viewSize;
    }
    /**
     * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
     *
     * @param index
     * @param length
     * @param viewSize
     * @returns {*}
     */


    function normalizeBackwardIndex(index, viewSize) {
      var length = Run.length;

      if (index >= 0) {
        return index;
      }

      if (Glide.isType('carousel')) {
        return index + (length + 1);
      }

      if (Glide.settings.rewind) {
        // bound does funny things with the length, therefor we have to be certain
        // that we are on first possible index value before we to rewind to the length given by bound
        if (Run.isBound() && Run.isStart()) {
          return length;
        }

        return Math.floor(length / viewSize) * viewSize;
      }

      return 0;
    }

    define(Run, 'move', {
      /**
       * Gets value of the move schema.
       *
       * @returns {Object}
       */
      get: function get() {
        return this._m;
      },

      /**
       * Sets value of the move schema.
       *
       * @returns {Object}
       */
      set: function set(value) {
        var step = value.substr(1);
        this._m = {
          direction: value.substr(0, 1),
          steps: step ? toInt(step) ? toInt(step) : step : 0
        };
      }
    });
    define(Run, 'length', {
      /**
       * Gets value of the running distance based
       * on zero-indexing number of slides.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;
        var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
        // reduced by `perView` and `focusAt` settings. Running distance
        // should end before creating an empty space after instance.

        if (this.isBound()) {
          return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
        }

        return length - 1;
      }
    });
    define(Run, 'offset', {
      /**
       * Gets status of the offsetting flag.
       *
       * @return {Boolean}
       */
      get: function get() {
        return this._o;
      }
    });
    return Run;
  }

  /**
   * Returns a current time.
   *
   * @return {Number}
   */
  function now() {
    return new Date().getTime();
  }

  /**
   * Returns a function, that, when invoked, will only be triggered
   * at most once during a given window of time.
   *
   * @param {Function} func
   * @param {Number} wait
   * @param {Object=} options
   * @return {Function}
   *
   * @see https://github.com/jashkenas/underscore
   */

  function throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout, context, args, result;
    var previous = 0;

    var later = function later() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function throttled() {
      var at = now();
      if (!previous && options.leading === false) previous = at;
      var remaining = wait - (at - previous);
      context = this;
      args = arguments;

      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        previous = at;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };

    throttled.cancel = function () {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  var MARGIN_TYPE = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft']
  };
  function Gaps (Glide, Components, Events) {
    var Gaps = {
      /**
       * Applies gaps between slides. First and last
       * slides do not receive it's edge margins.
       *
       * @param {HTMLCollection} slides
       * @return {Void}
       */
      apply: function apply(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          var direction = Components.Direction.value;

          if (i !== 0) {
            style[MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][0]] = '';
          }

          if (i !== slides.length - 1) {
            style[MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
          } else {
            style[MARGIN_TYPE[direction][1]] = '';
          }
        }
      },

      /**
       * Removes gaps from the slides.
       *
       * @param {HTMLCollection} slides
       * @returns {Void}
      */
      remove: function remove(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          style.marginLeft = '';
          style.marginRight = '';
        }
      }
    };
    define(Gaps, 'value', {
      /**
       * Gets value of the gap.
       *
       * @returns {Number}
       */
      get: function get() {
        return toInt(Glide.settings.gap);
      }
    });
    define(Gaps, 'grow', {
      /**
       * Gets additional dimensions value caused by gaps.
       * Used to increase width of the slides wrapper.
       *
       * @returns {Number}
       */
      get: function get() {
        return Gaps.value * Components.Sizes.length;
      }
    });
    define(Gaps, 'reductor', {
      /**
       * Gets reduction value caused by gaps.
       * Used to subtract width of the slides.
       *
       * @returns {Number}
       */
      get: function get() {
        var perView = Glide.settings.perView;
        return Gaps.value * (perView - 1) / perView;
      }
    });
    /**
     * Apply calculated gaps:
     * - after building, so slides (including clones) will receive proper margins
     * - on updating via API, to recalculate gaps with new options
     */

    Events.on(['build.after', 'update'], throttle(function () {
      Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
     * Remove gaps:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
  }

  /**
   * Finds siblings nodes of the passed node.
   *
   * @param  {Element} node
   * @return {Array}
   */
  function siblings(node) {
    if (node && node.parentNode) {
      var n = node.parentNode.firstChild;
      var matched = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== node) {
          matched.push(n);
        }
      }

      return matched;
    }

    return [];
  }
  /**
   * Coerces a NodeList to an Array.
   *
   * @param  {NodeList} nodeList
   * @return {Array}
   */

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  var TRACK_SELECTOR = '[data-glide-el="track"]';
  function Html (Glide, Components, Events) {
    var Html = {
      /**
       * Setup slider HTML nodes.
       *
       * @param {Glide} glide
       */
      mount: function mount() {
        this.root = Glide.selector;
        this.track = this.root.querySelector(TRACK_SELECTOR);
        this.collectSlides();
      },

      /**
       * Collect slides
       */
      collectSlides: function collectSlides() {
        this.slides = toArray(this.wrapper.children).filter(function (slide) {
          return !slide.classList.contains(Glide.settings.classes.slide.clone);
        });
      }
    };
    define(Html, 'root', {
      /**
       * Gets node of the glide main element.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._r;
      },

      /**
       * Sets node of the glide main element.
       *
       * @return {Object}
       */
      set: function set(r) {
        if (isString(r)) {
          r = document.querySelector(r);
        }

        if (r !== null) {
          Html._r = r;
        } else {
          warn('Root element must be a existing Html node');
        }
      }
    });
    define(Html, 'track', {
      /**
       * Gets node of the glide track with slides.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._t;
      },

      /**
       * Sets node of the glide track with slides.
       *
       * @return {Object}
       */
      set: function set(t) {
        Html._t = t;
      }
    });
    define(Html, 'wrapper', {
      /**
       * Gets node of the slides wrapper.
       *
       * @return {Object}
       */
      get: function get() {
        return Html.track.children[0];
      }
    });
    /**
     * Add/remove/reorder dynamic slides
     */

    Events.on('update', function () {
      Html.collectSlides();
    });
    return Html;
  }

  function Peek (Glide, Components, Events) {
    var Peek = {
      /**
       * Setups how much to peek based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.peek;
      }
    };
    define(Peek, 'value', {
      /**
       * Gets value of the peek.
       *
       * @returns {Number|Object}
       */
      get: function get() {
        return Peek._v;
      },

      /**
       * Sets value of the peek.
       *
       * @param {Number|Object} value
       * @return {Void}
       */
      set: function set(value) {
        if (isObject(value)) {
          value.before = toInt(value.before);
          value.after = toInt(value.after);
        } else {
          value = toInt(value);
        }

        Peek._v = value;
      }
    });
    define(Peek, 'reductor', {
      /**
       * Gets reduction value caused by peek.
       *
       * @returns {Number}
       */
      get: function get() {
        var value = Peek.value;
        var perView = Glide.settings.perView;

        if (isObject(value)) {
          return value.before / perView + value.after / perView;
        }

        return value * 2 / perView;
      }
    });
    /**
     * Recalculate peeking sizes on:
     * - when resizing window to update to proper percents
     */

    Events.on(['resize', 'update'], function () {
      Peek.mount();
    });
    return Peek;
  }

  function Move (Glide, Components, Events) {
    var Move = {
      /**
       * Constructs move component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        this._o = 0;
      },

      /**
       * Calculates a movement value based on passed offset and currently active index.
       *
       * @param  {Number} offset
       * @return {Void}
       */
      make: function make() {
        var _this = this;

        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.offset = offset;
        Events.emit('move', {
          movement: this.value
        });
        Components.Transition.after(function () {
          Events.emit('move.after', {
            movement: _this.value
          });
        });
      }
    };
    define(Move, 'offset', {
      /**
       * Gets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      get: function get() {
        return Move._o;
      },

      /**
       * Sets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      set: function set(value) {
        Move._o = !isUndefined(value) ? toInt(value) : 0;
      }
    });
    define(Move, 'translate', {
      /**
       * Gets a raw movement value.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Sizes.slideWidth * Glide.index;
      }
    });
    define(Move, 'value', {
      /**
       * Gets an actual movement value corrected by offset.
       *
       * @return {Number}
       */
      get: function get() {
        var offset = this.offset;
        var translate = this.translate;

        if (Components.Direction.is('rtl')) {
          return translate + offset;
        }

        return translate - offset;
      }
    });
    /**
     * Make movement to proper slide on:
     * - before build, so glide will start at `startAt` index
     * - on each standard run to move to newly calculated index
     */

    Events.on(['build.before', 'run'], function () {
      Move.make();
    });
    return Move;
  }

  function Sizes (Glide, Components, Events) {
    var Sizes = {
      /**
       * Setups dimensions of slides.
       *
       * @return {Void}
       */
      setupSlides: function setupSlides() {
        var width = "".concat(this.slideWidth, "px");
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = width;
        }
      },

      /**
       * Setups dimensions of slides wrapper.
       *
       * @return {Void}
       */
      setupWrapper: function setupWrapper() {
        Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
      },

      /**
       * Removes applied styles from HTML elements.
       *
       * @returns {Void}
       */
      remove: function remove() {
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
        }

        Components.Html.wrapper.style.width = '';
      }
    };
    define(Sizes, 'length', {
      /**
       * Gets count number of the slides.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.slides.length;
      }
    });
    define(Sizes, 'width', {
      /**
       * Gets width value of the slider (visible area).
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.track.offsetWidth;
      }
    });
    define(Sizes, 'wrapperSize', {
      /**
       * Gets size of the slides wrapper.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
      }
    });
    define(Sizes, 'slideWidth', {
      /**
       * Gets width value of a single slide.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
      }
    });
    /**
     * Apply calculated glide's dimensions:
     * - before building, so other dimensions (e.g. translate) will be calculated propertly
     * - when resizing window to recalculate sildes dimensions
     * - on updating via API, to calculate dimensions based on new options
     */

    Events.on(['build.before', 'resize', 'update'], function () {
      Sizes.setupSlides();
      Sizes.setupWrapper();
    });
    /**
     * Remove calculated glide's dimensions:
     * - on destoting to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Sizes.remove();
    });
    return Sizes;
  }

  function Build (Glide, Components, Events) {
    var Build = {
      /**
       * Init glide building. Adds classes, sets
       * dimensions and setups initial state.
       *
       * @return {Void}
       */
      mount: function mount() {
        Events.emit('build.before');
        this.typeClass();
        this.activeClass();
        Events.emit('build.after');
      },

      /**
       * Adds `type` class to the glide element.
       *
       * @return {Void}
       */
      typeClass: function typeClass() {
        Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      activeClass: function activeClass() {
        var classes = Glide.settings.classes;
        var slide = Components.Html.slides[Glide.index];

        if (slide) {
          slide.classList.add(classes.slide.active);
          siblings(slide).forEach(function (sibling) {
            sibling.classList.remove(classes.slide.active);
          });
        }
      },

      /**
       * Removes HTML classes applied at building.
       *
       * @return {Void}
       */
      removeClasses: function removeClasses() {
        var _Glide$settings$class = Glide.settings.classes,
            type = _Glide$settings$class.type,
            slide = _Glide$settings$class.slide;
        Components.Html.root.classList.remove(type[Glide.settings.type]);
        Components.Html.slides.forEach(function (sibling) {
          sibling.classList.remove(slide.active);
        });
      }
    };
    /**
     * Clear building classes:
     * - on destroying to bring HTML to its initial state
     * - on updating to remove classes before remounting component
     */

    Events.on(['destroy', 'update'], function () {
      Build.removeClasses();
    });
    /**
     * Remount component:
     * - on resizing of the window to calculate new dimensions
     * - on updating settings via API
     */

    Events.on(['resize', 'update'], function () {
      Build.mount();
    });
    /**
     * Swap active class of current slide:
     * - after each move to the new index
     */

    Events.on('move.after', function () {
      Build.activeClass();
    });
    return Build;
  }

  function Clones (Glide, Components, Events) {
    var Clones = {
      /**
       * Create pattern map and collect slides to be cloned.
       */
      mount: function mount() {
        this.items = [];

        if (Glide.isType('carousel')) {
          this.items = this.collect();
        }
      },

      /**
       * Collect clones with pattern.
       *
       * @return {[]}
       */
      collect: function collect() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var slides = Components.Html.slides;
        var _Glide$settings = Glide.settings,
            perView = _Glide$settings.perView,
            classes = _Glide$settings.classes,
            cloningRatio = _Glide$settings.cloningRatio;

        if (slides.length > 0) {
          var peekIncrementer = +!!Glide.settings.peek;
          var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
          var append = slides.slice(0, cloneCount).reverse();
          var prepend = slides.slice(cloneCount * -1);

          for (var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++) {
            for (var i = 0; i < append.length; i++) {
              var clone = append[i].cloneNode(true);
              clone.classList.add(classes.slide.clone);
              items.push(clone);
            }

            for (var _i = 0; _i < prepend.length; _i++) {
              var _clone = prepend[_i].cloneNode(true);

              _clone.classList.add(classes.slide.clone);

              items.unshift(_clone);
            }
          }
        }

        return items;
      },

      /**
       * Append cloned slides with generated pattern.
       *
       * @return {Void}
       */
      append: function append() {
        var items = this.items;
        var _Components$Html = Components.Html,
            wrapper = _Components$Html.wrapper,
            slides = _Components$Html.slides;
        var half = Math.floor(items.length / 2);
        var prepend = items.slice(0, half).reverse();
        var append = items.slice(half * -1).reverse();
        var width = "".concat(Components.Sizes.slideWidth, "px");

        for (var i = 0; i < append.length; i++) {
          wrapper.appendChild(append[i]);
        }

        for (var _i2 = 0; _i2 < prepend.length; _i2++) {
          wrapper.insertBefore(prepend[_i2], slides[0]);
        }

        for (var _i3 = 0; _i3 < items.length; _i3++) {
          items[_i3].style.width = width;
        }
      },

      /**
       * Remove all cloned slides.
       *
       * @return {Void}
       */
      remove: function remove() {
        var items = this.items;

        for (var i = 0; i < items.length; i++) {
          Components.Html.wrapper.removeChild(items[i]);
        }
      }
    };
    define(Clones, 'grow', {
      /**
       * Gets additional dimensions value caused by clones.
       *
       * @return {Number}
       */
      get: function get() {
        return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
      }
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('update', function () {
      Clones.remove();
      Clones.mount();
      Clones.append();
    });
    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */

    Events.on('build.before', function () {
      if (Glide.isType('carousel')) {
        Clones.append();
      }
    });
    /**
     * Remove clones HTMLElements:
     * - on destroying, to bring HTML to its initial state
     */

    Events.on('destroy', function () {
      Clones.remove();
    });
    return Clones;
  }

  var EventsBinder = /*#__PURE__*/function () {
    /**
     * Construct a EventsBinder instance.
     */
    function EventsBinder() {
      var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventsBinder);

      this.listeners = listeners;
    }
    /**
     * Adds events listeners to arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Function} closure
     * @param  {Boolean|Object} capture
     * @return {Void}
     */


    _createClass(EventsBinder, [{
      key: "on",
      value: function on(events, el, closure) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          this.listeners[events[i]] = closure;
          el.addEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Removes event listeners from arrows HTML elements.
       *
       * @param  {String|Array} events
       * @param  {Element|Window|Document} el
       * @param  {Boolean|Object} capture
       * @return {Void}
       */

    }, {
      key: "off",
      value: function off(events, el) {
        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          el.removeEventListener(events[i], this.listeners[events[i]], capture);
        }
      }
      /**
       * Destroy collected listeners.
       *
       * @returns {Void}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        delete this.listeners;
      }
    }]);

    return EventsBinder;
  }();

  function Resize (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Resize = {
      /**
       * Initializes window bindings.
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `rezsize` listener to the window.
       * It's a costly event, so we are debouncing it.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('resize', window, throttle(function () {
          Events.emit('resize');
        }, Glide.settings.throttle));
      },

      /**
       * Unbinds listeners from the window.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('resize', window);
      }
    };
    /**
     * Remove bindings from window:
     * - on destroying, to remove added EventListener
     */

    Events.on('destroy', function () {
      Resize.unbind();
      Binder.destroy();
    });
    return Resize;
  }

  var VALID_DIRECTIONS = ['ltr', 'rtl'];
  var FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
  };
  function Direction (Glide, Components, Events) {
    var Direction = {
      /**
       * Setups gap value based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.direction;
      },

      /**
       * Resolves pattern based on direction value
       *
       * @param {String} pattern
       * @returns {String}
       */
      resolve: function resolve(pattern) {
        var token = pattern.slice(0, 1);

        if (this.is('rtl')) {
          return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
        }

        return pattern;
      },

      /**
       * Checks value of direction mode.
       *
       * @param {String} direction
       * @returns {Boolean}
       */
      is: function is(direction) {
        return this.value === direction;
      },

      /**
       * Applies direction class to the root HTML element.
       *
       * @return {Void}
       */
      addClass: function addClass() {
        Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
      },

      /**
       * Removes direction class from the root HTML element.
       *
       * @return {Void}
       */
      removeClass: function removeClass() {
        Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
      }
    };
    define(Direction, 'value', {
      /**
       * Gets value of the direction.
       *
       * @returns {Number}
       */
      get: function get() {
        return Direction._v;
      },

      /**
       * Sets value of the direction.
       *
       * @param {String} value
       * @return {Void}
       */
      set: function set(value) {
        if (VALID_DIRECTIONS.indexOf(value) > -1) {
          Direction._v = value;
        } else {
          warn('Direction value must be `ltr` or `rtl`');
        }
      }
    });
    /**
     * Clear direction class:
     * - on destroy to bring HTML to its initial state
     * - on update to remove class before reappling bellow
     */

    Events.on(['destroy', 'update'], function () {
      Direction.removeClass();
    });
    /**
     * Remount component:
     * - on update to reflect changes in direction value
     */

    Events.on('update', function () {
      Direction.mount();
    });
    /**
     * Apply direction class:
     * - before building to apply class for the first time
     * - on updating to reapply direction class that may changed
     */

    Events.on(['build.before', 'update'], function () {
      Direction.addClass();
    });
    return Direction;
  }

  /**
   * Reflects value of glide movement.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Rtl (Glide, Components) {
    return {
      /**
       * Negates the passed translate if glide is in RTL option.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Components.Direction.is('rtl')) {
          return -translate;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `gap` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Gap (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with number in the `gap` settings.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
        return translate + Components.Gaps.value * multiplier;
      }
    };
  }

  /**
   * Updates glide movement with width of additional clones width.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Grow (Glide, Components) {
    return {
      /**
       * Adds to the passed translate width of the half of clones.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Clones.grow / 2;
      }
    };
  }

  /**
   * Updates glide movement with a `peek` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function Peeking (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with a `peek` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Glide.settings.focusAt >= 0) {
          var peek = Components.Peek.value;

          if (isObject(peek)) {
            return translate - peek.before;
          }

          return translate - peek;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `focusAt` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Focusing (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with index in the `focusAt` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var gap = Components.Gaps.value;
        var width = Components.Sizes.width;
        var focusAt = Glide.settings.focusAt;
        var slideWidth = Components.Sizes.slideWidth;

        if (focusAt === 'center') {
          return translate - (width / 2 - slideWidth / 2);
        }

        return translate - slideWidth * focusAt - gap * focusAt;
      }
    };
  }

  /**
   * Applies diffrent transformers on translate value.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */

  function mutator (Glide, Components, Events) {
    /**
     * Merge instance transformers with collection of default transformers.
     * It's important that the Rtl component be last on the list,
     * so it reflects all previous transformations.
     *
     * @type {Array}
     */
    var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);
    return {
      /**
       * Piplines translate value with registered transformers.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      mutate: function mutate(translate) {
        for (var i = 0; i < TRANSFORMERS.length; i++) {
          var transformer = TRANSFORMERS[i];

          if (isFunction(transformer) && isFunction(transformer().modify)) {
            translate = transformer(Glide, Components, Events).modify(translate);
          } else {
            warn('Transformer should be a function that returns an object with `modify()` method');
          }
        }

        return translate;
      }
    };
  }

  function Translate (Glide, Components, Events) {
    var Translate = {
      /**
       * Sets value of translate on HTML element.
       *
       * @param {Number} value
       * @return {Void}
       */
      set: function set(value) {
        var transform = mutator(Glide, Components).mutate(value);
        var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
        Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15

        Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22

        Components.Html.wrapper.style.transform = translate3d;
      },

      /**
       * Removes value of translate from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transform = '';
      },

      /**
       * @return {number}
       */
      getStartIndex: function getStartIndex() {
        var length = Components.Sizes.length;
        var index = Glide.index;
        var perView = Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          return length + (index - perView);
        } // "modulo length" converts an index that equals length to zero


        return (index + perView) % length;
      },

      /**
       * @return {number}
       */
      getTravelDistance: function getTravelDistance() {
        var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;

        if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) {
          // reverse travel distance so that we don't have to change subtract operations
          return travelDistance * -1;
        }

        return travelDistance;
      }
    };
    /**
     * Set new translate value:
     * - on move to reflect index change
     * - on updating via API to reflect possible changes in options
     */

    Events.on('move', function (context) {
      if (!Glide.isType('carousel') || !Components.Run.isOffset()) {
        return Translate.set(context.movement);
      }

      Components.Transition.after(function () {
        Events.emit('translate.jump');
        Translate.set(Components.Sizes.slideWidth * Glide.index);
      });
      var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
      return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
     * Remove translate:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Translate.remove();
    });
    return Translate;
  }

  function Transition (Glide, Components, Events) {
    /**
     * Holds inactivity status of transition.
     * When true transition is not applied.
     *
     * @type {Boolean}
     */
    var disabled = false;
    var Transition = {
      /**
       * Composes string of the CSS transition.
       *
       * @param {String} property
       * @return {String}
       */
      compose: function compose(property) {
        var settings = Glide.settings;

        if (disabled) {
          return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
        }

        return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
      },

      /**
       * Sets value of transition on HTML element.
       *
       * @param {String=} property
       * @return {Void}
       */
      set: function set() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
        Components.Html.wrapper.style.transition = this.compose(property);
      },

      /**
       * Removes value of transition from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transition = '';
      },

      /**
       * Runs callback after animation.
       *
       * @param  {Function} callback
       * @return {Void}
       */
      after: function after(callback) {
        setTimeout(function () {
          callback();
        }, this.duration);
      },

      /**
       * Enable transition.
       *
       * @return {Void}
       */
      enable: function enable() {
        disabled = false;
        this.set();
      },

      /**
       * Disable transition.
       *
       * @return {Void}
       */
      disable: function disable() {
        disabled = true;
        this.set();
      }
    };
    define(Transition, 'duration', {
      /**
       * Gets duration of the transition based
       * on currently running animation type.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;

        if (Glide.isType('slider') && Components.Run.offset) {
          return settings.rewindDuration;
        }

        return settings.animationDuration;
      }
    });
    /**
     * Set transition `style` value:
     * - on each moving, because it may be cleared by offset move
     */

    Events.on('move', function () {
      Transition.set();
    });
    /**
     * Disable transition:
     * - before initial build to avoid transitioning from `0` to `startAt` index
     * - while resizing window and recalculating dimensions
     * - on jumping from offset transition at start and end edges in `carousel` type
     */

    Events.on(['build.before', 'resize', 'translate.jump'], function () {
      Transition.disable();
    });
    /**
     * Enable transition:
     * - on each running, because it may be disabled by offset move
     */

    Events.on('run', function () {
      Transition.enable();
    });
    /**
     * Remove transition:
     * - on destroying to bring markup to its inital state
     */

    Events.on('destroy', function () {
      Transition.remove();
    });
    return Transition;
  }

  /**
   * Test via a getter in the options object to see
   * if the passive property is accessed.
   *
   * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
   */
  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  var supportsPassive$1 = supportsPassive;

  var START_EVENTS = ['touchstart', 'mousedown'];
  var MOVE_EVENTS = ['touchmove', 'mousemove'];
  var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
  var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
  function Swipe (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Swipe = {
      /**
       * Initializes swipe bindings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bindSwipeStart();
      },

      /**
       * Handler for `swipestart` event. Calculates entry points of the user's tap.
       *
       * @param {Object} event
       * @return {Void}
       */
      start: function start(event) {
        if (!disabled && !Glide.disabled) {
          this.disable();
          var swipe = this.touches(event);
          swipeSin = null;
          swipeStartX = toInt(swipe.pageX);
          swipeStartY = toInt(swipe.pageY);
          this.bindSwipeMove();
          this.bindSwipeEnd();
          Events.emit('swipe.start');
        }
      },

      /**
       * Handler for `swipemove` event. Calculates user's tap angle and distance.
       *
       * @param {Object} event
       */
      move: function move(event) {
        if (!Glide.disabled) {
          var _Glide$settings = Glide.settings,
              touchAngle = _Glide$settings.touchAngle,
              touchRatio = _Glide$settings.touchRatio,
              classes = _Glide$settings.classes;
          var swipe = this.touches(event);
          var subExSx = toInt(swipe.pageX) - swipeStartX;
          var subEySy = toInt(swipe.pageY) - swipeStartY;
          var powEX = Math.abs(subExSx << 2);
          var powEY = Math.abs(subEySy << 2);
          var swipeHypotenuse = Math.sqrt(powEX + powEY);
          var swipeCathetus = Math.sqrt(powEY);
          swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

          if (swipeSin * 180 / Math.PI < touchAngle) {
            event.stopPropagation();
            Components.Move.make(subExSx * toFloat(touchRatio));
            Components.Html.root.classList.add(classes.dragging);
            Events.emit('swipe.move');
          } else {
            return false;
          }
        }
      },

      /**
       * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
       *
       * @param {Object} event
       * @return {Void}
       */
      end: function end(event) {
        if (!Glide.disabled) {
          var _Glide$settings2 = Glide.settings,
              perSwipe = _Glide$settings2.perSwipe,
              touchAngle = _Glide$settings2.touchAngle,
              classes = _Glide$settings2.classes;
          var swipe = this.touches(event);
          var threshold = this.threshold(event);
          var swipeDistance = swipe.pageX - swipeStartX;
          var swipeDeg = swipeSin * 180 / Math.PI;
          this.enable();

          if (swipeDistance > threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
          } else if (swipeDistance < -threshold && swipeDeg < touchAngle) {
            Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
          } else {
            // While swipe don't reach distance apply previous transform.
            Components.Move.make();
          }

          Components.Html.root.classList.remove(classes.dragging);
          this.unbindSwipeMove();
          this.unbindSwipeEnd();
          Events.emit('swipe.end');
        }
      },

      /**
       * Binds swipe's starting event.
       *
       * @return {Void}
       */
      bindSwipeStart: function bindSwipeStart() {
        var _this = this;

        var _Glide$settings3 = Glide.settings,
            swipeThreshold = _Glide$settings3.swipeThreshold,
            dragThreshold = _Glide$settings3.dragThreshold;

        if (swipeThreshold) {
          Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }

        if (dragThreshold) {
          Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }
      },

      /**
       * Unbinds swipe's starting event.
       *
       * @return {Void}
       */
      unbindSwipeStart: function unbindSwipeStart() {
        Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
        Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's moving event.
       *
       * @return {Void}
       */
      bindSwipeMove: function bindSwipeMove() {
        var _this2 = this;

        Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
          _this2.move(event);
        }, Glide.settings.throttle), capture);
      },

      /**
       * Unbinds swipe's moving event.
       *
       * @return {Void}
       */
      unbindSwipeMove: function unbindSwipeMove() {
        Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
      },

      /**
       * Binds swipe's ending event.
       *
       * @return {Void}
       */
      bindSwipeEnd: function bindSwipeEnd() {
        var _this3 = this;

        Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
          _this3.end(event);
        });
      },

      /**
       * Unbinds swipe's ending event.
       *
       * @return {Void}
       */
      unbindSwipeEnd: function unbindSwipeEnd() {
        Binder.off(END_EVENTS, Components.Html.wrapper);
      },

      /**
       * Normalizes event touches points accorting to different types.
       *
       * @param {Object} event
       */
      touches: function touches(event) {
        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return event;
        }

        return event.touches[0] || event.changedTouches[0];
      },

      /**
       * Gets value of minimum swipe distance settings based on event type.
       *
       * @return {Number}
       */
      threshold: function threshold(event) {
        var settings = Glide.settings;

        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return settings.dragThreshold;
        }

        return settings.swipeThreshold;
      },

      /**
       * Enables swipe event.
       *
       * @return {self}
       */
      enable: function enable() {
        disabled = false;
        Components.Transition.enable();
        return this;
      },

      /**
       * Disables swipe event.
       *
       * @return {self}
       */
      disable: function disable() {
        disabled = true;
        Components.Transition.disable();
        return this;
      }
    };
    /**
     * Add component class:
     * - after initial building
     */

    Events.on('build.after', function () {
      Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
     * Remove swiping bindings:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Swipe.unbindSwipeStart();
      Swipe.unbindSwipeMove();
      Swipe.unbindSwipeEnd();
      Binder.destroy();
    });
    return Swipe;
  }

  function Images (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Images = {
      /**
       * Binds listener to glide wrapper.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bind();
      },

      /**
       * Binds `dragstart` event on wrapper to prevent dragging images.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
      },

      /**
       * Unbinds `dragstart` event on wrapper.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('dragstart', Components.Html.wrapper);
      },

      /**
       * Event handler. Prevents dragging.
       *
       * @return {Void}
       */
      dragstart: function dragstart(event) {
        event.preventDefault();
      }
    };
    /**
     * Remove bindings from images:
     * - on destroying, to remove added EventListeners
     */

    Events.on('destroy', function () {
      Images.unbind();
      Binder.destroy();
    });
    return Images;
  }

  function Anchors (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds detaching status of anchors.
     * Prevents detaching of already detached anchors.
     *
     * @private
     * @type {Boolean}
     */

    var detached = false;
    /**
     * Holds preventing status of anchors.
     * If `true` redirection after click will be disabled.
     *
     * @private
     * @type {Boolean}
     */

    var prevented = false;
    var Anchors = {
      /**
       * Setups a initial state of anchors component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        /**
         * Holds collection of anchors elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._a = Components.Html.wrapper.querySelectorAll('a');
        this.bind();
      },

      /**
       * Binds events to anchors inside a track.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('click', Components.Html.wrapper, this.click);
      },

      /**
       * Unbinds events attached to anchors inside a track.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('click', Components.Html.wrapper);
      },

      /**
       * Handler for click event. Prevents clicks when glide is in `prevent` status.
       *
       * @param  {Object} event
       * @return {Void}
       */
      click: function click(event) {
        if (prevented) {
          event.stopPropagation();
          event.preventDefault();
        }
      },

      /**
       * Detaches anchors click event inside glide.
       *
       * @return {self}
       */
      detach: function detach() {
        prevented = true;

        if (!detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = false;
          }

          detached = true;
        }

        return this;
      },

      /**
       * Attaches anchors click events inside glide.
       *
       * @return {self}
       */
      attach: function attach() {
        prevented = false;

        if (detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = true;
          }

          detached = false;
        }

        return this;
      }
    };
    define(Anchors, 'items', {
      /**
       * Gets collection of the arrows HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Anchors._a;
      }
    });
    /**
     * Detach anchors inside slides:
     * - on swiping, so they won't redirect to its `href` attributes
     */

    Events.on('swipe.move', function () {
      Anchors.detach();
    });
    /**
     * Attach anchors inside slides:
     * - after swiping and transitions ends, so they can redirect after click again
     */

    Events.on('swipe.end', function () {
      Components.Transition.after(function () {
        Anchors.attach();
      });
    });
    /**
     * Unbind anchors inside slides:
     * - on destroying, to bring anchors to its initial state
     */

    Events.on('destroy', function () {
      Anchors.attach();
      Anchors.unbind();
      Binder.destroy();
    });
    return Anchors;
  }

  var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
  var PREVIOUS_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
  var NEXT_CONTROLS_SELECTOR = "".concat(CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");
  function Controls (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var capture = supportsPassive$1 ? {
      passive: true
    } : false;
    var Controls = {
      /**
       * Inits arrows. Binds events listeners
       * to the arrows HTML elements.
       *
       * @return {Void}
       */
      mount: function mount() {
        /**
         * Collection of navigation HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
        /**
         * Collection of controls HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */

        this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
        /**
         * Collection of arrow control HTML elements.
         *
         * @private
         * @type {Object}
         */

        this._arrowControls = {
          previous: Components.Html.root.querySelectorAll(PREVIOUS_CONTROLS_SELECTOR),
          next: Components.Html.root.querySelectorAll(NEXT_CONTROLS_SELECTOR)
        };
        this.addBindings();
      },

      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      setActive: function setActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.addClass(this._n[i].children);
        }
      },

      /**
       * Removes active class to current slide.
       *
       * @return {Void}
       */
      removeActive: function removeActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.removeClass(this._n[i].children);
        }
      },

      /**
       * Toggles active class on items inside navigation.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      addClass: function addClass(controls) {
        var settings = Glide.settings;
        var item = controls[Glide.index];

        if (!item) {
          return;
        }

        item.classList.add(settings.classes.nav.active);
        siblings(item).forEach(function (sibling) {
          sibling.classList.remove(settings.classes.nav.active);
        });
      },

      /**
       * Removes active class from active control.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      removeClass: function removeClass(controls) {
        var item = controls[Glide.index];
        item === null || item === void 0 ? void 0 : item.classList.remove(Glide.settings.classes.nav.active);
      },

      /**
       * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
       */
      setArrowState: function setArrowState() {
        if (Glide.settings.rewind) {
          return;
        }

        var next = Controls._arrowControls.next;
        var previous = Controls._arrowControls.previous;
        this.resetArrowState(next, previous);

        if (Glide.index === 0) {
          this.disableArrow(previous);
        }

        if (Glide.index === Components.Run.length) {
          this.disableArrow(next);
        }
      },

      /**
       * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      resetArrowState: function resetArrowState() {
        var settings = Glide.settings;

        for (var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++) {
          lists[_key] = arguments[_key];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.remove(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
       *
       * @param {NodeList[]} lists
       */
      disableArrow: function disableArrow() {
        var settings = Glide.settings;

        for (var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          lists[_key2] = arguments[_key2];
        }

        lists.forEach(function (list) {
          toArray(list).forEach(function (element) {
            element.classList.add(settings.classes.arrow.disabled);
          });
        });
      },

      /**
       * Adds handles to the each group of controls.
       *
       * @return {Void}
       */
      addBindings: function addBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.bind(this._c[i].children);
        }
      },

      /**
       * Removes handles from the each group of controls.
       *
       * @return {Void}
       */
      removeBindings: function removeBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.unbind(this._c[i].children);
        }
      },

      /**
       * Binds events to arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      bind: function bind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.on('click', elements[i], this.click);
          Binder.on('touchstart', elements[i], this.click, capture);
        }
      },

      /**
       * Unbinds events binded to the arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      unbind: function unbind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.off(['click', 'touchstart'], elements[i]);
        }
      },

      /**
       * Handles `click` event on the arrows HTML elements.
       * Moves slider in direction given via the
       * `data-glide-dir` attribute.
       *
       * @param {Object} event
       * @return {void}
       */
      click: function click(event) {
        if (!supportsPassive$1 && event.type === 'touchstart') {
          event.preventDefault();
        }

        var direction = event.currentTarget.getAttribute('data-glide-dir');
        Components.Run.make(Components.Direction.resolve(direction));
      }
    };
    define(Controls, 'items', {
      /**
       * Gets collection of the controls HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Controls._c;
      }
    });
    /**
     * Swap active class of current navigation item:
     * - after mounting to set it to initial index
     * - after each move to the new index
     */

    Events.on(['mount.after', 'move.after'], function () {
      Controls.setActive();
    });
    /**
     * Add or remove disabled class of arrow elements
     */

    Events.on(['mount.after', 'run'], function () {
      Controls.setArrowState();
    });
    /**
     * Remove bindings and HTML Classes:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Controls.removeBindings();
      Controls.removeActive();
      Binder.destroy();
    });
    return Controls;
  }

  function Keyboard (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Keyboard = {
      /**
       * Binds keyboard events on component mount.
       *
       * @return {Void}
       */
      mount: function mount() {
        if (Glide.settings.keyboard) {
          this.bind();
        }
      },

      /**
       * Adds keyboard press events.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('keyup', document, this.press);
      },

      /**
       * Removes keyboard press events.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('keyup', document);
      },

      /**
       * Handles keyboard's arrows press and moving glide foward and backward.
       *
       * @param  {Object} event
       * @return {Void}
       */
      press: function press(event) {
        var perSwipe = Glide.settings.perSwipe;
        var arrowSymbols = {
          ArrowRight: '>',
          ArrowLeft: '<'
        };

        if (['ArrowRight', 'ArrowLeft'].includes(event.code)) {
          Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
        }
      }
    };
    /**
     * Remove bindings from keyboard:
     * - on destroying to remove added events
     * - on updating to remove events before remounting
     */

    Events.on(['destroy', 'update'], function () {
      Keyboard.unbind();
    });
    /**
     * Remount component
     * - on updating to reflect potential changes in settings
     */

    Events.on('update', function () {
      Keyboard.mount();
    });
    /**
     * Destroy binder:
     * - on destroying to remove listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Keyboard;
  }

  function Autoplay (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    var Autoplay = {
      /**
       * Initializes autoplaying and events.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.enable();
        this.start();

        if (Glide.settings.hoverpause) {
          this.bind();
        }
      },

      /**
       * Enables autoplaying
       *
       * @returns {Void}
       */
      enable: function enable() {
        this._e = true;
      },

      /**
       * Disables autoplaying.
       *
       * @returns {Void}
       */
      disable: function disable() {
        this._e = false;
      },

      /**
       * Starts autoplaying in configured interval.
       *
       * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Void}
       */
      start: function start() {
        var _this = this;

        if (!this._e) {
          return;
        }

        this.enable();

        if (Glide.settings.autoplay) {
          if (isUndefined(this._i)) {
            this._i = setInterval(function () {
              _this.stop();

              Components.Run.make('>');

              _this.start();

              Events.emit('autoplay');
            }, this.time);
          }
        }
      },

      /**
       * Stops autorunning of the glide.
       *
       * @return {Void}
       */
      stop: function stop() {
        this._i = clearInterval(this._i);
      },

      /**
       * Stops autoplaying while mouse is over glide's area.
       *
       * @return {Void}
       */
      bind: function bind() {
        var _this2 = this;

        Binder.on('mouseover', Components.Html.root, function () {
          if (_this2._e) {
            _this2.stop();
          }
        });
        Binder.on('mouseout', Components.Html.root, function () {
          if (_this2._e) {
            _this2.start();
          }
        });
      },

      /**
       * Unbind mouseover events.
       *
       * @returns {Void}
       */
      unbind: function unbind() {
        Binder.off(['mouseover', 'mouseout'], Components.Html.root);
      }
    };
    define(Autoplay, 'time', {
      /**
       * Gets time period value for the autoplay interval. Prioritizes
       * times in `data-glide-autoplay` attrubutes over options.
       *
       * @return {Number}
       */
      get: function get() {
        var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

        if (autoplay) {
          return toInt(autoplay);
        }

        return toInt(Glide.settings.autoplay);
      }
    });
    /**
     * Stop autoplaying and unbind events:
     * - on destroying, to clear defined interval
     * - on updating via API to reset interval that may changed
     */

    Events.on(['destroy', 'update'], function () {
      Autoplay.unbind();
    });
    /**
     * Stop autoplaying:
     * - before each run, to restart autoplaying
     * - on pausing via API
     * - on destroying, to clear defined interval
     * - while starting a swipe
     * - on updating via API to reset interval that may changed
     */

    Events.on(['run.before', 'swipe.start', 'update'], function () {
      Autoplay.stop();
    });
    Events.on(['pause', 'destroy'], function () {
      Autoplay.disable();
      Autoplay.stop();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['run.after', 'swipe.end'], function () {
      Autoplay.start();
    });
    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */

    Events.on(['play'], function () {
      Autoplay.enable();
      Autoplay.start();
    });
    /**
     * Remount autoplaying:
     * - on updating via API to reset interval that may changed
     */

    Events.on('update', function () {
      Autoplay.mount();
    });
    /**
     * Destroy a binder:
     * - on destroying glide instance to clearup listeners
     */

    Events.on('destroy', function () {
      Binder.destroy();
    });
    return Autoplay;
  }

  /**
   * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
   *
   * @param {Object} points
   * @returns {Object}
   */

  function sortBreakpoints(points) {
    if (isObject(points)) {
      return sortKeys(points);
    } else {
      warn("Breakpoints option must be an object");
    }

    return {};
  }

  function Breakpoints (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();
    /**
     * Holds reference to settings.
     *
     * @type {Object}
     */

    var settings = Glide.settings;
    /**
     * Holds reference to breakpoints object in settings. Sorts breakpoints
     * from smaller to larger. It is required in order to proper
     * matching currently active breakpoint settings.
     *
     * @type {Object}
     */

    var points = sortBreakpoints(settings.breakpoints);
    /**
     * Cache initial settings before overwritting.
     *
     * @type {Object}
     */

    var defaults = Object.assign({}, settings);
    var Breakpoints = {
      /**
       * Matches settings for currectly matching media breakpoint.
       *
       * @param {Object} points
       * @returns {Object}
       */
      match: function match(points) {
        if (typeof window.matchMedia !== 'undefined') {
          for (var point in points) {
            if (points.hasOwnProperty(point)) {
              if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) {
                return points[point];
              }
            }
          }
        }

        return defaults;
      }
    };
    /**
     * Overwrite instance settings with currently matching breakpoint settings.
     * This happens right after component initialization.
     */

    Object.assign(settings, Breakpoints.match(points));
    /**
     * Update glide with settings of matched brekpoint:
     * - window resize to update slider
     */

    Binder.on('resize', window, throttle(function () {
      Glide.settings = mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
     * Resort and update default settings:
     * - on reinit via API, so breakpoint matching will be performed with options
     */

    Events.on('update', function () {
      points = sortBreakpoints(points);
      defaults = Object.assign({}, settings);
    });
    /**
     * Unbind resize listener:
     * - on destroying, to bring markup to its initial state
     */

    Events.on('destroy', function () {
      Binder.off('resize', window);
    });
    return Breakpoints;
  }

  var COMPONENTS = {
    // Required
    Html: Html,
    Translate: Translate,
    Transition: Transition,
    Direction: Direction,
    Peek: Peek,
    Sizes: Sizes,
    Gaps: Gaps,
    Move: Move,
    Clones: Clones,
    Resize: Resize,
    Build: Build,
    Run: Run,
    // Optional
    Swipe: Swipe,
    Images: Images,
    Anchors: Anchors,
    Controls: Controls,
    Keyboard: Keyboard,
    Autoplay: Autoplay,
    Breakpoints: Breakpoints
  };

  var Glide = /*#__PURE__*/function (_Core) {
    _inherits(Glide, _Core);

    var _super = _createSuper(Glide);

    function Glide() {
      _classCallCheck(this, Glide);

      return _super.apply(this, arguments);
    }

    _createClass(Glide, [{
      key: "mount",
      value: function mount() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _get(_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, COMPONENTS, extensions));
      }
    }]);

    return Glide;
  }(Glide$1);

  return Glide;

}));

},{}],52:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":54}],53:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":60,"../core/createError":61,"./../core/settle":65,"./../helpers/buildURL":69,"./../helpers/cookies":71,"./../helpers/isURLSameOrigin":74,"./../helpers/parseHeaders":76,"./../utils":79}],54:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":55,"./cancel/CancelToken":56,"./cancel/isCancel":57,"./core/Axios":58,"./core/mergeConfig":64,"./defaults":67,"./helpers/bind":68,"./helpers/isAxiosError":73,"./helpers/spread":77,"./utils":79}],55:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],56:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":55}],57:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],58:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":69,"../helpers/validator":78,"./../utils":79,"./InterceptorManager":59,"./dispatchRequest":62,"./mergeConfig":64}],59:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":79}],60:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":70,"../helpers/isAbsoluteURL":72}],61:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":63}],62:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":57,"../defaults":67,"./../utils":79,"./transformData":66}],63:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],64:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":79}],65:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":61}],66:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":67,"./../utils":79}],67:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))

},{"./adapters/http":53,"./adapters/xhr":53,"./core/enhanceError":63,"./helpers/normalizeHeaderName":75,"./utils":79,"_process":81}],68:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],69:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":79}],70:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],71:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":79}],72:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],73:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],74:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":79}],75:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":79}],76:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":79}],77:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],78:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":80}],79:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":68}],80:[function(require,module,exports){
module.exports={
  "_from": "axios@^0.21.4",
  "_id": "axios@0.21.4",
  "_inBundle": false,
  "_integrity": "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==",
  "_location": "/axios",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "axios@^0.21.4",
    "name": "axios",
    "escapedName": "axios",
    "rawSpec": "^0.21.4",
    "saveSpec": null,
    "fetchSpec": "^0.21.4"
  },
  "_requiredBy": [
    "/",
    "/localtunnel",
    "/paged-request"
  ],
  "_resolved": "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz",
  "_shasum": "c67b90dc0568e5c1cf2b0b858c43ba28e2eda575",
  "_spec": "axios@^0.21.4",
  "_where": "C:\\NewRepos\\Amanacard\\src\\Amanacard.Frontend",
  "author": {
    "name": "Matt Zabriskie"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "bundleDependencies": false,
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ],
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "deprecated": false,
  "description": "Promise based HTTP client for the browser and node.js",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "homepage": "https://axios-http.com",
  "jsdelivr": "dist/axios.min.js",
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "license": "MIT",
  "main": "index.js",
  "name": "axios",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/axios/axios.git"
  },
  "scripts": {
    "build": "NODE_ENV=production grunt build",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "examples": "node ./examples/server.js",
    "fix": "eslint --fix lib/**/*.js",
    "postversion": "git push && git push --tags",
    "preversion": "npm test",
    "start": "node ./sandbox/server.js",
    "test": "grunt test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
  },
  "typings": "./index.d.ts",
  "unpkg": "dist/axios.min.js",
  "version": "0.21.4"
}

},{}],81:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[4,5,6,7,8,11,9,10,12,13,14,15,16,17,18,19,20,21,22,24,23,25,26,27,28,29,30,31,32,33,34,35,36,37,38,40,39,41,42,44,45,46,47,48,49,50])(50)
});

